import {
  InfiniteData,
  UseInfiniteQueryOptions,
  UseMutationOptions,
  UseQueryOptions,
  useInfiniteQuery,
  useMutation,
  useQuery,
} from '@tanstack/react-query';
import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
export type Maybe<T> = T;
export type InputMaybe<T> = T | undefined | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables extends { [key: string]: any }>(
  client: GraphQLClient,
  query: string,
  variables?: TVariables,
  requestHeaders?: RequestInit['headers'],
) {
  return async (): Promise<TData> =>
    client.request({
      document: query,
      variables,
      requestHeaders,
    });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  DateTimeTz: { input: any; output: any };
  JSON: { input: any; output: any };
  Upload: { input: any; output: any };
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  boat_detail_id?: Maybe<Scalars['ID']['output']>;
  causer_id?: Maybe<Scalars['ID']['output']>;
  causer_type?: Maybe<Scalars['String']['output']>;
  client_ip?: Maybe<Scalars['String']['output']>;
  client_ips?: Maybe<Scalars['JSON']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_api?: Maybe<Scalars['Boolean']['output']>;
  log_message?: Maybe<Scalars['String']['output']>;
  log_name?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Scalars['JSON']['output']>;
  subject_id?: Maybe<Scalars['ID']['output']>;
  subject_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of ActivityLog items. */
export type ActivityLogPaginator = {
  __typename?: 'ActivityLogPaginator';
  /** A list of ActivityLog items. */
  data: Array<ActivityLog>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type Alert = {
  __typename?: 'Alert';
  active?: Maybe<Scalars['Boolean']['output']>;
  alertable_id: Scalars['Int']['output'];
  alertable_type: Scalars['String']['output'];
  assignee_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  boat_detail?: Maybe<BoatDetails>;
  boat_detail_id?: Maybe<Scalars['ID']['output']>;
  can_delete?: Maybe<Scalars['Boolean']['output']>;
  can_share?: Maybe<Scalars['Boolean']['output']>;
  can_update?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invite_ids?: Maybe<Scalars['String']['output']>;
  marked_as_done_at?: Maybe<Scalars['DateTime']['output']>;
  priority: Scalars['Int']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  /** @deprecated status of the alert is field 'active' */
  status: Scalars['String']['output'];
  threshold?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  user_id: Scalars['ID']['output'];
};

export enum AlertFilter {
  Active = 'active',
  Completed = 'completed',
  Disabled = 'disabled',
  Raised = 'raised',
}

/** A paginated list of Alert items. */
export type AlertPaginator = {
  __typename?: 'AlertPaginator';
  /** A list of Alert items. */
  data: Array<Alert>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Auth0UserMetaData = {
  setup_profile_status?: InputMaybe<Scalars['String']['input']>;
};

export type AutomaticTax = {
  __typename?: 'AutomaticTax';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  liability?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Master boat model entity */
export type Boat = {
  __typename?: 'Boat';
  activities?: Maybe<Array<Maybe<Taxonomy>>>;
  /**
   * @deprecated See MTM relationship with `activities`
   * @deprecated See MTM relationship with `activities`.
   */
  activity?: Maybe<Scalars['String']['output']>;
  /**
   * @deprecated, see `hull_appendages`.
   * @deprecated See `hull_appendages`.
   */
  appendages?: Maybe<Scalars['String']['output']>;
  approved_at?: Maybe<Scalars['DateTime']['output']>;
  ballast_displacement?: Maybe<Scalars['Float']['output']>;
  ballast_length?: Maybe<Scalars['Float']['output']>;
  ballast_type?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use ballast_weight_float (Float) instead */
  ballast_weight?: Maybe<Scalars['String']['output']>;
  ballast_weight_float?: Maybe<Scalars['Float']['output']>;
  bcl?: Maybe<Scalars['Float']['output']>;
  bdcl?: Maybe<Scalars['Float']['output']>;
  berths?: Maybe<Scalars['Int']['output']>;
  bh?: Maybe<Scalars['Float']['output']>;
  boa?: Maybe<Scalars['Float']['output']>;
  cabins?: Maybe<Scalars['Int']['output']>;
  can_delete?: Maybe<Scalars['Boolean']['output']>;
  can_update?: Maybe<Scalars['Boolean']['output']>;
  categories?: Maybe<Array<Maybe<Taxonomy>>>;
  /**
   * @deprecated See MTM relationship with `categories`
   * @deprecated See MTM relationship with `categories`
   */
  category?: Maybe<Scalars['String']['output']>;
  ce_classification?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cockpit_location?: Maybe<Scalars['String']['output']>;
  cockpit_type?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  cruising_speed?: Maybe<Scalars['Float']['output']>;
  csf?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  designer_name?: Maybe<Scalars['String']['output']>;
  designer_site?: Maybe<Scalars['String']['output']>;
  displacement?: Maybe<Scalars['Float']['output']>;
  displacement_hull_speed?: Maybe<Scalars['Float']['output']>;
  displacement_length?: Maybe<Scalars['Float']['output']>;
  downwind_sail_area?: Maybe<Scalars['Float']['output']>;
  downwind_sail_area_displacement?: Maybe<Scalars['Float']['output']>;
  draft_max?: Maybe<Scalars['Float']['output']>;
  draft_min?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `engines` relationship instead. */
  engine?: Maybe<Array<Maybe<Engine>>>;
  /** @deprecated Use `engine.maker`. */
  engine_manufacturer?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `engine.maker`. */
  engine_manufacturer_b?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `engine.website`. */
  engine_manufacturer_site?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `engine.website`. */
  engine_manufacturer_site_b?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `engine.model`. */
  engine_model?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `engine.model`. */
  engine_model_b?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `engine.power`. */
  engine_power?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `engine.power`. */
  engine_power_b?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `engine.power_type`. */
  engine_power_type?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `engine.power_type`. */
  engine_power_type_b?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `engine.type`. */
  engine_type?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `engine.type`. */
  engine_type_b?: Maybe<Scalars['String']['output']>;
  exterior_design?: Maybe<Scalars['String']['output']>;
  exterior_site?: Maybe<Scalars['String']['output']>;
  favorites_count?: Maybe<Scalars['Int']['output']>;
  fields?: Maybe<Array<Maybe<FieldValue>>>;
  files?: Maybe<Array<Maybe<File>>>;
  /** @deprecated Use `fuel_tank`. */
  fuel_capacity?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `fuel_tank`. */
  fuel_capacity_tank_b?: Maybe<Scalars['Float']['output']>;
  fuel_tank?: Maybe<Array<Maybe<FuelTank>>>;
  genoa?: Maybe<Array<Maybe<Genoa>>>;
  /** @deprecated Use `genoa.value`. */
  genoa_sail_area_a?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `genoa.value`. */
  genoa_sail_area_b?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `genoa.value`. */
  genoa_sail_area_c?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `genoa.name`. */
  genoa_type_a?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `genoa.name`. */
  genoa_type_b?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `genoa.name`. */
  genoa_type_c?: Maybe<Scalars['String']['output']>;
  headroom?: Maybe<Scalars['Float']['output']>;
  heads?: Maybe<Scalars['Int']['output']>;
  headsail?: Maybe<Array<Maybe<HeadSail>>>;
  helm?: Maybe<Scalars['String']['output']>;
  holding_tank?: Maybe<Array<Maybe<HoldingTank>>>;
  /** @deprecated Use `holding_tank`. */
  holding_tank_capacity?: Maybe<Scalars['Float']['output']>;
  hull_appendages?: Maybe<Array<Maybe<HullAppendages>>>;
  hull_material: Scalars['String']['output'];
  hull_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<File>;
  image_id?: Maybe<Scalars['ID']['output']>;
  image_path?: Maybe<Scalars['String']['output']>;
  interior_design?: Maybe<Scalars['String']['output']>;
  interior_site?: Maybe<Scalars['String']['output']>;
  is_favorited?: Maybe<Scalars['Boolean']['output']>;
  is_featured?: Maybe<Scalars['Boolean']['output']>;
  keel_type?: Maybe<Scalars['String']['output']>;
  ksi?: Maybe<Scalars['Float']['output']>;
  loa?: Maybe<Scalars['Float']['output']>;
  lwl?: Maybe<Scalars['Float']['output']>;
  mainsail?: Maybe<Array<Maybe<MainSail>>>;
  manufacturer?: Maybe<Manufacturer>;
  manufacturer_id?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use `manufacturer` Relationship instead */
  manufacturer_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `manufacturer` Relationship instead */
  manufacturer_site?: Maybe<Scalars['String']['output']>;
  mast?: Maybe<Scalars['Float']['output']>;
  mast_configuration?: Maybe<Scalars['String']['output']>;
  /**
   * @deprecated, see `mast_configuration`.
   * @deprecated Use `mast_configuration`.
   */
  mast_position?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  nom?: Maybe<Scalars['Float']['output']>;
  og_description?: Maybe<Scalars['String']['output']>;
  og_image?: Maybe<Scalars['String']['output']>;
  og_title?: Maybe<Scalars['String']['output']>;
  og_url?: Maybe<Scalars['String']['output']>;
  price_html?: Maybe<Scalars['String']['output']>;
  reference_price?: Maybe<Scalars['Float']['output']>;
  reference_price_formated?: Maybe<Scalars['String']['output']>;
  rigging?: Maybe<Scalars['String']['output']>;
  rotating_spars?: Maybe<Scalars['Boolean']['output']>;
  rudder?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `mainsail.value`. */
  sail_area?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `mainsail.value`. */
  sail_area_b?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `mainsail.value`. */
  sail_area_c?: Maybe<Scalars['Float']['output']>;
  sail_area_displacement?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `mainsail.name`. */
  sail_area_type_a?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `mainsail.name`. */
  sail_area_type_b?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `mainsail.name`. */
  sail_area_type_c?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  spars?: Maybe<Scalars['String']['output']>;
  spinnaker?: Maybe<Array<Maybe<Spinnaker>>>;
  /** @deprecated Use `spinnaker.value`. */
  spinnaker_sail_area_a?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `spinnaker.value`. */
  spinnaker_sail_area_b?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `spinnaker.value`. */
  spinnaker_sail_area_c?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `spinnaker.name`. */
  spinnaker_type_a?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `spinnaker.name`. */
  spinnaker_type_b?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `spinnaker.name`. */
  spinnaker_type_c?: Maybe<Scalars['String']['output']>;
  spreaders_angle?: Maybe<Scalars['String']['output']>;
  spreaders_level?: Maybe<Scalars['Int']['output']>;
  sspd?: Maybe<Scalars['Float']['output']>;
  standing_rigging?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  tonnage_gross?: Maybe<Scalars['Float']['output']>;
  tonnage_net?: Maybe<Scalars['Float']['output']>;
  top_speed?: Maybe<Scalars['Float']['output']>;
  total_views?: Maybe<Scalars['Int']['output']>;
  trailerable?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  unique_views_count?: Maybe<Scalars['Int']['output']>;
  unit: Scalars['String']['output'];
  unsinkable?: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['DateTime']['output'];
  upwind_sail_area?: Maybe<Scalars['Float']['output']>;
  upwind_sail_area_displacement?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<User>;
  userBoatDetails?: Maybe<Array<Maybe<BoatDetails>>>;
  user_id: Scalars['ID']['output'];
  version?: Maybe<Scalars['String']['output']>;
  views_count?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `water_tank`. */
  water_capacity?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `water_tank`. */
  water_capacity_tank_b?: Maybe<Scalars['Float']['output']>;
  water_heater?: Maybe<Array<Maybe<WaterHeater>>>;
  /** @deprecated Use `water_heater`. */
  water_heater_capacity?: Maybe<Scalars['Float']['output']>;
  water_tank?: Maybe<Array<Maybe<WaterTank>>>;
  /**
   * The current year built for the boat. is deprecated use `year_first`
   * @deprecated See `year_first` instead
   */
  year?: Maybe<Scalars['Int']['output']>;
  /** The [year] when the boat was first built */
  year_first?: Maybe<Scalars['Int']['output']>;
  /** The [year] of last build for this boat model */
  year_last?: Maybe<Scalars['Int']['output']>;
};

export type BoatAutocomplete = {
  __typename?: 'BoatAutocomplete';
  id?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['ID']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type BoatDetails = {
  __typename?: 'BoatDetails';
  acquisition_date?: Maybe<Scalars['String']['output']>;
  acquisition_type?: Maybe<Scalars['String']['output']>;
  battery_power?: Maybe<Scalars['Float']['output']>;
  boat?: Maybe<Boat>;
  boat_id?: Maybe<Scalars['ID']['output']>;
  callsign?: Maybe<Scalars['String']['output']>;
  can_delete?: Maybe<Scalars['Boolean']['output']>;
  can_share?: Maybe<Scalars['Boolean']['output']>;
  can_update?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dg_power?: Maybe<Scalars['Float']['output']>;
  engine_battery_capacity?: Maybe<Scalars['Float']['output']>;
  engine_battery_voltage?: Maybe<Scalars['Float']['output']>;
  engines?: Maybe<Array<Maybe<Engine>>>;
  epirb?: Maybe<Scalars['String']['output']>;
  /** Array of custom fields from user */
  fields?: Maybe<Array<Maybe<FieldValue>>>;
  files?: Maybe<Array<Maybe<File>>>;
  flag: Scalars['String']['output'];
  hull_sn?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<File>;
  /** Boat Cover Image */
  image_id?: Maybe<Scalars['Int']['output']>;
  in_reach_tracker_id?: Maybe<Scalars['String']['output']>;
  inverter_power?: Maybe<Scalars['Float']['output']>;
  is_vat_paid?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  location_toponym?: Maybe<Scalars['String']['output']>;
  mmsi?: Maybe<Scalars['String']['output']>;
  mobile_phone?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nr_past_owners?: Maybe<Scalars['Int']['output']>;
  ownership_order?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<PlanOfUser>;
  price?: Maybe<Scalars['Float']['output']>;
  price_formated?: Maybe<Scalars['Float']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  satellite_phone?: Maybe<Scalars['String']['output']>;
  service_battery_capacity?: Maybe<Scalars['Float']['output']>;
  service_battery_voltage?: Maybe<Scalars['Float']['output']>;
  service_loads?: Maybe<Scalars['String']['output']>;
  solar_power?: Maybe<Scalars['Float']['output']>;
  spot_tracker_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  strapi_ref_document_id?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use `strapi_ref_document_id` instead */
  strapi_ref_id?: Maybe<Scalars['ID']['output']>;
  subscription_id?: Maybe<Scalars['Int']['output']>;
  tender_length?: Maybe<Scalars['Float']['output']>;
  tender_model?: Maybe<Scalars['String']['output']>;
  tender_name?: Maybe<Scalars['String']['output']>;
  tender_vendor?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  user_id: Scalars['ID']['output'];
  wind_power?: Maybe<Scalars['Float']['output']>;
  /** The current year built for the boat. */
  year?: Maybe<Scalars['Int']['output']>;
};

export type BoatDetailsInput = {
  acquisition_date?: InputMaybe<Scalars['String']['input']>;
  acquisition_type?: InputMaybe<Scalars['String']['input']>;
  battery_power?: InputMaybe<Scalars['Float']['input']>;
  callsign?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dg_power?: InputMaybe<Scalars['Float']['input']>;
  engine_battery_capacity?: InputMaybe<Scalars['Float']['input']>;
  engine_battery_voltage?: InputMaybe<Scalars['Float']['input']>;
  engines?: InputMaybe<Array<InputMaybe<EngineInput>>>;
  epirb?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<Scalars['Int']['input']>>;
  flag: Scalars['String']['input'];
  hull_sn?: InputMaybe<Scalars['String']['input']>;
  in_reach_tracker_id?: InputMaybe<Scalars['String']['input']>;
  inverter_power?: InputMaybe<Scalars['Float']['input']>;
  is_vat_paid?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  mmsi?: InputMaybe<Scalars['String']['input']>;
  mobile_phone?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nr_past_owners?: InputMaybe<Scalars['Int']['input']>;
  ownership_order?: InputMaybe<Scalars['String']['input']>;
  plan_id?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  satellite_phone?: InputMaybe<Scalars['String']['input']>;
  service_battery_capacity?: InputMaybe<Scalars['Float']['input']>;
  service_battery_voltage?: InputMaybe<Scalars['Float']['input']>;
  service_loads?: InputMaybe<Scalars['String']['input']>;
  solar_power?: InputMaybe<Scalars['Float']['input']>;
  spot_tracker_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  tender_length?: InputMaybe<Scalars['Float']['input']>;
  tender_model?: InputMaybe<Scalars['String']['input']>;
  tender_name?: InputMaybe<Scalars['String']['input']>;
  tender_vendor?: InputMaybe<Scalars['String']['input']>;
  wind_power?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['Int']['input'];
};

/** A paginated list of BoatDetails items. */
export type BoatDetailsPaginator = {
  __typename?: 'BoatDetailsPaginator';
  /** A list of BoatDetails items. */
  data: Array<BoatDetails>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** A paginated list of Boat items. */
export type BoatPaginator = {
  __typename?: 'BoatPaginator';
  /** A list of Boat items. */
  data: Array<Boat>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type BoatsWidgetResponse = {
  __typename?: 'BoatsWidgetResponse';
  boats?: Maybe<WidgetResponse>;
};

export type BreadcrumbFolder = {
  __typename?: 'BreadcrumbFolder';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CanShareResponse = {
  __typename?: 'CanShareResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Capacity = {
  capacity: Scalars['Float']['output'];
};

export type CapacityInput = {
  capacity: Scalars['Float']['input'];
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['ID']['output'];
  is_user_defined: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
};

/** A paginated list of Category items. */
export type CategoryPaginator = {
  __typename?: 'CategoryPaginator';
  /** A list of Category items. */
  data: Array<Category>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Channel = {
  __typename?: 'Channel';
  _integrationId?: Maybe<Scalars['String']['output']>;
  credentials?: Maybe<Credentials>;
  providerId?: Maybe<Scalars['String']['output']>;
};

export type Checklist = {
  __typename?: 'Checklist';
  belongs_to_current_user: Scalars['Boolean']['output'];
  can_add_comment: Scalars['Boolean']['output'];
  can_copy: Scalars['Boolean']['output'];
  can_create_new_item: Scalars['Boolean']['output'];
  can_delete: Scalars['Boolean']['output'];
  can_follow: Scalars['Boolean']['output'];
  can_share?: Maybe<Scalars['Boolean']['output']>;
  can_sort_items: Scalars['Boolean']['output'];
  can_unfollow: Scalars['Boolean']['output'];
  can_update: Scalars['Boolean']['output'];
  can_view: Scalars['Boolean']['output'];
  can_view_blocked_users: Scalars['Boolean']['output'];
  can_view_comments: Scalars['Boolean']['output'];
  can_view_followers: Scalars['Boolean']['output'];
  category_id?: Maybe<Scalars['ID']['output']>;
  clones_count?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  comments_count?: Maybe<Scalars['Int']['output']>;
  costs?: Maybe<Array<Maybe<Cost>>>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expenses?: Maybe<Array<Maybe<Expense>>>;
  fields?: Maybe<Array<Maybe<FieldValue>>>;
  files?: Maybe<Array<Maybe<File>>>;
  id: Scalars['ID']['output'];
  image?: Maybe<File>;
  image_id?: Maybe<Scalars['ID']['output']>;
  is_followed_by_current_user: Scalars['Boolean']['output'];
  is_public: Scalars['Boolean']['output'];
  items?: Maybe<Array<Maybe<ChecklistItem>>>;
  logs?: Maybe<Array<Maybe<Log>>>;
  old_image?: Maybe<File>;
  old_image_id?: Maybe<Scalars['ID']['output']>;
  parent?: Maybe<Checklist>;
  publishable?: Maybe<Scalars['Boolean']['output']>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  title: Scalars['String']['output'];
  trips?: Maybe<Array<Maybe<Trip>>>;
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  user_followers_count?: Maybe<Scalars['Int']['output']>;
};

export type ChecklistItem = {
  __typename?: 'ChecklistItem';
  can_check: Scalars['Boolean']['output'];
  can_delete: Scalars['Boolean']['output'];
  can_update: Scalars['Boolean']['output'];
  checked: Scalars['Boolean']['output'];
  checklist: Checklist;
  checklist_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ChecklistItemInput = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};

/** A paginated list of Checklist items. */
export type ChecklistPaginator = {
  __typename?: 'ChecklistPaginator';
  /** A list of Checklist items. */
  data: Array<Checklist>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ChecklistUser = {
  __typename?: 'ChecklistUser';
  code: Scalars['String']['output'];
  display_name: Scalars['String']['output'];
  email: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of ChecklistUser items. */
export type ChecklistUserPaginator = {
  __typename?: 'ChecklistUserPaginator';
  /** A list of ChecklistUser items. */
  data: Array<ChecklistUser>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Checklistable = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  cancel_url?: Maybe<Scalars['String']['output']>;
  client_secret?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  return_url?: Maybe<Scalars['String']['output']>;
  success_url?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CheckoutSessionResponse = {
  __typename?: 'CheckoutSessionResponse';
  plan_id?: Maybe<Scalars['ID']['output']>;
  plan_name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  renewal_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
};

export type ChunkUpload = {
  __typename?: 'ChunkUpload';
  chunk_uploaded?: Maybe<Scalars['Boolean']['output']>;
  file?: Maybe<File>;
};

export type Comment = {
  __typename?: 'Comment';
  can_delete: Scalars['Boolean']['output'];
  can_like: Scalars['Boolean']['output'];
  can_unlike: Scalars['Boolean']['output'];
  can_update: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  created_at_diff: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  like_count?: Maybe<Scalars['Int']['output']>;
  replies?: Maybe<Array<Maybe<Comment>>>;
  text: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_at_diff: Scalars['String']['output'];
  user?: Maybe<User>;
};

/** A paginated list of Comment items. */
export type CommentPaginator = {
  __typename?: 'CommentPaginator';
  /** A list of Comment items. */
  data: Array<Comment>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Condition = {
  conjunction: Conjunction;
  filter?: InputMaybe<Filter>;
  operator?: InputMaybe<Operator>;
};

export enum Conjunction {
  Orwhere = 'ORWHERE',
  Orwherenot = 'ORWHERENOT',
  Where = 'WHERE',
  Wherenot = 'WHERENOT',
}

export type Cost = {
  __typename?: 'Cost';
  amount?: Maybe<Scalars['Float']['output']>;
  boat_detail?: Maybe<BoatDetails>;
  boat_detail_id?: Maybe<Scalars['ID']['output']>;
  can_delete?: Maybe<Scalars['Boolean']['output']>;
  can_update?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Category>;
  category_id?: Maybe<Scalars['ID']['output']>;
  checklists?: Maybe<Array<Maybe<Checklist>>>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  created_at: Scalars['DateTime']['output'];
  currency?: Maybe<Currency>;
  currency_id: Scalars['ID']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  documents?: Maybe<Array<Maybe<File>>>;
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  expenses?: Maybe<Array<Maybe<Expense>>>;
  fields?: Maybe<Array<Maybe<FieldValue>>>;
  files?: Maybe<Array<Maybe<File>>>;
  id: Scalars['ID']['output'];
  is_maintenance_cost?: Maybe<Scalars['Boolean']['output']>;
  logs?: Maybe<Array<Maybe<Log>>>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  supplier?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  trips?: Maybe<Array<Maybe<Trip>>>;
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  user_id: Scalars['ID']['output'];
  vat_percentage?: Maybe<Scalars['Int']['output']>;
  vat_type?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Cost items. */
export type CostPaginator = {
  __typename?: 'CostPaginator';
  /** A list of Cost items. */
  data: Array<Cost>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Costable = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type Country = {
  __typename?: 'Country';
  id: Scalars['ID']['output'];
  iso_code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numcode?: Maybe<Scalars['Int']['output']>;
  phonecode?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of Country items. */
export type CountryPaginator = {
  __typename?: 'CountryPaginator';
  /** A list of Country items. */
  data: Array<Country>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum CreationType {
  Autologged = 'AUTOLOGGED',
  Generated = 'GENERATED',
  ManuAl = 'MANUAl',
}

export type Credentials = {
  __typename?: 'Credentials';
  deviceTokens?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Currency = {
  __typename?: 'Currency';
  id?: Maybe<Scalars['ID']['output']>;
  is_default?: Maybe<Scalars['String']['output']>;
  iso_code?: Maybe<Scalars['String']['output']>;
  iso_code_num?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Currency items. */
export type CurrencyPaginator = {
  __typename?: 'CurrencyPaginator';
  /** A list of Currency items. */
  data: Array<Currency>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type DefaultSettings = {
  __typename?: 'DefaultSettings';
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  automatic_tax: AutomaticTax;
  billing_cycle_anchor: Scalars['String']['output'];
  billing_thresholds?: Maybe<Scalars['JSON']['output']>;
  collection_method: Scalars['String']['output'];
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  issuer?: Maybe<Issuer>;
  on_behalf_of?: Maybe<Scalars['String']['output']>;
  transfer_data?: Maybe<Scalars['String']['output']>;
};

export type Dynamic = {
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Engine = {
  __typename?: 'Engine';
  boat_detail_id?: Maybe<Scalars['ID']['output']>;
  drive?: Maybe<Scalars['String']['output']>;
  fuel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maker?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  power?: Maybe<Scalars['String']['output']>;
  power_type?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type EngineInput = {
  drive?: InputMaybe<Scalars['String']['input']>;
  fuel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  maker?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  power?: InputMaybe<Scalars['String']['input']>;
  power_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type EngineLog = {
  __typename?: 'EngineLog';
  datetime?: Maybe<Scalars['DateTime']['output']>;
  engine_id: Scalars['Int']['output'];
  exhaust_check?: Maybe<Scalars['Boolean']['output']>;
  fuel_check?: Maybe<Scalars['Boolean']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  log_id?: Maybe<Scalars['Int']['output']>;
  oil_check?: Maybe<Scalars['Boolean']['output']>;
  rpm?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  water_check?: Maybe<Scalars['Boolean']['output']>;
};

export type EngineLogInput = {
  engine_id: Scalars['Int']['input'];
  exhaust_check?: InputMaybe<Scalars['Boolean']['input']>;
  fuel_check?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  oil_check?: InputMaybe<Scalars['Boolean']['input']>;
  rpm?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  water_check?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Expense = {
  __typename?: 'Expense';
  acquisition_date?: Maybe<Scalars['String']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  boat_detail?: Maybe<BoatDetails>;
  boat_detail_id: Scalars['ID']['output'];
  brand?: Maybe<Scalars['String']['output']>;
  can_delete?: Maybe<Scalars['Boolean']['output']>;
  can_share?: Maybe<Scalars['Boolean']['output']>;
  can_update?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Category>;
  category_id?: Maybe<Scalars['ID']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  consumption?: Maybe<Scalars['Float']['output']>;
  converted_total?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Cost>;
  costs?: Maybe<Array<Maybe<Cost>>>;
  created_at: Scalars['DateTime']['output'];
  current_usage_value?: Maybe<Scalars['Float']['output']>;
  depth?: Maybe<Scalars['Float']['output']>;
  due_date_time_unit?: Maybe<Scalars['Int']['output']>;
  due_date_time_unit_type?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['String']['output']>;
  expiration_is_custom?: Maybe<Scalars['Boolean']['output']>;
  expiration_time_unit?: Maybe<Scalars['Int']['output']>;
  expiration_time_unit_type?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<FieldValue>>>;
  files?: Maybe<Array<Maybe<File>>>;
  has_cost?: Maybe<Scalars['Boolean']['output']>;
  has_due_date_reminder?: Maybe<Scalars['Boolean']['output']>;
  has_expiration_reminder?: Maybe<Scalars['Boolean']['output']>;
  has_minimum_quantity_reminder?: Maybe<Scalars['Boolean']['output']>;
  has_threshold_reminder?: Maybe<Scalars['Boolean']['output']>;
  has_usage_reminder?: Maybe<Scalars['Boolean']['output']>;
  has_warranty_reminder?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  imported_at?: Maybe<Scalars['DateTime']['output']>;
  is_recurring?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Item>;
  item_id: Scalars['ID']['output'];
  item_name?: Maybe<Scalars['String']['output']>;
  linked_expenses?: Maybe<Array<Maybe<Expense>>>;
  linked_expenses_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  location?: Maybe<Scalars['String']['output']>;
  location_data?: Maybe<Location>;
  location_id?: Maybe<Scalars['ID']['output']>;
  logs?: Maybe<Array<Maybe<Log>>>;
  maintenance_synced?: Maybe<Scalars['Boolean']['output']>;
  minimum_quantity?: Maybe<Scalars['Float']['output']>;
  minimum_quantity_reminder?: Maybe<Scalars['Float']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  packing?: Maybe<Scalars['String']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  pivot?: Maybe<ExpensePivot>;
  quantity?: Maybe<Scalars['Float']['output']>;
  recurrence_type?: Maybe<Scalars['String']['output']>;
  serial_number?: Maybe<Scalars['String']['output']>;
  sub_locations?: Maybe<Array<Maybe<SubLocation>>>;
  sub_locations_data?: Maybe<Array<Maybe<Location>>>;
  supplier?: Maybe<Scalars['String']['output']>;
  supplier_contact?: Maybe<Scalars['String']['output']>;
  supplier_url?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  threshold_recurrence_reminder?: Maybe<Scalars['Float']['output']>;
  threshold_reminder_value?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  unit_price_currency?: Maybe<Currency>;
  unit_price_currency_id?: Maybe<Scalars['ID']['output']>;
  updated_at: Scalars['DateTime']['output'];
  usage_due_date?: Maybe<Scalars['String']['output']>;
  usage_is_custom?: Maybe<Scalars['Boolean']['output']>;
  usage_recurrence?: Maybe<Scalars['Float']['output']>;
  usage_recurrence_time_unit?: Maybe<Scalars['Int']['output']>;
  usage_recurrence_time_unit_type?: Maybe<Scalars['String']['output']>;
  usage_threshold?: Maybe<Scalars['Float']['output']>;
  usage_time_unit?: Maybe<Scalars['Int']['output']>;
  usage_time_unit_type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  user_id: Scalars['ID']['output'];
  vendor_page?: Maybe<Scalars['String']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
  warranty_date?: Maybe<Scalars['String']['output']>;
  warranty_is_custom?: Maybe<Scalars['Boolean']['output']>;
  warranty_time_unit?: Maybe<Scalars['Int']['output']>;
  warranty_time_unit_type?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

/** A paginated list of Expense items. */
export type ExpensePaginator = {
  __typename?: 'ExpensePaginator';
  /** A list of Expense items. */
  data: Array<Expense>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ExpensePivot = {
  __typename?: 'ExpensePivot';
  quantity?: Maybe<Scalars['Int']['output']>;
  quantity_action?: Maybe<Scalars['String']['output']>;
  usage_log_name?: Maybe<Scalars['String']['output']>;
  usage_value?: Maybe<Scalars['Float']['output']>;
};

export type ExpensesWidgetResponse = {
  __typename?: 'ExpensesWidgetResponse';
  expenses?: Maybe<WidgetResponse>;
};

export type Favoritable = Boat | BoatDetails;

export type Favorite = {
  __typename?: 'Favorite';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  favoritable?: Maybe<Favoritable>;
  favoritable_id: Scalars['String']['output'];
  favoritable_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id: Scalars['ID']['output'];
};

/** A paginated list of Favorite items. */
export type FavoritePaginator = {
  __typename?: 'FavoritePaginator';
  /** A list of Favorite items. */
  data: Array<Favorite>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/**
 * Available filter types when searching or fetchin featured boats.
 * This has a limit of 8, ordered by latest  by default.
 */
export enum FeaturedType {
  Activity = 'ACTIVITY',
  Category = 'CATEGORY',
  HullMaterial = 'HULL_MATERIAL',
  HullType = 'HULL_TYPE',
  Maker = 'MAKER',
  Type = 'TYPE',
}

export type Field = {
  __typename?: 'Field';
  id: Scalars['ID']['output'];
  module?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Scalars['String']['output']>;
  options_data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['ID']['output'];
};

export type FieldInput = {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FieldValue = {
  __typename?: 'FieldValue';
  id: Scalars['ID']['output'];
  module?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type File = {
  __typename?: 'File';
  alt?: Maybe<Scalars['String']['output']>;
  app_path?: Maybe<Scalars['String']['output']>;
  boat_detail?: Maybe<BoatDetails>;
  boat_detail_id?: Maybe<Scalars['ID']['output']>;
  can_clone?: Maybe<Scalars['Boolean']['output']>;
  can_delete?: Maybe<Scalars['Boolean']['output']>;
  can_share?: Maybe<Scalars['Boolean']['output']>;
  can_update?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  custom_properties?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimensions?: Maybe<Scalars['String']['output']>;
  disk: Scalars['String']['output'];
  download_url?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['DateTime']['output']>;
  expiration_date_time_unit?: Maybe<Scalars['Int']['output']>;
  expiration_date_time_unit_type?: Maybe<Scalars['String']['output']>;
  extension: Scalars['String']['output'];
  fields?: Maybe<Array<Maybe<FieldValue>>>;
  filename?: Maybe<Scalars['String']['output']>;
  folder?: Maybe<Folder>;
  folder_id?: Maybe<Scalars['ID']['output']>;
  has_expiration_date_reminder?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  issuance_date?: Maybe<Scalars['DateTime']['output']>;
  issued_by?: Maybe<Scalars['String']['output']>;
  linked_records?: Maybe<Array<Maybe<Fileable>>>;
  mime_type: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  public_url?: Maybe<Scalars['String']['output']>;
  size: Scalars['String']['output'];
  size_in_kb?: Maybe<Scalars['String']['output']>;
  total_linked_records?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uploaded_time?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']['output']>;
  visibility: Scalars['String']['output'];
};

/** A paginated list of File items. */
export type FilePaginator = {
  __typename?: 'FilePaginator';
  /** A list of File items. */
  data: Array<File>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Fileable = {
  __typename?: 'Fileable';
  display_name?: Maybe<Scalars['String']['output']>;
  fileable_id: Scalars['ID']['output'];
  fileable_type: Scalars['String']['output'];
};

export type FileableInput = {
  fileable_id: Scalars['ID']['input'];
  fileable_type: Scalars['String']['input'];
};

export type Filter = {
  conditions?: InputMaybe<Array<InputMaybe<Condition>>>;
};

export type Folder = {
  __typename?: 'Folder';
  breadcrumb_folders?: Maybe<Array<Maybe<BreadcrumbFolder>>>;
  can_delete?: Maybe<Scalars['Boolean']['output']>;
  can_share?: Maybe<Scalars['Boolean']['output']>;
  can_update?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  files_count?: Maybe<Scalars['Int']['output']>;
  folders_count?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Folder>;
  parent_id?: Maybe<Scalars['ID']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of Folder items. */
export type FolderPaginator = {
  __typename?: 'FolderPaginator';
  /** A list of Folder items. */
  data: Array<Folder>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type FuelTank = Capacity & {
  __typename?: 'FuelTank';
  capacity: Scalars['Float']['output'];
};

export type Genoa = Dynamic & {
  __typename?: 'Genoa';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GroupedExpensesWidgetResponse = {
  __typename?: 'GroupedExpensesWidgetResponse';
  color?: Maybe<Scalars['String']['output']>;
  highlight?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type HeadSail = Dynamic & {
  __typename?: 'HeadSail';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type HoldingTank = Capacity & {
  __typename?: 'HoldingTank';
  capacity: Scalars['Float']['output'];
};

export type HullAppendages = Dynamic & {
  __typename?: 'HullAppendages';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type InfoModel = {
  __typename?: 'InfoModel';
  activities?: Maybe<Array<Taxonomy>>;
  categories?: Maybe<Array<Taxonomy>>;
  hull_material?: Maybe<Array<Scalars['String']['output']>>;
  hull_type?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<Array<Scalars['String']['output']>>;
};

export type Invite = {
  __typename?: 'Invite';
  created_at: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  registered_at: Scalars['DateTime']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  account_country?: Maybe<Scalars['String']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  account_tax_ids?: Maybe<Scalars['String']['output']>;
  amount_due?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Int']['output']>;
  amount_remaining?: Maybe<Scalars['Int']['output']>;
  amount_shipping?: Maybe<Scalars['Int']['output']>;
  application?: Maybe<Scalars['String']['output']>;
  application_fee_amount?: Maybe<Scalars['String']['output']>;
  attempt_count?: Maybe<Scalars['Int']['output']>;
  attempted?: Maybe<Scalars['Boolean']['output']>;
  auto_advance?: Maybe<Scalars['Boolean']['output']>;
  automatic_tax?: Maybe<AutomaticTax>;
  billing_reason?: Maybe<Scalars['String']['output']>;
  charge?: Maybe<Scalars['String']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  custom_fields?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  customer_address?: Maybe<Scalars['String']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_shipping?: Maybe<Scalars['String']['output']>;
  customer_tax_exempt?: Maybe<Scalars['String']['output']>;
  customer_tax_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  default_tax_rates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  due_date?: Maybe<Scalars['String']['output']>;
  ending_balance?: Maybe<Scalars['String']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  from_invoice?: Maybe<Scalars['String']['output']>;
  hosted_invoice_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoice_pdf?: Maybe<Scalars['String']['output']>;
  issuer?: Maybe<Issuer>;
  last_finalization_error?: Maybe<Scalars['String']['output']>;
  latest_revision?: Maybe<Scalars['String']['output']>;
  lines?: Maybe<InvoiceLineItems>;
  livemode?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  next_payment_attempt?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  on_behalf_of?: Maybe<Scalars['String']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  paid_out_of_band?: Maybe<Scalars['Boolean']['output']>;
  payment_intent?: Maybe<Scalars['String']['output']>;
  payment_settings?: Maybe<PaymentSettings>;
  period_end?: Maybe<Scalars['Int']['output']>;
  period_start?: Maybe<Scalars['Int']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  quote?: Maybe<Scalars['String']['output']>;
  receipt_number?: Maybe<Scalars['String']['output']>;
  rendering_options?: Maybe<Scalars['String']['output']>;
  shipping_cost?: Maybe<Scalars['String']['output']>;
  shipping_details?: Maybe<Scalars['String']['output']>;
  starting_balance?: Maybe<Scalars['Int']['output']>;
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_transitions?: Maybe<StatusTransitions>;
  subscription?: Maybe<Scalars['String']['output']>;
  subscription_proration_date?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  subtotal_excluding_tax?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['String']['output']>;
  tax_percent?: Maybe<Scalars['Float']['output']>;
  test_clock?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  total_discount_amounts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  total_excluding_tax?: Maybe<Scalars['Int']['output']>;
  total_tax_amounts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  transfer_data?: Maybe<Scalars['String']['output']>;
  webhooks_delivered_at?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceLineItems = {
  __typename?: 'InvoiceLineItems';
  data?: Maybe<Array<Maybe<LineItem>>>;
  has_more?: Maybe<Scalars['Boolean']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Issuer = {
  __typename?: 'Issuer';
  address?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Item = {
  __typename?: 'Item';
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_defined: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  taxonomies?: Maybe<Array<Maybe<Taxonomy>>>;
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of Item items. */
export type ItemPaginator = {
  __typename?: 'ItemPaginator';
  /** A list of Item items. */
  data: Array<Item>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ItemsSearchResponse = {
  __typename?: 'ItemsSearchResponse';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Language = {
  __typename?: 'Language';
  id: Scalars['ID']['output'];
  is_rtl?: Maybe<Scalars['Boolean']['output']>;
  iso_code?: Maybe<Scalars['String']['output']>;
  language_code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Language items. */
export type LanguagePaginator = {
  __typename?: 'LanguagePaginator';
  /** A list of Language items. */
  data: Array<Language>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Limit = {
  __typename?: 'Limit';
  is_allowed?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['Float']['output']>;
};

export type LineItem = {
  __typename?: 'LineItem';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_amounts?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  discountable?: Maybe<Scalars['Boolean']['output']>;
  discounts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  invoice_item?: Maybe<Scalars['String']['output']>;
  livemode?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Period>;
  plan?: Maybe<SubscriptionPlan>;
  price?: Maybe<Price>;
  proration?: Maybe<Scalars['Boolean']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  subscription?: Maybe<Scalars['String']['output']>;
  subscription_item?: Maybe<Scalars['String']['output']>;
  tax_amounts?: Maybe<Array<Maybe<TaxAmount>>>;
  tax_rates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Location = {
  __typename?: 'Location';
  id: Scalars['ID']['output'];
  is_sub_location?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
};

/** A paginated list of Location items. */
export type LocationPaginator = {
  __typename?: 'LocationPaginator';
  /** A list of Location items. */
  data: Array<Location>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Log = {
  __typename?: 'Log';
  air_temp?: Maybe<Scalars['Float']['output']>;
  bar?: Maybe<Scalars['Float']['output']>;
  battery1?: Maybe<Scalars['Float']['output']>;
  battery2?: Maybe<Scalars['Float']['output']>;
  bilge?: Maybe<Scalars['Boolean']['output']>;
  boat_detail?: Maybe<BoatDetails>;
  boat_detail_id?: Maybe<Scalars['ID']['output']>;
  boat_water?: Maybe<Scalars['Float']['output']>;
  can_delete?: Maybe<Scalars['Boolean']['output']>;
  can_update?: Maybe<Scalars['Boolean']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Category>;
  category_id?: Maybe<Scalars['ID']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  cog?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  cost?: Maybe<Cost>;
  costs?: Maybe<Array<Maybe<Cost>>>;
  created_at: Scalars['DateTime']['output'];
  creation_type?: Maybe<Scalars['String']['output']>;
  creator_agent_name?: Maybe<Scalars['String']['output']>;
  datetime?: Maybe<Scalars['String']['output']>;
  depth?: Maybe<Scalars['Float']['output']>;
  diesel_generator_exhaust_check?: Maybe<Scalars['Boolean']['output']>;
  diesel_generator_fuel_check?: Maybe<Scalars['Boolean']['output']>;
  diesel_generator_hours?: Maybe<Scalars['Float']['output']>;
  diesel_generator_oil_check?: Maybe<Scalars['Boolean']['output']>;
  diesel_generator_rpm?: Maybe<Scalars['Int']['output']>;
  diesel_generator_status?: Maybe<Scalars['Boolean']['output']>;
  diesel_generator_water_check?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use engine logs type */
  engine_exhaust_check1?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use engine logs type */
  engine_exhaust_check2?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use engine logs type */
  engine_fuel_check1?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use engine logs type */
  engine_fuel_check2?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use engine logs type */
  engine_hours1?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use engine logs type */
  engine_hours2?: Maybe<Scalars['Float']['output']>;
  engine_logs?: Maybe<Array<Maybe<EngineLog>>>;
  /** @deprecated use engine logs type */
  engine_oil_check1?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use engine logs type */
  engine_oil_check2?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use engine logs type */
  engine_rpm1?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use engine logs type */
  engine_rpm2?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use engine logs type */
  engine_status1?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use engine logs type */
  engine_status2?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use engine logs type */
  engine_water_check1?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use engine logs type */
  engine_water_check2?: Maybe<Scalars['Boolean']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  expenses?: Maybe<Array<Maybe<Expense>>>;
  fields?: Maybe<Array<Maybe<FieldValue>>>;
  files?: Maybe<Array<Maybe<File>>>;
  fuel?: Maybe<Scalars['Float']['output']>;
  gas?: Maybe<Scalars['Float']['output']>;
  heading?: Maybe<Scalars['Int']['output']>;
  helm?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imminent?: Maybe<Scalars['String']['output']>;
  later?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  log?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outlook?: Maybe<Scalars['String']['output']>;
  pivot?: Maybe<ExpensePivot>;
  precipitation?: Maybe<Scalars['String']['output']>;
  sails?: Maybe<Scalars['String']['output']>;
  sea_area?: Maybe<Scalars['String']['output']>;
  sea_state?: Maybe<Scalars['Int']['output']>;
  sea_temp?: Maybe<Scalars['Float']['output']>;
  sky?: Maybe<Scalars['Int']['output']>;
  sog?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
  station?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  trip?: Maybe<Trip>;
  trip_id?: Maybe<Scalars['ID']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  user_id: Scalars['ID']['output'];
  visibility?: Maybe<Scalars['Float']['output']>;
  wind_direction?: Maybe<Scalars['Int']['output']>;
  wind_speed?: Maybe<Scalars['Float']['output']>;
};

/** A paginated list of Log items. */
export type LogPaginator = {
  __typename?: 'LogPaginator';
  /** A list of Log items. */
  data: Array<Log>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  popup?: Maybe<Popup>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type LogsWidgetResponse = {
  __typename?: 'LogsWidgetResponse';
  percentage?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MainSail = Dynamic & {
  __typename?: 'MainSail';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Manufacturer = {
  __typename?: 'Manufacturer';
  id?: Maybe<Scalars['ID']['output']>;
  logo?: Maybe<File>;
  logo_id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publicBoatCount: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Manufacturer items. */
export type ManufacturerPaginator = {
  __typename?: 'ManufacturerPaginator';
  /** A list of Manufacturer items. */
  data: Array<Manufacturer>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type MassDeleteResponse = {
  __typename?: 'MassDeleteResponse';
  deleted?: Maybe<Scalars['String']['output']>;
  notDeleted?: Maybe<Scalars['String']['output']>;
};

export type Mention = {
  __typename?: 'Mention';
  id?: Maybe<Scalars['ID']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
};

export enum ModeEnum {
  Embedded = 'embedded',
  Redirect = 'redirect',
}

export enum ModuleType {
  BoatDetails = 'boat_details',
  Checklist = 'checklist',
  Cost = 'cost',
  Expense = 'expense',
  File = 'file',
  Log = 'log',
  Task = 'task',
  Trip = 'trip',
}

export type Mutation = {
  __typename?: 'Mutation';
  addToFavorite: Boat;
  assignLicense?: Maybe<Plan>;
  /** @deprecated Use blockForUser mutation */
  blockChecklistFollower?: Maybe<Scalars['Boolean']['output']>;
  blockForUser?: Maybe<Scalars['Boolean']['output']>;
  boatsAutocomplete?: Maybe<Array<Maybe<BoatAutocomplete>>>;
  boatsWidget?: Maybe<BoatsWidgetResponse>;
  canLinkTo?: Maybe<Scalars['Boolean']['output']>;
  canShareTo?: Maybe<CanShareResponse>;
  cancelScheduledUpdate?: Maybe<Scalars['Boolean']['output']>;
  cancelSubscription?: Maybe<Scalars['Boolean']['output']>;
  changeChecklistItemsPosition?: Maybe<Scalars['Boolean']['output']>;
  changePassword?: Maybe<Scalars['Boolean']['output']>;
  changeQuantity?: Maybe<Scalars['Boolean']['output']>;
  checkChecklistItem?: Maybe<ChecklistItem>;
  cloneFile?: Maybe<File>;
  collaborators?: Maybe<Array<Maybe<User>>>;
  completeTask?: Maybe<Scalars['Boolean']['output']>;
  copyChecklist?: Maybe<Checklist>;
  deactivateUser?: Maybe<Scalars['Boolean']['output']>;
  deleteBoatDetails?: Maybe<Scalars['Boolean']['output']>;
  deleteCategory?: Maybe<Scalars['Boolean']['output']>;
  deleteChecklist?: Maybe<Scalars['Boolean']['output']>;
  deleteChecklistComment?: Maybe<Scalars['Boolean']['output']>;
  deleteChecklistItem?: Maybe<Scalars['Boolean']['output']>;
  deleteComment?: Maybe<Scalars['Boolean']['output']>;
  deleteCost?: Maybe<Scalars['Boolean']['output']>;
  deleteExpense?: Maybe<Scalars['Boolean']['output']>;
  deleteField?: Maybe<Scalars['Boolean']['output']>;
  deleteFile?: Maybe<Scalars['Boolean']['output']>;
  deleteFolder?: Maybe<Scalars['Boolean']['output']>;
  deleteLocation?: Maybe<Scalars['Boolean']['output']>;
  deleteLog?: Maybe<Scalars['Boolean']['output']>;
  deleteShare?: Maybe<Scalars['Boolean']['output']>;
  deleteTask?: Maybe<Scalars['Boolean']['output']>;
  deleteTrip?: Maybe<Scalars['Boolean']['output']>;
  deleteTripCoordinates?: Maybe<TripDeleteCoordinatesResponse>;
  downgradePlan?: Maybe<Scalars['Boolean']['output']>;
  expensesWidget?: Maybe<ExpensesWidgetResponse>;
  filteredLinkableModels?: Maybe<Array<Maybe<Fileable>>>;
  finishTrip?: Maybe<Scalars['Boolean']['output']>;
  followChecklist?: Maybe<Scalars['Boolean']['output']>;
  fullDeleteBoatDetails?: Maybe<Scalars['Boolean']['output']>;
  fullStoreBoatDetails?: Maybe<Boat>;
  fullUpdateBoatDetails?: Maybe<Boat>;
  generateCheckoutSession?: Maybe<CheckoutSession>;
  generatePortalSession?: Maybe<Scalars['String']['output']>;
  getTripCoordinates?: Maybe<Array<Maybe<TripCoordinatesResponse>>>;
  getUserNotificationSettings?: Maybe<Scalars['JSON']['output']>;
  groupedExpensesWidget?: Maybe<Array<Maybe<GroupedExpensesWidgetResponse>>>;
  likeComment?: Maybe<Scalars['Boolean']['output']>;
  linkModelsToFile?: Maybe<Array<Maybe<Fileable>>>;
  logOutOfOtherSessions?: Maybe<Scalars['Boolean']['output']>;
  login?: Maybe<LoginResponse>;
  logout?: Maybe<Scalars['Boolean']['output']>;
  logoutEverywhere?: Maybe<Scalars['Boolean']['output']>;
  logsWidget?: Maybe<Array<Maybe<LogsWidgetResponse>>>;
  markAlertAsDone?: Maybe<Alert>;
  massDeleteBoatDetails?: Maybe<MassDeleteResponse>;
  massDeleteCategories?: Maybe<MassDeleteResponse>;
  massDeleteChecklists?: Maybe<MassDeleteResponse>;
  massDeleteCosts?: Maybe<MassDeleteResponse>;
  massDeleteExpenses?: Maybe<MassDeleteResponse>;
  massDeleteFiles?: Maybe<MassDeleteResponse>;
  massDeleteFolders?: Maybe<MassDeleteResponse>;
  massDeleteLocations?: Maybe<MassDeleteResponse>;
  massDeleteLogs?: Maybe<MassDeleteResponse>;
  massDeleteShares?: Maybe<MassDeleteResponse>;
  massDeleteTasks?: Maybe<MassDeleteResponse>;
  massDeleteTrips?: Maybe<MassDeleteResponse>;
  massMove?: Maybe<Folder>;
  refreshAuthToken?: Maybe<Scalars['String']['output']>;
  register?: Maybe<User>;
  removeFromFavorite?: Maybe<Scalars['Boolean']['output']>;
  removeLicense?: Maybe<BoatDetails>;
  resendInvite?: Maybe<Scalars['Boolean']['output']>;
  resendVerificationEmail?: Maybe<ResendVerificationEmailResponse>;
  resetSubscription?: Maybe<Scalars['Boolean']['output']>;
  resetTrial?: Maybe<Scalars['Boolean']['output']>;
  resumeSubscription?: Maybe<Scalars['Boolean']['output']>;
  retrieveSessionData?: Maybe<CheckoutSessionResponse>;
  retriveCheckoutData?: Maybe<Plan>;
  revokeAccess?: Maybe<Array<Maybe<Share>>>;
  searchItems?: Maybe<Array<Maybe<ItemsSearchResponse>>>;
  shareItem?: Maybe<Array<Maybe<Share>>>;
  sharedWith?: Maybe<Array<Maybe<Share>>>;
  storeBoatDetails?: Maybe<BoatDetails>;
  storeBulkLog?: Maybe<Array<Maybe<Log>>>;
  storeCategory?: Maybe<Category>;
  storeChecklist?: Maybe<Checklist>;
  /** @deprecated use storeComment */
  storeChecklistComment?: Maybe<Comment>;
  storeChecklistItem?: Maybe<ChecklistItem>;
  storeComment?: Maybe<Comment>;
  storeCost?: Maybe<Cost>;
  /** @deprecated use storeComment mutation */
  storeCostComment?: Maybe<Comment>;
  storeExpense?: Maybe<Expense>;
  /** @deprecated use storeComment mutation */
  storeExpenseComment?: Maybe<Comment>;
  storeField?: Maybe<Field>;
  storeFolder?: Maybe<Folder>;
  storeLocation?: Maybe<Location>;
  storeLog?: Maybe<Log>;
  /** @deprecated use storeComment mutation */
  storeLogComment?: Maybe<Comment>;
  storeTask?: Maybe<Task>;
  /** @deprecated use storeComment mutation */
  storeTaskComment?: Maybe<Comment>;
  storeTrip?: Maybe<Trip>;
  submitTripCoordinates?: Maybe<TripSubmitCoordinatesResponse>;
  swapSubscriptionPrice?: Maybe<Scalars['Boolean']['output']>;
  switchTripAutologging?: Maybe<TripAutologResponse>;
  tasksWidget?: Maybe<TasksWidgetResponse>;
  tripsChartWidget?: Maybe<Array<Maybe<TripsChartWidgetResponse>>>;
  tripsWidget?: Maybe<TripsWidgetResponse>;
  /** @deprecated Use unblockForUser mutation */
  unblockChecklistFollower?: Maybe<Scalars['Boolean']['output']>;
  unblockForUser?: Maybe<Scalars['Boolean']['output']>;
  unfollowChecklist?: Maybe<Scalars['Boolean']['output']>;
  unlikeComment?: Maybe<Scalars['Boolean']['output']>;
  unlinkModelsFromFile?: Maybe<Array<Maybe<Fileable>>>;
  updateAlert?: Maybe<Alert>;
  updateAuthUser?: Maybe<UserData>;
  updateBoatDetails?: Maybe<BoatDetails>;
  updateCategory?: Maybe<Category>;
  updateChecklist?: Maybe<Checklist>;
  updateChecklistComment?: Maybe<Comment>;
  updateChecklistItem?: Maybe<ChecklistItem>;
  updateComment?: Maybe<Comment>;
  updateCost?: Maybe<Cost>;
  updateExpense?: Maybe<Expense>;
  updateField?: Maybe<Field>;
  updateFile?: Maybe<File>;
  updateFolder?: Maybe<Folder>;
  updateLocation?: Maybe<Location>;
  updateLog?: Maybe<Log>;
  updateNovuSubscriberCredentials?: Maybe<NovuSubscriber>;
  updateOrCreateAddress?: Maybe<Address>;
  /**
   * Set a setting for a user,
   * creates new record if doesn't exist
   * updates existing by key
   * @deprecated No longer supported
   */
  updateSetting?: Maybe<Setting>;
  /** @deprecated Use shareItem */
  updateShare?: Maybe<Share>;
  updateTask?: Maybe<Task>;
  updateTrip?: Maybe<Trip>;
  updateUserNotification?: Maybe<Scalars['Boolean']['output']>;
  updateUserNovuPreferences?: Maybe<Scalars['JSON']['output']>;
  /** Updates User Settings */
  updateUserSettings?: Maybe<Array<Maybe<Setting>>>;
  upgradePlan?: Maybe<Scalars['Boolean']['output']>;
  upload?: Maybe<File>;
  uploadChunk?: Maybe<ChunkUpload>;
  usageDone?: Maybe<Expense>;
  validateFileSize?: Maybe<UploadCheck>;
};

export type MutationAddToFavoriteArgs = {
  boat_id: Scalars['ID']['input'];
};

export type MutationAssignLicenseArgs = {
  boat_details_ids: Array<Scalars['ID']['input']>;
  plan_id?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationBlockChecklistFollowerArgs = {
  checklist_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};

export type MutationBlockForUserArgs = {
  blockable_id: Scalars['ID']['input'];
  blocker_id: Scalars['ID']['input'];
  blocker_type: Scalars['String']['input'];
};

export type MutationBoatsAutocompleteArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type MutationBoatsWidgetArgs = {
  boat_detail_id: Scalars['ID']['input'];
};

export type MutationCanLinkToArgs = {
  fileable: FileableInput;
  id: Scalars['ID']['input'];
};

export type MutationCanShareToArgs = {
  user: Scalars['String']['input'];
};

export type MutationCancelSubscriptionArgs = {
  plan_id: Scalars['ID']['input'];
};

export type MutationChangeChecklistItemsPositionArgs = {
  checklist_id: Scalars['ID']['input'];
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type MutationChangePasswordArgs = {
  confirm_password: Scalars['String']['input'];
  new_password: Scalars['String']['input'];
  old_password: Scalars['String']['input'];
};

export type MutationChangeQuantityArgs = {
  plan_id: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCheckChecklistItemArgs = {
  checked: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationCloneFileArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCollaboratorsArgs = {
  model_id: Scalars['ID']['input'];
  model_type: Scalars['String']['input'];
};

export type MutationCompleteTaskArgs = {
  id: Scalars['ID']['input'];
  marked_as_maintenance?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCopyChecklistArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteBoatDetailsArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCategoryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteChecklistArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteChecklistCommentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteChecklistItemArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCommentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationDeleteCostArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteExpenseArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteFieldArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteFileArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteFolderArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteLocationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteLogArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteShareArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteTaskArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteTripArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteTripCoordinatesArgs = {
  id: Scalars['ID']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  submitted_at?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationDowngradePlanArgs = {
  plan_id: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationExpensesWidgetArgs = {
  boat_detail_id: Scalars['ID']['input'];
};

export type MutationFilteredLinkableModelsArgs = {
  file_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationFinishTripArgs = {
  datetime?: InputMaybe<Scalars['String']['input']>;
  destinationName?: InputMaybe<Scalars['String']['input']>;
  engine_logs?: InputMaybe<Array<InputMaybe<EngineLogInput>>>;
  id: Scalars['ID']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationFollowChecklistArgs = {
  id: Scalars['ID']['input'];
};

export type MutationFullDeleteBoatDetailsArgs = {
  boat_detail_id: Scalars['ID']['input'];
};

export type MutationFullStoreBoatDetailsArgs = {
  activities?: InputMaybe<Array<Scalars['Int']['input']>>;
  activity?: InputMaybe<Scalars['String']['input']>;
  appendages?: InputMaybe<Scalars['String']['input']>;
  ballast_type?: InputMaybe<Scalars['String']['input']>;
  ballast_weight?: InputMaybe<Scalars['Float']['input']>;
  bcl?: InputMaybe<Scalars['Float']['input']>;
  bdcl?: InputMaybe<Scalars['Float']['input']>;
  berths?: InputMaybe<Scalars['Int']['input']>;
  bh?: InputMaybe<Scalars['Float']['input']>;
  boa?: InputMaybe<Scalars['Float']['input']>;
  boatDetails: BoatDetailsInput;
  cabins?: InputMaybe<Scalars['Int']['input']>;
  categories?: InputMaybe<Array<Scalars['Int']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  ce_classification?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  cockpit_location?: InputMaybe<Scalars['String']['input']>;
  cockpit_type?: InputMaybe<Scalars['String']['input']>;
  cruising_speed?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designer_name?: InputMaybe<Scalars['String']['input']>;
  designer_site?: InputMaybe<Scalars['String']['input']>;
  displacement?: InputMaybe<Scalars['Float']['input']>;
  downwind_sail_area?: InputMaybe<Scalars['Float']['input']>;
  draft_max?: InputMaybe<Scalars['Float']['input']>;
  draft_min?: InputMaybe<Scalars['Float']['input']>;
  engine?: InputMaybe<Array<EngineInput>>;
  engine_manufacturer?: InputMaybe<Scalars['String']['input']>;
  engine_manufacturer_b?: InputMaybe<Scalars['String']['input']>;
  engine_manufacturer_site?: InputMaybe<Scalars['String']['input']>;
  engine_manufacturer_site_b?: InputMaybe<Scalars['String']['input']>;
  engine_model?: InputMaybe<Scalars['String']['input']>;
  engine_model_b?: InputMaybe<Scalars['String']['input']>;
  engine_power?: InputMaybe<Scalars['Float']['input']>;
  engine_power_b?: InputMaybe<Scalars['Float']['input']>;
  engine_power_type?: InputMaybe<Scalars['String']['input']>;
  engine_power_type_b?: InputMaybe<Scalars['String']['input']>;
  engine_type?: InputMaybe<Scalars['String']['input']>;
  engine_type_b?: InputMaybe<Scalars['String']['input']>;
  exterior_design?: InputMaybe<Scalars['String']['input']>;
  exterior_site?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  files?: InputMaybe<Array<Scalars['Int']['input']>>;
  fuel_capacity?: InputMaybe<Scalars['Float']['input']>;
  fuel_capacity_tank_b?: InputMaybe<Scalars['Float']['input']>;
  fuel_tank?: InputMaybe<Array<CapacityInput>>;
  genoa?: InputMaybe<Array<FieldInput>>;
  genoa_sail_area_a?: InputMaybe<Scalars['Float']['input']>;
  genoa_sail_area_b?: InputMaybe<Scalars['Float']['input']>;
  genoa_sail_area_c?: InputMaybe<Scalars['Float']['input']>;
  genoa_type_a?: InputMaybe<Scalars['String']['input']>;
  genoa_type_b?: InputMaybe<Scalars['String']['input']>;
  genoa_type_c?: InputMaybe<Scalars['String']['input']>;
  headroom?: InputMaybe<Scalars['Float']['input']>;
  heads?: InputMaybe<Scalars['Int']['input']>;
  headsail?: InputMaybe<Array<FieldInput>>;
  helm?: InputMaybe<Scalars['String']['input']>;
  holding_tank?: InputMaybe<Array<CapacityInput>>;
  holding_tank_capacity?: InputMaybe<Scalars['Float']['input']>;
  hull_appendages?: InputMaybe<Array<FieldInput>>;
  hull_material: Scalars['String']['input'];
  hull_type: Scalars['String']['input'];
  image_id?: InputMaybe<Scalars['ID']['input']>;
  image_path?: InputMaybe<Scalars['Upload']['input']>;
  interior_design?: InputMaybe<Scalars['String']['input']>;
  interior_site?: InputMaybe<Scalars['String']['input']>;
  keel_type?: InputMaybe<Scalars['String']['input']>;
  loa: Scalars['Float']['input'];
  lwl?: InputMaybe<Scalars['Float']['input']>;
  mainsail?: InputMaybe<Array<FieldInput>>;
  manufacturer_id?: InputMaybe<Scalars['ID']['input']>;
  manufacturer_name?: InputMaybe<Scalars['String']['input']>;
  manufacturer_site?: InputMaybe<Scalars['String']['input']>;
  mast?: InputMaybe<Scalars['Float']['input']>;
  mast_configuration?: InputMaybe<Scalars['String']['input']>;
  mast_position?: InputMaybe<Scalars['String']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  model: Scalars['String']['input'];
  nom?: InputMaybe<Scalars['Float']['input']>;
  og_description?: InputMaybe<Scalars['String']['input']>;
  og_image?: InputMaybe<Scalars['Upload']['input']>;
  og_title?: InputMaybe<Scalars['String']['input']>;
  og_url?: InputMaybe<Scalars['String']['input']>;
  plan_id?: InputMaybe<Scalars['ID']['input']>;
  reference_price?: InputMaybe<Scalars['Float']['input']>;
  rigging?: InputMaybe<Scalars['String']['input']>;
  rotating_spars?: InputMaybe<Scalars['Boolean']['input']>;
  rudder?: InputMaybe<Scalars['String']['input']>;
  sail_area?: InputMaybe<Scalars['Float']['input']>;
  sail_area_b?: InputMaybe<Scalars['Float']['input']>;
  sail_area_c?: InputMaybe<Scalars['Float']['input']>;
  sail_area_type_a?: InputMaybe<Scalars['String']['input']>;
  sail_area_type_b?: InputMaybe<Scalars['String']['input']>;
  sail_area_type_c?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  spars?: InputMaybe<Scalars['String']['input']>;
  spinnaker?: InputMaybe<Array<FieldInput>>;
  spinnaker_sail_area_a?: InputMaybe<Scalars['Float']['input']>;
  spinnaker_sail_area_b?: InputMaybe<Scalars['Float']['input']>;
  spinnaker_sail_area_c?: InputMaybe<Scalars['Float']['input']>;
  spinnaker_type_a?: InputMaybe<Scalars['String']['input']>;
  spinnaker_type_b?: InputMaybe<Scalars['String']['input']>;
  spinnaker_type_c?: InputMaybe<Scalars['String']['input']>;
  spreaders_angle?: InputMaybe<Scalars['String']['input']>;
  spreaders_level?: InputMaybe<Scalars['Float']['input']>;
  standing_rigging?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  tonnage_gross?: InputMaybe<Scalars['Float']['input']>;
  tonnage_net?: InputMaybe<Scalars['Float']['input']>;
  top_speed?: InputMaybe<Scalars['Float']['input']>;
  trailerable?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  unsinkable?: InputMaybe<Scalars['Boolean']['input']>;
  upwind_sail_area?: InputMaybe<Scalars['Float']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  water_capacity?: InputMaybe<Scalars['Float']['input']>;
  water_capacity_tank_b?: InputMaybe<Scalars['Float']['input']>;
  water_heater?: InputMaybe<Array<CapacityInput>>;
  water_heater_capacity?: InputMaybe<Scalars['Float']['input']>;
  water_tank?: InputMaybe<Array<CapacityInput>>;
  year?: InputMaybe<Scalars['Int']['input']>;
  year_first?: InputMaybe<Scalars['Int']['input']>;
  year_last?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationFullUpdateBoatDetailsArgs = {
  activities?: InputMaybe<Array<Scalars['Int']['input']>>;
  activity?: InputMaybe<Scalars['String']['input']>;
  appendages?: InputMaybe<Scalars['String']['input']>;
  ballast_type?: InputMaybe<Scalars['String']['input']>;
  ballast_weight?: InputMaybe<Scalars['Float']['input']>;
  bcl?: InputMaybe<Scalars['Float']['input']>;
  bdcl?: InputMaybe<Scalars['Float']['input']>;
  berths?: InputMaybe<Scalars['Int']['input']>;
  bh?: InputMaybe<Scalars['Float']['input']>;
  boa?: InputMaybe<Scalars['Float']['input']>;
  boatDetails: BoatDetailsInput;
  boat_detail_id: Scalars['ID']['input'];
  cabins?: InputMaybe<Scalars['Int']['input']>;
  categories?: InputMaybe<Array<Scalars['Int']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  ce_classification?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  cockpit_location?: InputMaybe<Scalars['String']['input']>;
  cockpit_type?: InputMaybe<Scalars['String']['input']>;
  cruising_speed?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designer_name?: InputMaybe<Scalars['String']['input']>;
  designer_site?: InputMaybe<Scalars['String']['input']>;
  displacement?: InputMaybe<Scalars['Float']['input']>;
  downwind_sail_area?: InputMaybe<Scalars['Float']['input']>;
  draft_max?: InputMaybe<Scalars['Float']['input']>;
  draft_min?: InputMaybe<Scalars['Float']['input']>;
  engine?: InputMaybe<Array<EngineInput>>;
  engine_manufacturer?: InputMaybe<Scalars['String']['input']>;
  engine_manufacturer_b?: InputMaybe<Scalars['String']['input']>;
  engine_manufacturer_site?: InputMaybe<Scalars['String']['input']>;
  engine_manufacturer_site_b?: InputMaybe<Scalars['String']['input']>;
  engine_model?: InputMaybe<Scalars['String']['input']>;
  engine_model_b?: InputMaybe<Scalars['String']['input']>;
  engine_power?: InputMaybe<Scalars['Float']['input']>;
  engine_power_b?: InputMaybe<Scalars['Float']['input']>;
  engine_power_type?: InputMaybe<Scalars['String']['input']>;
  engine_power_type_b?: InputMaybe<Scalars['String']['input']>;
  engine_type?: InputMaybe<Scalars['String']['input']>;
  engine_type_b?: InputMaybe<Scalars['String']['input']>;
  exterior_design?: InputMaybe<Scalars['String']['input']>;
  exterior_site?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  files?: InputMaybe<Array<Scalars['Int']['input']>>;
  fuel_capacity?: InputMaybe<Scalars['Float']['input']>;
  fuel_capacity_tank_b?: InputMaybe<Scalars['Float']['input']>;
  fuel_tank?: InputMaybe<Array<CapacityInput>>;
  genoa?: InputMaybe<Array<FieldInput>>;
  genoa_sail_area_a?: InputMaybe<Scalars['Float']['input']>;
  genoa_sail_area_b?: InputMaybe<Scalars['Float']['input']>;
  genoa_sail_area_c?: InputMaybe<Scalars['Float']['input']>;
  genoa_type_a?: InputMaybe<Scalars['String']['input']>;
  genoa_type_b?: InputMaybe<Scalars['String']['input']>;
  genoa_type_c?: InputMaybe<Scalars['String']['input']>;
  headroom?: InputMaybe<Scalars['Float']['input']>;
  heads?: InputMaybe<Scalars['Int']['input']>;
  headsail?: InputMaybe<Array<FieldInput>>;
  helm?: InputMaybe<Scalars['String']['input']>;
  holding_tank?: InputMaybe<Array<CapacityInput>>;
  holding_tank_capacity?: InputMaybe<Scalars['Float']['input']>;
  hull_appendages?: InputMaybe<Array<FieldInput>>;
  hull_material: Scalars['String']['input'];
  hull_type: Scalars['String']['input'];
  image_id?: InputMaybe<Scalars['ID']['input']>;
  image_path?: InputMaybe<Scalars['Upload']['input']>;
  interior_design?: InputMaybe<Scalars['String']['input']>;
  interior_site?: InputMaybe<Scalars['String']['input']>;
  keel_type?: InputMaybe<Scalars['String']['input']>;
  loa: Scalars['Float']['input'];
  lwl?: InputMaybe<Scalars['Float']['input']>;
  mainsail?: InputMaybe<Array<FieldInput>>;
  manufacturer_id?: InputMaybe<Scalars['ID']['input']>;
  manufacturer_name?: InputMaybe<Scalars['String']['input']>;
  manufacturer_site?: InputMaybe<Scalars['String']['input']>;
  mast?: InputMaybe<Scalars['Float']['input']>;
  mast_configuration?: InputMaybe<Scalars['String']['input']>;
  mast_position?: InputMaybe<Scalars['String']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  model: Scalars['String']['input'];
  nom?: InputMaybe<Scalars['Float']['input']>;
  og_description?: InputMaybe<Scalars['String']['input']>;
  og_image?: InputMaybe<Scalars['Upload']['input']>;
  og_title?: InputMaybe<Scalars['String']['input']>;
  og_url?: InputMaybe<Scalars['String']['input']>;
  reference_price?: InputMaybe<Scalars['Float']['input']>;
  rigging?: InputMaybe<Scalars['String']['input']>;
  rotating_spars?: InputMaybe<Scalars['Boolean']['input']>;
  rudder?: InputMaybe<Scalars['String']['input']>;
  sail_area?: InputMaybe<Scalars['Float']['input']>;
  sail_area_b?: InputMaybe<Scalars['Float']['input']>;
  sail_area_c?: InputMaybe<Scalars['Float']['input']>;
  sail_area_type_a?: InputMaybe<Scalars['String']['input']>;
  sail_area_type_b?: InputMaybe<Scalars['String']['input']>;
  sail_area_type_c?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  spars?: InputMaybe<Scalars['String']['input']>;
  spinnaker?: InputMaybe<Array<FieldInput>>;
  spinnaker_sail_area_a?: InputMaybe<Scalars['Float']['input']>;
  spinnaker_sail_area_b?: InputMaybe<Scalars['Float']['input']>;
  spinnaker_sail_area_c?: InputMaybe<Scalars['Float']['input']>;
  spinnaker_type_a?: InputMaybe<Scalars['String']['input']>;
  spinnaker_type_b?: InputMaybe<Scalars['String']['input']>;
  spinnaker_type_c?: InputMaybe<Scalars['String']['input']>;
  spreaders_angle?: InputMaybe<Scalars['String']['input']>;
  spreaders_level?: InputMaybe<Scalars['Float']['input']>;
  standing_rigging?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  tonnage_gross?: InputMaybe<Scalars['Float']['input']>;
  tonnage_net?: InputMaybe<Scalars['Float']['input']>;
  top_speed?: InputMaybe<Scalars['Float']['input']>;
  trailerable?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  unsinkable?: InputMaybe<Scalars['Boolean']['input']>;
  upwind_sail_area?: InputMaybe<Scalars['Float']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  water_capacity?: InputMaybe<Scalars['Float']['input']>;
  water_capacity_tank_b?: InputMaybe<Scalars['Float']['input']>;
  water_heater?: InputMaybe<Array<CapacityInput>>;
  water_heater_capacity?: InputMaybe<Scalars['Float']['input']>;
  water_tank?: InputMaybe<Array<CapacityInput>>;
  year?: InputMaybe<Scalars['Int']['input']>;
  year_first?: InputMaybe<Scalars['Int']['input']>;
  year_last?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationGenerateCheckoutSessionArgs = {
  cancel_url?: InputMaybe<Scalars['String']['input']>;
  plan_id: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  return_url?: InputMaybe<Scalars['String']['input']>;
  success_url?: InputMaybe<Scalars['String']['input']>;
  ui_mode: ModeEnum;
};

export type MutationGeneratePortalSessionArgs = {
  return_url: Scalars['String']['input'];
};

export type MutationGetTripCoordinatesArgs = {
  id: Scalars['ID']['input'];
};

export type MutationGroupedExpensesWidgetArgs = {
  boat_detail_id: Scalars['ID']['input'];
};

export type MutationLikeCommentArgs = {
  comment_id: Scalars['ID']['input'];
};

export type MutationLinkModelsToFileArgs = {
  days_before?: InputMaybe<Scalars['Int']['input']>;
  due_date?: InputMaybe<Scalars['String']['input']>;
  file_id: Scalars['ID']['input'];
  fileable?: InputMaybe<Array<FileableInput>>;
  has_notification?: InputMaybe<Scalars['Boolean']['input']>;
  issuance_date?: InputMaybe<Scalars['String']['input']>;
  issued_by?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationLogsWidgetArgs = {
  boat_detail_id: Scalars['ID']['input'];
};

export type MutationMarkAlertAsDoneArgs = {
  create_operational_log?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  marked_as_done_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MutationMassDeleteBoatDetailsArgs = {
  ids?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMassDeleteCategoriesArgs = {
  ids?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMassDeleteChecklistsArgs = {
  ids: Scalars['String']['input'];
};

export type MutationMassDeleteCostsArgs = {
  ids?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMassDeleteExpensesArgs = {
  ids?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMassDeleteFilesArgs = {
  ids?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMassDeleteFoldersArgs = {
  ids?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMassDeleteLocationsArgs = {
  ids?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMassDeleteLogsArgs = {
  ids: Scalars['String']['input'];
};

export type MutationMassDeleteSharesArgs = {
  ids?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMassDeleteTasksArgs = {
  ids?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMassDeleteTripsArgs = {
  ids: Scalars['String']['input'];
};

export type MutationMassMoveArgs = {
  destination_id?: InputMaybe<Scalars['ID']['input']>;
  file_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  folder_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationRegisterArgs = {
  auth0_app_name?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  recaptcha: Scalars['String']['input'];
  referral?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRemoveFromFavoriteArgs = {
  boat_id: Scalars['ID']['input'];
};

export type MutationRemoveLicenseArgs = {
  boat_details_id: Scalars['ID']['input'];
};

export type MutationResendInviteArgs = {
  email: Scalars['String']['input'];
  share: Scalars['ID']['input'];
};

export type MutationResendVerificationEmailArgs = {
  email: Scalars['String']['input'];
};

export type MutationResumeSubscriptionArgs = {
  plan_id: Scalars['ID']['input'];
};

export type MutationRetrieveSessionDataArgs = {
  session_id: Scalars['String']['input'];
};

export type MutationRetriveCheckoutDataArgs = {
  boat_details_ids: Array<Scalars['ID']['input']>;
  plan_id: Scalars['ID']['input'];
};

export type MutationRevokeAccessArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationSearchItemsArgs = {
  term: Scalars['String']['input'];
};

export type MutationShareItemArgs = {
  model_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  model_type: Scalars['String']['input'];
  permission_type: Scalars['String']['input'];
  user: Array<Scalars['String']['input']>;
};

export type MutationSharedWithArgs = {
  model_id: Scalars['ID']['input'];
  model_type: Scalars['String']['input'];
};

export type MutationStoreBoatDetailsArgs = {
  acquisition_date?: InputMaybe<Scalars['String']['input']>;
  acquisition_type?: InputMaybe<Scalars['String']['input']>;
  battery_power?: InputMaybe<Scalars['Float']['input']>;
  callsign?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dg_power?: InputMaybe<Scalars['Float']['input']>;
  engine_battery_capacity?: InputMaybe<Scalars['Float']['input']>;
  engine_battery_voltage?: InputMaybe<Scalars['Float']['input']>;
  engines?: InputMaybe<Array<InputMaybe<EngineInput>>>;
  epirb?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  files?: InputMaybe<Array<Scalars['Int']['input']>>;
  flag: Scalars['String']['input'];
  hull_sn?: InputMaybe<Scalars['String']['input']>;
  image_id?: InputMaybe<Scalars['ID']['input']>;
  in_reach_tracker_id?: InputMaybe<Scalars['String']['input']>;
  inverter_power?: InputMaybe<Scalars['Float']['input']>;
  is_vat_paid?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  mmsi?: InputMaybe<Scalars['String']['input']>;
  mobile_phone?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nr_past_owners?: InputMaybe<Scalars['Int']['input']>;
  ownership_order?: InputMaybe<Scalars['String']['input']>;
  plan_id?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  satellite_phone?: InputMaybe<Scalars['String']['input']>;
  service_battery_capacity?: InputMaybe<Scalars['Float']['input']>;
  service_battery_voltage?: InputMaybe<Scalars['Float']['input']>;
  service_loads?: InputMaybe<Scalars['String']['input']>;
  solar_power?: InputMaybe<Scalars['Float']['input']>;
  spot_tracker_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  strapi_ref_document_id: Scalars['ID']['input'];
  strapi_ref_id?: InputMaybe<Scalars['ID']['input']>;
  tender_length?: InputMaybe<Scalars['Float']['input']>;
  tender_model?: InputMaybe<Scalars['String']['input']>;
  tender_name?: InputMaybe<Scalars['String']['input']>;
  tender_vendor?: InputMaybe<Scalars['String']['input']>;
  wind_power?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['Int']['input'];
};

export type MutationStoreBulkLogArgs = {
  logs: Array<StoreLogInput>;
};

export type MutationStoreCategoryArgs = {
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type MutationStoreChecklistArgs = {
  category_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  image_id?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<InputMaybe<ChecklistItemInput>>>;
  linked_records?: InputMaybe<Array<InputMaybe<Checklistable>>>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  with_items?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationStoreChecklistCommentArgs = {
  checklist_id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MutationStoreChecklistItemArgs = {
  checklist_id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type MutationStoreCommentArgs = {
  commentable_id: Scalars['ID']['input'];
  commentable_type: Scalars['String']['input'];
  parent_id?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};

export type MutationStoreCostArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  boat_detail_id: Scalars['ID']['input'];
  category_id?: InputMaybe<Scalars['ID']['input']>;
  costables: Array<Costable>;
  currency_id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  is_maintenance_cost?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantity_action?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  vat_percentage?: InputMaybe<Scalars['Int']['input']>;
  vat_type?: InputMaybe<Scalars['String']['input']>;
};

export type MutationStoreCostCommentArgs = {
  cost_id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MutationStoreExpenseArgs = {
  acquisition_date?: InputMaybe<Scalars['String']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  boat_detail_id: Scalars['ID']['input'];
  brand?: InputMaybe<Scalars['String']['input']>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  consumption?: InputMaybe<Scalars['Float']['input']>;
  currency_id?: InputMaybe<Scalars['ID']['input']>;
  current_amount?: InputMaybe<Scalars['Float']['input']>;
  current_usage_value?: InputMaybe<Scalars['Float']['input']>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  due_date_time_unit?: InputMaybe<Scalars['Int']['input']>;
  due_date_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  expiration_date?: InputMaybe<Scalars['String']['input']>;
  expiration_is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  expiration_time_unit?: InputMaybe<Scalars['Int']['input']>;
  expiration_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  has_due_date_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  has_expiration_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  has_minimum_quantity_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  has_threshold_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  has_usage_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  has_warranty_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  is_recurring?: InputMaybe<Scalars['Boolean']['input']>;
  item_name: Scalars['String']['input'];
  linked_expenses_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  location_id?: InputMaybe<Scalars['ID']['input']>;
  minimum_quantity?: InputMaybe<Scalars['Float']['input']>;
  minimum_quantity_reminder?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  packing?: InputMaybe<Scalars['String']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  recurrence_type?: InputMaybe<Scalars['String']['input']>;
  serial_number?: InputMaybe<Scalars['String']['input']>;
  sub_location_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  sub_locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  supplier_contact?: InputMaybe<Scalars['String']['input']>;
  supplier_url?: InputMaybe<Scalars['String']['input']>;
  task_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  threshold_recurrence_reminder?: InputMaybe<Scalars['Float']['input']>;
  threshold_reminder_value?: InputMaybe<Scalars['Float']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  usage_due_date?: InputMaybe<Scalars['String']['input']>;
  usage_is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  usage_recurrence?: InputMaybe<Scalars['Float']['input']>;
  usage_recurrence_time_unit?: InputMaybe<Scalars['Int']['input']>;
  usage_recurrence_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  usage_threshold?: InputMaybe<Scalars['Float']['input']>;
  usage_time_unit?: InputMaybe<Scalars['Int']['input']>;
  usage_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  vendor_page?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['Float']['input']>;
  warranty_date?: InputMaybe<Scalars['String']['input']>;
  warranty_is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  warranty_time_unit?: InputMaybe<Scalars['Int']['input']>;
  warranty_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationStoreExpenseCommentArgs = {
  expense_id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MutationStoreFieldArgs = {
  module?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type MutationStoreFolderArgs = {
  name: Scalars['String']['input'];
  parent_id?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationStoreLocationArgs = {
  is_sub_location?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationStoreLogArgs = {
  log: StoreLogInput;
};

export type MutationStoreLogCommentArgs = {
  log_id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MutationStoreTaskArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  assignee_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  boat_detail_id: Scalars['ID']['input'];
  category_id?: InputMaybe<Scalars['ID']['input']>;
  completed_at?: InputMaybe<Scalars['String']['input']>;
  cost_type?: InputMaybe<Scalars['String']['input']>;
  currency_id?: InputMaybe<Scalars['ID']['input']>;
  due_date?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  has_cost?: InputMaybe<Scalars['Boolean']['input']>;
  has_notification?: InputMaybe<Scalars['Boolean']['input']>;
  has_usage_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  is_recurring?: InputMaybe<Scalars['Int']['input']>;
  linked_expense_id?: InputMaybe<Scalars['Int']['input']>;
  marked_as_maintenance?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  recurrence_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  taxonomy?: InputMaybe<Scalars['Int']['input']>;
  threshold_recurrence_reminder?: InputMaybe<Scalars['Float']['input']>;
  time_unit?: InputMaybe<Scalars['Int']['input']>;
  time_unit_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  usage_is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  usage_recurrence?: InputMaybe<Scalars['Float']['input']>;
  usage_recurrence_time_unit?: InputMaybe<Scalars['Int']['input']>;
  usage_recurrence_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  usage_time_unit?: InputMaybe<Scalars['Int']['input']>;
  usage_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  vat_percentage?: InputMaybe<Scalars['Int']['input']>;
  vat_type?: InputMaybe<Scalars['String']['input']>;
};

export type MutationStoreTaskCommentArgs = {
  task_id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MutationStoreTripArgs = {
  boat_detail_id: Scalars['ID']['input'];
  closed_at?: InputMaybe<Scalars['String']['input']>;
  crewman_id?: InputMaybe<Scalars['ID']['input']>;
  destination_latitude?: InputMaybe<Scalars['Float']['input']>;
  destination_longitude?: InputMaybe<Scalars['Float']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  engine_logs?: InputMaybe<Array<InputMaybe<EngineLogInput>>>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  image_id?: InputMaybe<Scalars['ID']['input']>;
  member_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  origin_latitude: Scalars['Float']['input'];
  origin_longitude: Scalars['Float']['input'];
  skipper_id?: InputMaybe<Scalars['ID']['input']>;
  started_at: Scalars['String']['input'];
};

export type MutationSubmitTripCoordinatesArgs = {
  id: Scalars['ID']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationSwitchTripAutologgingArgs = {
  id: Scalars['ID']['input'];
};

export type MutationTasksWidgetArgs = {
  boat_detail_id?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationTripsChartWidgetArgs = {
  boat_detail_id: Scalars['ID']['input'];
};

export type MutationTripsWidgetArgs = {
  boat_detail_id: Scalars['ID']['input'];
};

export type MutationUnblockChecklistFollowerArgs = {
  checklist_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};

export type MutationUnblockForUserArgs = {
  blockable_id: Scalars['ID']['input'];
  blocker_id: Scalars['ID']['input'];
  blocker_type: Scalars['String']['input'];
};

export type MutationUnfollowChecklistArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUnlikeCommentArgs = {
  comment_id: Scalars['ID']['input'];
};

export type MutationUnlinkModelsFromFileArgs = {
  file_id: Scalars['ID']['input'];
  fileable?: InputMaybe<Array<FileableInput>>;
};

export type MutationUpdateAlertArgs = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationUpdateAuthUserArgs = {
  auth0UserMetadata?: InputMaybe<Auth0UserMetaData>;
  base_currency_id?: InputMaybe<Scalars['ID']['input']>;
  billing_email?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['ID']['input']>;
  currency_id?: InputMaybe<Scalars['ID']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  image_id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateBoatDetailsArgs = {
  acquisition_date?: InputMaybe<Scalars['String']['input']>;
  acquisition_type?: InputMaybe<Scalars['String']['input']>;
  battery_power?: InputMaybe<Scalars['Float']['input']>;
  callsign?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dg_power?: InputMaybe<Scalars['Float']['input']>;
  engine_battery_capacity?: InputMaybe<Scalars['Float']['input']>;
  engine_battery_voltage?: InputMaybe<Scalars['Float']['input']>;
  engines?: InputMaybe<Array<InputMaybe<EngineInput>>>;
  epirb?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  files?: InputMaybe<Array<Scalars['Int']['input']>>;
  flag: Scalars['String']['input'];
  hull_sn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  image_id?: InputMaybe<Scalars['ID']['input']>;
  in_reach_tracker_id?: InputMaybe<Scalars['String']['input']>;
  inverter_power?: InputMaybe<Scalars['Float']['input']>;
  is_vat_paid?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  mmsi?: InputMaybe<Scalars['String']['input']>;
  mobile_phone?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nr_past_owners?: InputMaybe<Scalars['Int']['input']>;
  ownership_order?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  satellite_phone?: InputMaybe<Scalars['String']['input']>;
  service_battery_capacity?: InputMaybe<Scalars['Float']['input']>;
  service_battery_voltage?: InputMaybe<Scalars['Float']['input']>;
  service_loads?: InputMaybe<Scalars['String']['input']>;
  solar_power?: InputMaybe<Scalars['Float']['input']>;
  spot_tracker_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  tender_length?: InputMaybe<Scalars['Float']['input']>;
  tender_model?: InputMaybe<Scalars['String']['input']>;
  tender_name?: InputMaybe<Scalars['String']['input']>;
  tender_vendor?: InputMaybe<Scalars['String']['input']>;
  wind_power?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['Int']['input'];
};

export type MutationUpdateCategoryArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type MutationUpdateChecklistArgs = {
  category_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['ID']['input'];
  image_id?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<InputMaybe<ChecklistItemInput>>>;
  linked_records?: InputMaybe<Array<InputMaybe<Checklistable>>>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  with_items?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationUpdateChecklistCommentArgs = {
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MutationUpdateChecklistItemArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type MutationUpdateCommentArgs = {
  comment_id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MutationUpdateCostArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  boat_detail_id: Scalars['ID']['input'];
  category_id?: InputMaybe<Scalars['ID']['input']>;
  costables: Array<Costable>;
  currency_id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id: Scalars['ID']['input'];
  is_maintenance_cost?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  vat_percentage?: InputMaybe<Scalars['Int']['input']>;
  vat_type?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateExpenseArgs = {
  acquisition_date?: InputMaybe<Scalars['String']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  boat_detail_id?: InputMaybe<Scalars['ID']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  consumption?: InputMaybe<Scalars['Float']['input']>;
  currency_id?: InputMaybe<Scalars['ID']['input']>;
  current_amount?: InputMaybe<Scalars['Float']['input']>;
  current_usage_value?: InputMaybe<Scalars['Float']['input']>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  due_date_time_unit?: InputMaybe<Scalars['Int']['input']>;
  due_date_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  expiration_date?: InputMaybe<Scalars['String']['input']>;
  expiration_is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  expiration_time_unit?: InputMaybe<Scalars['Int']['input']>;
  expiration_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  has_due_date_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  has_expiration_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  has_minimum_quantity_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  has_threshold_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  has_usage_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  has_warranty_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  is_recurring?: InputMaybe<Scalars['Boolean']['input']>;
  item_name: Scalars['String']['input'];
  linked_expenses_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  location_id?: InputMaybe<Scalars['ID']['input']>;
  minimum_quantity?: InputMaybe<Scalars['Float']['input']>;
  minimum_quantity_reminder?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  packing?: InputMaybe<Scalars['String']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  recurrence_type?: InputMaybe<Scalars['String']['input']>;
  serial_number?: InputMaybe<Scalars['String']['input']>;
  sub_location_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sub_locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  supplier_contact?: InputMaybe<Scalars['String']['input']>;
  supplier_url?: InputMaybe<Scalars['String']['input']>;
  task_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  threshold_recurrence_reminder?: InputMaybe<Scalars['Float']['input']>;
  threshold_reminder_value?: InputMaybe<Scalars['Float']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  usage_due_date?: InputMaybe<Scalars['String']['input']>;
  usage_is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  usage_recurrence?: InputMaybe<Scalars['Float']['input']>;
  usage_recurrence_time_unit?: InputMaybe<Scalars['Int']['input']>;
  usage_recurrence_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  usage_threshold?: InputMaybe<Scalars['Float']['input']>;
  usage_time_unit?: InputMaybe<Scalars['Int']['input']>;
  usage_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  vendor_page?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['Float']['input']>;
  warranty_date?: InputMaybe<Scalars['String']['input']>;
  warranty_is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  warranty_time_unit?: InputMaybe<Scalars['Int']['input']>;
  warranty_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationUpdateFieldArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MutationUpdateFileArgs = {
  boat_detail_id?: InputMaybe<Scalars['ID']['input']>;
  expiration_date?: InputMaybe<Scalars['DateTime']['input']>;
  expiration_date_time_unit?: InputMaybe<Scalars['Int']['input']>;
  expiration_date_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  filename?: InputMaybe<Scalars['String']['input']>;
  folder_id?: InputMaybe<Scalars['ID']['input']>;
  has_expiration_date_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  issuance_date?: InputMaybe<Scalars['DateTime']['input']>;
  issued_by?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateFolderArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  parent_id?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateLocationArgs = {
  id: Scalars['ID']['input'];
  is_sub_location?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationUpdateLogArgs = {
  air_temp?: InputMaybe<Scalars['Float']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  bar?: InputMaybe<Scalars['Float']['input']>;
  battery1?: InputMaybe<Scalars['Float']['input']>;
  battery2?: InputMaybe<Scalars['Float']['input']>;
  bilge?: InputMaybe<Scalars['Boolean']['input']>;
  boat_detail_id?: InputMaybe<Scalars['ID']['input']>;
  boat_water?: InputMaybe<Scalars['Float']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  cog?: InputMaybe<Scalars['Int']['input']>;
  cost_type?: InputMaybe<Scalars['String']['input']>;
  currency_id?: InputMaybe<Scalars['ID']['input']>;
  datetime: Scalars['String']['input'];
  depth?: InputMaybe<Scalars['Float']['input']>;
  diesel_generator_exhaust_check?: InputMaybe<Scalars['Boolean']['input']>;
  diesel_generator_fuel_check?: InputMaybe<Scalars['Boolean']['input']>;
  diesel_generator_hours?: InputMaybe<Scalars['Float']['input']>;
  diesel_generator_oil_check?: InputMaybe<Scalars['Boolean']['input']>;
  diesel_generator_rpm?: InputMaybe<Scalars['Int']['input']>;
  diesel_generator_status?: InputMaybe<Scalars['Boolean']['input']>;
  diesel_generator_water_check?: InputMaybe<Scalars['Boolean']['input']>;
  engine_exhaust_check1?: InputMaybe<Scalars['Boolean']['input']>;
  engine_exhaust_check2?: InputMaybe<Scalars['Boolean']['input']>;
  engine_fuel_check1?: InputMaybe<Scalars['Boolean']['input']>;
  engine_fuel_check2?: InputMaybe<Scalars['Boolean']['input']>;
  engine_hours1?: InputMaybe<Scalars['Float']['input']>;
  engine_hours2?: InputMaybe<Scalars['Float']['input']>;
  engine_logs?: InputMaybe<Array<InputMaybe<EngineLogInput>>>;
  engine_oil_check1?: InputMaybe<Scalars['Boolean']['input']>;
  engine_oil_check2?: InputMaybe<Scalars['Boolean']['input']>;
  engine_rpm1?: InputMaybe<Scalars['Int']['input']>;
  engine_rpm2?: InputMaybe<Scalars['Int']['input']>;
  engine_status1?: InputMaybe<Scalars['Boolean']['input']>;
  engine_status2?: InputMaybe<Scalars['Boolean']['input']>;
  engine_water_check1?: InputMaybe<Scalars['Boolean']['input']>;
  engine_water_check2?: InputMaybe<Scalars['Boolean']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fuel?: InputMaybe<Scalars['Float']['input']>;
  gas?: InputMaybe<Scalars['Float']['input']>;
  has_cost?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['Int']['input']>;
  helm?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imminent?: InputMaybe<Scalars['String']['input']>;
  later?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  log?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outlook?: InputMaybe<Scalars['String']['input']>;
  precipitation?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  sails?: InputMaybe<Scalars['String']['input']>;
  sea_area?: InputMaybe<Scalars['String']['input']>;
  sea_state?: InputMaybe<Scalars['Int']['input']>;
  sea_temp?: InputMaybe<Scalars['Float']['input']>;
  sky?: InputMaybe<Scalars['Int']['input']>;
  sog?: InputMaybe<Scalars['Float']['input']>;
  speed?: InputMaybe<Scalars['Float']['input']>;
  station?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  usage?: InputMaybe<Array<InputMaybe<UsageInput>>>;
  vat_percentage?: InputMaybe<Scalars['Int']['input']>;
  vat_type?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['Float']['input']>;
  wind_direction?: InputMaybe<Scalars['Int']['input']>;
  wind_speed?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationUpdateNovuSubscriberCredentialsArgs = {
  provider_id: ProviderId;
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationUpdateOrCreateAddressArgs = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  postal_code: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export type MutationUpdateSettingArgs = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateShareArgs = {
  id: Scalars['ID']['input'];
  permission_type: Scalars['String']['input'];
};

export type MutationUpdateTaskArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  assignee_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  boat_detail_id?: InputMaybe<Scalars['ID']['input']>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  completed_at?: InputMaybe<Scalars['String']['input']>;
  cost_type?: InputMaybe<Scalars['String']['input']>;
  currency_id?: InputMaybe<Scalars['ID']['input']>;
  due_date?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  has_cost?: InputMaybe<Scalars['Boolean']['input']>;
  has_notification?: InputMaybe<Scalars['Boolean']['input']>;
  has_usage_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  is_recurring?: InputMaybe<Scalars['Int']['input']>;
  linked_expense_id?: InputMaybe<Scalars['Int']['input']>;
  marked_as_maintenance?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  recurrence_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  taxonomy?: InputMaybe<Scalars['Int']['input']>;
  threshold_recurrence_reminder?: InputMaybe<Scalars['Float']['input']>;
  time_unit?: InputMaybe<Scalars['Int']['input']>;
  time_unit_type?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  usage_is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  usage_recurrence?: InputMaybe<Scalars['Float']['input']>;
  usage_recurrence_time_unit?: InputMaybe<Scalars['Int']['input']>;
  usage_recurrence_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  usage_time_unit?: InputMaybe<Scalars['Int']['input']>;
  usage_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  vat_percentage?: InputMaybe<Scalars['Int']['input']>;
  vat_type?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateTripArgs = {
  closed_at?: InputMaybe<Scalars['String']['input']>;
  crewman_id?: InputMaybe<Scalars['ID']['input']>;
  destination_latitude?: InputMaybe<Scalars['Float']['input']>;
  destination_longitude?: InputMaybe<Scalars['Float']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  id: Scalars['ID']['input'];
  image_id?: InputMaybe<Scalars['ID']['input']>;
  member_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  origin_latitude: Scalars['Float']['input'];
  origin_longitude: Scalars['Float']['input'];
  skipper_id?: InputMaybe<Scalars['ID']['input']>;
  started_at: Scalars['String']['input'];
};

export type MutationUpdateUserNotificationArgs = {
  notification: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type MutationUpdateUserNovuPreferencesArgs = {
  enabled: Scalars['Boolean']['input'];
  preferences: Array<InputMaybe<NovuPreferences>>;
  template_id?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateUserSettingsArgs = {
  date_format?: InputMaybe<Scalars['String']['input']>;
  decimal_symbol?: InputMaybe<Scalars['String']['input']>;
  digit_grouping_symbol?: InputMaybe<Scalars['String']['input']>;
  first_day_of_week?: InputMaybe<Scalars['Int']['input']>;
  language_id?: InputMaybe<Scalars['ID']['input']>;
  time_format?: InputMaybe<Scalars['String']['input']>;
  timezone_id?: InputMaybe<Scalars['ID']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpgradePlanArgs = {
  plan_id: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationUploadArgs = {
  boat_detail_id?: InputMaybe<Scalars['ID']['input']>;
  expiration_date?: InputMaybe<Scalars['DateTime']['input']>;
  expiration_date_time_unit?: InputMaybe<Scalars['Int']['input']>;
  expiration_date_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  filename?: InputMaybe<Scalars['String']['input']>;
  folder_id?: InputMaybe<Scalars['ID']['input']>;
  has_expiration_date_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  issuance_date?: InputMaybe<Scalars['DateTime']['input']>;
  issued_by?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUploadChunkArgs = {
  chunk_count: Scalars['Int']['input'];
  chunk_id: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
  filename: Scalars['String']['input'];
  is_public: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type MutationUsageDoneArgs = {
  id: Scalars['ID']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationValidateFileSizeArgs = {
  size: Scalars['Int']['input'];
};

export type NovuPreferences = {
  channel: Scalars['String']['input'];
  channel_enabled: Scalars['Boolean']['input'];
};

export type NovuSubscriber = {
  __typename?: 'NovuSubscriber';
  avatar?: Maybe<Scalars['String']['output']>;
  channels?: Maybe<Array<Maybe<Channel>>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  subscriberId?: Maybe<Scalars['String']['output']>;
};

export type Operator = {
  column: Scalars['String']['input'];
  date?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  operation?: InputMaybe<Scalars['String']['input']>;
  type: OperatorType;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum OperatorType {
  Between = 'BETWEEN',
  Compare = 'COMPARE',
  Contains = 'CONTAINS',
  In = 'IN',
}

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT',
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM',
}

/** Available Order methods */
export enum OrderTypes {
  AToZ = 'A_TO_Z',
  MostViewed = 'MOST_VIEWED',
  RecentlyAdded = 'RECENTLY_ADDED',
}

export type OverviewWidget = {
  __typename?: 'OverviewWidget';
  alert_count?: Maybe<Scalars['Int']['output']>;
  boat_count?: Maybe<Scalars['Int']['output']>;
  inventory_count?: Maybe<Scalars['Int']['output']>;
  storage_used_in_mb?: Maybe<Scalars['Float']['output']>;
  storage_used_percentage?: Maybe<Scalars['Float']['output']>;
  task_count?: Maybe<Scalars['Int']['output']>;
  total_costs?: Maybe<Scalars['Float']['output']>;
  trip_count?: Maybe<Scalars['Int']['output']>;
  with_disabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Information about pagination using a Relay style cursor connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Number of nodes in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** The cursor to continue paginating forwards. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** The cursor to continue paginating backwards. */
  startCursor?: Maybe<Scalars['String']['output']>;
  /** Total number of nodes in the paginated connection. */
  total: Scalars['Int']['output'];
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

export type PaymentSettings = {
  __typename?: 'PaymentSettings';
  default_mandate?: Maybe<Scalars['String']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  payment_method_options?: Maybe<Scalars['String']['output']>;
  payment_method_types?: Maybe<Scalars['String']['output']>;
};

export type Period = {
  __typename?: 'Period';
  end?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
};

export type Phase = {
  __typename?: 'Phase';
  add_invoice_items: Array<Scalars['JSON']['output']>;
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  billing_cycle_anchor?: Maybe<Scalars['String']['output']>;
  billing_thresholds?: Maybe<Scalars['JSON']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_tax_rates: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_date: Scalars['Int']['output'];
  invoice_settings?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<PhaseItem>>;
  metadata: Scalars['JSON']['output'];
  on_behalf_of?: Maybe<Scalars['String']['output']>;
  proration_behavior: Scalars['String']['output'];
  start_date: Scalars['Int']['output'];
  transfer_data?: Maybe<Scalars['String']['output']>;
  trial_end?: Maybe<Scalars['Int']['output']>;
};

export type PhaseItem = {
  __typename?: 'PhaseItem';
  billing_thresholds?: Maybe<Scalars['JSON']['output']>;
  metadata: Scalars['JSON']['output'];
  plan: Scalars['String']['output'];
  price: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  tax_rates: Array<Scalars['String']['output']>;
};

export type Plan = {
  __typename?: 'Plan';
  can_delete?: Maybe<Scalars['Boolean']['output']>;
  can_update?: Maybe<Scalars['Boolean']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gateway_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interval?: Maybe<Scalars['String']['output']>;
  interval_count?: Maybe<Scalars['Int']['output']>;
  is_for_company?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trial_days?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type PlanOfUser = {
  __typename?: 'PlanOfUser';
  available?: Maybe<Scalars['Int']['output']>;
  boat_details?: Maybe<Array<Maybe<BoatDetails>>>;
  can_delete?: Maybe<Scalars['Boolean']['output']>;
  can_update?: Maybe<Scalars['Boolean']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  first_subscription_date?: Maybe<Scalars['DateTime']['output']>;
  gateway_id?: Maybe<Scalars['String']['output']>;
  has_scheduled_update?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  interval?: Maybe<Scalars['String']['output']>;
  interval_count?: Maybe<Scalars['Int']['output']>;
  is_for_company?: Maybe<Scalars['Boolean']['output']>;
  is_on_grace?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscription_schedule?: Maybe<SubscriptionSchedule>;
  total?: Maybe<Scalars['Int']['output']>;
  trial_days?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
  used?: Maybe<Scalars['Int']['output']>;
};

export type Popup = {
  __typename?: 'Popup';
  actions?: Maybe<Array<Maybe<Popup_Action>>>;
  body?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Popup_Action = {
  __typename?: 'Popup_Action';
  href?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum PowerType {
  Hp = 'HP',
  Kw = 'KW',
}

export type Price = {
  __typename?: 'Price';
  active?: Maybe<Scalars['Boolean']['output']>;
  billing_scheme?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  livemode?: Maybe<Scalars['Boolean']['output']>;
  lookup_key?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  recurring?: Maybe<Recurring>;
  tiers_mode?: Maybe<Scalars['String']['output']>;
  transform_quantity?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unit_amount?: Maybe<Scalars['Int']['output']>;
  unit_amount_decimal?: Maybe<Scalars['String']['output']>;
};

export enum ProrationTimeEnum {
  NextBillingCycle = 'next_billing_cycle',
  Now = 'now',
}

export enum ProviderId {
  Expo = 'expo',
}

export type Query = {
  __typename?: 'Query';
  activityLog?: Maybe<ActivityLog>;
  activityLogs?: Maybe<ActivityLogPaginator>;
  alert?: Maybe<Alert>;
  alerts?: Maybe<AlertPaginator>;
  authUser?: Maybe<User>;
  /** Preview single boat */
  boat?: Maybe<Boat>;
  /**
   * Preview a single user boat. This is valid only after user is loggedIn.
   * Because on public area, the boat should be published in order to be viewed.
   */
  boatDetail?: Maybe<BoatDetails>;
  /** Get loged in user boats, AKA MyBoats */
  boatDetails?: Maybe<BoatDetailsPaginator>;
  /**
   * Return total number of boats for the logedin user
   * This will return only the count for logedin user, not  considering the shared ones.
   */
  boatsCount?: Maybe<Scalars['Int']['output']>;
  categories?: Maybe<CategoryPaginator>;
  category?: Maybe<Category>;
  checklist?: Maybe<Checklist>;
  checklistBlockedFollowers?: Maybe<ChecklistUserPaginator>;
  checklistCloners?: Maybe<ChecklistUserPaginator>;
  /** @deprecated use viewComments */
  checklistComments?: Maybe<CommentPaginator>;
  checklistFollowers?: Maybe<ChecklistUserPaginator>;
  checklistItems?: Maybe<Array<Maybe<ChecklistItem>>>;
  cost?: Maybe<Cost>;
  costs?: Maybe<CostPaginator>;
  countries?: Maybe<CountryPaginator>;
  country?: Maybe<Country>;
  currencies?: Maybe<CurrencyPaginator>;
  currency?: Maybe<Currency>;
  deviceTokenStatus?: Maybe<Scalars['Boolean']['output']>;
  engineLogs?: Maybe<Array<Maybe<EngineLog>>>;
  engines?: Maybe<Array<Maybe<Engine>>>;
  expense?: Maybe<Expense>;
  expenses?: Maybe<ExpensePaginator>;
  expensesOfBoat?: Maybe<ExpensePaginator>;
  /** Return all boats that are favorited by the logged-in user.  */
  favorites?: Maybe<FavoritePaginator>;
  featuredBoatsBy: Array<Boat>;
  /** @deprecated Use `featuredBoatsBy` for search instead. */
  featuredBoatsByActivity: Array<Boat>;
  /** @deprecated Use `featuredBoatsBy` for search instead. */
  featuredBoatsByCategory: Array<Boat>;
  /**
   * Get a list of all manufacturers for boats that we have in DB
   * @deprecated use manufacturers query instead
   */
  fetchBoatManufacturers?: Maybe<Array<Scalars['String']['output']>>;
  /** Get multiple Boat Details (aka User boats) by id, this might be usefull during comparison */
  fetchMultipleBoatDetails: Array<BoatDetails>;
  /** Get multiple Boats by id, this might be use during comparison */
  fetchMultipleBoats: Array<Boat>;
  /** Get UserBoats to display on homepage */
  fetchUsersBoats?: Maybe<Array<BoatDetails>>;
  fields?: Maybe<Array<Field>>;
  file?: Maybe<File>;
  files?: Maybe<FilePaginator>;
  /** Filter all user boats based on different search Chriteria on their parent boat aka main boat */
  filterBoatDetails?: Maybe<BoatDetailsPaginator>;
  /** Filter all boats based on different search Chriteria */
  filterBoats?: Maybe<BoatPaginator>;
  flatLogs?: Maybe<LogPaginator>;
  folder?: Maybe<Folder>;
  folders?: Maybe<FolderPaginator>;
  /** @deprecated Use novuDeviceTokens instead */
  getUserNovuDeviceTokens?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  info?: Maybe<InfoModel>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  item?: Maybe<Item>;
  items?: Maybe<ItemPaginator>;
  language?: Maybe<Language>;
  languages?: Maybe<LanguagePaginator>;
  limits?: Maybe<Array<Limit>>;
  location?: Maybe<Location>;
  locations?: Maybe<LocationPaginator>;
  log?: Maybe<Log>;
  logsOfRadius?: Maybe<LogPaginator>;
  logsOfTrip?: Maybe<LogPaginator>;
  manufacturer?: Maybe<Manufacturer>;
  manufacturers?: Maybe<ManufacturerPaginator>;
  /** Get boats that our users love */
  mostFavorited?: Maybe<Array<Boat>>;
  myChecklists?: Maybe<ChecklistPaginator>;
  novuDeviceTokens?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  overdueTasks?: Maybe<TaskPaginator>;
  overviewWidget?: Maybe<OverviewWidget>;
  plan?: Maybe<Plan>;
  planOfUser?: Maybe<PlanOfUser>;
  plans?: Maybe<Array<Plan>>;
  previewUpgradeInvoice?: Maybe<UpgradePreview>;
  /** Preview single boat. this is better when user is logedin seeing his dashboard. */
  publicBoat?: Maybe<Boat>;
  publicBoatBySlug?: Maybe<Boat>;
  publicBoats?: Maybe<BoatPaginator>;
  publicChecklists?: Maybe<ChecklistPaginator>;
  publishableChecklist: Checklist;
  publishableChecklists?: Maybe<ChecklistPaginator>;
  /** @deprecated use alerts query */
  recentAlertsOfBoat?: Maybe<AlertPaginator>;
  /** @deprecated use expenses query */
  recentExpensesOfBoat?: Maybe<ExpensePaginator>;
  /** @deprecated Use Tasks query */
  recentTasks?: Maybe<TaskPaginator>;
  /**
   * Get UserBoats to display on Single Master boat.
   * This will show user boats connected (related) to this boat.
   * This endpoint mainly will be used when you are viewing a boat and then see other boats connected to it.
   */
  relatedUsersBoats?: Maybe<Array<BoatDetails>>;
  retrieveCheckoutData?: Maybe<CheckoutSessionResponse>;
  scheduledUpdate?: Maybe<ScheduledUpdate>;
  /** @deprecated Use `publicBoats` for search instead. */
  searchPublicBoats?: Maybe<BoatPaginator>;
  searchUsers?: Maybe<Array<Maybe<User>>>;
  /** Select Boat Details for Logedin USer. */
  selectBoatDetails?: Maybe<BoatDetailsPaginator>;
  /**
   * Get the settings of the logged in user
   * All, or selected
   */
  settings?: Maybe<SettingPaginator>;
  share?: Maybe<Share>;
  shares?: Maybe<SharePaginator>;
  subscription?: Maybe<UserSubscription>;
  task?: Maybe<Task>;
  tasks?: Maybe<TaskPaginator>;
  tasksOfBoat?: Maybe<TaskPaginator>;
  taxonomies?: Maybe<TaxonomyPaginator>;
  taxonomy?: Maybe<Taxonomy>;
  timezone?: Maybe<Timezone>;
  timezones?: Maybe<TimezonePaginator>;
  trip?: Maybe<Trip>;
  trips?: Maybe<TripPaginator>;
  tripsOfBoat?: Maybe<TripPaginator>;
  unpaginatedCosts?: Maybe<Array<Cost>>;
  upcomingInvoice?: Maybe<Invoice>;
  user?: Maybe<User>;
  /** Preview a single user boat */
  userBoat?: Maybe<BoatDetails>;
  userNovuPreferences?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  users?: Maybe<UserPaginator>;
  viewCommentReplies?: Maybe<CommentPaginator>;
  viewComments?: Maybe<CommentPaginator>;
};

export type QueryActivityLogArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryActivityLogsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryAlertArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryAlertsArgs = {
  boat_detail_id?: InputMaybe<Scalars['ID']['input']>;
  due_date_range?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterByStatus?: InputMaybe<AlertFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBoatArgs = {
  slug: Scalars['String']['input'];
};

export type QueryBoatDetailArgs = {
  id: Scalars['ID']['input'];
};

export type QueryBoatDetailsArgs = {
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  with_shared?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCategoriesArgs = {
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCategoryArgs = {
  id: Scalars['ID']['input'];
};

export type QueryChecklistArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryChecklistBlockedFollowersArgs = {
  checklist_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryChecklistClonersArgs = {
  checklist_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryChecklistCommentsArgs = {
  checklist_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryChecklistFollowersArgs = {
  checklist_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryChecklistItemsArgs = {
  checklist_id: Scalars['ID']['input'];
};

export type QueryCostArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCostsArgs = {
  boat_details_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  record_id?: InputMaybe<Scalars['ID']['input']>;
  record_type?: InputMaybe<Scalars['String']['input']>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCountriesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCountryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCurrenciesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCurrencyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryDeviceTokenStatusArgs = {
  provider: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type QueryEngineLogsArgs = {
  engine_id: Scalars['Int']['input'];
};

export type QueryEnginesArgs = {
  boat_detail_id: Scalars['ID']['input'];
};

export type QueryExpenseArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryExpensesArgs = {
  category_id?: InputMaybe<Scalars['ID']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryExpensesOfBoatArgs = {
  boat_detail_id: Scalars['ID']['input'];
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  packing?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sub_location?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryFavoritesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderByClause>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFeaturedBoatsByArgs = {
  id: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderTypes>;
  query?: InputMaybe<Scalars['String']['input']>;
  type: FeaturedType;
};

export type QueryFeaturedBoatsByActivityArgs = {
  id: Scalars['ID']['input'];
};

export type QueryFeaturedBoatsByCategoryArgs = {
  id: Scalars['ID']['input'];
};

export type QueryFetchMultipleBoatDetailsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type QueryFetchMultipleBoatsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type QueryFetchUsersBoatsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
};

export type QueryFieldsArgs = {
  module: ModuleType;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
};

export type QueryFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryFilesArgs = {
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder_id?: InputMaybe<Scalars['ID']['input']>;
  initialValues?: InputMaybe<Array<Scalars['ID']['input']>>;
  is_filepicker?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryFilterBoatDetailsArgs = {
  filters?: InputMaybe<SearchFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderTypes>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFilterBoatsArgs = {
  filters?: InputMaybe<SearchFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderTypes>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFlatLogsArgs = {
  expense_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryFoldersArgs = {
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  initialValues?: InputMaybe<Array<Scalars['ID']['input']>>;
  is_filepicker?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  parent_id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryInvoicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  starting_after?: InputMaybe<Scalars['String']['input']>;
};

export type QueryItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryItemsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryLanguageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryLanguagesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryLimitsArgs = {
  boat_details_id?: InputMaybe<Scalars['ID']['input']>;
  trip_id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryLocationsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  is_sub_location?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryLogArgs = {
  id: Scalars['ID']['input'];
};

export type QueryLogsOfRadiusArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  trip_id: Scalars['ID']['input'];
};

export type QueryLogsOfTripArgs = {
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  trip_id: Scalars['ID']['input'];
};

export type QueryManufacturerArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryManufacturersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryMostFavoritedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryMyChecklistsArgs = {
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryOverdueTasksArgs = {
  boat_detail_id: Scalars['ID']['input'];
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryOverviewWidgetArgs = {
  boat_detail_id?: InputMaybe<Scalars['ID']['input']>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPlanArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPlanOfUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPlansArgs = {
  filter?: InputMaybe<Filter>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
};

export type QueryPreviewUpgradeInvoiceArgs = {
  plan_id: Scalars['ID']['input'];
  proration_time: ProrationTimeEnum;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPublicBoatArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPublicBoatBySlugArgs = {
  slug: Scalars['String']['input'];
};

export type QueryPublicBoatsArgs = {
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hull_material?: InputMaybe<Scalars['String']['input']>;
  hull_type?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPublicChecklistsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPublishableChecklistArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPublishableChecklistsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryRecentAlertsOfBoatArgs = {
  boat_detail_id: Scalars['ID']['input'];
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryRecentExpensesOfBoatArgs = {
  boat_detail_id: Scalars['ID']['input'];
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryRecentTasksArgs = {
  boat_detail_id: Scalars['ID']['input'];
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryRelatedUsersBoatsArgs = {
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderByClause>;
};

export type QueryRetrieveCheckoutDataArgs = {
  session_id: Scalars['String']['input'];
};

export type QuerySearchPublicBoatsArgs = {
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySearchUsersArgs = {
  exclude_auth_user?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySelectBoatDetailsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySettingsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryShareArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerySharesArgs = {
  boat_detail_id: Scalars['ID']['input'];
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};

export type QueryTasksArgs = {
  boat_details_id?: InputMaybe<Scalars['ID']['input']>;
  due_date_range?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  taxonomy?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryTasksOfBoatArgs = {
  boat_detail_id: Scalars['ID']['input'];
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  taxonomy?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryTaxonomiesArgs = {
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTaxonomyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryTimezoneArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryTimezonesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryTripArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryTripsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  boat_details_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryTripsOfBoatArgs = {
  boat_detail_id: Scalars['ID']['input'];
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryUnpaginatedCostsArgs = {
  boat_details_id?: InputMaybe<Scalars['ID']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Filter>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  record_id?: InputMaybe<Scalars['ID']['input']>;
  record_type?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryUserBoatArgs = {
  id: Scalars['ID']['input'];
};

export type QueryUsersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryViewCommentRepliesArgs = {
  comment_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryViewCommentsArgs = {
  commentable_id?: InputMaybe<Scalars['ID']['input']>;
  commentable_type?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type Range = {
  max?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
};

export type Recurring = {
  __typename?: 'Recurring';
  aggregate_usage?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  interval_count?: Maybe<Scalars['Int']['output']>;
  trial_period_days?: Maybe<Scalars['Int']['output']>;
  usage_type?: Maybe<Scalars['String']['output']>;
};

export type RenewalInterval = {
  __typename?: 'RenewalInterval';
  interval: Scalars['String']['output'];
  length: Scalars['Int']['output'];
};

export type ResendVerificationEmailResponse = {
  __typename?: 'ResendVerificationEmailResponse';
  attempts?: Maybe<Scalars['Int']['output']>;
  attempts_left?: Maybe<Scalars['Int']['output']>;
  last_verification_attempt?: Maybe<Scalars['String']['output']>;
  wait_time?: Maybe<Scalars['Int']['output']>;
};

export type ScheduledUpdate = {
  __typename?: 'ScheduledUpdate';
  application?: Maybe<Scalars['String']['output']>;
  canceled_at?: Maybe<Scalars['Int']['output']>;
  completed_at?: Maybe<Scalars['Int']['output']>;
  created: Scalars['Int']['output'];
  current_phase?: Maybe<Scalars['String']['output']>;
  customer: Scalars['String']['output'];
  default_settings: DefaultSettings;
  end_behavior: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  livemode: Scalars['Boolean']['output'];
  metadata: Scalars['JSON']['output'];
  object: Scalars['String']['output'];
  phases: Array<Phase>;
  released_at?: Maybe<Scalars['Int']['output']>;
  released_subscription?: Maybe<Scalars['String']['output']>;
  renewal_interval?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  subscription?: Maybe<Scalars['String']['output']>;
  test_clock?: Maybe<Scalars['String']['output']>;
};

export type SearchFilters = {
  /** Multiple id of activities this boat belongs to. */
  activity?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Multiple id of categories this boat belongs to. */
  category?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Material of the hull. */
  hull_material?: InputMaybe<Scalars['String']['input']>;
  /** Hull type of the boat, monohull, etc. */
  hull_type?: InputMaybe<Scalars['String']['input']>;
  /** Min/Max Length overall of the boat */
  length?: InputMaybe<Range>;
  /** Maker of the boat. */
  manufacturer_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Maker of the boat. */
  manufacturer_name?: InputMaybe<Scalars['String']['input']>;
  /** Free text search for manufacturer, model, year. */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Type of boat, Sail, power etc. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Min/Max Construction year for the boat. */
  year?: InputMaybe<Range>;
};

export type Setting = {
  __typename?: 'Setting';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Setting items. */
export type SettingPaginator = {
  __typename?: 'SettingPaginator';
  /** A list of Setting items. */
  data: Array<Setting>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Share = {
  __typename?: 'Share';
  boat_detail_id?: Maybe<Scalars['ID']['output']>;
  can_delete?: Maybe<Scalars['Boolean']['output']>;
  can_update?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['DateTime']['output'];
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inherited_from?: Maybe<Scalars['String']['output']>;
  model_id?: Maybe<Scalars['ID']['output']>;
  model_type: Scalars['String']['output'];
  permission_type?: Maybe<Scalars['String']['output']>;
  shareable_id: Scalars['ID']['output'];
  shareable_type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

/** A paginated list of Share items. */
export type SharePaginator = {
  __typename?: 'SharePaginator';
  /** A list of Share items. */
  data: Array<Share>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Information about pagination using a simple paginator. */
export type SimplePaginatorInfo = {
  __typename?: 'SimplePaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC',
}

export type Spinnaker = Dynamic & {
  __typename?: 'Spinnaker';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type StatusTransitions = {
  __typename?: 'StatusTransitions';
  finalized_at?: Maybe<Scalars['String']['output']>;
  marked_uncollectible_at?: Maybe<Scalars['String']['output']>;
  paid_at?: Maybe<Scalars['String']['output']>;
  voided_at?: Maybe<Scalars['String']['output']>;
};

export type StoreLogInput = {
  air_temp?: InputMaybe<Scalars['Float']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  bar?: InputMaybe<Scalars['Float']['input']>;
  battery1?: InputMaybe<Scalars['Float']['input']>;
  battery2?: InputMaybe<Scalars['Float']['input']>;
  bilge?: InputMaybe<Scalars['Boolean']['input']>;
  boat_detail_id?: InputMaybe<Scalars['ID']['input']>;
  boat_water?: InputMaybe<Scalars['Float']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  cog?: InputMaybe<Scalars['Int']['input']>;
  cost_type?: InputMaybe<Scalars['String']['input']>;
  creation_type?: InputMaybe<CreationType>;
  creator_agent_name?: InputMaybe<Scalars['String']['input']>;
  currency_id?: InputMaybe<Scalars['ID']['input']>;
  datetime: Scalars['String']['input'];
  depth?: InputMaybe<Scalars['Float']['input']>;
  diesel_generator_exhaust_check?: InputMaybe<Scalars['Boolean']['input']>;
  diesel_generator_fuel_check?: InputMaybe<Scalars['Boolean']['input']>;
  diesel_generator_hours?: InputMaybe<Scalars['Float']['input']>;
  diesel_generator_oil_check?: InputMaybe<Scalars['Boolean']['input']>;
  diesel_generator_rpm?: InputMaybe<Scalars['Int']['input']>;
  diesel_generator_status?: InputMaybe<Scalars['Boolean']['input']>;
  diesel_generator_water_check?: InputMaybe<Scalars['Boolean']['input']>;
  engine_exhaust_check1?: InputMaybe<Scalars['Boolean']['input']>;
  engine_exhaust_check2?: InputMaybe<Scalars['Boolean']['input']>;
  engine_fuel_check1?: InputMaybe<Scalars['Boolean']['input']>;
  engine_fuel_check2?: InputMaybe<Scalars['Boolean']['input']>;
  engine_hours1?: InputMaybe<Scalars['Float']['input']>;
  engine_hours2?: InputMaybe<Scalars['Float']['input']>;
  engine_logs?: InputMaybe<Array<InputMaybe<EngineLogInput>>>;
  engine_oil_check1?: InputMaybe<Scalars['Boolean']['input']>;
  engine_oil_check2?: InputMaybe<Scalars['Boolean']['input']>;
  engine_rpm1?: InputMaybe<Scalars['Int']['input']>;
  engine_rpm2?: InputMaybe<Scalars['Int']['input']>;
  engine_status1?: InputMaybe<Scalars['Boolean']['input']>;
  engine_status2?: InputMaybe<Scalars['Boolean']['input']>;
  engine_water_check1?: InputMaybe<Scalars['Boolean']['input']>;
  engine_water_check2?: InputMaybe<Scalars['Boolean']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fuel?: InputMaybe<Scalars['Float']['input']>;
  gas?: InputMaybe<Scalars['Float']['input']>;
  has_cost?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['Int']['input']>;
  helm?: InputMaybe<Scalars['String']['input']>;
  imminent?: InputMaybe<Scalars['String']['input']>;
  later?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  log?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outlook?: InputMaybe<Scalars['String']['input']>;
  precipitation?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  sails?: InputMaybe<Scalars['String']['input']>;
  sea_area?: InputMaybe<Scalars['String']['input']>;
  sea_state?: InputMaybe<Scalars['Int']['input']>;
  sea_temp?: InputMaybe<Scalars['Float']['input']>;
  sky?: InputMaybe<Scalars['Int']['input']>;
  sog?: InputMaybe<Scalars['Float']['input']>;
  speed?: InputMaybe<Scalars['Float']['input']>;
  station?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  trip_id?: InputMaybe<Scalars['ID']['input']>;
  type: Scalars['String']['input'];
  usage?: InputMaybe<Array<InputMaybe<UsageInput>>>;
  vat_percentage?: InputMaybe<Scalars['Int']['input']>;
  vat_type?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['Float']['input']>;
  wind_direction?: InputMaybe<Scalars['Int']['input']>;
  wind_speed?: InputMaybe<Scalars['Float']['input']>;
};

export type SubLocation = {
  __typename?: 'SubLocation';
  level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  active?: Maybe<Scalars['Boolean']['output']>;
  aggregate_usage?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  amount_decimal?: Maybe<Scalars['String']['output']>;
  billing_scheme?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  interval_count?: Maybe<Scalars['Int']['output']>;
  livemode?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  tiers_mode?: Maybe<Scalars['String']['output']>;
  transform_quantity?: Maybe<Scalars['String']['output']>;
  trial_period_days?: Maybe<Scalars['Int']['output']>;
  usage_type?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionSchedule = {
  __typename?: 'SubscriptionSchedule';
  canceled_at?: Maybe<Scalars['Int']['output']>;
  completed_at?: Maybe<Scalars['Int']['output']>;
  created: Scalars['Int']['output'];
  current_phase?: Maybe<SubscriptionSchedulePhase>;
  customer: Scalars['String']['output'];
  default_settings?: Maybe<SubscriptionScheduleDefaultSettings>;
  end_behavior: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  livemode: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  object: Scalars['String']['output'];
  phases?: Maybe<Array<Maybe<SubscriptionSchedulePhase>>>;
  released_at?: Maybe<Scalars['Int']['output']>;
  released_subscription?: Maybe<Scalars['String']['output']>;
  renewal_interval?: Maybe<RenewalInterval>;
  status: Scalars['String']['output'];
  subscription?: Maybe<Scalars['String']['output']>;
  test_clock?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionScheduleDefaultSettings = {
  __typename?: 'SubscriptionScheduleDefaultSettings';
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  billing_cycle_anchor: Scalars['String']['output'];
  billing_thresholds?: Maybe<Scalars['JSON']['output']>;
  collection_method: Scalars['String']['output'];
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  on_behalf_of?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionSchedulePhase = {
  __typename?: 'SubscriptionSchedulePhase';
  add_invoice_items?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  billing_cycle_anchor?: Maybe<Scalars['String']['output']>;
  billing_thresholds?: Maybe<Scalars['JSON']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_date: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  on_behalf_of?: Maybe<Scalars['String']['output']>;
  plans: Array<SubscriptionSchedulePlan>;
  prorate?: Maybe<Scalars['Boolean']['output']>;
  proration_behavior?: Maybe<Scalars['String']['output']>;
  start_date: Scalars['Int']['output'];
  tax_percent?: Maybe<Scalars['Float']['output']>;
  trial_end?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionSchedulePlan = {
  __typename?: 'SubscriptionSchedulePlan';
  billing_thresholds?: Maybe<Scalars['JSON']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  plan: Scalars['String']['output'];
  price: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type Task = {
  __typename?: 'Task';
  alert?: Maybe<Alert>;
  assignee?: Maybe<User>;
  assignee_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  boat_detail?: Maybe<BoatDetails>;
  boat_detail_id: Scalars['ID']['output'];
  can_delete?: Maybe<Scalars['Boolean']['output']>;
  can_share?: Maybe<Scalars['Boolean']['output']>;
  can_update?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Category>;
  category_id?: Maybe<Scalars['ID']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  cost?: Maybe<Cost>;
  costs?: Maybe<Array<Maybe<Cost>>>;
  created_at: Scalars['DateTime']['output'];
  due_date?: Maybe<Scalars['DateTime']['output']>;
  due_date_time_unit?: Maybe<Scalars['Int']['output']>;
  due_date_time_unit_type?: Maybe<Scalars['String']['output']>;
  expenses?: Maybe<Array<Maybe<Expense>>>;
  fields?: Maybe<Array<Maybe<FieldValue>>>;
  files?: Maybe<Array<Maybe<File>>>;
  frequency?: Maybe<Scalars['String']['output']>;
  has_due_date_reminder?: Maybe<Scalars['Boolean']['output']>;
  has_notification?: Maybe<Scalars['Boolean']['output']>;
  has_usage_reminder?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  invite_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  invites?: Maybe<Array<Maybe<Invite>>>;
  is_recurring?: Maybe<Scalars['Boolean']['output']>;
  linked_expense_id?: Maybe<Scalars['Int']['output']>;
  marked_as_maintenance?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Task>;
  priority?: Maybe<Scalars['Int']['output']>;
  recurrence_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subtasks?: Maybe<Array<Maybe<Task>>>;
  taxonomies?: Maybe<Array<Maybe<Taxonomy>>>;
  threshold_recurrence_reminder?: Maybe<Scalars['Float']['output']>;
  time_unit?: Maybe<Scalars['Int']['output']>;
  time_unit_type?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  usage_is_custom?: Maybe<Scalars['Boolean']['output']>;
  usage_recurrence?: Maybe<Scalars['Float']['output']>;
  usage_recurrence_time_unit?: Maybe<Scalars['Int']['output']>;
  usage_recurrence_time_unit_type?: Maybe<Scalars['String']['output']>;
  usage_time_unit?: Maybe<Scalars['Int']['output']>;
  usage_time_unit_type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  user_id: Scalars['ID']['output'];
};

/** A paginated list of Task items. */
export type TaskPaginator = {
  __typename?: 'TaskPaginator';
  /** A list of Task items. */
  data: Array<Task>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type TasksWidgetResponse = {
  __typename?: 'TasksWidgetResponse';
  tasks?: Maybe<WidgetResponse>;
};

export type TaxAmount = {
  __typename?: 'TaxAmount';
  amount?: Maybe<Scalars['Int']['output']>;
  inclusive?: Maybe<Scalars['Boolean']['output']>;
  tax_rate?: Maybe<Scalars['String']['output']>;
  taxability_reason?: Maybe<Scalars['String']['output']>;
  taxable_amount?: Maybe<Scalars['Int']['output']>;
};

export type Taxonomy = {
  __typename?: 'Taxonomy';
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image_id?: Maybe<Scalars['ID']['output']>;
  is_displayed: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['ID']['output']>;
  publicBoatCount: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of Taxonomy items. */
export type TaxonomyPaginator = {
  __typename?: 'TaxonomyPaginator';
  /** A list of Taxonomy items. */
  data: Array<Taxonomy>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Timezone = {
  __typename?: 'Timezone';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Timezone items. */
export type TimezonePaginator = {
  __typename?: 'TimezonePaginator';
  /** A list of Timezone items. */
  data: Array<Timezone>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT',
}

export type Trip = {
  __typename?: 'Trip';
  boat_detail?: Maybe<BoatDetails>;
  boat_detail_id: Scalars['ID']['output'];
  can_delete?: Maybe<Scalars['Boolean']['output']>;
  can_share?: Maybe<Scalars['Boolean']['output']>;
  can_update?: Maybe<Scalars['Boolean']['output']>;
  closed_at?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  crewman?: Maybe<User>;
  crewman_id?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  destination_latitude?: Maybe<Scalars['Float']['output']>;
  destination_longitude?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  fields?: Maybe<Array<Maybe<FieldValue>>>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  general_logs_count?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<File>;
  image_id?: Maybe<Scalars['Int']['output']>;
  invites?: Maybe<Array<Maybe<Invite>>>;
  members?: Maybe<Array<Maybe<User>>>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  origin_latitude?: Maybe<Scalars['Float']['output']>;
  origin_longitude?: Maybe<Scalars['Float']['output']>;
  radio_logs_count?: Maybe<Scalars['Int']['output']>;
  skipper?: Maybe<User>;
  skipper_id?: Maybe<Scalars['String']['output']>;
  social_logs_count?: Maybe<Scalars['Int']['output']>;
  started_at?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  user_id: Scalars['ID']['output'];
  weather_logs_count?: Maybe<Scalars['Int']['output']>;
};

export type TripAutologResponse = {
  __typename?: 'TripAutologResponse';
  auto_logging?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TripCoordinatesResponse = {
  __typename?: 'TripCoordinatesResponse';
  datetime: Scalars['DateTime']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type TripDeleteCoordinatesResponse = {
  __typename?: 'TripDeleteCoordinatesResponse';
  deleted: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Trip items. */
export type TripPaginator = {
  __typename?: 'TripPaginator';
  /** A list of Trip items. */
  data: Array<Trip>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type TripSubmitCoordinatesResponse = {
  __typename?: 'TripSubmitCoordinatesResponse';
  message?: Maybe<Scalars['String']['output']>;
  submitted: Scalars['Boolean']['output'];
};

export type TripsChartWidgetResponse = {
  __typename?: 'TripsChartWidgetResponse';
  general?: Maybe<Scalars['Int']['output']>;
  radio?: Maybe<Scalars['Int']['output']>;
  social?: Maybe<Scalars['Int']['output']>;
  weather?: Maybe<Scalars['Int']['output']>;
  x?: Maybe<Scalars['String']['output']>;
};

export type TripsWidgetResponse = {
  __typename?: 'TripsWidgetResponse';
  trips?: Maybe<WidgetResponse>;
};

export type UpgradePreview = {
  __typename?: 'UpgradePreview';
  account_country?: Maybe<Scalars['String']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  amount_due?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Int']['output']>;
  amount_remaining?: Maybe<Scalars['Int']['output']>;
  application_fee_amount?: Maybe<Scalars['Int']['output']>;
  attempt_count?: Maybe<Scalars['Int']['output']>;
  attempted?: Maybe<Scalars['Boolean']['output']>;
  billing_reason?: Maybe<Scalars['String']['output']>;
  charge?: Maybe<Scalars['String']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  custom_fields?: Maybe<Scalars['JSON']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  customer_address?: Maybe<Scalars['String']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_shipping?: Maybe<Scalars['JSON']['output']>;
  customer_tax_exempt?: Maybe<Scalars['String']['output']>;
  customer_tax_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  default_tax_rates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['JSON']['output']>;
  discounts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  due_date?: Maybe<Scalars['Int']['output']>;
  ending_balance?: Maybe<Scalars['Int']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  from_invoice?: Maybe<Scalars['String']['output']>;
  hosted_invoice_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoice_pdf?: Maybe<Scalars['String']['output']>;
  issuer?: Maybe<Issuer>;
  last_finalization_error?: Maybe<Scalars['String']['output']>;
  latest_revision?: Maybe<Scalars['String']['output']>;
  lines?: Maybe<InvoiceLineItems>;
  livemode?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  next_payment_attempt?: Maybe<Scalars['Int']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  on_behalf_of?: Maybe<Scalars['String']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  paid_out_of_band?: Maybe<Scalars['Boolean']['output']>;
  payment_intent?: Maybe<Scalars['String']['output']>;
  payment_settings?: Maybe<PaymentSettings>;
  period_end?: Maybe<Scalars['Int']['output']>;
  period_start?: Maybe<Scalars['Int']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  quote?: Maybe<Scalars['String']['output']>;
  receipt_number?: Maybe<Scalars['String']['output']>;
  rendering_options?: Maybe<Scalars['String']['output']>;
  shipping_cost?: Maybe<Scalars['Int']['output']>;
  shipping_details?: Maybe<Scalars['String']['output']>;
  starting_balance?: Maybe<Scalars['Int']['output']>;
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_transitions?: Maybe<StatusTransitions>;
  subscription?: Maybe<Scalars['String']['output']>;
  subscription_proration_date?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['JSON']['output']>;
  tax_percent?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  total_discount_amounts?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  total_excluding_tax?: Maybe<Scalars['Int']['output']>;
  total_tax_amounts?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  transfer_data?: Maybe<Scalars['JSON']['output']>;
  webhooks_delivered_at?: Maybe<Scalars['Int']['output']>;
};

export type UploadCheck = {
  __typename?: 'UploadCheck';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UsageInput = {
  expense_id?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantity_action?: InputMaybe<Scalars['String']['input']>;
  usage_value?: InputMaybe<Scalars['Float']['input']>;
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['ID']['output']>;
  auth_0_id: Scalars['String']['output'];
  base_currency?: Maybe<Currency>;
  base_currency_id?: Maybe<Scalars['ID']['output']>;
  billing_email?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['Date']['output']>;
  boats_count?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use pm_type instead */
  card_brand?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use pm_last_four instead */
  card_last_four?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  country?: Maybe<Country>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Currency>;
  currency_id?: Maybe<Scalars['ID']['output']>;
  current_subscription?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  email_verified_at?: Maybe<Scalars['DateTime']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<File>;
  image_id?: Maybe<Scalars['Int']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  is_banned?: Maybe<Scalars['String']['output']>;
  is_calculating_costs?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Language>;
  last_login_at?: Maybe<Scalars['DateTime']['output']>;
  last_login_ip?: Maybe<Scalars['String']['output']>;
  memory_usage_percentage?: Maybe<Scalars['Float']['output']>;
  memory_used_in_mb?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  novu_id?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pm_last_four?: Maybe<Scalars['String']['output']>;
  pm_type?: Maybe<Scalars['String']['output']>;
  remember_token?: Maybe<Scalars['String']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<UserSubscription>;
  surname?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Timezone>;
  trial_ends_at?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type UserData = {
  __typename?: 'UserData';
  base_currency?: Maybe<Currency>;
  base_currency_id?: Maybe<Scalars['ID']['output']>;
  billing_email?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['Date']['output']>;
  country?: Maybe<Country>;
  currency?: Maybe<Currency>;
  currency_id?: Maybe<Scalars['ID']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  image_id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of User items. */
export type UserPaginator = {
  __typename?: 'UserPaginator';
  /** A list of User items. */
  data: Array<User>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type UserSubscription = {
  __typename?: 'UserSubscription';
  available_active_alert_slots?: Maybe<Scalars['Int']['output']>;
  available_licenses?: Maybe<Scalars['Int']['output']>;
  cost?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  current_subscription?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  first_subscription_date?: Maybe<Scalars['String']['output']>;
  free_subscription_id?: Maybe<Scalars['ID']['output']>;
  has_available_trial?: Maybe<Scalars['Boolean']['output']>;
  has_free_boat_available?: Maybe<Scalars['Boolean']['output']>;
  has_scheduled_update?: Maybe<Scalars['Boolean']['output']>;
  has_started_trial?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  interval_count?: Maybe<Scalars['Int']['output']>;
  is_beta_user?: Maybe<Scalars['Boolean']['output']>;
  is_free?: Maybe<Scalars['Boolean']['output']>;
  is_on_generic_trial?: Maybe<Scalars['Boolean']['output']>;
  is_on_grace?: Maybe<Scalars['Boolean']['output']>;
  is_on_trial?: Maybe<Scalars['Boolean']['output']>;
  next_billing_date?: Maybe<Scalars['DateTime']['output']>;
  plan?: Maybe<PlanOfUser>;
  status?: Maybe<Scalars['String']['output']>;
  subscription_schedule?: Maybe<SubscriptionSchedule>;
  total_licenses?: Maybe<Scalars['Int']['output']>;
  trial_days?: Maybe<Scalars['Int']['output']>;
  trial_ends_at?: Maybe<Scalars['String']['output']>;
  used_licenses?: Maybe<Scalars['Int']['output']>;
};

export type WaterHeater = Capacity & {
  __typename?: 'WaterHeater';
  capacity: Scalars['Float']['output'];
};

export type WaterTank = Capacity & {
  __typename?: 'WaterTank';
  capacity: Scalars['Float']['output'];
};

export type WidgetResponse = {
  __typename?: 'WidgetResponse';
  all?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  recent?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type YearInt = {
  __typename?: 'YearInt';
  year_last?: Maybe<Scalars['Int']['output']>;
};

export type YearLast = YearInt | YearString;

export type YearString = {
  __typename?: 'YearString';
  year_last?: Maybe<Scalars['String']['output']>;
};

export type AlertDetailsFragment = {
  __typename?: 'Alert';
  id: string;
  priority: number;
  active?: boolean;
  alertable_id: number;
  alertable_type: string;
  title?: string;
  type?: string;
  date?: any;
  created_at: any;
  category?: string;
  quantity?: number;
  threshold?: number;
  marked_as_done_at?: any;
};

export type AlertsListItem = {
  __typename?: 'Alert';
  id: string;
  priority: number;
  active?: boolean;
  alertable_id: number;
  alertable_type: string;
  title?: string;
  type?: string;
  date?: any;
  created_at: any;
  category?: string;
  quantity?: number;
  threshold?: number;
  marked_as_done_at?: any;
};

export type ChecklistFragment = {
  __typename: 'Checklist';
  created_at: any;
  belongs_to_current_user: boolean;
  can_add_comment: boolean;
  can_copy: boolean;
  can_create_new_item: boolean;
  can_delete: boolean;
  can_follow: boolean;
  can_update: boolean;
  can_sort_items: boolean;
  can_unfollow: boolean;
  can_share?: boolean;
  can_view: boolean;
  can_view_blocked_users: boolean;
  can_view_comments: boolean;
  can_view_followers: boolean;
  clones_count?: number;
  comments_count?: number;
  description?: string;
  id: string;
  is_followed_by_current_user: boolean;
  is_public: boolean;
  old_image_id?: string;
  category_id?: string;
  updated_at: any;
  title: string;
  user_followers_count?: number;
  image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
  old_image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
  files?: Array<{
    __typename?: 'File';
    can_delete?: boolean;
    can_update?: boolean;
    can_share?: boolean;
    id: string;
    type: string;
    size: string;
    mime_type: string;
    extension: string;
    name: string;
    filename?: string;
    issued_by?: string;
    issuance_date?: any;
    boat_detail_id?: string;
    notes?: string;
    dimensions?: string;
    disk: string;
    alt?: string;
    description?: string;
    visibility: string;
    url?: string;
    public_url?: string;
    download_url?: string;
    folder_id?: string;
    expiration_date?: any;
    expiration_date_time_unit?: number;
    expiration_date_time_unit_type?: string;
    has_expiration_date_reminder?: boolean;
    created_at?: any;
    updated_at?: any;
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
  }>;
  tasks?: Array<{ __typename?: 'Task'; id: string; name: string }>;
  expenses?: Array<{ __typename?: 'Expense'; id: string; item_name?: string }>;
  logs?: Array<{ __typename?: 'Log'; id: string; name?: string }>;
  trips?: Array<{ __typename?: 'Trip'; id: string; name: string }>;
  items?: Array<{ __typename?: 'ChecklistItem'; id: string; name: string; position?: number; checked: boolean }>;
  user?: {
    __typename?: 'User';
    id: string;
    name?: string;
    surname?: string;
    display_name?: string;
    image?: { __typename?: 'File'; url?: string };
  };
};

export type ChecklistCompleteItem = {
  __typename: 'Checklist';
  created_at: any;
  belongs_to_current_user: boolean;
  can_add_comment: boolean;
  can_copy: boolean;
  can_create_new_item: boolean;
  can_delete: boolean;
  can_follow: boolean;
  can_update: boolean;
  can_sort_items: boolean;
  can_unfollow: boolean;
  can_share?: boolean;
  can_view: boolean;
  can_view_blocked_users: boolean;
  can_view_comments: boolean;
  can_view_followers: boolean;
  clones_count?: number;
  comments_count?: number;
  description?: string;
  id: string;
  is_followed_by_current_user: boolean;
  is_public: boolean;
  updated_at: any;
  old_image_id?: string;
  title: string;
  user_followers_count?: number;
  image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
  old_image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
  items?: Array<{ __typename?: 'ChecklistItem'; id: string; name: string; position?: number; checked: boolean }>;
  user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
};

export type PublishableChecklistFragment = {
  __typename?: 'Checklist';
  id: string;
  title: string;
  description?: string;
  old_image_id?: string;
  comments_count?: number;
  user_followers_count?: number;
  clones_count?: number;
  image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
  comments?: Array<{
    __typename?: 'Comment';
    id: string;
    text: string;
    created_at_diff: string;
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string };
  }>;
  old_image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
  items?: Array<{ __typename?: 'ChecklistItem'; id: string; name: string }>;
  user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
};

export type CommentFragment = {
  __typename?: 'Comment';
  id: string;
  can_unlike: boolean;
  like_count?: number;
  text: string;
  created_at_diff: string;
  updated_at_diff: string;
  can_update: boolean;
  can_delete: boolean;
  can_like: boolean;
  user?: {
    __typename?: 'User';
    id: string;
    surname?: string;
    name?: string;
    image?: { __typename?: 'File'; id: string; url?: string };
  };
};

export type CostFragment = {
  __typename?: 'Cost';
  amount?: number;
  id: string;
  notes?: string;
  type: string;
  exchange_rate?: number;
  quantity?: number;
  is_maintenance_cost?: boolean;
  name: string;
  can_delete?: boolean;
  can_update?: boolean;
  date?: any;
  user_id: string;
  boat_detail_id?: string;
  category_id?: string;
  currency_id: string;
  supplier?: string;
  vat_percentage?: number;
  vat_type?: string;
  created_at: any;
  updated_at: any;
  trips?: Array<{ __typename?: 'Trip'; id: string; name: string }>;
  logs?: Array<{ __typename?: 'Log'; id: string; datetime?: string }>;
  tasks?: Array<{ __typename?: 'Task'; id: string; name: string }>;
  expenses?: Array<{ __typename?: 'Expense'; id: string; item_name?: string }>;
  comments?: Array<{ __typename?: 'Comment'; id: string; text: string }>;
  category?: { __typename?: 'Category'; id: string; name: string };
  documents?: Array<{
    __typename?: 'File';
    id: string;
    type: string;
    size: string;
    mime_type: string;
    extension: string;
    name: string;
    filename?: string;
    issued_by?: string;
    issuance_date?: any;
    boat_detail_id?: string;
    notes?: string;
    dimensions?: string;
    disk: string;
    alt?: string;
    description?: string;
    visibility: string;
    url?: string;
    public_url?: string;
    download_url?: string;
    folder_id?: string;
    expiration_date?: any;
    expiration_date_time_unit?: number;
    expiration_date_time_unit_type?: string;
    has_expiration_date_reminder?: boolean;
    created_at?: any;
    updated_at?: any;
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
  }>;
  files?: Array<{
    __typename?: 'File';
    id: string;
    type: string;
    size: string;
    mime_type: string;
    extension: string;
    name: string;
    filename?: string;
    issued_by?: string;
    issuance_date?: any;
    boat_detail_id?: string;
    notes?: string;
    dimensions?: string;
    disk: string;
    alt?: string;
    description?: string;
    visibility: string;
    url?: string;
    public_url?: string;
    download_url?: string;
    folder_id?: string;
    expiration_date?: any;
    expiration_date_time_unit?: number;
    expiration_date_time_unit_type?: string;
    has_expiration_date_reminder?: boolean;
    created_at?: any;
    updated_at?: any;
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
  }>;
  user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
  boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string; flag: string };
  currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string; symbol?: string };
};

export type ExpenseFragment = {
  __typename?: 'Expense';
  id: string;
  boat_detail_id: string;
  user_id: string;
  item_id: string;
  item_name?: string;
  type?: string;
  notes?: string;
  location?: string;
  has_minimum_quantity_reminder?: boolean;
  minimum_quantity?: number;
  minimum_quantity_reminder?: number;
  brand?: string;
  model?: string;
  part_number?: string;
  serial_number?: string;
  barcode?: string;
  vendor_page?: string;
  packing?: string;
  acquisition_date?: string;
  expiration_date?: string;
  expiration_time_unit?: number;
  expiration_time_unit_type?: string;
  expiration_is_custom?: boolean;
  has_expiration_reminder?: boolean;
  warranty_date?: string;
  warranty_time_unit?: number;
  warranty_time_unit_type?: string;
  warranty_is_custom?: boolean;
  has_warranty_reminder?: boolean;
  is_recurring?: boolean;
  has_usage_reminder?: boolean;
  current_usage_value?: number;
  usage_due_date?: string;
  due_date_time_unit?: number;
  due_date_time_unit_type?: string;
  has_due_date_reminder?: boolean;
  usage_threshold?: number;
  usage_time_unit?: number;
  usage_time_unit_type?: string;
  recurrence_type?: string;
  threshold_reminder_value?: number;
  has_threshold_reminder?: boolean;
  threshold_recurrence_reminder?: number;
  usage_recurrence_time_unit?: number;
  usage_recurrence_time_unit_type?: string;
  usage_is_custom?: boolean;
  usage_recurrence?: number;
  maintenance_synced?: boolean;
  unit?: string;
  quantity?: number;
  total?: number;
  converted_total?: number;
  unit_price?: number;
  voltage?: number;
  width?: number;
  height?: number;
  depth?: number;
  weight?: number;
  consumption?: number;
  supplier?: string;
  supplier_contact?: string;
  linked_expenses_ids?: Array<string>;
  supplier_url?: string;
  can_delete?: boolean;
  can_share?: boolean;
  can_update?: boolean;
  created_at: any;
  updated_at: any;
  imported_at?: any;
  boat_detail?: {
    __typename?: 'BoatDetails';
    name: string;
    id: string;
    flag: string;
    plan?: { __typename?: 'PlanOfUser'; slug?: string };
  };
  item?: { __typename?: 'Item'; id: string; name?: string };
  comments?: Array<{ __typename?: 'Comment'; id: string; like_count?: number }>;
  files?: Array<{
    __typename?: 'File';
    id: string;
    alt?: string;
    url?: string;
    type: string;
    extension: string;
    name: string;
    size: string;
  }>;
  sub_locations?: Array<{ __typename?: 'SubLocation'; level?: number; name?: string }>;
  location_data?: { __typename?: 'Location'; id: string; name: string };
  sub_locations_data?: Array<{ __typename?: 'Location'; id: string; name: string }>;
  unit_price_currency?: { __typename?: 'Currency'; id?: string; iso_code?: string; symbol?: string };
  user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
  linked_expenses?: Array<{
    __typename?: 'Expense';
    item_id: string;
    boat_detail_id: string;
    item_name?: string;
    id: string;
  }>;
  tasks?: Array<{
    __typename?: 'Task';
    id: string;
    name: string;
    boat_detail_id: string;
    user_id: string;
    due_date?: any;
    marked_as_maintenance?: boolean;
    user?: { __typename?: 'User'; display_name?: string; name?: string };
  }>;
  category?: { __typename?: 'Category'; id: string; user_id: string; name: string; type: string };
  costs?: Array<{
    __typename?: 'Cost';
    id: string;
    amount?: number;
    currency_id: string;
    vat_percentage?: number;
    vat_type?: string;
    type: string;
    currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
  }>;
  cost?: {
    __typename?: 'Cost';
    id: string;
    amount?: number;
    currency_id: string;
    vat_percentage?: number;
    vat_type?: string;
    type: string;
    currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
  };
  logs?: Array<{
    __typename?: 'Log';
    id: string;
    datetime?: string;
    trip_id?: string;
    pivot?: { __typename?: 'ExpensePivot'; usage_log_name?: string; usage_value?: number; quantity?: number };
    trip?: { __typename?: 'Trip'; started_at?: string };
    user?: { __typename?: 'User'; id: string; display_name?: string; name?: string; surname?: string };
  }>;
  fields?: Array<{
    __typename?: 'FieldValue';
    id: string;
    name?: string;
    value?: string;
    type?: string;
    options?: Array<string>;
  }>;
};

export type ExpenseItemHistoryFragment = {
  __typename?: 'Expense';
  id: string;
  boat_detail_id: string;
  item_name?: string;
  quantity?: number;
  current_usage_value?: number;
  supplier?: string;
  category_id?: string;
  user?: { __typename?: 'User'; id: string; name?: string; surname?: string };
};

export type FieldsListFragment = {
  __typename?: 'FieldValue';
  id: string;
  name?: string;
  value?: string;
  type?: string;
  options?: Array<string>;
};

export type FileFields = {
  __typename?: 'File';
  can_delete?: boolean;
  can_update?: boolean;
  can_share?: boolean;
  id: string;
  type: string;
  size: string;
  mime_type: string;
  extension: string;
  name: string;
  filename?: string;
  issued_by?: string;
  issuance_date?: any;
  boat_detail_id?: string;
  notes?: string;
  dimensions?: string;
  disk: string;
  alt?: string;
  description?: string;
  visibility: string;
  url?: string;
  public_url?: string;
  download_url?: string;
  folder_id?: string;
  expiration_date?: any;
  expiration_date_time_unit?: number;
  expiration_date_time_unit_type?: string;
  has_expiration_date_reminder?: boolean;
  created_at?: any;
  updated_at?: any;
  user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
  boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
};

export type RequiredFileFields = {
  __typename?: 'File';
  id: string;
  type: string;
  size: string;
  mime_type: string;
  extension: string;
  name: string;
  filename?: string;
  issued_by?: string;
  issuance_date?: any;
  boat_detail_id?: string;
  notes?: string;
  dimensions?: string;
  disk: string;
  alt?: string;
  description?: string;
  visibility: string;
  url?: string;
  public_url?: string;
  download_url?: string;
  folder_id?: string;
  expiration_date?: any;
  expiration_date_time_unit?: number;
  expiration_date_time_unit_type?: string;
  has_expiration_date_reminder?: boolean;
  created_at?: any;
  updated_at?: any;
  boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
};

export type UserProfileImage = { __typename?: 'File'; id: string; url?: string; public_url?: string };

export type FileCard = {
  __typename?: 'File';
  id: string;
  alt?: string;
  url?: string;
  can_delete?: boolean;
  filename?: string;
  type: string;
  extension: string;
  name: string;
  size: string;
};

export type FileCardGallery = {
  __typename?: 'File';
  id: string;
  alt?: string;
  url?: string;
  type: string;
  extension: string;
  name: string;
  size: string;
};

export type FileDetailsFragment = {
  __typename?: 'File';
  id: string;
  type: string;
  size: string;
  mime_type: string;
  extension: string;
  name: string;
  filename?: string;
  issued_by?: string;
  issuance_date?: any;
  boat_detail_id?: string;
  can_delete?: boolean;
  can_update?: boolean;
  can_share?: boolean;
  expiration_date?: any;
  expiration_date_time_unit?: number;
  expiration_date_time_unit_type?: string;
  dimensions?: string;
  url?: string;
  download_url?: string;
  boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
  linked_records?: Array<{
    __typename?: 'Fileable';
    fileable_type: string;
    fileable_id: string;
    display_name?: string;
  }>;
};

export type FolderFragment = {
  __typename?: 'Folder';
  id: string;
  user_id?: number;
  name?: string;
  parent_id?: string;
  path?: string;
  files_count?: number;
  folders_count?: number;
  created_at?: any;
  updated_at?: any;
  parent?: {
    __typename?: 'Folder';
    id: string;
    name?: string;
    parent_id?: string;
    parent?: { __typename?: 'Folder'; id: string; name?: string; parent_id?: string };
  };
  breadcrumb_folders?: Array<{ __typename?: 'BreadcrumbFolder'; id?: string; name?: string }>;
};

export type FolderBreadcrumbs = {
  __typename?: 'Folder';
  id: string;
  name?: string;
  parent_id?: string;
  path?: string;
  breadcrumb_folders?: Array<{ __typename?: 'BreadcrumbFolder'; id?: string; name?: string }>;
};

export type DefaultPagination = {
  __typename?: 'PaginatorInfo';
  count: number;
  currentPage: number;
  firstItem?: number;
  hasMorePages: boolean;
  lastItem?: number;
  lastPage: number;
  perPage: number;
  total: number;
};

export type PlanOfAUserFragment = {
  __typename?: 'PlanOfUser';
  id: string;
  name: string;
  slug?: string;
  gateway_id?: string;
  cost?: number;
  currency?: string;
  interval?: string;
  trial_days?: number;
  status?: string;
  used?: number;
  available?: number;
  total?: number;
  interval_count?: number;
  first_subscription_date?: any;
  end_date?: any;
  is_on_grace?: boolean;
  has_scheduled_update?: boolean;
  subscription_schedule?: {
    __typename?: 'SubscriptionSchedule';
    id: string;
    phases?: Array<{
      __typename?: 'SubscriptionSchedulePhase';
      start_date: number;
      description?: string;
      prorate?: boolean;
      end_date: number;
      plans: Array<{
        __typename?: 'SubscriptionSchedulePlan';
        plan: string;
        price: string;
        quantity: number;
        billing_thresholds?: any;
      }>;
    }>;
  };
};

export type PlanFragment = {
  __typename?: 'Plan';
  id: string;
  name: string;
  slug?: string;
  gateway_id?: string;
  cost?: number;
  currency?: string;
  interval?: string;
  trial_days?: number;
  status?: string;
};

export type UserSubscriptionFragment = {
  __typename?: 'UserSubscription';
  id?: string;
  free_subscription_id?: string;
  is_free?: boolean;
  available_active_alert_slots?: number;
  used_licenses?: number;
  total_licenses?: number;
  available_licenses?: number;
  cost?: number;
  currency?: string;
  interval?: string;
  trial_days?: number;
  status?: string;
  is_on_trial?: boolean;
  interval_count?: number;
  first_subscription_date?: string;
  end_date?: string;
  is_on_grace?: boolean;
  has_scheduled_update?: boolean;
  has_free_boat_available?: boolean;
  trial_ends_at?: string;
  has_available_trial?: boolean;
  next_billing_date?: any;
};

export type SubscriptionScheduleFragment = {
  __typename?: 'SubscriptionSchedule';
  id: string;
  phases?: Array<{
    __typename?: 'SubscriptionSchedulePhase';
    start_date: number;
    description?: string;
    prorate?: boolean;
    end_date: number;
    plans: Array<{
      __typename?: 'SubscriptionSchedulePlan';
      plan: string;
      price: string;
      quantity: number;
      billing_thresholds?: any;
    }>;
  }>;
};

export type SubscriptionPlanFragment = {
  __typename?: 'PlanOfUser';
  id: string;
  name: string;
  slug?: string;
  status?: string;
  cost?: number;
  total?: number;
  available?: number;
};

export type TripFields = {
  __typename?: 'Trip';
  id: string;
  name: string;
  started_at?: string;
  finished_at?: any;
  closed_at?: string;
  boat_detail_id: string;
  origin?: string;
  origin_latitude?: number;
  origin_longitude?: number;
  destination?: string;
  destination_longitude?: number;
  destination_latitude?: number;
  general_logs_count?: number;
  radio_logs_count?: number;
  social_logs_count?: number;
  weather_logs_count?: number;
  can_update?: boolean;
  can_delete?: boolean;
  can_share?: boolean;
  skipper_id?: string;
  crewman_id?: string;
  notes?: string;
  created_at: any;
  updated_at: any;
  boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string; flag: string; location?: string };
  image?: {
    __typename?: 'File';
    id: string;
    type: string;
    size: string;
    mime_type: string;
    extension: string;
    name: string;
    filename?: string;
    issued_by?: string;
    issuance_date?: any;
    boat_detail_id?: string;
    notes?: string;
    dimensions?: string;
    disk: string;
    alt?: string;
    description?: string;
    visibility: string;
    url?: string;
    public_url?: string;
    download_url?: string;
    folder_id?: string;
    expiration_date?: any;
    expiration_date_time_unit?: number;
    expiration_date_time_unit_type?: string;
    has_expiration_date_reminder?: boolean;
    created_at?: any;
    updated_at?: any;
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
  };
  user?: {
    __typename?: 'User';
    id: string;
    display_name?: string;
    name?: string;
    surname?: string;
    email: string;
    image?: {
      __typename?: 'File';
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    };
  };
  skipper?: {
    __typename?: 'User';
    id: string;
    display_name?: string;
    email: string;
    name?: string;
    surname?: string;
    image?: {
      __typename?: 'File';
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    };
  };
  crewman?: {
    __typename?: 'User';
    id: string;
    display_name?: string;
    name?: string;
    surname?: string;
    email: string;
    image?: {
      __typename?: 'File';
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    };
  };
  members?: Array<{
    __typename?: 'User';
    id: string;
    email: string;
    display_name?: string;
    name?: string;
    surname?: string;
    image?: {
      __typename?: 'File';
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    };
  }>;
};

export type ResendEmailVerificationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type ResendEmailVerification = {
  __typename?: 'Mutation';
  resendVerificationEmail?: {
    __typename?: 'ResendVerificationEmailResponse';
    attempts?: number;
    attempts_left?: number;
    last_verification_attempt?: string;
    wait_time?: number;
  };
};

export type UpdateNovuSubscriberCredentialsMutationVariables = Exact<{
  tokens: Array<Scalars['String']['input']> | Scalars['String']['input'];
  provider_id: ProviderId;
}>;

export type UpdateNovuSubscriberCredentialsMutation = {
  __typename?: 'Mutation';
  updateNovuSubscriberCredentials?: {
    __typename?: 'NovuSubscriber';
    id?: string;
    subscriberId?: string;
    channels?: Array<{ __typename?: 'Channel'; _integrationId?: string; providerId?: string }>;
  };
};

export type RegisterNewAccountVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  recaptcha: Scalars['String']['input'];
  referral?: InputMaybe<Scalars['String']['input']>;
}>;

export type RegisterNewAccount = {
  __typename?: 'Mutation';
  register?: { __typename?: 'User'; email: string; id: string; email_verified_at?: any; auth_0_id: string };
};

export type UpdateAlertVariables = Exact<{
  id: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
}>;

export type UpdateAlert = {
  __typename?: 'Mutation';
  updateAlert?: { __typename?: 'Alert'; id: string; active?: boolean };
};

export type MarkAlertAsDoneMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  create_operational_log?: InputMaybe<Scalars['Boolean']['input']>;
  marked_as_done_at?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type MarkAlertAsDoneMutation = {
  __typename?: 'Mutation';
  markAlertAsDone?: {
    __typename?: 'Alert';
    id: string;
    priority: number;
    active?: boolean;
    alertable_id: number;
    alertable_type: string;
    title?: string;
    type?: string;
    date?: any;
    created_at: any;
    category?: string;
    quantity?: number;
    threshold?: number;
    marked_as_done_at?: any;
  };
};

export type AddBoatFromDbVariables = Exact<{
  strapi_ref_document_id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  flag: Scalars['String']['input'];
  year: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  hull_sn?: InputMaybe<Scalars['String']['input']>;
  acquisition_type?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  is_vat_paid?: InputMaybe<Scalars['Boolean']['input']>;
  acquisition_date?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  callsign?: InputMaybe<Scalars['String']['input']>;
  mmsi?: InputMaybe<Scalars['String']['input']>;
  epirb?: InputMaybe<Scalars['String']['input']>;
  in_reach_tracker_id?: InputMaybe<Scalars['String']['input']>;
  spot_tracker_id?: InputMaybe<Scalars['String']['input']>;
  satellite_phone?: InputMaybe<Scalars['String']['input']>;
  mobile_phone?: InputMaybe<Scalars['String']['input']>;
  engine_battery_voltage?: InputMaybe<Scalars['Float']['input']>;
  engine_battery_capacity?: InputMaybe<Scalars['Float']['input']>;
  service_battery_voltage?: InputMaybe<Scalars['Float']['input']>;
  service_battery_capacity?: InputMaybe<Scalars['Float']['input']>;
  inverter_power?: InputMaybe<Scalars['Float']['input']>;
  battery_power?: InputMaybe<Scalars['Float']['input']>;
  solar_power?: InputMaybe<Scalars['Float']['input']>;
  wind_power?: InputMaybe<Scalars['Float']['input']>;
  dg_power?: InputMaybe<Scalars['Float']['input']>;
  service_loads?: InputMaybe<Scalars['String']['input']>;
  tender_name?: InputMaybe<Scalars['String']['input']>;
  tender_vendor?: InputMaybe<Scalars['String']['input']>;
  tender_model?: InputMaybe<Scalars['String']['input']>;
  tender_length?: InputMaybe<Scalars['Float']['input']>;
  image_id?: InputMaybe<Scalars['ID']['input']>;
  files?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  plan_id?: InputMaybe<Scalars['ID']['input']>;
  engines?: InputMaybe<Array<EngineInput> | EngineInput>;
}>;

export type AddBoatFromDb = {
  __typename?: 'Mutation';
  storeBoatDetails?: { __typename?: 'BoatDetails'; name: string };
};

export type AddBoatManuallyVariables = Exact<{
  unit: Scalars['String']['input'];
  image_id?: InputMaybe<Scalars['ID']['input']>;
  manufacturer_name?: InputMaybe<Scalars['String']['input']>;
  manufacturer_site?: InputMaybe<Scalars['String']['input']>;
  manufacturer_id?: InputMaybe<Scalars['ID']['input']>;
  model: Scalars['String']['input'];
  year_first?: InputMaybe<Scalars['Int']['input']>;
  year_last?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  reference_price?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  categories?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  activities?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  hull_type: Scalars['String']['input'];
  hull_material: Scalars['String']['input'];
  cabins?: InputMaybe<Scalars['Int']['input']>;
  berths?: InputMaybe<Scalars['Int']['input']>;
  heads?: InputMaybe<Scalars['Int']['input']>;
  hull_appendages?: InputMaybe<Array<FieldInput> | FieldInput>;
  top_speed?: InputMaybe<Scalars['Float']['input']>;
  cruising_speed?: InputMaybe<Scalars['Float']['input']>;
  mast?: InputMaybe<Scalars['Float']['input']>;
  loa: Scalars['Float']['input'];
  lwl?: InputMaybe<Scalars['Float']['input']>;
  boa?: InputMaybe<Scalars['Float']['input']>;
  bcl?: InputMaybe<Scalars['Float']['input']>;
  bh?: InputMaybe<Scalars['Float']['input']>;
  headroom?: InputMaybe<Scalars['Float']['input']>;
  bdcl?: InputMaybe<Scalars['Float']['input']>;
  nom?: InputMaybe<Scalars['Float']['input']>;
  draft_max?: InputMaybe<Scalars['Float']['input']>;
  draft_min?: InputMaybe<Scalars['Float']['input']>;
  displacement?: InputMaybe<Scalars['Float']['input']>;
  tonnage_gross?: InputMaybe<Scalars['Float']['input']>;
  tonnage_net?: InputMaybe<Scalars['Float']['input']>;
  ballast_type?: InputMaybe<Scalars['String']['input']>;
  ballast_weight?: InputMaybe<Scalars['Float']['input']>;
  helm?: InputMaybe<Scalars['String']['input']>;
  rudder?: InputMaybe<Scalars['String']['input']>;
  cockpit_location?: InputMaybe<Scalars['String']['input']>;
  cockpit_type?: InputMaybe<Scalars['String']['input']>;
  unsinkable?: InputMaybe<Scalars['Boolean']['input']>;
  trailerable?: InputMaybe<Scalars['Boolean']['input']>;
  ce_classification?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>> | InputMaybe<Scalars['Float']['input']>>;
  designer_name?: InputMaybe<Scalars['String']['input']>;
  designer_site?: InputMaybe<Scalars['String']['input']>;
  exterior_design?: InputMaybe<Scalars['String']['input']>;
  exterior_site?: InputMaybe<Scalars['String']['input']>;
  interior_design?: InputMaybe<Scalars['String']['input']>;
  interior_site?: InputMaybe<Scalars['String']['input']>;
  rigging?: InputMaybe<Scalars['String']['input']>;
  rotating_spars?: InputMaybe<Scalars['Boolean']['input']>;
  mast_configuration?: InputMaybe<Scalars['String']['input']>;
  spars?: InputMaybe<Scalars['String']['input']>;
  standing_rigging?: InputMaybe<Scalars['String']['input']>;
  spreaders_level?: InputMaybe<Scalars['Float']['input']>;
  spreaders_angle?: InputMaybe<Scalars['String']['input']>;
  upwind_sail_area?: InputMaybe<Scalars['Float']['input']>;
  downwind_sail_area?: InputMaybe<Scalars['Float']['input']>;
  mainsail?: InputMaybe<Array<FieldInput> | FieldInput>;
  headsail?: InputMaybe<Array<FieldInput> | FieldInput>;
  spinnaker?: InputMaybe<Array<FieldInput> | FieldInput>;
  fuel_tank?: InputMaybe<Array<CapacityInput> | CapacityInput>;
  water_tank?: InputMaybe<Array<CapacityInput> | CapacityInput>;
  holding_tank?: InputMaybe<Array<CapacityInput> | CapacityInput>;
  water_heater?: InputMaybe<Array<CapacityInput> | CapacityInput>;
  files?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  boatDetails: BoatDetailsInput;
  plan_id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type AddBoatManually = {
  __typename?: 'Mutation';
  fullStoreBoatDetails?: {
    __typename?: 'Boat';
    id: string;
    userBoatDetails?: Array<{ __typename?: 'BoatDetails'; name: string }>;
    manufacturer?: { __typename?: 'Manufacturer'; name?: string };
  };
};

export type UpdateBoatFromDbVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  flag: Scalars['String']['input'];
  year: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  acquisition_date?: InputMaybe<Scalars['String']['input']>;
  acquisition_type?: InputMaybe<Scalars['String']['input']>;
  nr_past_owners?: InputMaybe<Scalars['Int']['input']>;
  ownership_order?: InputMaybe<Scalars['String']['input']>;
  hull_sn?: InputMaybe<Scalars['String']['input']>;
  mmsi?: InputMaybe<Scalars['String']['input']>;
  callsign?: InputMaybe<Scalars['String']['input']>;
  epirb?: InputMaybe<Scalars['String']['input']>;
  in_reach_tracker_id?: InputMaybe<Scalars['String']['input']>;
  spot_tracker_id?: InputMaybe<Scalars['String']['input']>;
  satellite_phone?: InputMaybe<Scalars['String']['input']>;
  mobile_phone?: InputMaybe<Scalars['String']['input']>;
  is_vat_paid?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  engine_battery_voltage?: InputMaybe<Scalars['Float']['input']>;
  engine_battery_capacity?: InputMaybe<Scalars['Float']['input']>;
  service_battery_voltage?: InputMaybe<Scalars['Float']['input']>;
  service_battery_capacity?: InputMaybe<Scalars['Float']['input']>;
  battery_power?: InputMaybe<Scalars['Float']['input']>;
  inverter_power?: InputMaybe<Scalars['Float']['input']>;
  solar_power?: InputMaybe<Scalars['Float']['input']>;
  wind_power?: InputMaybe<Scalars['Float']['input']>;
  dg_power?: InputMaybe<Scalars['Float']['input']>;
  service_loads?: InputMaybe<Scalars['String']['input']>;
  tender_name?: InputMaybe<Scalars['String']['input']>;
  tender_vendor?: InputMaybe<Scalars['String']['input']>;
  tender_model?: InputMaybe<Scalars['String']['input']>;
  tender_length?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  image_id?: InputMaybe<Scalars['ID']['input']>;
  files?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  fields?: InputMaybe<Array<FieldInput> | FieldInput>;
  engines?: InputMaybe<Array<EngineInput> | EngineInput>;
}>;

export type UpdateBoatFromDb = {
  __typename?: 'Mutation';
  updateBoatDetails?: { __typename?: 'BoatDetails'; id: string; name: string };
};

export type UpdateBoatManuallyVariables = Exact<{
  boat_detail_id: Scalars['ID']['input'];
  unit: Scalars['String']['input'];
  image_path?: InputMaybe<Scalars['Upload']['input']>;
  image_id?: InputMaybe<Scalars['ID']['input']>;
  manufacturer_name?: InputMaybe<Scalars['String']['input']>;
  manufacturer_site?: InputMaybe<Scalars['String']['input']>;
  manufacturer_id?: InputMaybe<Scalars['ID']['input']>;
  model: Scalars['String']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
  year_first?: InputMaybe<Scalars['Int']['input']>;
  year_last?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  reference_price?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  activity?: InputMaybe<Scalars['String']['input']>;
  activities?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  hull_type: Scalars['String']['input'];
  hull_material: Scalars['String']['input'];
  keel_type?: InputMaybe<Scalars['String']['input']>;
  cabins?: InputMaybe<Scalars['Int']['input']>;
  berths?: InputMaybe<Scalars['Int']['input']>;
  heads?: InputMaybe<Scalars['Int']['input']>;
  appendages?: InputMaybe<Scalars['String']['input']>;
  hull_appendages?: InputMaybe<Array<FieldInput> | FieldInput>;
  top_speed?: InputMaybe<Scalars['Float']['input']>;
  cruising_speed?: InputMaybe<Scalars['Float']['input']>;
  mast?: InputMaybe<Scalars['Float']['input']>;
  loa: Scalars['Float']['input'];
  lwl?: InputMaybe<Scalars['Float']['input']>;
  boa?: InputMaybe<Scalars['Float']['input']>;
  bcl?: InputMaybe<Scalars['Float']['input']>;
  bh?: InputMaybe<Scalars['Float']['input']>;
  headroom?: InputMaybe<Scalars['Float']['input']>;
  bdcl?: InputMaybe<Scalars['Float']['input']>;
  nom?: InputMaybe<Scalars['Float']['input']>;
  draft_max?: InputMaybe<Scalars['Float']['input']>;
  draft_min?: InputMaybe<Scalars['Float']['input']>;
  displacement?: InputMaybe<Scalars['Float']['input']>;
  tonnage_gross?: InputMaybe<Scalars['Float']['input']>;
  tonnage_net?: InputMaybe<Scalars['Float']['input']>;
  ballast_type?: InputMaybe<Scalars['String']['input']>;
  ballast_weight?: InputMaybe<Scalars['Float']['input']>;
  helm?: InputMaybe<Scalars['String']['input']>;
  rudder?: InputMaybe<Scalars['String']['input']>;
  cockpit_location?: InputMaybe<Scalars['String']['input']>;
  cockpit_type?: InputMaybe<Scalars['String']['input']>;
  unsinkable?: InputMaybe<Scalars['Boolean']['input']>;
  trailerable?: InputMaybe<Scalars['Boolean']['input']>;
  ce_classification?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>> | InputMaybe<Scalars['Float']['input']>>;
  designer_name?: InputMaybe<Scalars['String']['input']>;
  designer_site?: InputMaybe<Scalars['String']['input']>;
  exterior_design?: InputMaybe<Scalars['String']['input']>;
  exterior_site?: InputMaybe<Scalars['String']['input']>;
  interior_design?: InputMaybe<Scalars['String']['input']>;
  interior_site?: InputMaybe<Scalars['String']['input']>;
  rigging?: InputMaybe<Scalars['String']['input']>;
  rotating_spars?: InputMaybe<Scalars['Boolean']['input']>;
  mast_position?: InputMaybe<Scalars['String']['input']>;
  mast_configuration?: InputMaybe<Scalars['String']['input']>;
  spars?: InputMaybe<Scalars['String']['input']>;
  standing_rigging?: InputMaybe<Scalars['String']['input']>;
  spreaders_level?: InputMaybe<Scalars['Float']['input']>;
  spreaders_angle?: InputMaybe<Scalars['String']['input']>;
  upwind_sail_area?: InputMaybe<Scalars['Float']['input']>;
  downwind_sail_area?: InputMaybe<Scalars['Float']['input']>;
  sail_area_type_a?: InputMaybe<Scalars['String']['input']>;
  sail_area_type_b?: InputMaybe<Scalars['String']['input']>;
  sail_area_type_c?: InputMaybe<Scalars['String']['input']>;
  sail_area?: InputMaybe<Scalars['Float']['input']>;
  sail_area_b?: InputMaybe<Scalars['Float']['input']>;
  sail_area_c?: InputMaybe<Scalars['Float']['input']>;
  genoa_type_a?: InputMaybe<Scalars['String']['input']>;
  genoa_type_b?: InputMaybe<Scalars['String']['input']>;
  genoa_type_c?: InputMaybe<Scalars['String']['input']>;
  genoa_sail_area_a?: InputMaybe<Scalars['Float']['input']>;
  genoa_sail_area_b?: InputMaybe<Scalars['Float']['input']>;
  genoa_sail_area_c?: InputMaybe<Scalars['Float']['input']>;
  spinnaker_type_a?: InputMaybe<Scalars['String']['input']>;
  spinnaker_type_b?: InputMaybe<Scalars['String']['input']>;
  spinnaker_type_c?: InputMaybe<Scalars['String']['input']>;
  spinnaker_sail_area_a?: InputMaybe<Scalars['Float']['input']>;
  spinnaker_sail_area_b?: InputMaybe<Scalars['Float']['input']>;
  spinnaker_sail_area_c?: InputMaybe<Scalars['Float']['input']>;
  mainsail?: InputMaybe<Array<FieldInput> | FieldInput>;
  headsail?: InputMaybe<Array<FieldInput> | FieldInput>;
  spinnaker?: InputMaybe<Array<FieldInput> | FieldInput>;
  genoa?: InputMaybe<Array<FieldInput> | FieldInput>;
  engine_manufacturer?: InputMaybe<Scalars['String']['input']>;
  engine_manufacturer_site?: InputMaybe<Scalars['String']['input']>;
  engine_model?: InputMaybe<Scalars['String']['input']>;
  engine_type?: InputMaybe<Scalars['String']['input']>;
  engine_power?: InputMaybe<Scalars['Float']['input']>;
  engine_power_type?: InputMaybe<Scalars['String']['input']>;
  engine_manufacturer_b?: InputMaybe<Scalars['String']['input']>;
  engine_manufacturer_site_b?: InputMaybe<Scalars['String']['input']>;
  engine_model_b?: InputMaybe<Scalars['String']['input']>;
  engine_type_b?: InputMaybe<Scalars['String']['input']>;
  engine_power_b?: InputMaybe<Scalars['Float']['input']>;
  engine_power_type_b?: InputMaybe<Scalars['String']['input']>;
  water_capacity?: InputMaybe<Scalars['Float']['input']>;
  water_capacity_tank_b?: InputMaybe<Scalars['Float']['input']>;
  fuel_capacity?: InputMaybe<Scalars['Float']['input']>;
  fuel_capacity_tank_b?: InputMaybe<Scalars['Float']['input']>;
  holding_tank_capacity?: InputMaybe<Scalars['Float']['input']>;
  water_heater_capacity?: InputMaybe<Scalars['Float']['input']>;
  fuel_tank?: InputMaybe<Array<CapacityInput> | CapacityInput>;
  water_tank?: InputMaybe<Array<CapacityInput> | CapacityInput>;
  holding_tank?: InputMaybe<Array<CapacityInput> | CapacityInput>;
  water_heater?: InputMaybe<Array<CapacityInput> | CapacityInput>;
  files?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  boatDetails: BoatDetailsInput;
  fields?: InputMaybe<Array<FieldInput> | FieldInput>;
}>;

export type UpdateBoatManually = {
  __typename?: 'Mutation';
  fullUpdateBoatDetails?: {
    __typename?: 'Boat';
    id: string;
    userBoatDetails?: Array<{
      __typename?: 'BoatDetails';
      id: string;
      name: string;
      files?: Array<{ __typename?: 'File'; id: string }>;
      boat?: { __typename?: 'Boat'; files?: Array<{ __typename?: 'File'; id: string }> };
    }>;
  };
};

export type DeleteBoatVariables = Exact<{
  boat_id: Scalars['ID']['input'];
}>;

export type DeleteBoat = { __typename?: 'Mutation'; deleteBoatDetails?: boolean };

export type AddCategoryVariables = Exact<{
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;

export type AddCategory = {
  __typename?: 'Mutation';
  storeCategory?: {
    __typename?: 'Category';
    id: string;
    user_id: string;
    name: string;
    type: string;
    is_user_defined: boolean;
  };
};

export type UpdateCategoryVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;

export type UpdateCategory = {
  __typename?: 'Mutation';
  updateCategory?: {
    __typename?: 'Category';
    id: string;
    user_id: string;
    name: string;
    type: string;
    is_user_defined: boolean;
  };
};

export type DeleteCategoryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteCategory = { __typename?: 'Mutation'; deleteCategory?: boolean };

export type AddChecklistVariables = Exact<{
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  with_items?: InputMaybe<Scalars['Boolean']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  image_id?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<InputMaybe<ChecklistItemInput>> | InputMaybe<ChecklistItemInput>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  related_records?: InputMaybe<Array<InputMaybe<Checklistable>> | InputMaybe<Checklistable>>;
}>;

export type AddChecklist = {
  __typename?: 'Mutation';
  storeChecklist?: {
    __typename: 'Checklist';
    created_at: any;
    belongs_to_current_user: boolean;
    can_add_comment: boolean;
    can_copy: boolean;
    can_create_new_item: boolean;
    can_delete: boolean;
    can_follow: boolean;
    can_update: boolean;
    can_sort_items: boolean;
    can_unfollow: boolean;
    can_share?: boolean;
    can_view: boolean;
    can_view_blocked_users: boolean;
    can_view_comments: boolean;
    can_view_followers: boolean;
    clones_count?: number;
    comments_count?: number;
    description?: string;
    id: string;
    is_followed_by_current_user: boolean;
    is_public: boolean;
    updated_at: any;
    old_image_id?: string;
    title: string;
    user_followers_count?: number;
    image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
    old_image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
    items?: Array<{ __typename?: 'ChecklistItem'; id: string; name: string; position?: number; checked: boolean }>;
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
  };
};

export type UpdateChecklistVariables = Exact<{
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  with_items?: InputMaybe<Scalars['Boolean']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  image_id?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<InputMaybe<ChecklistItemInput>> | InputMaybe<ChecklistItemInput>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  related_records?: InputMaybe<Array<InputMaybe<Checklistable>> | InputMaybe<Checklistable>>;
}>;

export type UpdateChecklist = {
  __typename?: 'Mutation';
  updateChecklist?: {
    __typename: 'Checklist';
    created_at: any;
    belongs_to_current_user: boolean;
    can_add_comment: boolean;
    can_copy: boolean;
    can_create_new_item: boolean;
    can_delete: boolean;
    can_follow: boolean;
    can_update: boolean;
    can_sort_items: boolean;
    can_unfollow: boolean;
    can_share?: boolean;
    can_view: boolean;
    can_view_blocked_users: boolean;
    can_view_comments: boolean;
    can_view_followers: boolean;
    clones_count?: number;
    comments_count?: number;
    description?: string;
    id: string;
    is_followed_by_current_user: boolean;
    is_public: boolean;
    updated_at: any;
    old_image_id?: string;
    title: string;
    user_followers_count?: number;
    image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
    old_image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
    items?: Array<{ __typename?: 'ChecklistItem'; id: string; name: string; position?: number; checked: boolean }>;
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
  };
};

export type CopyChecklistVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CopyChecklist = {
  __typename?: 'Mutation';
  copyChecklist?: {
    __typename: 'Checklist';
    created_at: any;
    belongs_to_current_user: boolean;
    can_add_comment: boolean;
    can_copy: boolean;
    can_create_new_item: boolean;
    can_delete: boolean;
    can_follow: boolean;
    can_update: boolean;
    can_sort_items: boolean;
    can_unfollow: boolean;
    can_share?: boolean;
    can_view: boolean;
    can_view_blocked_users: boolean;
    can_view_comments: boolean;
    can_view_followers: boolean;
    clones_count?: number;
    comments_count?: number;
    description?: string;
    id: string;
    is_followed_by_current_user: boolean;
    is_public: boolean;
    updated_at: any;
    old_image_id?: string;
    title: string;
    user_followers_count?: number;
    image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
    old_image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
    items?: Array<{ __typename?: 'ChecklistItem'; id: string; name: string; position?: number; checked: boolean }>;
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
  };
};

export type DeleteChecklistVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteChecklist = { __typename?: 'Mutation'; deleteChecklist?: boolean };

export type FollowChecklistVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type FollowChecklist = { __typename?: 'Mutation'; followChecklist?: boolean };

export type UnfollowChecklistVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type UnfollowChecklist = { __typename?: 'Mutation'; unfollowChecklist?: boolean };

export type AddChecklistCommentVariables = Exact<{
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;

export type AddChecklistComment = {
  __typename?: 'Mutation';
  storeChecklistComment?: { __typename?: 'Comment'; id: string; text: string };
};

export type EditChecklistCommentVariables = Exact<{
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;

export type EditChecklistComment = {
  __typename?: 'Mutation';
  updateChecklistComment?: {
    __typename?: 'Comment';
    id: string;
    text: string;
    updated_at_diff: string;
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
  };
};

export type DeleteChecklistCommentVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteChecklistComment = { __typename?: 'Mutation'; deleteChecklistComment?: boolean };

export type PostCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  commentable_type: Scalars['String']['input'];
  text: Scalars['String']['input'];
}>;

export type PostCommentMutation = {
  __typename?: 'Mutation';
  storeComment?: {
    __typename?: 'Comment';
    id: string;
    can_unlike: boolean;
    like_count?: number;
    text: string;
    created_at_diff: string;
    updated_at_diff: string;
    can_update: boolean;
    can_delete: boolean;
    can_like: boolean;
    user?: {
      __typename?: 'User';
      id: string;
      surname?: string;
      name?: string;
      image?: { __typename?: 'File'; id: string; url?: string };
    };
  };
};

export type UpdateCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;

export type UpdateCommentMutation = {
  __typename?: 'Mutation';
  updateComment?: {
    __typename?: 'Comment';
    id: string;
    can_unlike: boolean;
    like_count?: number;
    text: string;
    created_at_diff: string;
    updated_at_diff: string;
    can_update: boolean;
    can_delete: boolean;
    can_like: boolean;
    user?: {
      __typename?: 'User';
      id: string;
      surname?: string;
      name?: string;
      image?: { __typename?: 'File'; id: string; url?: string };
    };
  };
};

export type DeleteCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteCommentMutation = { __typename?: 'Mutation'; deleteComment?: boolean };

export type LikeCommentMutationVariables = Exact<{
  comment_id: Scalars['ID']['input'];
}>;

export type LikeCommentMutation = { __typename?: 'Mutation'; likeComment?: boolean };

export type UnlikeCommentMutationVariables = Exact<{
  comment_id: Scalars['ID']['input'];
}>;

export type UnlikeCommentMutation = { __typename?: 'Mutation'; unlikeComment?: boolean };

export type BlockForUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  blocker_type: Scalars['String']['input'];
  blocker_id: Scalars['ID']['input'];
}>;

export type BlockForUserMutation = { __typename?: 'Mutation'; blockForUser?: boolean };

export type UnblockForUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  blocker_type: Scalars['String']['input'];
  blocker_id: Scalars['ID']['input'];
}>;

export type UnblockForUserMutation = { __typename?: 'Mutation'; unblockForUser?: boolean };

export type StoreCostVariables = Exact<{
  boat_detail_id: Scalars['ID']['input'];
  category_id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  vat_percentage?: InputMaybe<Scalars['Int']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  vat_type?: InputMaybe<Scalars['String']['input']>;
  currency_id: Scalars['ID']['input'];
  files?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  costables: Array<Costable> | Costable;
  is_maintenance_cost?: InputMaybe<Scalars['Boolean']['input']>;
  quantity_action?: InputMaybe<Scalars['String']['input']>;
}>;

export type StoreCost = {
  __typename?: 'Mutation';
  storeCost?: {
    __typename?: 'Cost';
    amount?: number;
    id: string;
    notes?: string;
    type: string;
    exchange_rate?: number;
    quantity?: number;
    is_maintenance_cost?: boolean;
    name: string;
    can_delete?: boolean;
    can_update?: boolean;
    date?: any;
    user_id: string;
    boat_detail_id?: string;
    category_id?: string;
    currency_id: string;
    supplier?: string;
    vat_percentage?: number;
    vat_type?: string;
    created_at: any;
    updated_at: any;
    trips?: Array<{ __typename?: 'Trip'; id: string; name: string }>;
    logs?: Array<{ __typename?: 'Log'; id: string; datetime?: string }>;
    tasks?: Array<{ __typename?: 'Task'; id: string; name: string }>;
    expenses?: Array<{ __typename?: 'Expense'; id: string; item_name?: string }>;
    comments?: Array<{ __typename?: 'Comment'; id: string; text: string }>;
    category?: { __typename?: 'Category'; id: string; name: string };
    documents?: Array<{
      __typename?: 'File';
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    }>;
    files?: Array<{
      __typename?: 'File';
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    }>;
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string; flag: string };
    currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string; symbol?: string };
  };
};

export type UpdateCostVariables = Exact<{
  id: Scalars['ID']['input'];
  boat_detail_id: Scalars['ID']['input'];
  category_id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  vat_percentage?: InputMaybe<Scalars['Int']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  vat_type?: InputMaybe<Scalars['String']['input']>;
  currency_id: Scalars['ID']['input'];
  files?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  costables: Array<Costable> | Costable;
  is_maintenance_cost?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UpdateCost = {
  __typename?: 'Mutation';
  updateCost?: {
    __typename?: 'Cost';
    amount?: number;
    id: string;
    notes?: string;
    type: string;
    exchange_rate?: number;
    quantity?: number;
    is_maintenance_cost?: boolean;
    name: string;
    can_delete?: boolean;
    can_update?: boolean;
    date?: any;
    user_id: string;
    boat_detail_id?: string;
    category_id?: string;
    currency_id: string;
    supplier?: string;
    vat_percentage?: number;
    vat_type?: string;
    created_at: any;
    updated_at: any;
    trips?: Array<{ __typename?: 'Trip'; id: string; name: string }>;
    logs?: Array<{ __typename?: 'Log'; id: string; datetime?: string }>;
    tasks?: Array<{ __typename?: 'Task'; id: string; name: string }>;
    expenses?: Array<{ __typename?: 'Expense'; id: string; item_name?: string }>;
    comments?: Array<{ __typename?: 'Comment'; id: string; text: string }>;
    category?: { __typename?: 'Category'; id: string; name: string };
    documents?: Array<{
      __typename?: 'File';
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    }>;
    files?: Array<{
      __typename?: 'File';
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    }>;
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string; flag: string };
    currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string; symbol?: string };
  };
};

export type DeleteCostVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteCost = { __typename?: 'Mutation'; deleteCost?: boolean };

export type StoreFieldVariables = Exact<{
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  module?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type StoreField = {
  __typename?: 'Mutation';
  storeField?: {
    __typename?: 'Field';
    id: string;
    user_id: string;
    type?: string;
    name?: string;
    module?: string;
    options_data?: Array<string>;
    options?: string;
    slug?: string;
  };
};

export type UpdateFieldVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type UpdateField = {
  __typename?: 'Mutation';
  updateField?: {
    __typename?: 'Field';
    id: string;
    user_id: string;
    type?: string;
    name?: string;
    module?: string;
    options_data?: Array<string>;
    options?: string;
    slug?: string;
  };
};

export type DeleteFieldVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteField = { __typename?: 'Mutation'; deleteField?: boolean };

export type DeactivateUserVariables = Exact<{ [key: string]: never }>;

export type DeactivateUser = { __typename?: 'Mutation'; deactivateUser?: boolean };

export type AddExpenseVariables = Exact<{
  boat_detail_id: Scalars['ID']['input'];
  item_name: Scalars['String']['input'];
  currency_id?: InputMaybe<Scalars['ID']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  sub_locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  serial_number?: InputMaybe<Scalars['String']['input']>;
  vendor_page?: InputMaybe<Scalars['String']['input']>;
  packing?: InputMaybe<Scalars['String']['input']>;
  acquisition_date?: InputMaybe<Scalars['String']['input']>;
  expiration_date?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  linked_expenses_ids?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  notes?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  consumption?: InputMaybe<Scalars['Float']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  supplier_contact?: InputMaybe<Scalars['String']['input']>;
  expiration_time_unit?: InputMaybe<Scalars['Int']['input']>;
  expiration_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  expiration_is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  has_expiration_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  warranty_date?: InputMaybe<Scalars['String']['input']>;
  warranty_time_unit?: InputMaybe<Scalars['Int']['input']>;
  warranty_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  warranty_is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  has_warranty_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  is_recurring?: InputMaybe<Scalars['Boolean']['input']>;
  has_usage_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  current_usage_value?: InputMaybe<Scalars['Float']['input']>;
  usage_threshold?: InputMaybe<Scalars['Float']['input']>;
  usage_time_unit?: InputMaybe<Scalars['Int']['input']>;
  usage_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  usage_is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  recurrence_type?: InputMaybe<Scalars['String']['input']>;
  threshold_reminder_value?: InputMaybe<Scalars['Float']['input']>;
  has_threshold_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  usage_recurrence_time_unit?: InputMaybe<Scalars['Int']['input']>;
  usage_recurrence_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  threshold_recurrence_reminder?: InputMaybe<Scalars['Float']['input']>;
  usage_due_date?: InputMaybe<Scalars['String']['input']>;
  due_date_time_unit?: InputMaybe<Scalars['Int']['input']>;
  due_date_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  has_due_date_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  usage_recurrence?: InputMaybe<Scalars['Float']['input']>;
  task_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  location_id?: InputMaybe<Scalars['ID']['input']>;
  sub_location_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  current_amount?: InputMaybe<Scalars['Float']['input']>;
  minimum_quantity?: InputMaybe<Scalars['Float']['input']>;
  minimum_quantity_reminder?: InputMaybe<Scalars['Float']['input']>;
  has_minimum_quantity_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>> | InputMaybe<FieldInput>>;
}>;

export type AddExpense = {
  __typename?: 'Mutation';
  storeExpense?: {
    __typename?: 'Expense';
    id: string;
    boat_detail_id: string;
    user_id: string;
    item_id: string;
    item_name?: string;
    type?: string;
    notes?: string;
    location?: string;
    has_minimum_quantity_reminder?: boolean;
    minimum_quantity?: number;
    minimum_quantity_reminder?: number;
    brand?: string;
    model?: string;
    part_number?: string;
    serial_number?: string;
    barcode?: string;
    vendor_page?: string;
    packing?: string;
    acquisition_date?: string;
    expiration_date?: string;
    expiration_time_unit?: number;
    expiration_time_unit_type?: string;
    expiration_is_custom?: boolean;
    has_expiration_reminder?: boolean;
    warranty_date?: string;
    warranty_time_unit?: number;
    warranty_time_unit_type?: string;
    warranty_is_custom?: boolean;
    has_warranty_reminder?: boolean;
    is_recurring?: boolean;
    has_usage_reminder?: boolean;
    current_usage_value?: number;
    usage_due_date?: string;
    due_date_time_unit?: number;
    due_date_time_unit_type?: string;
    has_due_date_reminder?: boolean;
    usage_threshold?: number;
    usage_time_unit?: number;
    usage_time_unit_type?: string;
    recurrence_type?: string;
    threshold_reminder_value?: number;
    has_threshold_reminder?: boolean;
    threshold_recurrence_reminder?: number;
    usage_recurrence_time_unit?: number;
    usage_recurrence_time_unit_type?: string;
    usage_is_custom?: boolean;
    usage_recurrence?: number;
    maintenance_synced?: boolean;
    unit?: string;
    quantity?: number;
    total?: number;
    converted_total?: number;
    unit_price?: number;
    voltage?: number;
    width?: number;
    height?: number;
    depth?: number;
    weight?: number;
    consumption?: number;
    supplier?: string;
    supplier_contact?: string;
    linked_expenses_ids?: Array<string>;
    supplier_url?: string;
    can_delete?: boolean;
    can_share?: boolean;
    can_update?: boolean;
    created_at: any;
    updated_at: any;
    imported_at?: any;
    boat_detail?: {
      __typename?: 'BoatDetails';
      name: string;
      id: string;
      flag: string;
      plan?: { __typename?: 'PlanOfUser'; slug?: string };
    };
    item?: { __typename?: 'Item'; id: string; name?: string };
    comments?: Array<{ __typename?: 'Comment'; id: string; like_count?: number }>;
    files?: Array<{
      __typename?: 'File';
      id: string;
      alt?: string;
      url?: string;
      type: string;
      extension: string;
      name: string;
      size: string;
    }>;
    sub_locations?: Array<{ __typename?: 'SubLocation'; level?: number; name?: string }>;
    location_data?: { __typename?: 'Location'; id: string; name: string };
    sub_locations_data?: Array<{ __typename?: 'Location'; id: string; name: string }>;
    unit_price_currency?: { __typename?: 'Currency'; id?: string; iso_code?: string; symbol?: string };
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
    linked_expenses?: Array<{
      __typename?: 'Expense';
      item_id: string;
      boat_detail_id: string;
      item_name?: string;
      id: string;
    }>;
    tasks?: Array<{
      __typename?: 'Task';
      id: string;
      name: string;
      boat_detail_id: string;
      user_id: string;
      due_date?: any;
      marked_as_maintenance?: boolean;
      user?: { __typename?: 'User'; display_name?: string; name?: string };
    }>;
    category?: { __typename?: 'Category'; id: string; user_id: string; name: string; type: string };
    costs?: Array<{
      __typename?: 'Cost';
      id: string;
      amount?: number;
      currency_id: string;
      vat_percentage?: number;
      vat_type?: string;
      type: string;
      currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
    }>;
    cost?: {
      __typename?: 'Cost';
      id: string;
      amount?: number;
      currency_id: string;
      vat_percentage?: number;
      vat_type?: string;
      type: string;
      currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
    };
    logs?: Array<{
      __typename?: 'Log';
      id: string;
      datetime?: string;
      trip_id?: string;
      pivot?: { __typename?: 'ExpensePivot'; usage_log_name?: string; usage_value?: number; quantity?: number };
      trip?: { __typename?: 'Trip'; started_at?: string };
      user?: { __typename?: 'User'; id: string; display_name?: string; name?: string; surname?: string };
    }>;
    fields?: Array<{
      __typename?: 'FieldValue';
      id: string;
      name?: string;
      value?: string;
      type?: string;
      options?: Array<string>;
    }>;
  };
};

export type EditExpenseVariables = Exact<{
  id: Scalars['ID']['input'];
  item_name: Scalars['String']['input'];
  currency_id?: InputMaybe<Scalars['ID']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  sub_locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  serial_number?: InputMaybe<Scalars['String']['input']>;
  vendor_page?: InputMaybe<Scalars['String']['input']>;
  packing?: InputMaybe<Scalars['String']['input']>;
  acquisition_date?: InputMaybe<Scalars['String']['input']>;
  expiration_date?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  linked_expenses_ids?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  notes?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  consumption?: InputMaybe<Scalars['Float']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  supplier_contact?: InputMaybe<Scalars['String']['input']>;
  expiration_time_unit?: InputMaybe<Scalars['Int']['input']>;
  expiration_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  expiration_is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  has_expiration_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  warranty_date?: InputMaybe<Scalars['String']['input']>;
  warranty_time_unit?: InputMaybe<Scalars['Int']['input']>;
  warranty_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  warranty_is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  has_warranty_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  is_recurring?: InputMaybe<Scalars['Boolean']['input']>;
  has_usage_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  current_usage_value?: InputMaybe<Scalars['Float']['input']>;
  usage_threshold?: InputMaybe<Scalars['Float']['input']>;
  usage_time_unit?: InputMaybe<Scalars['Int']['input']>;
  usage_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  usage_is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  recurrence_type?: InputMaybe<Scalars['String']['input']>;
  threshold_reminder_value?: InputMaybe<Scalars['Float']['input']>;
  has_threshold_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  usage_recurrence_time_unit?: InputMaybe<Scalars['Int']['input']>;
  usage_recurrence_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  threshold_recurrence_reminder?: InputMaybe<Scalars['Float']['input']>;
  usage_due_date?: InputMaybe<Scalars['String']['input']>;
  due_date_time_unit?: InputMaybe<Scalars['Int']['input']>;
  due_date_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  has_due_date_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  usage_recurrence?: InputMaybe<Scalars['Float']['input']>;
  task_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  location_id?: InputMaybe<Scalars['ID']['input']>;
  sub_location_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  current_amount?: InputMaybe<Scalars['Float']['input']>;
  minimum_quantity?: InputMaybe<Scalars['Float']['input']>;
  minimum_quantity_reminder?: InputMaybe<Scalars['Float']['input']>;
  has_minimum_quantity_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  boat_detail_id: Scalars['ID']['input'];
  fields?: InputMaybe<Array<InputMaybe<FieldInput>> | InputMaybe<FieldInput>>;
}>;

export type EditExpense = {
  __typename?: 'Mutation';
  updateExpense?: {
    __typename?: 'Expense';
    id: string;
    boat_detail_id: string;
    user_id: string;
    item_id: string;
    item_name?: string;
    type?: string;
    notes?: string;
    location?: string;
    has_minimum_quantity_reminder?: boolean;
    minimum_quantity?: number;
    minimum_quantity_reminder?: number;
    brand?: string;
    model?: string;
    part_number?: string;
    serial_number?: string;
    barcode?: string;
    vendor_page?: string;
    packing?: string;
    acquisition_date?: string;
    expiration_date?: string;
    expiration_time_unit?: number;
    expiration_time_unit_type?: string;
    expiration_is_custom?: boolean;
    has_expiration_reminder?: boolean;
    warranty_date?: string;
    warranty_time_unit?: number;
    warranty_time_unit_type?: string;
    warranty_is_custom?: boolean;
    has_warranty_reminder?: boolean;
    is_recurring?: boolean;
    has_usage_reminder?: boolean;
    current_usage_value?: number;
    usage_due_date?: string;
    due_date_time_unit?: number;
    due_date_time_unit_type?: string;
    has_due_date_reminder?: boolean;
    usage_threshold?: number;
    usage_time_unit?: number;
    usage_time_unit_type?: string;
    recurrence_type?: string;
    threshold_reminder_value?: number;
    has_threshold_reminder?: boolean;
    threshold_recurrence_reminder?: number;
    usage_recurrence_time_unit?: number;
    usage_recurrence_time_unit_type?: string;
    usage_is_custom?: boolean;
    usage_recurrence?: number;
    maintenance_synced?: boolean;
    unit?: string;
    quantity?: number;
    total?: number;
    converted_total?: number;
    unit_price?: number;
    voltage?: number;
    width?: number;
    height?: number;
    depth?: number;
    weight?: number;
    consumption?: number;
    supplier?: string;
    supplier_contact?: string;
    linked_expenses_ids?: Array<string>;
    supplier_url?: string;
    can_delete?: boolean;
    can_share?: boolean;
    can_update?: boolean;
    created_at: any;
    updated_at: any;
    imported_at?: any;
    boat_detail?: {
      __typename?: 'BoatDetails';
      name: string;
      id: string;
      flag: string;
      plan?: { __typename?: 'PlanOfUser'; slug?: string };
    };
    item?: { __typename?: 'Item'; id: string; name?: string };
    comments?: Array<{ __typename?: 'Comment'; id: string; like_count?: number }>;
    files?: Array<{
      __typename?: 'File';
      id: string;
      alt?: string;
      url?: string;
      type: string;
      extension: string;
      name: string;
      size: string;
    }>;
    sub_locations?: Array<{ __typename?: 'SubLocation'; level?: number; name?: string }>;
    location_data?: { __typename?: 'Location'; id: string; name: string };
    sub_locations_data?: Array<{ __typename?: 'Location'; id: string; name: string }>;
    unit_price_currency?: { __typename?: 'Currency'; id?: string; iso_code?: string; symbol?: string };
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
    linked_expenses?: Array<{
      __typename?: 'Expense';
      item_id: string;
      boat_detail_id: string;
      item_name?: string;
      id: string;
    }>;
    tasks?: Array<{
      __typename?: 'Task';
      id: string;
      name: string;
      boat_detail_id: string;
      user_id: string;
      due_date?: any;
      marked_as_maintenance?: boolean;
      user?: { __typename?: 'User'; display_name?: string; name?: string };
    }>;
    category?: { __typename?: 'Category'; id: string; user_id: string; name: string; type: string };
    costs?: Array<{
      __typename?: 'Cost';
      id: string;
      amount?: number;
      currency_id: string;
      vat_percentage?: number;
      vat_type?: string;
      type: string;
      currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
    }>;
    cost?: {
      __typename?: 'Cost';
      id: string;
      amount?: number;
      currency_id: string;
      vat_percentage?: number;
      vat_type?: string;
      type: string;
      currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
    };
    logs?: Array<{
      __typename?: 'Log';
      id: string;
      datetime?: string;
      trip_id?: string;
      pivot?: { __typename?: 'ExpensePivot'; usage_log_name?: string; usage_value?: number; quantity?: number };
      trip?: { __typename?: 'Trip'; started_at?: string };
      user?: { __typename?: 'User'; id: string; display_name?: string; name?: string; surname?: string };
    }>;
    fields?: Array<{
      __typename?: 'FieldValue';
      id: string;
      name?: string;
      value?: string;
      type?: string;
      options?: Array<string>;
    }>;
  };
};

export type DeleteExpenseVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteExpense = { __typename?: 'Mutation'; deleteExpense?: boolean };

export type UsageDoneVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type UsageDone = {
  __typename?: 'Mutation';
  usageDone?: {
    __typename?: 'Expense';
    id: string;
    boat_detail_id: string;
    user_id: string;
    item_id: string;
    item_name?: string;
    type?: string;
    notes?: string;
    location?: string;
    has_minimum_quantity_reminder?: boolean;
    minimum_quantity?: number;
    minimum_quantity_reminder?: number;
    brand?: string;
    model?: string;
    part_number?: string;
    serial_number?: string;
    barcode?: string;
    vendor_page?: string;
    packing?: string;
    acquisition_date?: string;
    expiration_date?: string;
    expiration_time_unit?: number;
    expiration_time_unit_type?: string;
    expiration_is_custom?: boolean;
    has_expiration_reminder?: boolean;
    warranty_date?: string;
    warranty_time_unit?: number;
    warranty_time_unit_type?: string;
    warranty_is_custom?: boolean;
    has_warranty_reminder?: boolean;
    is_recurring?: boolean;
    has_usage_reminder?: boolean;
    current_usage_value?: number;
    usage_due_date?: string;
    due_date_time_unit?: number;
    due_date_time_unit_type?: string;
    has_due_date_reminder?: boolean;
    usage_threshold?: number;
    usage_time_unit?: number;
    usage_time_unit_type?: string;
    recurrence_type?: string;
    threshold_reminder_value?: number;
    has_threshold_reminder?: boolean;
    threshold_recurrence_reminder?: number;
    usage_recurrence_time_unit?: number;
    usage_recurrence_time_unit_type?: string;
    usage_is_custom?: boolean;
    usage_recurrence?: number;
    maintenance_synced?: boolean;
    unit?: string;
    quantity?: number;
    total?: number;
    converted_total?: number;
    unit_price?: number;
    voltage?: number;
    width?: number;
    height?: number;
    depth?: number;
    weight?: number;
    consumption?: number;
    supplier?: string;
    supplier_contact?: string;
    linked_expenses_ids?: Array<string>;
    supplier_url?: string;
    can_delete?: boolean;
    can_share?: boolean;
    can_update?: boolean;
    created_at: any;
    updated_at: any;
    imported_at?: any;
    boat_detail?: {
      __typename?: 'BoatDetails';
      name: string;
      id: string;
      flag: string;
      plan?: { __typename?: 'PlanOfUser'; slug?: string };
    };
    item?: { __typename?: 'Item'; id: string; name?: string };
    comments?: Array<{ __typename?: 'Comment'; id: string; like_count?: number }>;
    files?: Array<{
      __typename?: 'File';
      id: string;
      alt?: string;
      url?: string;
      type: string;
      extension: string;
      name: string;
      size: string;
    }>;
    sub_locations?: Array<{ __typename?: 'SubLocation'; level?: number; name?: string }>;
    location_data?: { __typename?: 'Location'; id: string; name: string };
    sub_locations_data?: Array<{ __typename?: 'Location'; id: string; name: string }>;
    unit_price_currency?: { __typename?: 'Currency'; id?: string; iso_code?: string; symbol?: string };
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
    linked_expenses?: Array<{
      __typename?: 'Expense';
      item_id: string;
      boat_detail_id: string;
      item_name?: string;
      id: string;
    }>;
    tasks?: Array<{
      __typename?: 'Task';
      id: string;
      name: string;
      boat_detail_id: string;
      user_id: string;
      due_date?: any;
      marked_as_maintenance?: boolean;
      user?: { __typename?: 'User'; display_name?: string; name?: string };
    }>;
    category?: { __typename?: 'Category'; id: string; user_id: string; name: string; type: string };
    costs?: Array<{
      __typename?: 'Cost';
      id: string;
      amount?: number;
      currency_id: string;
      vat_percentage?: number;
      vat_type?: string;
      type: string;
      currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
    }>;
    cost?: {
      __typename?: 'Cost';
      id: string;
      amount?: number;
      currency_id: string;
      vat_percentage?: number;
      vat_type?: string;
      type: string;
      currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
    };
    logs?: Array<{
      __typename?: 'Log';
      id: string;
      datetime?: string;
      trip_id?: string;
      pivot?: { __typename?: 'ExpensePivot'; usage_log_name?: string; usage_value?: number; quantity?: number };
      trip?: { __typename?: 'Trip'; started_at?: string };
      user?: { __typename?: 'User'; id: string; display_name?: string; name?: string; surname?: string };
    }>;
    fields?: Array<{
      __typename?: 'FieldValue';
      id: string;
      name?: string;
      value?: string;
      type?: string;
      options?: Array<string>;
    }>;
  };
};

export type MassDeleteExpensesMutationVariables = Exact<{
  ids?: InputMaybe<Scalars['String']['input']>;
}>;

export type MassDeleteExpensesMutation = {
  __typename?: 'Mutation';
  massDeleteExpenses?: { __typename?: 'MassDeleteResponse'; deleted?: string; notDeleted?: string };
};

export type AddToFavoriteVariables = Exact<{
  boat_id: Scalars['ID']['input'];
}>;

export type AddToFavorite = {
  __typename?: 'Mutation';
  addToFavorite: { __typename?: 'Boat'; id: string; favorites_count?: number };
};

export type RemoveFromFavoritesVariables = Exact<{
  boat_id: Scalars['ID']['input'];
}>;

export type RemoveFromFavorites = { __typename?: 'Mutation'; removeFromFavorite?: boolean };

export type UpdateFileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  folder_id?: InputMaybe<Scalars['ID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  issued_by?: InputMaybe<Scalars['String']['input']>;
  issuance_date?: InputMaybe<Scalars['DateTime']['input']>;
  boat_detail_id?: InputMaybe<Scalars['ID']['input']>;
  expiration_date?: InputMaybe<Scalars['DateTime']['input']>;
  expiration_date_time_unit?: InputMaybe<Scalars['Int']['input']>;
  expiration_date_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  has_expiration_date_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateFileMutation = {
  __typename?: 'Mutation';
  updateFile?: {
    __typename?: 'File';
    id: string;
    type: string;
    size: string;
    mime_type: string;
    extension: string;
    name: string;
    filename?: string;
    issued_by?: string;
    issuance_date?: any;
    boat_detail_id?: string;
    notes?: string;
    dimensions?: string;
    disk: string;
    alt?: string;
    description?: string;
    visibility: string;
    url?: string;
    public_url?: string;
    download_url?: string;
    folder_id?: string;
    expiration_date?: any;
    expiration_date_time_unit?: number;
    expiration_date_time_unit_type?: string;
    has_expiration_date_reminder?: boolean;
    created_at?: any;
    updated_at?: any;
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
  };
};

export type UploadFileVariables = Exact<{
  file: Scalars['Upload']['input'];
  folder_id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UploadFile = {
  __typename?: 'Mutation';
  upload?: {
    __typename?: 'File';
    id: string;
    type: string;
    size: string;
    mime_type: string;
    extension: string;
    name: string;
    filename?: string;
    issued_by?: string;
    issuance_date?: any;
    boat_detail_id?: string;
    notes?: string;
    dimensions?: string;
    disk: string;
    alt?: string;
    description?: string;
    visibility: string;
    url?: string;
    public_url?: string;
    download_url?: string;
    folder_id?: string;
    expiration_date?: any;
    expiration_date_time_unit?: number;
    expiration_date_time_unit_type?: string;
    has_expiration_date_reminder?: boolean;
    created_at?: any;
    updated_at?: any;
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
  };
};

export type ValidateFileSizeVariables = Exact<{
  size: Scalars['Int']['input'];
}>;

export type ValidateFileSize = {
  __typename?: 'Mutation';
  validateFileSize?: { __typename?: 'UploadCheck'; status?: boolean; message?: string };
};

export type MassDeleteFilesVariables = Exact<{
  ids: Scalars['String']['input'];
}>;

export type MassDeleteFiles = {
  __typename?: 'Mutation';
  massDeleteFiles?: { __typename?: 'MassDeleteResponse'; deleted?: string; notDeleted?: string };
};

export type DeleteFileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteFileMutation = { __typename?: 'Mutation'; deleteFile?: boolean };

export type AddFolderVariables = Exact<{
  name: Scalars['String']['input'];
  parent_id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type AddFolder = {
  __typename?: 'Mutation';
  storeFolder?: {
    __typename?: 'Folder';
    id: string;
    user_id?: number;
    name?: string;
    parent_id?: string;
    path?: string;
    files_count?: number;
    folders_count?: number;
    created_at?: any;
    updated_at?: any;
    parent?: {
      __typename?: 'Folder';
      id: string;
      name?: string;
      parent_id?: string;
      parent?: { __typename?: 'Folder'; id: string; name?: string; parent_id?: string };
    };
    breadcrumb_folders?: Array<{ __typename?: 'BreadcrumbFolder'; id?: string; name?: string }>;
  };
};

export type UpdateFolderVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  parent_id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UpdateFolder = {
  __typename?: 'Mutation';
  updateFolder?: {
    __typename?: 'Folder';
    id: string;
    user_id?: number;
    name?: string;
    parent_id?: string;
    path?: string;
    files_count?: number;
    folders_count?: number;
    created_at?: any;
    updated_at?: any;
    parent?: {
      __typename?: 'Folder';
      id: string;
      name?: string;
      parent_id?: string;
      parent?: { __typename?: 'Folder'; id: string; name?: string; parent_id?: string };
    };
    breadcrumb_folders?: Array<{ __typename?: 'BreadcrumbFolder'; id?: string; name?: string }>;
  };
};

export type DeleteFolderVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteFolder = { __typename?: 'Mutation'; deleteFolder?: boolean };

export type MassDeleteFoldersVariables = Exact<{
  ids?: InputMaybe<Scalars['String']['input']>;
}>;

export type MassDeleteFolders = {
  __typename?: 'Mutation';
  massDeleteFolders?: { __typename?: 'MassDeleteResponse'; deleted?: string; notDeleted?: string };
};

export type MassMoveVariables = Exact<{
  file_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  folder_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  destination_id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type MassMove = {
  __typename?: 'Mutation';
  massMove?: {
    __typename?: 'Folder';
    id: string;
    user_id?: number;
    name?: string;
    parent_id?: string;
    path?: string;
    files_count?: number;
    folders_count?: number;
    created_at?: any;
    updated_at?: any;
    parent?: {
      __typename?: 'Folder';
      id: string;
      name?: string;
      parent_id?: string;
      parent?: { __typename?: 'Folder'; id: string; name?: string; parent_id?: string };
    };
    breadcrumb_folders?: Array<{ __typename?: 'BreadcrumbFolder'; id?: string; name?: string }>;
  };
};

export type AddLocationVariables = Exact<{
  name: Scalars['String']['input'];
  is_sub_location?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AddLocation = {
  __typename?: 'Mutation';
  storeLocation?: { __typename?: 'Location'; id: string; name: string; is_sub_location?: boolean };
};

export type EditLocationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  is_sub_location?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type EditLocation = {
  __typename?: 'Mutation';
  updateLocation?: { __typename?: 'Location'; id: string; name: string; is_sub_location?: boolean };
};

export type DeleteLocationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteLocation = { __typename?: 'Mutation'; deleteLocation?: boolean };

export type AddLogVariables = Exact<{
  log: StoreLogInput;
}>;

export type AddLog = {
  __typename?: 'Mutation';
  storeLog?: {
    __typename?: 'Log';
    id: string;
    later?: string;
    datetime?: string;
    latitude?: number;
    longitude?: number;
    log?: number;
    type: string;
    created_at: any;
    updated_at: any;
  };
};

export type StoreMultipleLogsVariables = Exact<{
  logs: Array<StoreLogInput> | StoreLogInput;
}>;

export type StoreMultipleLogs = {
  __typename?: 'Mutation';
  storeBulkLog?: Array<{
    __typename?: 'Log';
    id: string;
    later?: string;
    datetime?: string;
    latitude?: number;
    longitude?: number;
    log?: number;
    type: string;
    created_at: any;
    updated_at: any;
  }>;
};

export type UpdateLogVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  boat_detail_id?: InputMaybe<Scalars['ID']['input']>;
  datetime: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  type: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  sea_area?: InputMaybe<Scalars['String']['input']>;
  imminent?: InputMaybe<Scalars['String']['input']>;
  later?: InputMaybe<Scalars['String']['input']>;
  outlook?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  station?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['Int']['input']>;
  cog?: InputMaybe<Scalars['Int']['input']>;
  helm?: InputMaybe<Scalars['String']['input']>;
  speed?: InputMaybe<Scalars['Float']['input']>;
  sog?: InputMaybe<Scalars['Float']['input']>;
  log?: InputMaybe<Scalars['Float']['input']>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  bar?: InputMaybe<Scalars['Float']['input']>;
  wind_speed?: InputMaybe<Scalars['Float']['input']>;
  wind_direction?: InputMaybe<Scalars['Int']['input']>;
  sky?: InputMaybe<Scalars['Int']['input']>;
  precipitation?: InputMaybe<Scalars['String']['input']>;
  sea_state?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<Scalars['Float']['input']>;
  air_temp?: InputMaybe<Scalars['Float']['input']>;
  sea_temp?: InputMaybe<Scalars['Float']['input']>;
  sails?: InputMaybe<Scalars['String']['input']>;
  diesel_generator_status?: InputMaybe<Scalars['Boolean']['input']>;
  diesel_generator_hours?: InputMaybe<Scalars['Float']['input']>;
  diesel_generator_rpm?: InputMaybe<Scalars['Int']['input']>;
  diesel_generator_fuel_check?: InputMaybe<Scalars['Boolean']['input']>;
  diesel_generator_oil_check?: InputMaybe<Scalars['Boolean']['input']>;
  diesel_generator_water_check?: InputMaybe<Scalars['Boolean']['input']>;
  diesel_generator_exhaust_check?: InputMaybe<Scalars['Boolean']['input']>;
  battery1?: InputMaybe<Scalars['Float']['input']>;
  battery2?: InputMaybe<Scalars['Float']['input']>;
  boat_water?: InputMaybe<Scalars['Float']['input']>;
  fuel?: InputMaybe<Scalars['Float']['input']>;
  gas?: InputMaybe<Scalars['Float']['input']>;
  bilge?: InputMaybe<Scalars['Boolean']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  usage?: InputMaybe<Array<InputMaybe<UsageInput>> | InputMaybe<UsageInput>>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  cost_type?: InputMaybe<Scalars['String']['input']>;
  vat_percentage?: InputMaybe<Scalars['Int']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  vat_type?: InputMaybe<Scalars['String']['input']>;
  currency_id?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  has_cost?: InputMaybe<Scalars['Boolean']['input']>;
  engine_logs?: InputMaybe<Array<InputMaybe<EngineLogInput>> | InputMaybe<EngineLogInput>>;
}>;

export type UpdateLog = {
  __typename?: 'Mutation';
  updateLog?: { __typename?: 'Log'; id: string; notes?: string; datetime?: string };
};

export type DeleteLogVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteLog = { __typename?: 'Mutation'; deleteLog?: boolean };

export type UpdateAuthUserVariables = Exact<{
  image_id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  auth0UserMetadata?: InputMaybe<Auth0UserMetaData>;
  country_id?: InputMaybe<Scalars['ID']['input']>;
  currency_id?: InputMaybe<Scalars['ID']['input']>;
  base_currency_id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UpdateAuthUser = {
  __typename?: 'Mutation';
  updateAuthUser?: {
    __typename?: 'UserData';
    image_id?: string;
    name?: string;
    surname?: string;
    display_name?: string;
    email?: string;
    phone?: string;
    birthday?: any;
    gender?: string;
    country?: { __typename?: 'Country'; id: string };
  };
};

export type UpdateUserSettingsVariables = Exact<{
  language_id?: InputMaybe<Scalars['ID']['input']>;
  date_format?: InputMaybe<Scalars['String']['input']>;
  time_format?: InputMaybe<Scalars['String']['input']>;
  timezone_id?: InputMaybe<Scalars['ID']['input']>;
  first_day_of_week?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  decimal_symbol?: InputMaybe<Scalars['String']['input']>;
  digit_grouping_symbol?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateUserSettings = {
  __typename?: 'Mutation';
  updateUserSettings?: Array<{ __typename?: 'Setting'; key: string; value?: string }>;
};

export type UpdateOrCreateAddressVariables = Exact<{
  city: Scalars['String']['input'];
  postal_code: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  country: Scalars['String']['input'];
}>;

export type UpdateOrCreateAddress = {
  __typename?: 'Mutation';
  updateOrCreateAddress?: { __typename?: 'Address'; id: string };
};

export type SharedWithVariables = Exact<{
  model_id: Scalars['ID']['input'];
  model_type: Scalars['String']['input'];
}>;

export type SharedWith = {
  __typename?: 'Mutation';
  sharedWith?: Array<{
    __typename?: 'Share';
    id: string;
    model_id?: string;
    model_type: string;
    permission_type?: string;
    inherited_from?: string;
    display_name?: string;
    email?: string;
    shareable_type: string;
    user_id?: string;
    user?: {
      __typename?: 'User';
      id: string;
      display_name?: string;
      email: string;
      name?: string;
      surname?: string;
      image?: { __typename?: 'File'; url?: string; public_url?: string };
    };
  }>;
};

export type RemoveShareVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type RemoveShare = { __typename?: 'Mutation'; deleteShare?: boolean };

export type AddOrEditShareVariables = Exact<{
  model_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  model_type: Scalars['String']['input'];
  permission_type: Scalars['String']['input'];
  userEmail: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type AddOrEditShare = {
  __typename?: 'Mutation';
  shareItem?: Array<{
    __typename?: 'Share';
    id: string;
    email?: string;
    display_name?: string;
    permission_type?: string;
  }>;
};

export type ResendShareInviteVariables = Exact<{
  userEmail: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}>;

export type ResendShareInvite = { __typename?: 'Mutation'; resendInvite?: boolean };

export type GenerateCheckoutSessionVariables = Exact<{
  planId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  success_url?: InputMaybe<Scalars['String']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  cancel_url?: InputMaybe<Scalars['String']['input']>;
  ui_mode: ModeEnum;
}>;

export type GenerateCheckoutSession = {
  __typename?: 'Mutation';
  generateCheckoutSession?: { __typename?: 'CheckoutSession'; id?: string; client_secret?: string };
};

export type GetGeneratedPortalSessionVariables = Exact<{
  returnUrl: Scalars['String']['input'];
}>;

export type GetGeneratedPortalSession = { __typename?: 'Mutation'; generatePortalSession?: string };

export type AssignLicenseToBoatsVariables = Exact<{
  plan_id?: InputMaybe<Scalars['ID']['input']>;
  boat_details_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type AssignLicenseToBoats = {
  __typename?: 'Mutation';
  assignLicense?: { __typename?: 'Plan'; id: string; status?: string; name: string };
};

export type ChangePlanQuantityVariables = Exact<{
  plan_id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
}>;

export type ChangePlanQuantity = { __typename?: 'Mutation'; changeQuantity?: boolean };

export type HardResetSubscriptionVariables = Exact<{ [key: string]: never }>;

export type HardResetSubscription = { __typename?: 'Mutation'; resetSubscription?: boolean };

export type HardResetTrialVariables = Exact<{ [key: string]: never }>;

export type HardResetTrial = { __typename?: 'Mutation'; resetTrial?: boolean };

export type RemoveBoatLicenseVariables = Exact<{
  boat_details_id: Scalars['ID']['input'];
}>;

export type RemoveBoatLicense = { __typename?: 'Mutation'; removeLicense?: { __typename?: 'BoatDetails'; id: string } };

export type CancelBoatSubscriptionVariables = Exact<{
  plan_id: Scalars['ID']['input'];
}>;

export type CancelBoatSubscription = { __typename?: 'Mutation'; cancelSubscription?: boolean };

export type ResumeBoatSubscriptionVariables = Exact<{
  plan_id: Scalars['ID']['input'];
}>;

export type ResumeBoatSubscription = { __typename?: 'Mutation'; resumeSubscription?: boolean };

export type UpgradePlanMutationVariables = Exact<{
  planId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
}>;

export type UpgradePlanMutation = { __typename?: 'Mutation'; upgradePlan?: boolean };

export type DowngradePlanMutationVariables = Exact<{
  planId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
}>;

export type DowngradePlanMutation = { __typename?: 'Mutation'; downgradePlan?: boolean };

export type RetrieveSessionDataVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;

export type RetrieveSessionData = {
  __typename?: 'Mutation';
  retrieveSessionData?: {
    __typename?: 'CheckoutSessionResponse';
    plan_id?: string;
    plan_name?: string;
    renewal_date?: any;
    quantity?: number;
    price?: number;
    total_price?: number;
    status?: string;
  };
};

export type CancelScheduledUpdateMutationVariables = Exact<{ [key: string]: never }>;

export type CancelScheduledUpdateMutation = { __typename?: 'Mutation'; cancelScheduledUpdate?: boolean };

export type TaskFields = {
  __typename?: 'Task';
  boat_detail_id: string;
  user_id: string;
  assignee_ids?: Array<string>;
  id: string;
  name: string;
  category_id?: string;
  type?: string;
  status?: string;
  is_recurring?: boolean;
  frequency?: string;
  priority?: number;
  due_date?: any;
  completed_at?: any;
  has_notification?: boolean;
  time_unit?: number;
  time_unit_type?: string;
  linked_expense_id?: number;
  marked_as_maintenance?: boolean;
  usage_is_custom?: boolean;
  usage_time_unit_type?: string;
  usage_time_unit?: number;
  usage_recurrence_time_unit?: number;
  usage_recurrence_time_unit_type?: string;
  has_usage_reminder?: boolean;
  recurrence_type?: string;
  usage_recurrence?: number;
  threshold_recurrence_reminder?: number;
  can_delete?: boolean;
  can_update?: boolean;
  can_share?: boolean;
  boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
  taxonomies?: Array<{ __typename?: 'Taxonomy'; id: string; name?: string }>;
  category?: { __typename?: 'Category'; id: string; name: string };
  user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
  expenses?: Array<{ __typename?: 'Expense'; id: string; item_name?: string }>;
  costs?: Array<{
    __typename?: 'Cost';
    id: string;
    amount?: number;
    currency_id: string;
    vat_percentage?: number;
    vat_type?: string;
    type: string;
    supplier?: string;
    currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
  }>;
  cost?: {
    __typename?: 'Cost';
    id: string;
    amount?: number;
    currency_id: string;
    vat_percentage?: number;
    vat_type?: string;
    type: string;
    supplier?: string;
    currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
  };
  files?: Array<{ __typename?: 'File'; id: string; name: string; url?: string; type: string; created_at?: any }>;
  alert?: { __typename?: 'Alert'; id: string };
};

export type AddTaskVariables = Exact<{
  name: Scalars['String']['input'];
  boat_detail_id: Scalars['ID']['input'];
  taxonomy?: InputMaybe<Scalars['Int']['input']>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  is_recurring?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  assignee_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  parent_id?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['String']['input']>;
  completed_at?: InputMaybe<Scalars['String']['input']>;
  has_notification?: InputMaybe<Scalars['Boolean']['input']>;
  time_unit?: InputMaybe<Scalars['Int']['input']>;
  time_unit_type?: InputMaybe<Scalars['String']['input']>;
  linked_expense_id?: InputMaybe<Scalars['Int']['input']>;
  marked_as_maintenance?: InputMaybe<Scalars['Boolean']['input']>;
  usage_is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  usage_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  usage_time_unit?: InputMaybe<Scalars['Int']['input']>;
  usage_recurrence_time_unit?: InputMaybe<Scalars['Int']['input']>;
  usage_recurrence_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  has_usage_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  recurrence_type?: InputMaybe<Scalars['String']['input']>;
  usage_recurrence?: InputMaybe<Scalars['Float']['input']>;
  threshold_recurrence_reminder?: InputMaybe<Scalars['Float']['input']>;
  cost_type?: InputMaybe<Scalars['String']['input']>;
  vat_percentage?: InputMaybe<Scalars['Int']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  vat_type?: InputMaybe<Scalars['String']['input']>;
  currency_id?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  has_cost?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AddTask = {
  __typename?: 'Mutation';
  storeTask?: {
    __typename?: 'Task';
    boat_detail_id: string;
    user_id: string;
    assignee_ids?: Array<string>;
    id: string;
    name: string;
    category_id?: string;
    type?: string;
    status?: string;
    is_recurring?: boolean;
    frequency?: string;
    priority?: number;
    due_date?: any;
    completed_at?: any;
    has_notification?: boolean;
    time_unit?: number;
    time_unit_type?: string;
    linked_expense_id?: number;
    marked_as_maintenance?: boolean;
    usage_is_custom?: boolean;
    usage_time_unit_type?: string;
    usage_time_unit?: number;
    usage_recurrence_time_unit?: number;
    usage_recurrence_time_unit_type?: string;
    has_usage_reminder?: boolean;
    recurrence_type?: string;
    usage_recurrence?: number;
    threshold_recurrence_reminder?: number;
    can_delete?: boolean;
    can_update?: boolean;
    can_share?: boolean;
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    taxonomies?: Array<{ __typename?: 'Taxonomy'; id: string; name?: string }>;
    category?: { __typename?: 'Category'; id: string; name: string };
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
    expenses?: Array<{ __typename?: 'Expense'; id: string; item_name?: string }>;
    costs?: Array<{
      __typename?: 'Cost';
      id: string;
      amount?: number;
      currency_id: string;
      vat_percentage?: number;
      vat_type?: string;
      type: string;
      supplier?: string;
      currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
    }>;
    cost?: {
      __typename?: 'Cost';
      id: string;
      amount?: number;
      currency_id: string;
      vat_percentage?: number;
      vat_type?: string;
      type: string;
      supplier?: string;
      currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
    };
    files?: Array<{ __typename?: 'File'; id: string; name: string; url?: string; type: string; created_at?: any }>;
    alert?: { __typename?: 'Alert'; id: string };
  };
};

export type EditTaskVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  taxonomy?: InputMaybe<Scalars['Int']['input']>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  is_recurring?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  assignee_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['String']['input']>;
  completed_at?: InputMaybe<Scalars['String']['input']>;
  has_notification?: InputMaybe<Scalars['Boolean']['input']>;
  time_unit?: InputMaybe<Scalars['Int']['input']>;
  time_unit_type?: InputMaybe<Scalars['String']['input']>;
  linked_expense_id?: InputMaybe<Scalars['Int']['input']>;
  marked_as_maintenance?: InputMaybe<Scalars['Boolean']['input']>;
  usage_is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  usage_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  usage_time_unit?: InputMaybe<Scalars['Int']['input']>;
  usage_recurrence_time_unit?: InputMaybe<Scalars['Int']['input']>;
  usage_recurrence_time_unit_type?: InputMaybe<Scalars['String']['input']>;
  has_usage_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  recurrence_type?: InputMaybe<Scalars['String']['input']>;
  usage_recurrence?: InputMaybe<Scalars['Float']['input']>;
  threshold_recurrence_reminder?: InputMaybe<Scalars['Float']['input']>;
  cost_type?: InputMaybe<Scalars['String']['input']>;
  vat_percentage?: InputMaybe<Scalars['Int']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  vat_type?: InputMaybe<Scalars['String']['input']>;
  currency_id?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  has_cost?: InputMaybe<Scalars['Boolean']['input']>;
  boat_detail_id: Scalars['ID']['input'];
}>;

export type EditTask = {
  __typename?: 'Mutation';
  updateTask?: {
    __typename?: 'Task';
    boat_detail_id: string;
    user_id: string;
    assignee_ids?: Array<string>;
    id: string;
    name: string;
    category_id?: string;
    type?: string;
    status?: string;
    is_recurring?: boolean;
    frequency?: string;
    priority?: number;
    due_date?: any;
    completed_at?: any;
    has_notification?: boolean;
    time_unit?: number;
    time_unit_type?: string;
    linked_expense_id?: number;
    marked_as_maintenance?: boolean;
    usage_is_custom?: boolean;
    usage_time_unit_type?: string;
    usage_time_unit?: number;
    usage_recurrence_time_unit?: number;
    usage_recurrence_time_unit_type?: string;
    has_usage_reminder?: boolean;
    recurrence_type?: string;
    usage_recurrence?: number;
    threshold_recurrence_reminder?: number;
    can_delete?: boolean;
    can_update?: boolean;
    can_share?: boolean;
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    taxonomies?: Array<{ __typename?: 'Taxonomy'; id: string; name?: string }>;
    category?: { __typename?: 'Category'; id: string; name: string };
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
    expenses?: Array<{ __typename?: 'Expense'; id: string; item_name?: string }>;
    costs?: Array<{
      __typename?: 'Cost';
      id: string;
      amount?: number;
      currency_id: string;
      vat_percentage?: number;
      vat_type?: string;
      type: string;
      supplier?: string;
      currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
    }>;
    cost?: {
      __typename?: 'Cost';
      id: string;
      amount?: number;
      currency_id: string;
      vat_percentage?: number;
      vat_type?: string;
      type: string;
      supplier?: string;
      currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
    };
    files?: Array<{ __typename?: 'File'; id: string; name: string; url?: string; type: string; created_at?: any }>;
    alert?: { __typename?: 'Alert'; id: string };
  };
};

export type DeleteTaskVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteTask = { __typename?: 'Mutation'; deleteTask?: boolean };

export type CompleteTaskVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CompleteTask = { __typename?: 'Mutation'; completeTask?: boolean };

export type AddTripVariables = Exact<{
  name: Scalars['String']['input'];
  boat_detail_id: Scalars['ID']['input'];
  started_at: Scalars['String']['input'];
  closed_at?: InputMaybe<Scalars['String']['input']>;
  skipper_id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  origin_latitude: Scalars['Float']['input'];
  origin_longitude: Scalars['Float']['input'];
  destination_latitude?: InputMaybe<Scalars['Float']['input']>;
  destination_longitude?: InputMaybe<Scalars['Float']['input']>;
  crewman_id?: InputMaybe<Scalars['ID']['input']>;
  image_id?: InputMaybe<Scalars['ID']['input']>;
  member_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type AddTrip = {
  __typename?: 'Mutation';
  storeTrip?: {
    __typename?: 'Trip';
    id: string;
    name: string;
    started_at?: string;
    finished_at?: any;
    closed_at?: string;
    boat_detail_id: string;
    origin?: string;
    origin_latitude?: number;
    origin_longitude?: number;
    destination?: string;
    destination_longitude?: number;
    destination_latitude?: number;
    general_logs_count?: number;
    radio_logs_count?: number;
    social_logs_count?: number;
    weather_logs_count?: number;
    can_update?: boolean;
    can_delete?: boolean;
    can_share?: boolean;
    skipper_id?: string;
    crewman_id?: string;
    notes?: string;
    created_at: any;
    updated_at: any;
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string; flag: string; location?: string };
    image?: {
      __typename?: 'File';
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    };
    user?: {
      __typename?: 'User';
      id: string;
      display_name?: string;
      name?: string;
      surname?: string;
      email: string;
      image?: {
        __typename?: 'File';
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      };
    };
    skipper?: {
      __typename?: 'User';
      id: string;
      display_name?: string;
      email: string;
      name?: string;
      surname?: string;
      image?: {
        __typename?: 'File';
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      };
    };
    crewman?: {
      __typename?: 'User';
      id: string;
      display_name?: string;
      name?: string;
      surname?: string;
      email: string;
      image?: {
        __typename?: 'File';
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      };
    };
    members?: Array<{
      __typename?: 'User';
      id: string;
      email: string;
      display_name?: string;
      name?: string;
      surname?: string;
      image?: {
        __typename?: 'File';
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      };
    }>;
  };
};

export type EditTripVariables = Exact<{
  trip_id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  started_at: Scalars['String']['input'];
  closed_at?: InputMaybe<Scalars['String']['input']>;
  skipper_id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  origin_latitude: Scalars['Float']['input'];
  origin_longitude: Scalars['Float']['input'];
  destination_latitude?: InputMaybe<Scalars['Float']['input']>;
  destination_longitude?: InputMaybe<Scalars['Float']['input']>;
  crewman_id?: InputMaybe<Scalars['ID']['input']>;
  image_id?: InputMaybe<Scalars['ID']['input']>;
  member_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type EditTrip = {
  __typename?: 'Mutation';
  updateTrip?: {
    __typename?: 'Trip';
    id: string;
    name: string;
    started_at?: string;
    finished_at?: any;
    closed_at?: string;
    boat_detail_id: string;
    origin?: string;
    origin_latitude?: number;
    origin_longitude?: number;
    destination?: string;
    destination_longitude?: number;
    destination_latitude?: number;
    general_logs_count?: number;
    radio_logs_count?: number;
    social_logs_count?: number;
    weather_logs_count?: number;
    can_update?: boolean;
    can_delete?: boolean;
    can_share?: boolean;
    skipper_id?: string;
    crewman_id?: string;
    notes?: string;
    created_at: any;
    updated_at: any;
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string; flag: string; location?: string };
    image?: {
      __typename?: 'File';
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    };
    user?: {
      __typename?: 'User';
      id: string;
      display_name?: string;
      name?: string;
      surname?: string;
      email: string;
      image?: {
        __typename?: 'File';
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      };
    };
    skipper?: {
      __typename?: 'User';
      id: string;
      display_name?: string;
      email: string;
      name?: string;
      surname?: string;
      image?: {
        __typename?: 'File';
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      };
    };
    crewman?: {
      __typename?: 'User';
      id: string;
      display_name?: string;
      name?: string;
      surname?: string;
      email: string;
      image?: {
        __typename?: 'File';
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      };
    };
    members?: Array<{
      __typename?: 'User';
      id: string;
      email: string;
      display_name?: string;
      name?: string;
      surname?: string;
      image?: {
        __typename?: 'File';
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      };
    }>;
  };
};

export type DeleteTripVariables = Exact<{
  tripId: Scalars['ID']['input'];
}>;

export type DeleteTrip = { __typename?: 'Mutation'; deleteTrip?: boolean };

export type FinishTripVariables = Exact<{
  tripId: Scalars['ID']['input'];
  dateTime?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
}>;

export type FinishTrip = { __typename?: 'Mutation'; finishTrip?: boolean };

export type GetActivityLogsVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetActivityLogs = {
  __typename?: 'Query';
  activityLogs?: {
    __typename?: 'ActivityLogPaginator';
    data: Array<{
      __typename?: 'ActivityLog';
      id: string;
      log_name?: string;
      log_message?: string;
      description?: string;
      subject_id?: string;
      subject_type?: string;
      causer_id?: string;
      causer_type?: string;
      properties?: any;
      client_ip?: string;
      client_ips?: any;
      user_agent?: string;
      is_api?: boolean;
      boat_detail_id?: string;
      created_at?: any;
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number;
      hasMorePages: boolean;
      lastItem?: number;
      lastPage: number;
      perPage: number;
      total: number;
    };
  };
};

export type GetAlertsVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>> | InputMaybe<OrderByClause>>;
  boat_detail_id?: InputMaybe<Scalars['ID']['input']>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  filterByStatus?: InputMaybe<AlertFilter>;
  due_date_range?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetAlerts = {
  __typename?: 'Query';
  alerts?: {
    __typename?: 'AlertPaginator';
    data: Array<{
      __typename?: 'Alert';
      id: string;
      priority: number;
      active?: boolean;
      alertable_id: number;
      alertable_type: string;
      title?: string;
      type?: string;
      date?: any;
      created_at: any;
      category?: string;
      quantity?: number;
      threshold?: number;
      marked_as_done_at?: any;
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number;
      hasMorePages: boolean;
      lastItem?: number;
      lastPage: number;
      perPage: number;
      total: number;
    };
  };
};

export type GetInfiniteAlertsVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>> | InputMaybe<OrderByClause>>;
  boat_detail_id?: InputMaybe<Scalars['ID']['input']>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetInfiniteAlerts = {
  __typename?: 'Query';
  alerts?: {
    __typename?: 'AlertPaginator';
    data: Array<{
      __typename?: 'Alert';
      id: string;
      title?: string;
      boat_detail_id?: string;
      alertable_type: string;
      alertable_id: number;
      created_at: any;
      active?: boolean;
      priority: number;
      date?: any;
      can_share?: boolean;
      threshold?: number;
      quantity?: number;
      category?: string;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string; flag: string };
      user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string; email: string };
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      firstItem?: number;
      lastItem?: number;
      currentPage: number;
      perPage: number;
      total: number;
      hasMorePages: boolean;
    };
  };
};

export type GetAlertVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetAlert = {
  __typename?: 'Query';
  alert?: {
    __typename?: 'Alert';
    id: string;
    title?: string;
    active?: boolean;
    date?: any;
    priority: number;
    alertable_type: string;
    alertable_id: number;
    boat_detail_id?: string;
    threshold?: number;
    quantity?: number;
    category?: string;
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string; flag: string };
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string; email: string };
  };
};

export type AlertQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type AlertQuery = {
  __typename?: 'Query';
  alert?: {
    __typename?: 'Alert';
    id: string;
    priority: number;
    active?: boolean;
    alertable_id: number;
    alertable_type: string;
    title?: string;
    type?: string;
    date?: any;
    created_at: any;
    category?: string;
    quantity?: number;
    threshold?: number;
    marked_as_done_at?: any;
  };
};

export type GetBoatDetailsVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetBoatDetails = {
  __typename?: 'Query';
  boatDetail?: {
    __typename?: 'BoatDetails';
    id: string;
    user_id: string;
    boat_id?: string;
    strapi_ref_document_id?: string;
    name: string;
    description?: string;
    flag: string;
    acquisition_date?: string;
    acquisition_type?: string;
    year?: number;
    nr_past_owners?: number;
    ownership_order?: string;
    mmsi?: string;
    is_vat_paid?: boolean;
    currency?: string;
    price?: number;
    price_formated?: number;
    location?: string;
    service_loads?: string;
    engine_battery_voltage?: number;
    engine_battery_capacity?: number;
    service_battery_voltage?: number;
    service_battery_capacity?: number;
    battery_power?: number;
    inverter_power?: number;
    solar_power?: number;
    wind_power?: number;
    dg_power?: number;
    tender_name?: string;
    tender_vendor?: string;
    tender_model?: string;
    tender_length?: number;
    status?: boolean;
    hull_sn?: string;
    callsign?: string;
    epirb?: string;
    in_reach_tracker_id?: string;
    spot_tracker_id?: string;
    satellite_phone?: string;
    mobile_phone?: string;
    can_share?: boolean;
    can_update?: boolean;
    can_delete?: boolean;
    created_at: any;
    updated_at: any;
    subscription_id?: number;
    image?: {
      __typename?: 'File';
      user_id?: number;
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    };
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
    engines?: Array<{
      __typename?: 'Engine';
      id: string;
      maker?: string;
      website?: string;
      model?: string;
      type?: string;
      drive?: string;
      fuel?: string;
      power?: string;
      power_type?: string;
    }>;
    files?: Array<{
      __typename?: 'File';
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    }>;
    boat?: {
      __typename?: 'Boat';
      id: string;
      user_id: string;
      unit: string;
      model?: string;
      year_first?: number;
      year_last?: number;
      version?: string;
      reference_price?: number;
      currency?: string;
      reference_price_formated?: string;
      price_html?: string;
      is_favorited?: boolean;
      slug?: string;
      description?: string;
      meta_title?: string;
      meta_description?: string;
      og_title?: string;
      og_description?: string;
      og_image?: string;
      og_url?: string;
      type: string;
      hull_type: string;
      hull_material: string;
      keel_type?: string;
      cabins?: number;
      berths?: number;
      heads?: number;
      top_speed?: number;
      cruising_speed?: number;
      mast?: number;
      loa?: number;
      lwl?: number;
      boa?: number;
      bcl?: number;
      bh?: number;
      headroom?: number;
      bdcl?: number;
      nom?: number;
      draft_max?: number;
      draft_min?: number;
      displacement?: number;
      tonnage_gross?: number;
      tonnage_net?: number;
      ballast_type?: string;
      ballast_weight?: string;
      helm?: string;
      rudder?: string;
      cockpit_type?: string;
      cockpit_location?: string;
      unsinkable?: boolean;
      trailerable?: boolean;
      ce_classification?: Array<string>;
      designer_name?: string;
      designer_site?: string;
      exterior_design?: string;
      exterior_site?: string;
      interior_design?: string;
      interior_site?: string;
      rigging?: string;
      rotating_spars?: boolean;
      mast_configuration?: string;
      spars?: string;
      standing_rigging?: string;
      spreaders_level?: number;
      spreaders_angle?: string;
      upwind_sail_area?: number;
      downwind_sail_area?: number;
      sail_area_displacement?: number;
      upwind_sail_area_displacement?: number;
      downwind_sail_area_displacement?: number;
      ballast_length?: number;
      ballast_displacement?: number;
      csf?: number;
      sspd?: number;
      ksi?: number;
      displacement_hull_speed?: number;
      displacement_length?: number;
      favorites_count?: number;
      status?: boolean;
      is_featured?: boolean;
      can_update?: boolean;
      can_delete?: boolean;
      approved_at?: any;
      created_at: any;
      updated_at: any;
      image?: {
        __typename?: 'File';
        user_id?: number;
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      };
      files?: Array<{
        __typename?: 'File';
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      }>;
      categories?: Array<{ __typename?: 'Taxonomy'; name?: string; id: string }>;
      activities?: Array<{ __typename?: 'Taxonomy'; id: string; name?: string }>;
      manufacturer?: { __typename?: 'Manufacturer'; id?: string; name?: string; website?: string };
      hull_appendages?: Array<{ __typename?: 'HullAppendages'; name: string; value: string }>;
      mainsail?: Array<{ __typename?: 'MainSail'; name: string; value: string }>;
      headsail?: Array<{ __typename?: 'HeadSail'; name: string; value: string }>;
      spinnaker?: Array<{ __typename?: 'Spinnaker'; name: string; value: string }>;
      fuel_tank?: Array<{ __typename?: 'FuelTank'; capacity: number }>;
      water_tank?: Array<{ __typename?: 'WaterTank'; capacity: number }>;
      holding_tank?: Array<{ __typename?: 'HoldingTank'; capacity: number }>;
      water_heater?: Array<{ __typename?: 'WaterHeater'; capacity: number }>;
    };
    fields?: Array<{
      __typename?: 'FieldValue';
      id: string;
      name?: string;
      value?: string;
      type?: string;
      options?: Array<string>;
    }>;
    plan?: {
      __typename?: 'PlanOfUser';
      id: string;
      name: string;
      status?: string;
      available?: number;
      gateway_id?: string;
      slug?: string;
    };
  };
};

export type GetCategoriesVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>> | InputMaybe<OrderByClause>>;
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetCategories = {
  __typename?: 'Query';
  categories?: {
    __typename?: 'CategoryPaginator';
    data: Array<{ __typename?: 'Category'; id: string; user_id: string; name: string; is_user_defined: boolean }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number;
      hasMorePages: boolean;
      lastItem?: number;
      lastPage: number;
      perPage: number;
      total: number;
    };
  };
};

export type GetPublicChecklistVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetPublicChecklist = {
  __typename?: 'Query';
  publicChecklists?: {
    __typename?: 'ChecklistPaginator';
    data: Array<{
      __typename: 'Checklist';
      created_at: any;
      belongs_to_current_user: boolean;
      can_add_comment: boolean;
      can_copy: boolean;
      can_create_new_item: boolean;
      can_delete: boolean;
      can_follow: boolean;
      can_update: boolean;
      can_sort_items: boolean;
      can_unfollow: boolean;
      can_share?: boolean;
      can_view: boolean;
      can_view_blocked_users: boolean;
      can_view_comments: boolean;
      can_view_followers: boolean;
      clones_count?: number;
      comments_count?: number;
      description?: string;
      id: string;
      is_followed_by_current_user: boolean;
      is_public: boolean;
      old_image_id?: string;
      category_id?: string;
      updated_at: any;
      title: string;
      user_followers_count?: number;
      image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
      old_image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
      files?: Array<{
        __typename?: 'File';
        can_delete?: boolean;
        can_update?: boolean;
        can_share?: boolean;
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      }>;
      tasks?: Array<{ __typename?: 'Task'; id: string; name: string }>;
      expenses?: Array<{ __typename?: 'Expense'; id: string; item_name?: string }>;
      logs?: Array<{ __typename?: 'Log'; id: string; name?: string }>;
      trips?: Array<{ __typename?: 'Trip'; id: string; name: string }>;
      items?: Array<{ __typename?: 'ChecklistItem'; id: string; name: string; position?: number; checked: boolean }>;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string;
        surname?: string;
        display_name?: string;
        image?: { __typename?: 'File'; url?: string };
      };
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      firstItem?: number;
      lastItem?: number;
      currentPage: number;
      hasMorePages: boolean;
      count: number;
      perPage: number;
      total: number;
    };
  };
};

export type GetMyChecklistsVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>> | InputMaybe<OrderByClause>>;
}>;

export type GetMyChecklists = {
  __typename?: 'Query';
  myChecklists?: {
    __typename?: 'ChecklistPaginator';
    data: Array<{
      __typename: 'Checklist';
      created_at: any;
      belongs_to_current_user: boolean;
      can_add_comment: boolean;
      can_copy: boolean;
      can_create_new_item: boolean;
      can_delete: boolean;
      can_follow: boolean;
      can_update: boolean;
      can_sort_items: boolean;
      can_unfollow: boolean;
      can_share?: boolean;
      can_view: boolean;
      can_view_blocked_users: boolean;
      can_view_comments: boolean;
      can_view_followers: boolean;
      clones_count?: number;
      comments_count?: number;
      description?: string;
      id: string;
      is_followed_by_current_user: boolean;
      is_public: boolean;
      old_image_id?: string;
      category_id?: string;
      updated_at: any;
      title: string;
      user_followers_count?: number;
      image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
      old_image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
      files?: Array<{
        __typename?: 'File';
        can_delete?: boolean;
        can_update?: boolean;
        can_share?: boolean;
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      }>;
      tasks?: Array<{ __typename?: 'Task'; id: string; name: string }>;
      expenses?: Array<{ __typename?: 'Expense'; id: string; item_name?: string }>;
      logs?: Array<{ __typename?: 'Log'; id: string; name?: string }>;
      trips?: Array<{ __typename?: 'Trip'; id: string; name: string }>;
      items?: Array<{ __typename?: 'ChecklistItem'; id: string; name: string; position?: number; checked: boolean }>;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string;
        surname?: string;
        display_name?: string;
        image?: { __typename?: 'File'; url?: string };
      };
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      firstItem?: number;
      lastItem?: number;
      currentPage: number;
      hasMorePages: boolean;
      count: number;
      perPage: number;
      total: number;
    };
  };
};

export type GetChecklistVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetChecklist = {
  __typename?: 'Query';
  checklist?: {
    __typename: 'Checklist';
    created_at: any;
    belongs_to_current_user: boolean;
    can_add_comment: boolean;
    can_copy: boolean;
    can_create_new_item: boolean;
    can_delete: boolean;
    can_follow: boolean;
    can_update: boolean;
    can_sort_items: boolean;
    can_unfollow: boolean;
    can_share?: boolean;
    can_view: boolean;
    can_view_blocked_users: boolean;
    can_view_comments: boolean;
    can_view_followers: boolean;
    clones_count?: number;
    comments_count?: number;
    description?: string;
    id: string;
    is_followed_by_current_user: boolean;
    is_public: boolean;
    old_image_id?: string;
    category_id?: string;
    updated_at: any;
    title: string;
    user_followers_count?: number;
    image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
    old_image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
    files?: Array<{
      __typename?: 'File';
      can_delete?: boolean;
      can_update?: boolean;
      can_share?: boolean;
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    }>;
    tasks?: Array<{ __typename?: 'Task'; id: string; name: string }>;
    expenses?: Array<{ __typename?: 'Expense'; id: string; item_name?: string }>;
    logs?: Array<{ __typename?: 'Log'; id: string; name?: string }>;
    trips?: Array<{ __typename?: 'Trip'; id: string; name: string }>;
    items?: Array<{ __typename?: 'ChecklistItem'; id: string; name: string; position?: number; checked: boolean }>;
    user?: {
      __typename?: 'User';
      id: string;
      name?: string;
      surname?: string;
      display_name?: string;
      image?: { __typename?: 'File'; url?: string };
    };
  };
};

export type GetChecklistCommentsVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetChecklistComments = {
  __typename?: 'Query';
  checklistComments?: {
    __typename?: 'CommentPaginator';
    data: Array<{
      __typename?: 'Comment';
      id: string;
      text: string;
      updated_at_diff: string;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string;
        surname?: string;
        display_name?: string;
        image?: { __typename?: 'File'; id: string; public_url?: string };
      };
    }>;
    paginatorInfo: { __typename?: 'PaginatorInfo'; currentPage: number; count: number; perPage: number; total: number };
  };
};

export type GetChecklistFollowersVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetChecklistFollowers = {
  __typename?: 'Query';
  checklistFollowers?: {
    __typename?: 'ChecklistUserPaginator';
    data: Array<{
      __typename?: 'ChecklistUser';
      id: string;
      code: string;
      display_name: string;
      email: string;
      gender?: string;
      image_url?: string;
    }>;
    paginatorInfo: { __typename?: 'PaginatorInfo'; currentPage: number; count: number; perPage: number; total: number };
  };
};

export type ChecklistBlockedFollowersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ChecklistBlockedFollowersQuery = {
  __typename?: 'Query';
  checklistBlockedFollowers?: {
    __typename?: 'ChecklistUserPaginator';
    data: Array<{ __typename?: 'ChecklistUser'; id: string; display_name: string; image_url?: string }>;
    paginatorInfo: { __typename?: 'PaginatorInfo'; currentPage: number; count: number; perPage: number; total: number };
  };
};

export type GetPublishableChecklistsVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetPublishableChecklists = {
  __typename?: 'Query';
  publishableChecklists?: {
    __typename?: 'ChecklistPaginator';
    data: Array<{
      __typename?: 'Checklist';
      id: string;
      title: string;
      description?: string;
      old_image_id?: string;
      comments_count?: number;
      user_followers_count?: number;
      clones_count?: number;
      image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
      comments?: Array<{
        __typename?: 'Comment';
        id: string;
        text: string;
        created_at_diff: string;
        user?: { __typename?: 'User'; id: string; name?: string; surname?: string };
      }>;
      old_image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
      items?: Array<{ __typename?: 'ChecklistItem'; id: string; name: string }>;
      user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number;
      hasMorePages: boolean;
      lastItem?: number;
      lastPage: number;
      perPage: number;
      total: number;
    };
  };
};

export type GetPublishableChecklistVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetPublishableChecklist = {
  __typename?: 'Query';
  publishableChecklist: {
    __typename?: 'Checklist';
    id: string;
    title: string;
    description?: string;
    old_image_id?: string;
    comments_count?: number;
    user_followers_count?: number;
    clones_count?: number;
    image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
    comments?: Array<{
      __typename?: 'Comment';
      id: string;
      text: string;
      created_at_diff: string;
      user?: { __typename?: 'User'; id: string; name?: string; surname?: string };
    }>;
    old_image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
    items?: Array<{ __typename?: 'ChecklistItem'; id: string; name: string }>;
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
  };
};

export type GetCollectionInfoVariables = Exact<{ [key: string]: never }>;

export type GetCollectionInfo = {
  __typename?: 'Query';
  info?: {
    __typename?: 'InfoModel';
    type?: Array<string>;
    hull_type?: Array<string>;
    hull_material?: Array<string>;
    categories?: Array<{
      __typename?: 'Taxonomy';
      id: string;
      parent_id?: string;
      image_id?: string;
      slug: string;
      name?: string;
      description?: string;
      type?: string;
      is_displayed: boolean;
      publicBoatCount: number;
    }>;
    activities?: Array<{
      __typename?: 'Taxonomy';
      id: string;
      parent_id?: string;
      image_id?: string;
      slug: string;
      name?: string;
      description?: string;
      type?: string;
      is_displayed: boolean;
    }>;
  };
};

export type GetFormInfoVariables = Exact<{ [key: string]: never }>;

export type GetFormInfo = {
  __typename?: 'Query';
  info?: {
    __typename?: 'InfoModel';
    categories?: Array<{ __typename?: 'Taxonomy'; id: string; name?: string }>;
    activities?: Array<{ __typename?: 'Taxonomy'; id: string; name?: string }>;
  };
};

export type GetCommentsVariables = Exact<{
  id: Scalars['ID']['input'];
  commentable_type: Scalars['String']['input'];
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>> | InputMaybe<OrderByClause>>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetComments = {
  __typename?: 'Query';
  viewComments?: {
    __typename?: 'CommentPaginator';
    data: Array<{
      __typename?: 'Comment';
      id: string;
      can_unlike: boolean;
      like_count?: number;
      text: string;
      created_at_diff: string;
      updated_at_diff: string;
      can_update: boolean;
      can_delete: boolean;
      can_like: boolean;
      user?: {
        __typename?: 'User';
        id: string;
        surname?: string;
        name?: string;
        image?: { __typename?: 'File'; id: string; url?: string };
      };
    }>;
    paginatorInfo: { __typename?: 'PaginatorInfo'; currentPage: number; hasMorePages: boolean; count: number };
  };
};

export type GetCostsVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>> | InputMaybe<OrderByClause>>;
  filter?: InputMaybe<Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  record_id?: InputMaybe<Scalars['ID']['input']>;
  record_type?: InputMaybe<Scalars['String']['input']>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetCosts = {
  __typename?: 'Query';
  costs?: {
    __typename?: 'CostPaginator';
    data: Array<{
      __typename?: 'Cost';
      amount?: number;
      id: string;
      notes?: string;
      type: string;
      exchange_rate?: number;
      quantity?: number;
      is_maintenance_cost?: boolean;
      name: string;
      can_delete?: boolean;
      can_update?: boolean;
      date?: any;
      user_id: string;
      boat_detail_id?: string;
      category_id?: string;
      currency_id: string;
      supplier?: string;
      vat_percentage?: number;
      vat_type?: string;
      created_at: any;
      updated_at: any;
      trips?: Array<{ __typename?: 'Trip'; id: string; name: string }>;
      logs?: Array<{ __typename?: 'Log'; id: string; datetime?: string }>;
      tasks?: Array<{ __typename?: 'Task'; id: string; name: string }>;
      expenses?: Array<{ __typename?: 'Expense'; id: string; item_name?: string }>;
      comments?: Array<{ __typename?: 'Comment'; id: string; text: string }>;
      category?: { __typename?: 'Category'; id: string; name: string };
      documents?: Array<{
        __typename?: 'File';
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      }>;
      files?: Array<{
        __typename?: 'File';
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      }>;
      user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string; flag: string };
      currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string; symbol?: string };
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number;
      hasMorePages: boolean;
      lastItem?: number;
      lastPage: number;
      perPage: number;
      total: number;
    };
  };
};

export type GetCostVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetCost = {
  __typename?: 'Query';
  cost?: {
    __typename?: 'Cost';
    amount?: number;
    id: string;
    notes?: string;
    type: string;
    exchange_rate?: number;
    quantity?: number;
    is_maintenance_cost?: boolean;
    name: string;
    can_delete?: boolean;
    can_update?: boolean;
    date?: any;
    user_id: string;
    boat_detail_id?: string;
    category_id?: string;
    currency_id: string;
    supplier?: string;
    vat_percentage?: number;
    vat_type?: string;
    created_at: any;
    updated_at: any;
    trips?: Array<{ __typename?: 'Trip'; id: string; name: string }>;
    logs?: Array<{ __typename?: 'Log'; id: string; datetime?: string }>;
    tasks?: Array<{ __typename?: 'Task'; id: string; name: string }>;
    expenses?: Array<{ __typename?: 'Expense'; id: string; item_name?: string }>;
    comments?: Array<{ __typename?: 'Comment'; id: string; text: string }>;
    category?: { __typename?: 'Category'; id: string; name: string };
    documents?: Array<{
      __typename?: 'File';
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    }>;
    files?: Array<{
      __typename?: 'File';
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    }>;
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string; flag: string };
    currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string; symbol?: string };
  };
};

export type GetUnpaginatedCostsVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>> | InputMaybe<OrderByClause>>;
  filter?: InputMaybe<Filter>;
  record_type?: InputMaybe<Scalars['String']['input']>;
  record_id?: InputMaybe<Scalars['ID']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  boat_details_id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetUnpaginatedCosts = {
  __typename?: 'Query';
  unpaginatedCosts?: Array<{
    __typename?: 'Cost';
    amount?: number;
    id: string;
    notes?: string;
    type: string;
    exchange_rate?: number;
    quantity?: number;
    is_maintenance_cost?: boolean;
    name: string;
    can_delete?: boolean;
    can_update?: boolean;
    date?: any;
    user_id: string;
    boat_detail_id?: string;
    category_id?: string;
    currency_id: string;
    supplier?: string;
    vat_percentage?: number;
    vat_type?: string;
    created_at: any;
    updated_at: any;
    trips?: Array<{ __typename?: 'Trip'; id: string; name: string }>;
    logs?: Array<{ __typename?: 'Log'; id: string; datetime?: string }>;
    tasks?: Array<{ __typename?: 'Task'; id: string; name: string }>;
    expenses?: Array<{ __typename?: 'Expense'; id: string; item_name?: string }>;
    comments?: Array<{ __typename?: 'Comment'; id: string; text: string }>;
    category?: { __typename?: 'Category'; id: string; name: string };
    documents?: Array<{
      __typename?: 'File';
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    }>;
    files?: Array<{
      __typename?: 'File';
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    }>;
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string; flag: string };
    currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string; symbol?: string };
  }>;
};

export type GetCountriesVariables = Exact<{ [key: string]: never }>;

export type GetCountries = {
  __typename?: 'Query';
  countries?: {
    __typename?: 'CountryPaginator';
    data: Array<{ __typename?: 'Country'; id: string; name?: string; iso_code?: string }>;
  };
};

export type GetCurrenciesVariables = Exact<{ [key: string]: never }>;

export type GetCurrencies = {
  __typename?: 'Query';
  currencies?: {
    __typename?: 'CurrencyPaginator';
    data: Array<{ __typename?: 'Currency'; id?: string; iso_code?: string; symbol?: string; is_default?: string }>;
  };
};

export type FieldsVariables = Exact<{
  module: ModuleType;
}>;

export type Fields = {
  __typename?: 'Query';
  fields?: Array<{
    __typename?: 'Field';
    id: string;
    name?: string;
    options?: string;
    type?: string;
    options_data?: Array<string>;
  }>;
};

export type GetBoatEngineByIdVariables = Exact<{
  boat_detail_id: Scalars['ID']['input'];
}>;

export type GetBoatEngineById = {
  __typename?: 'Query';
  engines?: Array<{
    __typename?: 'Engine';
    id: string;
    maker?: string;
    website?: string;
    model?: string;
    drive?: string;
    fuel?: string;
    boat_detail_id?: string;
  }>;
};

export type GetEngineLogsVariables = Exact<{
  engine_id: Scalars['Int']['input'];
}>;

export type GetEngineLogs = {
  __typename?: 'Query';
  engineLogs?: Array<{
    __typename?: 'EngineLog';
    id?: string;
    engine_id: number;
    status?: boolean;
    hours?: number;
    rpm?: number;
    fuel_check?: boolean;
    oil_check?: boolean;
    water_check?: boolean;
    exhaust_check?: boolean;
    datetime?: any;
    log_id?: number;
  }>;
};

export type GetExpensesVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>> | InputMaybe<OrderByClause>>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetExpenses = {
  __typename?: 'Query';
  expenses?: {
    __typename?: 'ExpensePaginator';
    data: Array<{
      __typename?: 'Expense';
      id: string;
      boat_detail_id: string;
      user_id: string;
      item_id: string;
      item_name?: string;
      type?: string;
      notes?: string;
      location?: string;
      has_minimum_quantity_reminder?: boolean;
      minimum_quantity?: number;
      minimum_quantity_reminder?: number;
      brand?: string;
      model?: string;
      part_number?: string;
      serial_number?: string;
      barcode?: string;
      vendor_page?: string;
      packing?: string;
      acquisition_date?: string;
      expiration_date?: string;
      expiration_time_unit?: number;
      expiration_time_unit_type?: string;
      expiration_is_custom?: boolean;
      has_expiration_reminder?: boolean;
      warranty_date?: string;
      warranty_time_unit?: number;
      warranty_time_unit_type?: string;
      warranty_is_custom?: boolean;
      has_warranty_reminder?: boolean;
      is_recurring?: boolean;
      has_usage_reminder?: boolean;
      current_usage_value?: number;
      usage_due_date?: string;
      due_date_time_unit?: number;
      due_date_time_unit_type?: string;
      has_due_date_reminder?: boolean;
      usage_threshold?: number;
      usage_time_unit?: number;
      usage_time_unit_type?: string;
      recurrence_type?: string;
      threshold_reminder_value?: number;
      has_threshold_reminder?: boolean;
      threshold_recurrence_reminder?: number;
      usage_recurrence_time_unit?: number;
      usage_recurrence_time_unit_type?: string;
      usage_is_custom?: boolean;
      usage_recurrence?: number;
      maintenance_synced?: boolean;
      unit?: string;
      quantity?: number;
      total?: number;
      converted_total?: number;
      unit_price?: number;
      voltage?: number;
      width?: number;
      height?: number;
      depth?: number;
      weight?: number;
      consumption?: number;
      supplier?: string;
      supplier_contact?: string;
      linked_expenses_ids?: Array<string>;
      supplier_url?: string;
      can_delete?: boolean;
      can_share?: boolean;
      can_update?: boolean;
      created_at: any;
      updated_at: any;
      imported_at?: any;
      boat_detail?: {
        __typename?: 'BoatDetails';
        name: string;
        id: string;
        flag: string;
        plan?: { __typename?: 'PlanOfUser'; slug?: string };
      };
      item?: { __typename?: 'Item'; id: string; name?: string };
      comments?: Array<{ __typename?: 'Comment'; id: string; like_count?: number }>;
      files?: Array<{
        __typename?: 'File';
        id: string;
        alt?: string;
        url?: string;
        type: string;
        extension: string;
        name: string;
        size: string;
      }>;
      sub_locations?: Array<{ __typename?: 'SubLocation'; level?: number; name?: string }>;
      location_data?: { __typename?: 'Location'; id: string; name: string };
      sub_locations_data?: Array<{ __typename?: 'Location'; id: string; name: string }>;
      unit_price_currency?: { __typename?: 'Currency'; id?: string; iso_code?: string; symbol?: string };
      user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
      linked_expenses?: Array<{
        __typename?: 'Expense';
        item_id: string;
        boat_detail_id: string;
        item_name?: string;
        id: string;
      }>;
      tasks?: Array<{
        __typename?: 'Task';
        id: string;
        name: string;
        boat_detail_id: string;
        user_id: string;
        due_date?: any;
        marked_as_maintenance?: boolean;
        user?: { __typename?: 'User'; display_name?: string; name?: string };
      }>;
      category?: { __typename?: 'Category'; id: string; user_id: string; name: string; type: string };
      costs?: Array<{
        __typename?: 'Cost';
        id: string;
        amount?: number;
        currency_id: string;
        vat_percentage?: number;
        vat_type?: string;
        type: string;
        currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
      }>;
      cost?: {
        __typename?: 'Cost';
        id: string;
        amount?: number;
        currency_id: string;
        vat_percentage?: number;
        vat_type?: string;
        type: string;
        currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
      };
      logs?: Array<{
        __typename?: 'Log';
        id: string;
        datetime?: string;
        trip_id?: string;
        pivot?: { __typename?: 'ExpensePivot'; usage_log_name?: string; usage_value?: number; quantity?: number };
        trip?: { __typename?: 'Trip'; started_at?: string };
        user?: { __typename?: 'User'; id: string; display_name?: string; name?: string; surname?: string };
      }>;
      fields?: Array<{
        __typename?: 'FieldValue';
        id: string;
        name?: string;
        value?: string;
        type?: string;
        options?: Array<string>;
      }>;
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      firstItem?: number;
      lastItem?: number;
      count: number;
      currentPage: number;
      perPage: number;
      total: number;
      hasMorePages: boolean;
    };
  };
};

export type GetExpenseVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetExpense = {
  __typename?: 'Query';
  expense?: {
    __typename?: 'Expense';
    id: string;
    boat_detail_id: string;
    user_id: string;
    item_id: string;
    item_name?: string;
    type?: string;
    notes?: string;
    location?: string;
    has_minimum_quantity_reminder?: boolean;
    minimum_quantity?: number;
    minimum_quantity_reminder?: number;
    brand?: string;
    model?: string;
    part_number?: string;
    serial_number?: string;
    barcode?: string;
    vendor_page?: string;
    packing?: string;
    acquisition_date?: string;
    expiration_date?: string;
    expiration_time_unit?: number;
    expiration_time_unit_type?: string;
    expiration_is_custom?: boolean;
    has_expiration_reminder?: boolean;
    warranty_date?: string;
    warranty_time_unit?: number;
    warranty_time_unit_type?: string;
    warranty_is_custom?: boolean;
    has_warranty_reminder?: boolean;
    is_recurring?: boolean;
    has_usage_reminder?: boolean;
    current_usage_value?: number;
    usage_due_date?: string;
    due_date_time_unit?: number;
    due_date_time_unit_type?: string;
    has_due_date_reminder?: boolean;
    usage_threshold?: number;
    usage_time_unit?: number;
    usage_time_unit_type?: string;
    recurrence_type?: string;
    threshold_reminder_value?: number;
    has_threshold_reminder?: boolean;
    threshold_recurrence_reminder?: number;
    usage_recurrence_time_unit?: number;
    usage_recurrence_time_unit_type?: string;
    usage_is_custom?: boolean;
    usage_recurrence?: number;
    maintenance_synced?: boolean;
    unit?: string;
    quantity?: number;
    total?: number;
    converted_total?: number;
    unit_price?: number;
    voltage?: number;
    width?: number;
    height?: number;
    depth?: number;
    weight?: number;
    consumption?: number;
    supplier?: string;
    supplier_contact?: string;
    linked_expenses_ids?: Array<string>;
    supplier_url?: string;
    can_delete?: boolean;
    can_share?: boolean;
    can_update?: boolean;
    created_at: any;
    updated_at: any;
    imported_at?: any;
    boat_detail?: {
      __typename?: 'BoatDetails';
      name: string;
      id: string;
      flag: string;
      plan?: { __typename?: 'PlanOfUser'; slug?: string };
    };
    item?: { __typename?: 'Item'; id: string; name?: string };
    comments?: Array<{ __typename?: 'Comment'; id: string; like_count?: number }>;
    files?: Array<{
      __typename?: 'File';
      id: string;
      alt?: string;
      url?: string;
      type: string;
      extension: string;
      name: string;
      size: string;
    }>;
    sub_locations?: Array<{ __typename?: 'SubLocation'; level?: number; name?: string }>;
    location_data?: { __typename?: 'Location'; id: string; name: string };
    sub_locations_data?: Array<{ __typename?: 'Location'; id: string; name: string }>;
    unit_price_currency?: { __typename?: 'Currency'; id?: string; iso_code?: string; symbol?: string };
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
    linked_expenses?: Array<{
      __typename?: 'Expense';
      item_id: string;
      boat_detail_id: string;
      item_name?: string;
      id: string;
    }>;
    tasks?: Array<{
      __typename?: 'Task';
      id: string;
      name: string;
      boat_detail_id: string;
      user_id: string;
      due_date?: any;
      marked_as_maintenance?: boolean;
      user?: { __typename?: 'User'; display_name?: string; name?: string };
    }>;
    category?: { __typename?: 'Category'; id: string; user_id: string; name: string; type: string };
    costs?: Array<{
      __typename?: 'Cost';
      id: string;
      amount?: number;
      currency_id: string;
      vat_percentage?: number;
      vat_type?: string;
      type: string;
      currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
    }>;
    cost?: {
      __typename?: 'Cost';
      id: string;
      amount?: number;
      currency_id: string;
      vat_percentage?: number;
      vat_type?: string;
      type: string;
      currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
    };
    logs?: Array<{
      __typename?: 'Log';
      id: string;
      datetime?: string;
      trip_id?: string;
      pivot?: { __typename?: 'ExpensePivot'; usage_log_name?: string; usage_value?: number; quantity?: number };
      trip?: { __typename?: 'Trip'; started_at?: string };
      user?: { __typename?: 'User'; id: string; display_name?: string; name?: string; surname?: string };
    }>;
    fields?: Array<{
      __typename?: 'FieldValue';
      id: string;
      name?: string;
      value?: string;
      type?: string;
      options?: Array<string>;
    }>;
  };
};

export type GetFavoritesVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderByClause>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetFavorites = {
  __typename?: 'Query';
  favorites?: {
    __typename?: 'FavoritePaginator';
    paginatorInfo: { __typename?: 'PaginatorInfo'; currentPage: number; count: number; total: number };
    data: Array<{
      __typename?: 'Favorite';
      id: string;
      user_id: string;
      favoritable_type: string;
      favoritable_id: string;
      favoritable?:
        | {
            __typename?: 'Boat';
            model?: string;
            id: string;
            type: string;
            slug?: string;
            description?: string;
            is_favorited?: boolean;
            total_views?: number;
            favorites_count?: number;
            year_first?: number;
            image?: { __typename?: 'File'; public_url?: string };
          }
        | { __typename?: 'BoatDetails' };
    }>;
  };
};

export type FavoritableBoatFields = {
  __typename?: 'Boat';
  model?: string;
  id: string;
  type: string;
  slug?: string;
  description?: string;
  is_favorited?: boolean;
  total_views?: number;
  favorites_count?: number;
  year_first?: number;
  image?: { __typename?: 'File'; public_url?: string };
};

export type GetFeaturedBoatsByVariables = Exact<{
  type: FeaturedType;
  id: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderTypes>;
}>;

export type GetFeaturedBoatsBy = {
  __typename?: 'Query';
  featuredBoatsBy: Array<{
    __typename?: 'Boat';
    id: string;
    type: string;
    slug?: string;
    is_favorited?: boolean;
    total_views?: number;
    favorites_count?: number;
    model?: string;
    year_first?: number;
    image?: { __typename?: 'File'; public_url?: string };
    manufacturer?: { __typename?: 'Manufacturer'; id?: string; name?: string; slug?: string; website?: string };
  }>;
};

export type GetFilesVariables = Exact<{
  type?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  is_filepicker?: InputMaybe<Scalars['Boolean']['input']>;
  folder_id?: InputMaybe<Scalars['ID']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetFiles = {
  __typename?: 'Query';
  files?: {
    __typename?: 'FilePaginator';
    data: Array<{
      __typename?: 'File';
      can_delete?: boolean;
      can_update?: boolean;
      can_share?: boolean;
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      currentPage: number;
      count: number;
      perPage: number;
      total: number;
      hasMorePages: boolean;
    };
  };
};

export type GetPaginatedFilesVariables = Exact<{
  type?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>> | InputMaybe<OrderByClause>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Filter>;
  folder_id?: InputMaybe<Scalars['ID']['input']>;
  is_filepicker?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetPaginatedFiles = {
  __typename?: 'Query';
  files?: {
    __typename?: 'FilePaginator';
    data: Array<{
      __typename?: 'File';
      can_delete?: boolean;
      can_update?: boolean;
      can_share?: boolean;
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      currentPage: number;
      count: number;
      perPage: number;
      total: number;
      hasMorePages: boolean;
      firstItem?: number;
      lastItem?: number;
    };
  };
};

export type GetFileVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetFile = {
  __typename?: 'Query';
  file?: {
    __typename?: 'File';
    can_delete?: boolean;
    can_update?: boolean;
    can_share?: boolean;
    id: string;
    type: string;
    size: string;
    mime_type: string;
    extension: string;
    name: string;
    filename?: string;
    issued_by?: string;
    issuance_date?: any;
    boat_detail_id?: string;
    notes?: string;
    dimensions?: string;
    disk: string;
    alt?: string;
    description?: string;
    visibility: string;
    url?: string;
    public_url?: string;
    download_url?: string;
    folder_id?: string;
    expiration_date?: any;
    expiration_date_time_unit?: number;
    expiration_date_time_unit_type?: string;
    has_expiration_date_reminder?: boolean;
    created_at?: any;
    updated_at?: any;
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
  };
};

export type FileQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type FileQuery = {
  __typename?: 'Query';
  file?: {
    __typename?: 'File';
    id: string;
    type: string;
    size: string;
    mime_type: string;
    extension: string;
    name: string;
    filename?: string;
    issued_by?: string;
    issuance_date?: any;
    boat_detail_id?: string;
    can_delete?: boolean;
    can_update?: boolean;
    can_share?: boolean;
    expiration_date?: any;
    expiration_date_time_unit?: number;
    expiration_date_time_unit_type?: string;
    dimensions?: string;
    url?: string;
    download_url?: string;
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    linked_records?: Array<{
      __typename?: 'Fileable';
      fileable_type: string;
      fileable_id: string;
      display_name?: string;
    }>;
  };
};

export type FilesCardQueryVariables = Exact<{
  type?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  is_filepicker?: InputMaybe<Scalars['Boolean']['input']>;
  folder_id?: InputMaybe<Scalars['ID']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>> | InputMaybe<OrderByClause>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
}>;

export type FilesCardQuery = {
  __typename?: 'Query';
  files?: {
    __typename?: 'FilePaginator';
    data: Array<{
      __typename?: 'File';
      id: string;
      alt?: string;
      url?: string;
      can_delete?: boolean;
      filename?: string;
      type: string;
      extension: string;
      name: string;
      size: string;
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      currentPage: number;
      count: number;
      perPage: number;
      total: number;
      hasMorePages: boolean;
    };
  };
};

export type GetFilteredBoatsVariables = Exact<{
  filters?: InputMaybe<SearchFilters>;
  orderBy?: InputMaybe<OrderTypes>;
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetFilteredBoats = {
  __typename?: 'Query';
  filterBoats?: {
    __typename?: 'BoatPaginator';
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      currentPage: number;
      count: number;
      total: number;
      perPage: number;
      lastPage: number;
    };
    data: Array<{
      __typename?: 'Boat';
      id: string;
      type: string;
      slug?: string;
      is_favorited?: boolean;
      total_views?: number;
      favorites_count?: number;
      model?: string;
      hull_type: string;
      year_first?: number;
      manufacturer?: { __typename?: 'Manufacturer'; id?: string; name?: string };
      image?: { __typename?: 'File'; public_url?: string };
    }>;
  };
};

export type GetFoldersVariables = Exact<{
  initialValues?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>> | InputMaybe<OrderByClause>>;
  filter?: InputMaybe<Filter>;
  parent_id?: InputMaybe<Scalars['ID']['input']>;
  is_filepicker?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetFolders = {
  __typename?: 'Query';
  folders?: {
    __typename?: 'FolderPaginator';
    data: Array<{
      __typename?: 'Folder';
      id: string;
      user_id?: number;
      name?: string;
      parent_id?: string;
      path?: string;
      files_count?: number;
      folders_count?: number;
      created_at?: any;
      updated_at?: any;
      parent?: {
        __typename?: 'Folder';
        id: string;
        name?: string;
        parent_id?: string;
        parent?: { __typename?: 'Folder'; id: string; name?: string; parent_id?: string };
      };
      breadcrumb_folders?: Array<{ __typename?: 'BreadcrumbFolder'; id?: string; name?: string }>;
    }>;
  };
};

export type GetFolderVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetFolder = {
  __typename?: 'Query';
  folder?: {
    __typename?: 'Folder';
    id: string;
    user_id?: number;
    name?: string;
    parent_id?: string;
    path?: string;
    files_count?: number;
    folders_count?: number;
    created_at?: any;
    updated_at?: any;
    parent?: {
      __typename?: 'Folder';
      id: string;
      name?: string;
      parent_id?: string;
      parent?: { __typename?: 'Folder'; id: string; name?: string; parent_id?: string };
    };
    breadcrumb_folders?: Array<{ __typename?: 'BreadcrumbFolder'; id?: string; name?: string }>;
  };
};

export type FolderBreadcrumbsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type FolderBreadcrumbsQuery = {
  __typename?: 'Query';
  folder?: {
    __typename?: 'Folder';
    id: string;
    name?: string;
    parent_id?: string;
    path?: string;
    breadcrumb_folders?: Array<{ __typename?: 'BreadcrumbFolder'; id?: string; name?: string }>;
  };
};

export type GetLimitsVariables = Exact<{
  boat_details_id?: InputMaybe<Scalars['ID']['input']>;
  trip_id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetLimits = {
  __typename?: 'Query';
  limits?: Array<{
    __typename?: 'Limit';
    name?: string;
    total?: number;
    type?: string;
    used?: number;
    is_allowed?: boolean;
  }>;
};

export type GetLocationsVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>> | InputMaybe<OrderByClause>>;
  is_sub_location?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetLocations = {
  __typename?: 'Query';
  locations?: {
    __typename?: 'LocationPaginator';
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number;
      hasMorePages: boolean;
      lastItem?: number;
      lastPage: number;
      perPage: number;
      total: number;
    };
    data: Array<{ __typename: 'Location'; id: string; name: string; is_sub_location?: boolean; user_id: string }>;
  };
};

export type GetTripLogsVariables = Exact<{
  trip_id: Scalars['ID']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Filter>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>> | InputMaybe<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetTripLogs = {
  __typename?: 'Query';
  logsOfTrip?: {
    __typename?: 'LogPaginator';
    data: Array<{
      __typename?: 'Log';
      id: string;
      name?: string;
      datetime?: string;
      latitude?: number;
      longitude?: number;
      log?: number;
      type: string;
      created_at: any;
      updated_at: any;
      notes?: string;
      category_id?: string;
      category?: { __typename?: 'Category'; id: string; name: string };
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      total: number;
      hasMorePages: boolean;
      firstItem?: number;
      currentPage: number;
      lastItem?: number;
      lastPage: number;
    };
  };
};

export type TotalTripLogsQueryVariables = Exact<{
  trip_id: Scalars['ID']['input'];
}>;

export type TotalTripLogsQuery = {
  __typename?: 'Query';
  logsOfTrip?: {
    __typename?: 'LogPaginator';
    paginatorInfo: { __typename?: 'PaginatorInfo'; count: number; total: number };
  };
};

export type GetLogVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetLog = {
  __typename?: 'Query';
  log?: {
    __typename?: 'Log';
    id: string;
    name?: string;
    boat_detail_id?: string;
    trip_id?: string;
    user_id: string;
    datetime?: string;
    latitude?: number;
    longitude?: number;
    type: string;
    notes?: string;
    caption?: string;
    sea_area?: string;
    imminent?: string;
    later?: string;
    outlook?: string;
    channel?: string;
    station?: string;
    message?: string;
    event?: string;
    heading?: number;
    cog?: number;
    helm?: string;
    speed?: number;
    sog?: number;
    log?: number;
    depth?: number;
    bar?: number;
    wind_speed?: number;
    wind_direction?: number;
    sky?: number;
    precipitation?: string;
    sea_state?: number;
    visibility?: number;
    air_temp?: number;
    sea_temp?: number;
    sails?: string;
    engine_status1?: boolean;
    engine_hours1?: number;
    engine_rpm1?: number;
    engine_fuel_check1?: boolean;
    engine_oil_check1?: boolean;
    engine_water_check1?: boolean;
    engine_exhaust_check1?: boolean;
    engine_status2?: boolean;
    engine_hours2?: number;
    engine_rpm2?: number;
    engine_fuel_check2?: boolean;
    engine_oil_check2?: boolean;
    engine_water_check2?: boolean;
    engine_exhaust_check2?: boolean;
    diesel_generator_status?: boolean;
    diesel_generator_hours?: number;
    diesel_generator_rpm?: number;
    diesel_generator_fuel_check?: boolean;
    diesel_generator_oil_check?: boolean;
    diesel_generator_water_check?: boolean;
    diesel_generator_exhaust_check?: boolean;
    battery1?: number;
    battery2?: number;
    boat_water?: number;
    fuel?: number;
    gas?: number;
    bilge?: boolean;
    category_id?: string;
    can_delete?: boolean;
    can_update?: boolean;
    creation_type?: string;
    creator_agent_name?: string;
    created_at: any;
    updated_at: any;
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string; flag: string };
    comments?: Array<{
      __typename?: 'Comment';
      id: string;
      text: string;
      created_at_diff: string;
      created_at: any;
      updated_at_diff: string;
      updated_at: any;
      can_update: boolean;
      can_unlike: boolean;
      can_delete: boolean;
      can_like: boolean;
    }>;
    files?: Array<{
      __typename?: 'File';
      id: string;
      alt?: string;
      url?: string;
      type: string;
      extension: string;
      name: string;
      size: string;
    }>;
    engine_logs?: Array<{
      __typename?: 'EngineLog';
      id?: string;
      engine_id: number;
      status?: boolean;
      hours?: number;
      rpm?: number;
      fuel_check?: boolean;
      oil_check?: boolean;
      water_check?: boolean;
      exhaust_check?: boolean;
    }>;
    category?: { __typename?: 'Category'; id: string; name: string };
    expenses?: Array<{
      __typename?: 'Expense';
      id: string;
      boat_detail_id: string;
      item_name?: string;
      quantity?: number;
      current_usage_value?: number;
      supplier?: string;
      category_id?: string;
      pivot?: {
        __typename?: 'ExpensePivot';
        usage_log_name?: string;
        usage_value?: number;
        quantity?: number;
        quantity_action?: string;
      };
      user?: { __typename?: 'User'; id: string; name?: string; surname?: string };
    }>;
    trip?: {
      __typename?: 'Trip';
      id: string;
      boat_detail?: { __typename?: 'BoatDetails'; name: string; flag: string; id: string };
    };
    user?: { __typename?: 'User'; id: string; display_name?: string; name?: string; surname?: string };
    costs?: Array<{
      __typename?: 'Cost';
      id: string;
      amount?: number;
      currency_id: string;
      vat_percentage?: number;
      vat_type?: string;
      type: string;
      supplier?: string;
      currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
    }>;
    cost?: {
      __typename?: 'Cost';
      id: string;
      amount?: number;
      currency_id: string;
      vat_percentage?: number;
      vat_type?: string;
      type: string;
      supplier?: string;
      currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
      category?: { __typename?: 'Category'; id: string; name: string };
    };
  };
};

export type GetAllLogsVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>> | InputMaybe<OrderByClause>>;
  expense_id?: InputMaybe<Scalars['ID']['input']>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Filter>;
}>;

export type GetAllLogs = {
  __typename?: 'Query';
  flatLogs?: {
    __typename?: 'LogPaginator';
    data: Array<{
      __typename?: 'Log';
      id: string;
      name?: string;
      boat_detail_id?: string;
      log?: number;
      datetime?: string;
      type: string;
      notes?: string;
      latitude?: number;
      longitude?: number;
      caption?: string;
      sea_area?: string;
      imminent?: string;
      later?: string;
      outlook?: string;
      channel?: string;
      station?: string;
      message?: string;
      event?: string;
      heading?: number;
      cog?: number;
      helm?: string;
      speed?: number;
      sog?: number;
      depth?: number;
      bar?: number;
      wind_speed?: number;
      wind_direction?: number;
      sky?: number;
      precipitation?: string;
      sea_state?: number;
      visibility?: number;
      air_temp?: number;
      sea_temp?: number;
      sails?: string;
      engine_status1?: boolean;
      engine_hours1?: number;
      engine_rpm1?: number;
      engine_fuel_check1?: boolean;
      engine_oil_check1?: boolean;
      engine_water_check1?: boolean;
      engine_exhaust_check1?: boolean;
      engine_status2?: boolean;
      engine_hours2?: number;
      engine_rpm2?: number;
      engine_fuel_check2?: boolean;
      engine_oil_check2?: boolean;
      engine_water_check2?: boolean;
      engine_exhaust_check2?: boolean;
      diesel_generator_status?: boolean;
      diesel_generator_hours?: number;
      diesel_generator_rpm?: number;
      diesel_generator_fuel_check?: boolean;
      diesel_generator_oil_check?: boolean;
      diesel_generator_water_check?: boolean;
      diesel_generator_exhaust_check?: boolean;
      battery1?: number;
      battery2?: number;
      boat_water?: number;
      fuel?: number;
      gas?: number;
      bilge?: boolean;
      created_at: any;
      updated_at: any;
      can_delete?: boolean;
      can_update?: boolean;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string; flag: string };
      trip?: {
        __typename?: 'Trip';
        name: string;
        id: string;
        boat_detail?: { __typename?: 'BoatDetails'; name: string; flag: string; id: string };
      };
      expenses?: Array<{
        __typename?: 'Expense';
        id: string;
        item_name?: string;
        pivot?: {
          __typename?: 'ExpensePivot';
          usage_log_name?: string;
          usage_value?: number;
          quantity?: number;
          quantity_action?: string;
        };
      }>;
      user?: { __typename?: 'User'; name?: string; surname?: string };
      files?: Array<{ __typename?: 'File'; id: string; name: string; url?: string }>;
      costs?: Array<{
        __typename?: 'Cost';
        id: string;
        amount?: number;
        currency_id: string;
        vat_percentage?: number;
        vat_type?: string;
        type: string;
        supplier?: string;
        currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
      }>;
      cost?: {
        __typename?: 'Cost';
        id: string;
        amount?: number;
        currency_id: string;
        vat_percentage?: number;
        vat_type?: string;
        type: string;
        supplier?: string;
        currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
      };
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number;
      hasMorePages: boolean;
      lastItem?: number;
      lastPage: number;
      perPage: number;
      total: number;
    };
  };
};

export type GetManufacturersVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetManufacturers = {
  __typename?: 'Query';
  manufacturers?: {
    __typename?: 'ManufacturerPaginator';
    data: Array<{
      __typename?: 'Manufacturer';
      id?: string;
      name?: string;
      website?: string;
      publicBoatCount: number;
      slug?: string;
      logo?: { __typename?: 'File'; public_url?: string };
    }>;
    paginatorInfo: { __typename?: 'PaginatorInfo'; count: number; currentPage: number; perPage: number; total: number };
  };
};

export type GetMakersVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetMakers = {
  __typename?: 'Query';
  manufacturers?: {
    __typename?: 'ManufacturerPaginator';
    data: Array<{ __typename?: 'Manufacturer'; id?: string; website?: string; name?: string }>;
  };
};

export type GetCurrentUserDataVariables = Exact<{ [key: string]: never }>;

export type GetCurrentUserData = {
  __typename?: 'Query';
  authUser?: {
    __typename?: 'User';
    id: string;
    display_name?: string;
    birthday?: any;
    gender?: string;
    image_id?: number;
    name?: string;
    surname?: string;
    email: string;
    phone?: string;
    unit?: string;
    memory_usage_percentage?: number;
    novu_id?: string;
    base_currency_id?: string;
    card_last_four?: string;
    card_brand?: string;
    created_at?: any;
    image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
    timezone?: { __typename?: 'Timezone'; id: string; name?: string };
    country?: { __typename?: 'Country'; id: string };
    currency?: { __typename?: 'Currency'; id?: string; iso_code?: string };
    base_currency?: { __typename?: 'Currency'; id?: string; iso_code?: string; symbol?: string };
    address?: {
      __typename?: 'Address';
      id: string;
      street?: string;
      city?: string;
      state?: string;
      postal_code?: string;
      country?: string;
    };
  };
};

export type NovuDeviceTokensQueryVariables = Exact<{ [key: string]: never }>;

export type NovuDeviceTokensQuery = { __typename?: 'Query'; novuDeviceTokens?: Array<string> };

export type DeviceTokenStatusQueryVariables = Exact<{
  provider: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;

export type DeviceTokenStatusQuery = { __typename?: 'Query'; deviceTokenStatus?: boolean };

export type GetPlanOfUserVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetPlanOfUser = {
  __typename?: 'Query';
  planOfUser?: {
    __typename?: 'PlanOfUser';
    id: string;
    name: string;
    slug?: string;
    gateway_id?: string;
    cost?: number;
    currency?: string;
    interval?: string;
    trial_days?: number;
    status?: string;
    used?: number;
    available?: number;
    total?: number;
    interval_count?: number;
    first_subscription_date?: any;
    end_date?: any;
    is_on_grace?: boolean;
    has_scheduled_update?: boolean;
    subscription_schedule?: {
      __typename?: 'SubscriptionSchedule';
      id: string;
      phases?: Array<{
        __typename?: 'SubscriptionSchedulePhase';
        start_date: number;
        description?: string;
        prorate?: boolean;
        end_date: number;
        plans: Array<{
          __typename?: 'SubscriptionSchedulePlan';
          plan: string;
          price: string;
          quantity: number;
          billing_thresholds?: any;
        }>;
      }>;
    };
  };
};

export type GetCheckoutDataVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;

export type GetCheckoutData = {
  __typename?: 'Query';
  retrieveCheckoutData?: {
    __typename?: 'CheckoutSessionResponse';
    plan_id?: string;
    plan_name?: string;
    renewal_date?: any;
  };
};

export type PlansQueryVariables = Exact<{ [key: string]: never }>;

export type PlansQuery = {
  __typename?: 'Query';
  plans?: Array<{
    __typename?: 'Plan';
    id: string;
    name: string;
    slug?: string;
    gateway_id?: string;
    cost?: number;
    currency?: string;
    interval?: string;
    trial_days?: number;
    status?: string;
  }>;
};

export type PlanOfUserQueryVariables = Exact<{ [key: string]: never }>;

export type PlanOfUserQuery = {
  __typename?: 'Query';
  planOfUser?: {
    __typename?: 'PlanOfUser';
    id: string;
    name: string;
    slug?: string;
    gateway_id?: string;
    cost?: number;
    currency?: string;
    interval?: string;
    trial_days?: number;
    status?: string;
    used?: number;
    available?: number;
    total?: number;
    interval_count?: number;
    first_subscription_date?: any;
    end_date?: any;
    is_on_grace?: boolean;
    has_scheduled_update?: boolean;
    subscription_schedule?: {
      __typename?: 'SubscriptionSchedule';
      id: string;
      phases?: Array<{
        __typename?: 'SubscriptionSchedulePhase';
        start_date: number;
        description?: string;
        prorate?: boolean;
        end_date: number;
        plans: Array<{
          __typename?: 'SubscriptionSchedulePlan';
          plan: string;
          price: string;
          quantity: number;
          billing_thresholds?: any;
        }>;
      }>;
    };
  };
};

export type InvoicesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  starting_after?: InputMaybe<Scalars['String']['input']>;
}>;

export type InvoicesQuery = {
  __typename?: 'Query';
  invoices?: Array<{
    __typename?: 'Invoice';
    id?: string;
    created?: number;
    hosted_invoice_url?: string;
    paid?: boolean;
    total?: number;
    status?: string;
  }>;
};

export type PreviewUpgradeInvoiceQueryVariables = Exact<{
  plan_id: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  proration_time: ProrationTimeEnum;
}>;

export type PreviewUpgradeInvoiceQuery = {
  __typename?: 'Query';
  previewUpgradeInvoice?: {
    __typename?: 'UpgradePreview';
    id?: string;
    billing_reason?: string;
    charge?: string;
    collection_method?: string;
    currency?: string;
    total?: number;
    subtotal?: number;
    subscription?: string;
    due_date?: number;
    default_payment_method?: string;
    period_end?: number;
    period_start?: number;
    statement_descriptor?: string;
    discount?: any;
    object?: string;
    amount_due?: number;
    created?: number;
    customer?: string;
    customer_address?: string;
    default_source?: string;
    default_tax_rates?: Array<string>;
    lines?: {
      __typename?: 'InvoiceLineItems';
      object?: string;
      data?: Array<{
        __typename?: 'LineItem';
        id?: string;
        subscription?: string;
        currency?: string;
        quantity?: number;
        amount?: number;
        object?: string;
        description?: string;
        proration?: boolean;
        period?: { __typename?: 'Period'; start?: number; end?: number };
        price?: {
          __typename?: 'Price';
          id?: string;
          unit_amount?: number;
          currency?: string;
          unit_amount_decimal?: string;
          tiers_mode?: string;
          transform_quantity?: string;
          type?: string;
        };
        tax_amounts?: Array<{
          __typename?: 'TaxAmount';
          amount?: number;
          inclusive?: boolean;
          tax_rate?: string;
          taxability_reason?: string;
          taxable_amount?: number;
        }>;
      }>;
    };
  };
};

export type UpcomingInvoiceQueryVariables = Exact<{ [key: string]: never }>;

export type UpcomingInvoiceQuery = {
  __typename?: 'Query';
  upcomingInvoice?: {
    __typename?: 'Invoice';
    id?: string;
    billing_reason?: string;
    lines?: {
      __typename?: 'InvoiceLineItems';
      object?: string;
      data?: Array<{
        __typename?: 'LineItem';
        id?: string;
        subscription?: string;
        currency?: string;
        quantity?: number;
        amount?: number;
        object?: string;
        description?: string;
        proration?: boolean;
        period?: { __typename?: 'Period'; start?: number; end?: number };
        price?: {
          __typename?: 'Price';
          id?: string;
          unit_amount?: number;
          currency?: string;
          unit_amount_decimal?: string;
          tiers_mode?: string;
          transform_quantity?: string;
          type?: string;
        };
      }>;
    };
  };
};

export type ScheduledUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type ScheduledUpdateQuery = {
  __typename?: 'Query';
  scheduledUpdate?: {
    __typename?: 'ScheduledUpdate';
    id: string;
    object: string;
    application?: string;
    canceled_at?: number;
    completed_at?: number;
    created: number;
    current_phase?: string;
    customer: string;
    end_behavior: string;
    livemode: boolean;
    metadata: any;
    released_at?: number;
    released_subscription?: string;
    renewal_interval?: string;
    status: string;
    subscription?: string;
    test_clock?: string;
    default_settings: {
      __typename?: 'DefaultSettings';
      application_fee_percent?: number;
      billing_cycle_anchor: string;
      billing_thresholds?: any;
      collection_method: string;
      default_payment_method?: string;
      default_source?: string;
      description?: string;
      on_behalf_of?: string;
      transfer_data?: string;
      automatic_tax: { __typename?: 'AutomaticTax'; enabled?: boolean; liability?: string };
      issuer?: { __typename?: 'Issuer'; type?: string };
    };
    phases: Array<{
      __typename?: 'Phase';
      add_invoice_items: Array<any>;
      application_fee_percent?: number;
      billing_cycle_anchor?: string;
      billing_thresholds?: any;
      collection_method?: string;
      coupon?: string;
      currency: string;
      default_payment_method?: string;
      default_tax_rates: Array<string>;
      description?: string;
      end_date: number;
      invoice_settings?: string;
      metadata: any;
      on_behalf_of?: string;
      proration_behavior: string;
      start_date: number;
      transfer_data?: string;
      trial_end?: number;
      items?: Array<{
        __typename?: 'PhaseItem';
        billing_thresholds?: any;
        metadata: any;
        plan: string;
        price: string;
        quantity: number;
        tax_rates: Array<string>;
      }>;
    }>;
  };
};

export type GetRelatedUsersBoatsVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetRelatedUsersBoats = {
  __typename?: 'Query';
  relatedUsersBoats?: Array<{
    __typename?: 'BoatDetails';
    flag: string;
    user?: { __typename?: 'User'; name?: string; surname?: string };
    boat?: {
      __typename?: 'Boat';
      id: string;
      views_count?: number;
      favorites_count?: number;
      year_first?: number;
      model?: string;
      manufacturer_name?: string;
      slug?: string;
      is_favorited?: boolean;
    };
  }>;
};

export type UserSettingsVariables = Exact<{ [key: string]: never }>;

export type UserSettings = {
  __typename?: 'Query';
  settings?: { __typename?: 'SettingPaginator'; data: Array<{ __typename: 'Setting'; key: string; value?: string }> };
};

export type UserSubscriptionQueryVariables = Exact<{ [key: string]: never }>;

export type UserSubscriptionQuery = {
  __typename?: 'Query';
  subscription?: {
    __typename?: 'UserSubscription';
    id?: string;
    free_subscription_id?: string;
    is_free?: boolean;
    available_active_alert_slots?: number;
    used_licenses?: number;
    total_licenses?: number;
    available_licenses?: number;
    cost?: number;
    currency?: string;
    interval?: string;
    trial_days?: number;
    status?: string;
    is_on_trial?: boolean;
    interval_count?: number;
    first_subscription_date?: string;
    end_date?: string;
    is_on_grace?: boolean;
    has_scheduled_update?: boolean;
    has_free_boat_available?: boolean;
    trial_ends_at?: string;
    has_available_trial?: boolean;
    next_billing_date?: any;
    subscription_schedule?: {
      __typename?: 'SubscriptionSchedule';
      id: string;
      phases?: Array<{
        __typename?: 'SubscriptionSchedulePhase';
        start_date: number;
        description?: string;
        prorate?: boolean;
        end_date: number;
        plans: Array<{
          __typename?: 'SubscriptionSchedulePlan';
          plan: string;
          price: string;
          quantity: number;
          billing_thresholds?: any;
        }>;
      }>;
    };
    plan?: {
      __typename?: 'PlanOfUser';
      id: string;
      name: string;
      slug?: string;
      status?: string;
      cost?: number;
      total?: number;
      available?: number;
    };
  };
};

export type GetTasksVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>> | InputMaybe<OrderByClause>>;
  boat_details_id?: InputMaybe<Scalars['ID']['input']>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  due_date_range?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetTasks = {
  __typename?: 'Query';
  tasks?: {
    __typename?: 'TaskPaginator';
    data: Array<{
      __typename?: 'Task';
      boat_detail_id: string;
      user_id: string;
      assignee_ids?: Array<string>;
      id: string;
      name: string;
      category_id?: string;
      type?: string;
      status?: string;
      frequency?: string;
      is_recurring?: boolean;
      priority?: number;
      notes?: string;
      created_at: any;
      due_date?: any;
      has_notification?: boolean;
      completed_at?: any;
      time_unit?: number;
      time_unit_type?: string;
      linked_expense_id?: number;
      marked_as_maintenance?: boolean;
      usage_is_custom?: boolean;
      usage_time_unit_type?: string;
      usage_time_unit?: number;
      usage_recurrence_time_unit?: number;
      usage_recurrence_time_unit_type?: string;
      has_usage_reminder?: boolean;
      recurrence_type?: string;
      usage_recurrence?: number;
      threshold_recurrence_reminder?: number;
      can_delete?: boolean;
      can_update?: boolean;
      can_share?: boolean;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string; flag: string };
      assignee?: {
        __typename?: 'User';
        display_name?: string;
        email: string;
        name?: string;
        surname?: string;
        id: string;
        image?: {
          __typename?: 'File';
          id: string;
          type: string;
          size: string;
          mime_type: string;
          extension: string;
          name: string;
          filename?: string;
          issued_by?: string;
          issuance_date?: any;
          boat_detail_id?: string;
          notes?: string;
          dimensions?: string;
          disk: string;
          alt?: string;
          description?: string;
          visibility: string;
          url?: string;
          public_url?: string;
          download_url?: string;
          folder_id?: string;
          expiration_date?: any;
          expiration_date_time_unit?: number;
          expiration_date_time_unit_type?: string;
          has_expiration_date_reminder?: boolean;
          created_at?: any;
          updated_at?: any;
          boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
        };
      };
      taxonomies?: Array<{ __typename?: 'Taxonomy'; id: string; name?: string }>;
      category?: { __typename?: 'Category'; id: string; name: string; type: string };
      user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
      expenses?: Array<{ __typename?: 'Expense'; id: string; item_name?: string }>;
      costs?: Array<{
        __typename?: 'Cost';
        id: string;
        amount?: number;
        currency_id: string;
        vat_percentage?: number;
        vat_type?: string;
        type: string;
        supplier?: string;
        currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
      }>;
      cost?: {
        __typename?: 'Cost';
        id: string;
        amount?: number;
        currency_id: string;
        vat_percentage?: number;
        vat_type?: string;
        type: string;
        supplier?: string;
        currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
      };
      files?: Array<{
        __typename?: 'File';
        id: string;
        alt?: string;
        url?: string;
        type: string;
        extension: string;
        name: string;
        size: string;
      }>;
      alert?: { __typename?: 'Alert'; id: string };
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      firstItem?: number;
      currentPage: number;
      count: number;
      perPage: number;
      total: number;
      lastItem?: number;
    };
  };
};

export type GetTaskVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetTask = {
  __typename?: 'Query';
  task?: {
    __typename?: 'Task';
    boat_detail_id: string;
    user_id: string;
    assignee_ids?: Array<string>;
    id: string;
    name: string;
    category_id?: string;
    type?: string;
    status?: string;
    is_recurring?: boolean;
    frequency?: string;
    priority?: number;
    notes?: string;
    due_date?: any;
    has_notification?: boolean;
    completed_at?: any;
    time_unit?: number;
    time_unit_type?: string;
    linked_expense_id?: number;
    marked_as_maintenance?: boolean;
    usage_is_custom?: boolean;
    usage_time_unit_type?: string;
    usage_time_unit?: number;
    usage_recurrence_time_unit?: number;
    usage_recurrence_time_unit_type?: string;
    has_usage_reminder?: boolean;
    recurrence_type?: string;
    usage_recurrence?: number;
    threshold_recurrence_reminder?: number;
    created_at: any;
    can_delete?: boolean;
    can_update?: boolean;
    can_share?: boolean;
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string; flag: string };
    assignee?: {
      __typename?: 'User';
      id: string;
      display_name?: string;
      email: string;
      name?: string;
      surname?: string;
      image?: {
        __typename?: 'File';
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      };
    };
    taxonomies?: Array<{ __typename?: 'Taxonomy'; id: string; name?: string }>;
    category?: { __typename?: 'Category'; id: string; name: string; type: string };
    user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
    expenses?: Array<{ __typename?: 'Expense'; id: string; item_name?: string }>;
    costs?: Array<{
      __typename?: 'Cost';
      id: string;
      amount?: number;
      currency_id: string;
      vat_percentage?: number;
      vat_type?: string;
      type: string;
      supplier?: string;
      currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
    }>;
    cost?: {
      __typename?: 'Cost';
      id: string;
      amount?: number;
      currency_id: string;
      vat_percentage?: number;
      vat_type?: string;
      type: string;
      supplier?: string;
      currency?: { __typename?: 'Currency'; id?: string; name?: string; iso_code?: string };
    };
    files?: Array<{
      __typename?: 'File';
      created_at?: any;
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    }>;
    alert?: { __typename?: 'Alert'; id: string };
  };
};

export type GetTimeZonesVariables = Exact<{ [key: string]: never }>;

export type GetTimeZones = {
  __typename?: 'Query';
  timezones?: { __typename?: 'TimezonePaginator'; data: Array<{ __typename?: 'Timezone'; id: string; name?: string }> };
};

export type GetTripsVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  firstItem?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>> | InputMaybe<OrderByClause>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Filter>;
  boat_details_id?: InputMaybe<Scalars['ID']['input']>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetTrips = {
  __typename?: 'Query';
  trips?: {
    __typename?: 'TripPaginator';
    data: Array<{
      __typename?: 'Trip';
      id: string;
      name: string;
      started_at?: string;
      finished_at?: any;
      closed_at?: string;
      boat_detail_id: string;
      origin?: string;
      origin_latitude?: number;
      origin_longitude?: number;
      destination?: string;
      destination_longitude?: number;
      destination_latitude?: number;
      general_logs_count?: number;
      radio_logs_count?: number;
      social_logs_count?: number;
      weather_logs_count?: number;
      can_update?: boolean;
      can_delete?: boolean;
      can_share?: boolean;
      skipper_id?: string;
      crewman_id?: string;
      notes?: string;
      created_at: any;
      updated_at: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string; flag: string; location?: string };
      image?: {
        __typename?: 'File';
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      };
      user?: {
        __typename?: 'User';
        id: string;
        display_name?: string;
        name?: string;
        surname?: string;
        email: string;
        image?: {
          __typename?: 'File';
          id: string;
          type: string;
          size: string;
          mime_type: string;
          extension: string;
          name: string;
          filename?: string;
          issued_by?: string;
          issuance_date?: any;
          boat_detail_id?: string;
          notes?: string;
          dimensions?: string;
          disk: string;
          alt?: string;
          description?: string;
          visibility: string;
          url?: string;
          public_url?: string;
          download_url?: string;
          folder_id?: string;
          expiration_date?: any;
          expiration_date_time_unit?: number;
          expiration_date_time_unit_type?: string;
          has_expiration_date_reminder?: boolean;
          created_at?: any;
          updated_at?: any;
          boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
        };
      };
      skipper?: {
        __typename?: 'User';
        id: string;
        display_name?: string;
        email: string;
        name?: string;
        surname?: string;
        image?: {
          __typename?: 'File';
          id: string;
          type: string;
          size: string;
          mime_type: string;
          extension: string;
          name: string;
          filename?: string;
          issued_by?: string;
          issuance_date?: any;
          boat_detail_id?: string;
          notes?: string;
          dimensions?: string;
          disk: string;
          alt?: string;
          description?: string;
          visibility: string;
          url?: string;
          public_url?: string;
          download_url?: string;
          folder_id?: string;
          expiration_date?: any;
          expiration_date_time_unit?: number;
          expiration_date_time_unit_type?: string;
          has_expiration_date_reminder?: boolean;
          created_at?: any;
          updated_at?: any;
          boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
        };
      };
      crewman?: {
        __typename?: 'User';
        id: string;
        display_name?: string;
        name?: string;
        surname?: string;
        email: string;
        image?: {
          __typename?: 'File';
          id: string;
          type: string;
          size: string;
          mime_type: string;
          extension: string;
          name: string;
          filename?: string;
          issued_by?: string;
          issuance_date?: any;
          boat_detail_id?: string;
          notes?: string;
          dimensions?: string;
          disk: string;
          alt?: string;
          description?: string;
          visibility: string;
          url?: string;
          public_url?: string;
          download_url?: string;
          folder_id?: string;
          expiration_date?: any;
          expiration_date_time_unit?: number;
          expiration_date_time_unit_type?: string;
          has_expiration_date_reminder?: boolean;
          created_at?: any;
          updated_at?: any;
          boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
        };
      };
      members?: Array<{
        __typename?: 'User';
        id: string;
        email: string;
        display_name?: string;
        name?: string;
        surname?: string;
        image?: {
          __typename?: 'File';
          id: string;
          type: string;
          size: string;
          mime_type: string;
          extension: string;
          name: string;
          filename?: string;
          issued_by?: string;
          issuance_date?: any;
          boat_detail_id?: string;
          notes?: string;
          dimensions?: string;
          disk: string;
          alt?: string;
          description?: string;
          visibility: string;
          url?: string;
          public_url?: string;
          download_url?: string;
          folder_id?: string;
          expiration_date?: any;
          expiration_date_time_unit?: number;
          expiration_date_time_unit_type?: string;
          has_expiration_date_reminder?: boolean;
          created_at?: any;
          updated_at?: any;
          boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
        };
      }>;
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      firstItem?: number;
      lastItem?: number;
      count: number;
      currentPage: number;
      perPage: number;
      total: number;
      hasMorePages: boolean;
    };
  };
};

export type GetTotalTripLogsVariables = Exact<{
  trip_id: Scalars['ID']['input'];
}>;

export type GetTotalTripLogs = {
  __typename?: 'Query';
  logsOfTrip?: {
    __typename?: 'LogPaginator';
    paginatorInfo: { __typename?: 'PaginatorInfo'; total: number; count: number };
  };
};

export type GetTripDetailsVariables = Exact<{
  trip_id: Scalars['ID']['input'];
}>;

export type GetTripDetails = {
  __typename?: 'Query';
  trip?: {
    __typename?: 'Trip';
    id: string;
    name: string;
    started_at?: string;
    finished_at?: any;
    closed_at?: string;
    boat_detail_id: string;
    origin?: string;
    origin_latitude?: number;
    origin_longitude?: number;
    destination?: string;
    destination_longitude?: number;
    destination_latitude?: number;
    general_logs_count?: number;
    radio_logs_count?: number;
    social_logs_count?: number;
    weather_logs_count?: number;
    can_update?: boolean;
    can_delete?: boolean;
    can_share?: boolean;
    skipper_id?: string;
    crewman_id?: string;
    notes?: string;
    created_at: any;
    updated_at: any;
    boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string; flag: string; location?: string };
    image?: {
      __typename?: 'File';
      id: string;
      type: string;
      size: string;
      mime_type: string;
      extension: string;
      name: string;
      filename?: string;
      issued_by?: string;
      issuance_date?: any;
      boat_detail_id?: string;
      notes?: string;
      dimensions?: string;
      disk: string;
      alt?: string;
      description?: string;
      visibility: string;
      url?: string;
      public_url?: string;
      download_url?: string;
      folder_id?: string;
      expiration_date?: any;
      expiration_date_time_unit?: number;
      expiration_date_time_unit_type?: string;
      has_expiration_date_reminder?: boolean;
      created_at?: any;
      updated_at?: any;
      boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
    };
    user?: {
      __typename?: 'User';
      id: string;
      display_name?: string;
      name?: string;
      surname?: string;
      email: string;
      image?: {
        __typename?: 'File';
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      };
    };
    skipper?: {
      __typename?: 'User';
      id: string;
      display_name?: string;
      email: string;
      name?: string;
      surname?: string;
      image?: {
        __typename?: 'File';
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      };
    };
    crewman?: {
      __typename?: 'User';
      id: string;
      display_name?: string;
      name?: string;
      surname?: string;
      email: string;
      image?: {
        __typename?: 'File';
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      };
    };
    members?: Array<{
      __typename?: 'User';
      id: string;
      email: string;
      display_name?: string;
      name?: string;
      surname?: string;
      image?: {
        __typename?: 'File';
        id: string;
        type: string;
        size: string;
        mime_type: string;
        extension: string;
        name: string;
        filename?: string;
        issued_by?: string;
        issuance_date?: any;
        boat_detail_id?: string;
        notes?: string;
        dimensions?: string;
        disk: string;
        alt?: string;
        description?: string;
        visibility: string;
        url?: string;
        public_url?: string;
        download_url?: string;
        folder_id?: string;
        expiration_date?: any;
        expiration_date_time_unit?: number;
        expiration_date_time_unit_type?: string;
        has_expiration_date_reminder?: boolean;
        created_at?: any;
        updated_at?: any;
        boat_detail?: { __typename?: 'BoatDetails'; id: string; name: string };
      };
    }>;
  };
};

export type GetUserVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetUser = {
  __typename?: 'Query';
  user?: { __typename?: 'User'; id: string; name?: string; surname?: string; email: string; display_name?: string };
};

export type GetSearchedUsersVariables = Exact<{
  keyword: Scalars['String']['input'];
}>;

export type GetSearchedUsers = {
  __typename?: 'Query';
  searchUsers?: Array<{
    __typename?: 'User';
    id: string;
    email: string;
    display_name?: string;
    name?: string;
    surname?: string;
    image?: { __typename?: 'File'; url?: string };
  }>;
};

export type GetUserBoatsVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByClause>> | InputMaybe<OrderByClause>>;
  with_disabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetUserBoats = {
  __typename?: 'Query';
  boatDetails?: {
    __typename?: 'BoatDetailsPaginator';
    data: Array<{
      __typename?: 'BoatDetails';
      id: string;
      name: string;
      can_share?: boolean;
      can_update?: boolean;
      can_delete?: boolean;
      description?: string;
      flag: string;
      user_id: string;
      location?: string;
      location_toponym?: string;
      strapi_ref_document_id?: string;
      subscription_id?: number;
      created_at: any;
      image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
      boat?: {
        __typename?: 'Boat';
        model?: string;
        year_first?: number;
        image?: { __typename?: 'File'; id: string; url?: string; public_url?: string };
        manufacturer?: { __typename?: 'Manufacturer'; name?: string };
      };
      files?: Array<{ __typename?: 'File'; id: string; name: string; url?: string }>;
      user?: { __typename?: 'User'; id: string; name?: string; surname?: string; display_name?: string };
      plan?: {
        __typename?: 'PlanOfUser';
        id: string;
        name: string;
        status?: string;
        available?: number;
        gateway_id?: string;
        cost?: number;
        slug?: string;
      };
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      currentPage: number;
      count: number;
      perPage: number;
      total: number;
      firstItem?: number;
      lastItem?: number;
    };
  };
};

export type GetBoatsToAddLicenseVariables = Exact<{ [key: string]: never }>;

export type GetBoatsToAddLicense = {
  __typename?: 'Query';
  boatDetails?: {
    __typename?: 'BoatDetailsPaginator';
    data: Array<{
      __typename?: 'BoatDetails';
      id: string;
      user_id: string;
      name: string;
      status?: boolean;
      flag: string;
      subscription_id?: number;
      plan?: {
        __typename?: 'PlanOfUser';
        id: string;
        name: string;
        slug?: string;
        gateway_id?: string;
        cost?: number;
        available?: number;
        used?: number;
        status?: string;
      };
    }>;
  };
};

export type GetStatisticsVariables = Exact<{
  boat_detail_id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetStatistics = {
  __typename?: 'Query';
  overviewWidget?: {
    __typename?: 'OverviewWidget';
    boat_count?: number;
    trip_count?: number;
    task_count?: number;
    inventory_count?: number;
    alert_count?: number;
    total_costs?: number;
    storage_used_percentage?: number;
    storage_used_in_mb?: number;
  };
};

export const AlertDetailsFragment = `
    fragment AlertDetailsFragment on Alert {
  id
  priority
  active
  alertable_id
  alertable_type
  title
  type
  date
  created_at
  category
  quantity
  threshold
  marked_as_done_at
}
    `;
export const AlertsListItem = `
    fragment AlertsListItem on Alert {
  id
  priority
  active
  alertable_id
  alertable_type
  title
  type
  date
  created_at
  category
  quantity
  threshold
  marked_as_done_at
}
    `;
export const RequiredFileFields = `
    fragment RequiredFileFields on File {
  id
  type
  size
  mime_type
  extension
  name
  filename
  issued_by
  issuance_date
  boat_detail_id
  boat_detail {
    id
    name
  }
  notes
  dimensions
  disk
  alt
  description
  visibility
  url
  public_url
  download_url
  folder_id
  expiration_date
  expiration_date_time_unit
  expiration_date_time_unit_type
  has_expiration_date_reminder
  created_at
  updated_at
}
    `;
export const FileFields = `
    fragment FileFields on File {
  ...RequiredFileFields
  can_delete
  can_update
  can_share
  user {
    id
    name
    surname
    display_name
  }
}
    ${RequiredFileFields}`;
export const ChecklistFragment = `
    fragment ChecklistFragment on Checklist {
  created_at
  belongs_to_current_user
  can_add_comment
  can_copy
  can_create_new_item
  can_delete
  can_follow
  can_update
  can_sort_items
  can_unfollow
  can_update
  can_share
  can_view
  can_view_blocked_users
  can_view_comments
  can_view_followers
  clones_count
  comments_count
  description
  id
  is_followed_by_current_user
  is_public
  image {
    id
    url
    public_url
  }
  old_image_id
  old_image {
    id
    url
    public_url
  }
  files {
    ...FileFields
  }
  category_id
  updated_at
  tasks {
    id
    name
  }
  expenses {
    id
    item_name
  }
  logs {
    id
    name
  }
  trips {
    id
    name
  }
  items {
    id
    name
    position
    checked
  }
  title
  user_followers_count
  user {
    id
    name
    surname
    display_name
    image {
      url
    }
  }
  __typename
}
    ${FileFields}`;
export const ChecklistCompleteItem = `
    fragment ChecklistCompleteItem on Checklist {
  created_at
  belongs_to_current_user
  can_add_comment
  can_copy
  can_create_new_item
  can_delete
  can_follow
  can_update
  can_sort_items
  can_unfollow
  can_update
  can_share
  can_view
  can_view_blocked_users
  can_view_comments
  can_view_followers
  clones_count
  comments_count
  description
  id
  is_followed_by_current_user
  is_public
  image {
    id
    url
    public_url
  }
  updated_at
  old_image_id
  old_image {
    id
    url
    public_url
  }
  items {
    id
    name
    position
    checked
  }
  title
  user_followers_count
  user {
    id
    name
    surname
    display_name
  }
  __typename
}
    `;
export const PublishableChecklistFragment = `
    fragment PublishableChecklistFragment on Checklist {
  id
  title
  description
  image {
    id
    url
    public_url
  }
  comments {
    id
    user {
      id
      name
      surname
    }
    text
  }
  old_image_id
  old_image {
    id
    url
    public_url
  }
  comments {
    id
    text
    user {
      id
      name
    }
    created_at_diff
  }
  items {
    id
    name
  }
  user {
    id
    name
    surname
    display_name
  }
  comments_count
  user_followers_count
  clones_count
}
    `;
export const CommentFragment = `
    fragment CommentFragment on Comment {
  id
  can_unlike
  like_count
  text
  user {
    id
    surname
    name
    image {
      id
      url
    }
  }
  created_at_diff
  updated_at_diff
  can_update
  can_delete
  can_like
}
    `;
export const CostFragment = `
    fragment CostFragment on Cost {
  amount
  id
  notes
  type
  trips {
    id
    name
  }
  logs {
    id
    datetime
  }
  tasks {
    id
    name
  }
  expenses {
    id
    item_name
  }
  comments {
    id
    text
  }
  category {
    id
    name
  }
  exchange_rate
  quantity
  documents {
    ...RequiredFileFields
  }
  files {
    ...RequiredFileFields
  }
  is_maintenance_cost
  name
  can_delete
  can_update
  date
  user_id
  user {
    id
    name
    surname
    display_name
  }
  boat_detail_id
  boat_detail {
    id
    name
    flag
  }
  category_id
  currency_id
  currency {
    id
    name
    iso_code
    symbol
  }
  supplier
  vat_percentage
  vat_type
  created_at
  updated_at
}
    ${RequiredFileFields}`;
export const FileCardGallery = `
    fragment FileCardGallery on File {
  id
  alt
  url
  type
  extension
  name
  size
  type
}
    `;
export const FieldsListFragment = `
    fragment FieldsListFragment on FieldValue {
  id
  name
  value
  type
  options
}
    `;
export const ExpenseFragment = `
    fragment ExpenseFragment on Expense {
  id
  boat_detail_id
  boat_detail {
    name
    id
    flag
    plan {
      slug
    }
  }
  user_id
  item_id
  item_name
  item {
    id
    name
  }
  type
  comments {
    id
    like_count
  }
  files {
    ...FileCardGallery
  }
  notes
  location
  sub_locations {
    level
    name
  }
  location_data {
    id
    name
  }
  sub_locations_data {
    id
    name
  }
  unit_price_currency {
    id
    iso_code
    symbol
  }
  has_minimum_quantity_reminder
  minimum_quantity
  minimum_quantity_reminder
  brand
  model
  part_number
  serial_number
  barcode
  vendor_page
  packing
  acquisition_date
  expiration_date
  expiration_time_unit
  expiration_time_unit_type
  expiration_is_custom
  has_expiration_reminder
  warranty_date
  warranty_time_unit
  warranty_time_unit_type
  warranty_is_custom
  has_warranty_reminder
  is_recurring
  has_usage_reminder
  current_usage_value
  usage_due_date
  due_date_time_unit
  due_date_time_unit_type
  has_due_date_reminder
  usage_threshold
  usage_time_unit
  usage_time_unit_type
  recurrence_type
  threshold_reminder_value
  has_threshold_reminder
  threshold_recurrence_reminder
  usage_recurrence_time_unit
  usage_recurrence_time_unit_type
  usage_is_custom
  usage_recurrence
  maintenance_synced
  unit
  quantity
  total
  converted_total
  unit_price
  voltage
  width
  height
  depth
  weight
  consumption
  supplier
  user {
    id
    name
    surname
    display_name
  }
  supplier_contact
  linked_expenses_ids
  linked_expenses {
    item_id
    boat_detail_id
    item_name
    id
  }
  boat_detail {
    name
  }
  supplier_url
  tasks {
    id
    name
    boat_detail_id
    user_id
    due_date
    user {
      display_name
      name
    }
    marked_as_maintenance
  }
  category {
    id
    user_id
    name
    type
  }
  costs {
    id
    amount
    currency_id
    currency {
      id
      name
      iso_code
    }
    vat_percentage
    vat_type
    type
  }
  cost {
    id
    amount
    currency_id
    currency {
      id
      name
      iso_code
    }
    vat_percentage
    vat_type
    type
  }
  logs {
    id
    datetime
    pivot {
      usage_log_name
      usage_value
      quantity
    }
    trip_id
    trip {
      started_at
    }
    user {
      id
      display_name
      name
      surname
    }
  }
  can_delete
  can_share
  can_update
  created_at
  updated_at
  imported_at
  fields {
    ...FieldsListFragment
  }
}
    ${FileCardGallery}
${FieldsListFragment}`;
export const ExpenseItemHistoryFragment = `
    fragment ExpenseItemHistoryFragment on Expense {
  id
  boat_detail_id
  item_name
  quantity
  current_usage_value
  supplier
  category_id
  user {
    id
    name
    surname
  }
}
    `;
export const UserProfileImage = `
    fragment UserProfileImage on File {
  id
  url
  public_url
}
    `;
export const FileCard = `
    fragment FileCard on File {
  id
  alt
  url
  can_delete
  filename
  type
  extension
  name
  size
  type
}
    `;
export const FileDetailsFragment = `
    fragment FileDetailsFragment on File {
  id
  type
  size
  mime_type
  extension
  name
  filename
  issued_by
  issuance_date
  boat_detail_id
  can_delete
  can_update
  can_share
  expiration_date
  expiration_date
  expiration_date_time_unit
  expiration_date_time_unit_type
  dimensions
  url
  download_url
  boat_detail {
    id
    name
  }
  linked_records {
    fileable_type
    fileable_id
    display_name
  }
}
    `;
export const FolderFragment = `
    fragment FolderFragment on Folder {
  id
  user_id
  name
  parent {
    id
    name
    parent_id
    parent {
      id
      name
      parent_id
    }
  }
  parent_id
  path
  breadcrumb_folders {
    id
    name
  }
  files_count
  folders_count
  created_at
  updated_at
}
    `;
export const FolderBreadcrumbs = `
    fragment FolderBreadcrumbs on Folder {
  id
  name
  parent_id
  path
  breadcrumb_folders {
    id
    name
  }
}
    `;
export const DefaultPagination = `
    fragment DefaultPagination on PaginatorInfo {
  count
  currentPage
  firstItem
  hasMorePages
  lastItem
  lastPage
  perPage
  total
}
    `;
export const PlanOfAUserFragment = `
    fragment PlanOfAUserFragment on PlanOfUser {
  id
  name
  slug
  gateway_id
  cost
  currency
  interval
  trial_days
  status
  used
  available
  total
  interval_count
  first_subscription_date
  trial_days
  end_date
  is_on_grace
  has_scheduled_update
  subscription_schedule {
    id
    phases {
      start_date
      description
      prorate
      end_date
      plans {
        plan
        price
        quantity
        billing_thresholds
      }
    }
  }
}
    `;
export const PlanFragment = `
    fragment PlanFragment on Plan {
  id
  name
  slug
  gateway_id
  cost
  currency
  interval
  trial_days
  status
}
    `;
export const UserSubscriptionFragment = `
    fragment UserSubscriptionFragment on UserSubscription {
  id
  free_subscription_id
  is_free
  available_active_alert_slots
  used_licenses
  total_licenses
  available_licenses
  cost
  currency
  interval
  trial_days
  status
  is_on_trial
  interval_count
  first_subscription_date
  end_date
  is_on_grace
  has_scheduled_update
  has_free_boat_available
  trial_ends_at
  has_available_trial
  next_billing_date
}
    `;
export const SubscriptionScheduleFragment = `
    fragment SubscriptionScheduleFragment on SubscriptionSchedule {
  id
  phases {
    start_date
    description
    prorate
    end_date
    plans {
      plan
      price
      quantity
      billing_thresholds
    }
  }
}
    `;
export const SubscriptionPlanFragment = `
    fragment SubscriptionPlanFragment on PlanOfUser {
  id
  name
  slug
  status
  cost
  total
  available
}
    `;
export const TripFields = `
    fragment TripFields on Trip {
  id
  name
  started_at
  finished_at
  closed_at
  boat_detail {
    id
    name
    flag
    location
  }
  boat_detail_id
  origin
  origin_latitude
  origin_longitude
  destination
  destination_longitude
  destination_latitude
  general_logs_count
  radio_logs_count
  social_logs_count
  weather_logs_count
  can_update
  can_delete
  can_share
  skipper_id
  crewman_id
  notes
  image {
    ...RequiredFileFields
  }
  user {
    id
    display_name
    name
    surname
    email
    image {
      ...RequiredFileFields
    }
  }
  skipper {
    id
    display_name
    email
    name
    surname
    image {
      ...RequiredFileFields
    }
  }
  crewman {
    id
    display_name
    name
    surname
    email
    image {
      ...RequiredFileFields
    }
  }
  members {
    id
    email
    display_name
    name
    surname
    image {
      ...RequiredFileFields
    }
  }
  created_at
  updated_at
}
    ${RequiredFileFields}`;
export const TaskFields = `
    fragment taskFields on Task {
  boat_detail_id
  boat_detail {
    id
    name
  }
  user_id
  assignee_ids
  id
  name
  taxonomies {
    id
    name
  }
  category_id
  category {
    id
    name
  }
  type
  status
  user {
    id
    name
    surname
    display_name
  }
  is_recurring
  frequency
  priority
  due_date
  completed_at
  has_notification
  time_unit
  time_unit_type
  linked_expense_id
  expenses {
    id
    item_name
  }
  marked_as_maintenance
  usage_is_custom
  usage_time_unit_type
  usage_time_unit
  usage_recurrence_time_unit
  usage_recurrence_time_unit_type
  has_usage_reminder
  recurrence_type
  usage_recurrence
  threshold_recurrence_reminder
  costs {
    id
    amount
    currency_id
    currency {
      id
      name
      iso_code
    }
    vat_percentage
    vat_type
    type
    supplier
  }
  cost {
    id
    amount
    currency_id
    currency {
      id
      name
      iso_code
    }
    vat_percentage
    vat_type
    type
    supplier
  }
  files {
    id
    name
    url
    type
    created_at
  }
  can_delete
  can_update
  can_share
  alert {
    id
  }
}
    `;
export const FavoritableBoatFields = `
    fragment FavoritableBoatFields on Boat {
  model
  id
  type
  slug
  image {
    public_url
  }
  description
  is_favorited
  total_views
  favorites_count
  favorites_count
  model
  year_first
}
    `;
export const ResendEmailVerificationDocument = `
    mutation resendEmailVerification($email: String!) {
  resendVerificationEmail(email: $email) {
    attempts
    attempts_left
    last_verification_attempt
    wait_time
  }
}
    `;

export const useResendEmailVerification = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<ResendEmailVerification, TError, ResendEmailVerificationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<ResendEmailVerification, TError, ResendEmailVerificationVariables, TContext>({
    mutationKey: ['resendEmailVerification'],
    mutationFn: (variables?: ResendEmailVerificationVariables) =>
      fetcher<ResendEmailVerification, ResendEmailVerificationVariables>(
        client,
        ResendEmailVerificationDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useResendEmailVerification.fetcher = (
  client: GraphQLClient,
  variables: ResendEmailVerificationVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<ResendEmailVerification, ResendEmailVerificationVariables>(
    client,
    ResendEmailVerificationDocument,
    variables,
    headers,
  );

export const UpdateNovuSubscriberCredentialsMutationDocument = `
    mutation updateNovuSubscriberCredentialsMutation($tokens: [String!]!, $provider_id: ProviderId!) {
  updateNovuSubscriberCredentials(provider_id: $provider_id, tokens: $tokens) {
    id
    subscriberId
    channels {
      _integrationId
      providerId
    }
  }
}
    `;

export const useUpdateNovuSubscriberCredentialsMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UpdateNovuSubscriberCredentialsMutation,
    TError,
    UpdateNovuSubscriberCredentialsMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers'],
) => {
  return useMutation<
    UpdateNovuSubscriberCredentialsMutation,
    TError,
    UpdateNovuSubscriberCredentialsMutationVariables,
    TContext
  >({
    mutationKey: ['updateNovuSubscriberCredentialsMutation'],
    mutationFn: (variables?: UpdateNovuSubscriberCredentialsMutationVariables) =>
      fetcher<UpdateNovuSubscriberCredentialsMutation, UpdateNovuSubscriberCredentialsMutationVariables>(
        client,
        UpdateNovuSubscriberCredentialsMutationDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useUpdateNovuSubscriberCredentialsMutation.fetcher = (
  client: GraphQLClient,
  variables: UpdateNovuSubscriberCredentialsMutationVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<UpdateNovuSubscriberCredentialsMutation, UpdateNovuSubscriberCredentialsMutationVariables>(
    client,
    UpdateNovuSubscriberCredentialsMutationDocument,
    variables,
    headers,
  );

export const RegisterNewAccountDocument = `
    mutation registerNewAccount($email: String!, $password: String!, $recaptcha: String!, $referral: String) {
  register(
    email: $email
    password: $password
    recaptcha: $recaptcha
    referral: $referral
  ) {
    email
    id
    email_verified_at
    auth_0_id
  }
}
    `;

export const useRegisterNewAccount = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<RegisterNewAccount, TError, RegisterNewAccountVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<RegisterNewAccount, TError, RegisterNewAccountVariables, TContext>({
    mutationKey: ['registerNewAccount'],
    mutationFn: (variables?: RegisterNewAccountVariables) =>
      fetcher<RegisterNewAccount, RegisterNewAccountVariables>(
        client,
        RegisterNewAccountDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useRegisterNewAccount.fetcher = (
  client: GraphQLClient,
  variables: RegisterNewAccountVariables,
  headers?: RequestInit['headers'],
) => fetcher<RegisterNewAccount, RegisterNewAccountVariables>(client, RegisterNewAccountDocument, variables, headers);

export const UpdateAlertDocument = `
    mutation updateAlert($id: ID!, $active: Boolean!) {
  updateAlert(id: $id, active: $active) {
    id
    active
  }
}
    `;

export const useUpdateAlert = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpdateAlert, TError, UpdateAlertVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UpdateAlert, TError, UpdateAlertVariables, TContext>({
    mutationKey: ['updateAlert'],
    mutationFn: (variables?: UpdateAlertVariables) =>
      fetcher<UpdateAlert, UpdateAlertVariables>(client, UpdateAlertDocument, variables, headers)(),
    ...options,
  });
};

useUpdateAlert.fetcher = (client: GraphQLClient, variables: UpdateAlertVariables, headers?: RequestInit['headers']) =>
  fetcher<UpdateAlert, UpdateAlertVariables>(client, UpdateAlertDocument, variables, headers);

export const MarkAlertAsDoneMutationDocument = `
    mutation markAlertAsDoneMutation($id: ID!, $create_operational_log: Boolean, $marked_as_done_at: DateTime) {
  markAlertAsDone(
    id: $id
    create_operational_log: $create_operational_log
    marked_as_done_at: $marked_as_done_at
  ) {
    ...AlertDetailsFragment
  }
}
    ${AlertDetailsFragment}`;

export const useMarkAlertAsDoneMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<MarkAlertAsDoneMutation, TError, MarkAlertAsDoneMutationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<MarkAlertAsDoneMutation, TError, MarkAlertAsDoneMutationVariables, TContext>({
    mutationKey: ['markAlertAsDoneMutation'],
    mutationFn: (variables?: MarkAlertAsDoneMutationVariables) =>
      fetcher<MarkAlertAsDoneMutation, MarkAlertAsDoneMutationVariables>(
        client,
        MarkAlertAsDoneMutationDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useMarkAlertAsDoneMutation.fetcher = (
  client: GraphQLClient,
  variables: MarkAlertAsDoneMutationVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<MarkAlertAsDoneMutation, MarkAlertAsDoneMutationVariables>(
    client,
    MarkAlertAsDoneMutationDocument,
    variables,
    headers,
  );

export const AddBoatFromDbDocument = `
    mutation addBoatFromDb($strapi_ref_document_id: ID!, $name: String!, $flag: String!, $year: Int!, $description: String, $hull_sn: String, $acquisition_type: String, $price: Float, $currency: String, $is_vat_paid: Boolean, $acquisition_date: String, $location: String, $callsign: String, $mmsi: String, $epirb: String, $in_reach_tracker_id: String, $spot_tracker_id: String, $satellite_phone: String, $mobile_phone: String, $engine_battery_voltage: Float, $engine_battery_capacity: Float, $service_battery_voltage: Float, $service_battery_capacity: Float, $inverter_power: Float, $battery_power: Float, $solar_power: Float, $wind_power: Float, $dg_power: Float, $service_loads: String, $tender_name: String, $tender_vendor: String, $tender_model: String, $tender_length: Float, $image_id: ID, $files: [Int!], $plan_id: ID, $engines: [EngineInput!]) {
  storeBoatDetails(
    strapi_ref_document_id: $strapi_ref_document_id
    name: $name
    flag: $flag
    year: $year
    description: $description
    hull_sn: $hull_sn
    acquisition_type: $acquisition_type
    price: $price
    currency: $currency
    is_vat_paid: $is_vat_paid
    acquisition_date: $acquisition_date
    location: $location
    callsign: $callsign
    mmsi: $mmsi
    epirb: $epirb
    in_reach_tracker_id: $in_reach_tracker_id
    spot_tracker_id: $spot_tracker_id
    satellite_phone: $satellite_phone
    mobile_phone: $mobile_phone
    engine_battery_voltage: $engine_battery_voltage
    engine_battery_capacity: $engine_battery_capacity
    service_battery_voltage: $service_battery_voltage
    service_battery_capacity: $service_battery_capacity
    inverter_power: $inverter_power
    battery_power: $battery_power
    solar_power: $solar_power
    wind_power: $wind_power
    dg_power: $dg_power
    service_loads: $service_loads
    tender_name: $tender_name
    tender_vendor: $tender_vendor
    tender_model: $tender_model
    tender_length: $tender_length
    image_id: $image_id
    files: $files
    plan_id: $plan_id
    engines: $engines
  ) {
    name
  }
}
    `;

export const useAddBoatFromDb = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<AddBoatFromDb, TError, AddBoatFromDbVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<AddBoatFromDb, TError, AddBoatFromDbVariables, TContext>({
    mutationKey: ['addBoatFromDb'],
    mutationFn: (variables?: AddBoatFromDbVariables) =>
      fetcher<AddBoatFromDb, AddBoatFromDbVariables>(client, AddBoatFromDbDocument, variables, headers)(),
    ...options,
  });
};

useAddBoatFromDb.fetcher = (
  client: GraphQLClient,
  variables: AddBoatFromDbVariables,
  headers?: RequestInit['headers'],
) => fetcher<AddBoatFromDb, AddBoatFromDbVariables>(client, AddBoatFromDbDocument, variables, headers);

export const AddBoatManuallyDocument = `
    mutation addBoatManually($unit: String!, $image_id: ID, $manufacturer_name: String, $manufacturer_site: String, $manufacturer_id: ID, $model: String!, $year_first: Int, $year_last: Int, $version: String, $reference_price: Float, $currency: String, $type: String!, $categories: [Int!], $activities: [Int!], $hull_type: String!, $hull_material: String!, $cabins: Int, $berths: Int, $heads: Int, $hull_appendages: [FieldInput!], $top_speed: Float, $cruising_speed: Float, $mast: Float, $loa: Float!, $lwl: Float, $boa: Float, $bcl: Float, $bh: Float, $headroom: Float, $bdcl: Float, $nom: Float, $draft_max: Float, $draft_min: Float, $displacement: Float, $tonnage_gross: Float, $tonnage_net: Float, $ballast_type: String, $ballast_weight: Float, $helm: String, $rudder: String, $cockpit_location: String, $cockpit_type: String, $unsinkable: Boolean, $trailerable: Boolean, $ce_classification: [Float], $designer_name: String, $designer_site: String, $exterior_design: String, $exterior_site: String, $interior_design: String, $interior_site: String, $rigging: String, $rotating_spars: Boolean, $mast_configuration: String, $spars: String, $standing_rigging: String, $spreaders_level: Float, $spreaders_angle: String, $upwind_sail_area: Float, $downwind_sail_area: Float, $mainsail: [FieldInput!], $headsail: [FieldInput!], $spinnaker: [FieldInput!], $fuel_tank: [CapacityInput!], $water_tank: [CapacityInput!], $holding_tank: [CapacityInput!], $water_heater: [CapacityInput!], $files: [Int!], $status: Boolean, $boatDetails: BoatDetailsInput!, $plan_id: ID) {
  fullStoreBoatDetails(
    unit: $unit
    image_id: $image_id
    manufacturer_name: $manufacturer_name
    manufacturer_site: $manufacturer_site
    manufacturer_id: $manufacturer_id
    model: $model
    year_first: $year_first
    year_last: $year_last
    version: $version
    reference_price: $reference_price
    currency: $currency
    plan_id: $plan_id
    type: $type
    categories: $categories
    activities: $activities
    hull_type: $hull_type
    hull_material: $hull_material
    cabins: $cabins
    berths: $berths
    heads: $heads
    hull_appendages: $hull_appendages
    top_speed: $top_speed
    cruising_speed: $cruising_speed
    mast: $mast
    loa: $loa
    lwl: $lwl
    boa: $boa
    bcl: $bcl
    bh: $bh
    headroom: $headroom
    bdcl: $bdcl
    nom: $nom
    draft_max: $draft_max
    draft_min: $draft_min
    displacement: $displacement
    tonnage_gross: $tonnage_gross
    tonnage_net: $tonnage_net
    ballast_type: $ballast_type
    ballast_weight: $ballast_weight
    helm: $helm
    rudder: $rudder
    cockpit_location: $cockpit_location
    cockpit_type: $cockpit_type
    unsinkable: $unsinkable
    trailerable: $trailerable
    ce_classification: $ce_classification
    designer_name: $designer_name
    designer_site: $designer_site
    exterior_design: $exterior_design
    exterior_site: $exterior_site
    interior_design: $interior_design
    interior_site: $interior_site
    rigging: $rigging
    rotating_spars: $rotating_spars
    mast_configuration: $mast_configuration
    spars: $spars
    standing_rigging: $standing_rigging
    spreaders_level: $spreaders_level
    spreaders_angle: $spreaders_angle
    upwind_sail_area: $upwind_sail_area
    downwind_sail_area: $downwind_sail_area
    mainsail: $mainsail
    headsail: $headsail
    spinnaker: $spinnaker
    fuel_tank: $fuel_tank
    water_tank: $water_tank
    holding_tank: $holding_tank
    water_heater: $water_heater
    files: $files
    status: $status
    boatDetails: $boatDetails
  ) {
    id
    userBoatDetails {
      name
    }
    manufacturer {
      name
    }
  }
}
    `;

export const useAddBoatManually = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<AddBoatManually, TError, AddBoatManuallyVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<AddBoatManually, TError, AddBoatManuallyVariables, TContext>({
    mutationKey: ['addBoatManually'],
    mutationFn: (variables?: AddBoatManuallyVariables) =>
      fetcher<AddBoatManually, AddBoatManuallyVariables>(client, AddBoatManuallyDocument, variables, headers)(),
    ...options,
  });
};

useAddBoatManually.fetcher = (
  client: GraphQLClient,
  variables: AddBoatManuallyVariables,
  headers?: RequestInit['headers'],
) => fetcher<AddBoatManually, AddBoatManuallyVariables>(client, AddBoatManuallyDocument, variables, headers);

export const UpdateBoatFromDbDocument = `
    mutation updateBoatFromDB($id: ID!, $name: String!, $flag: String!, $year: Int!, $description: String, $acquisition_date: String, $acquisition_type: String, $nr_past_owners: Int, $ownership_order: String, $hull_sn: String, $mmsi: String, $callsign: String, $epirb: String, $in_reach_tracker_id: String, $spot_tracker_id: String, $satellite_phone: String, $mobile_phone: String, $is_vat_paid: Boolean, $price: Float, $currency: String, $location: String, $engine_battery_voltage: Float, $engine_battery_capacity: Float, $service_battery_voltage: Float, $service_battery_capacity: Float, $battery_power: Float, $inverter_power: Float, $solar_power: Float, $wind_power: Float, $dg_power: Float, $service_loads: String, $tender_name: String, $tender_vendor: String, $tender_model: String, $tender_length: Float, $status: Boolean, $image_id: ID, $files: [Int!], $fields: [FieldInput!], $engines: [EngineInput!]) {
  updateBoatDetails(
    id: $id
    name: $name
    flag: $flag
    year: $year
    description: $description
    acquisition_date: $acquisition_date
    acquisition_type: $acquisition_type
    nr_past_owners: $nr_past_owners
    ownership_order: $ownership_order
    hull_sn: $hull_sn
    mmsi: $mmsi
    callsign: $callsign
    epirb: $epirb
    in_reach_tracker_id: $in_reach_tracker_id
    spot_tracker_id: $spot_tracker_id
    satellite_phone: $satellite_phone
    mobile_phone: $mobile_phone
    is_vat_paid: $is_vat_paid
    price: $price
    currency: $currency
    location: $location
    engine_battery_voltage: $engine_battery_voltage
    engine_battery_capacity: $engine_battery_capacity
    service_battery_voltage: $service_battery_voltage
    service_battery_capacity: $service_battery_capacity
    battery_power: $battery_power
    inverter_power: $inverter_power
    solar_power: $solar_power
    wind_power: $wind_power
    dg_power: $dg_power
    service_loads: $service_loads
    tender_name: $tender_name
    tender_vendor: $tender_vendor
    tender_model: $tender_model
    tender_length: $tender_length
    status: $status
    image_id: $image_id
    files: $files
    fields: $fields
    engines: $engines
  ) {
    id
    name
  }
}
    `;

export const useUpdateBoatFromDb = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpdateBoatFromDb, TError, UpdateBoatFromDbVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UpdateBoatFromDb, TError, UpdateBoatFromDbVariables, TContext>({
    mutationKey: ['updateBoatFromDB'],
    mutationFn: (variables?: UpdateBoatFromDbVariables) =>
      fetcher<UpdateBoatFromDb, UpdateBoatFromDbVariables>(client, UpdateBoatFromDbDocument, variables, headers)(),
    ...options,
  });
};

useUpdateBoatFromDb.fetcher = (
  client: GraphQLClient,
  variables: UpdateBoatFromDbVariables,
  headers?: RequestInit['headers'],
) => fetcher<UpdateBoatFromDb, UpdateBoatFromDbVariables>(client, UpdateBoatFromDbDocument, variables, headers);

export const UpdateBoatManuallyDocument = `
    mutation updateBoatManually($boat_detail_id: ID!, $unit: String!, $image_path: Upload, $image_id: ID, $manufacturer_name: String, $manufacturer_site: String, $manufacturer_id: ID, $model: String!, $year: Int, $year_first: Int, $year_last: Int, $version: String, $reference_price: Float, $currency: String, $slug: String, $description: String, $type: String!, $category: String, $categories: [Int!], $activity: String, $activities: [Int!], $hull_type: String!, $hull_material: String!, $keel_type: String, $cabins: Int, $berths: Int, $heads: Int, $appendages: String, $hull_appendages: [FieldInput!], $top_speed: Float, $cruising_speed: Float, $mast: Float, $loa: Float!, $lwl: Float, $boa: Float, $bcl: Float, $bh: Float, $headroom: Float, $bdcl: Float, $nom: Float, $draft_max: Float, $draft_min: Float, $displacement: Float, $tonnage_gross: Float, $tonnage_net: Float, $ballast_type: String, $ballast_weight: Float, $helm: String, $rudder: String, $cockpit_location: String, $cockpit_type: String, $unsinkable: Boolean, $trailerable: Boolean, $ce_classification: [Float], $designer_name: String, $designer_site: String, $exterior_design: String, $exterior_site: String, $interior_design: String, $interior_site: String, $rigging: String, $rotating_spars: Boolean, $mast_position: String, $mast_configuration: String, $spars: String, $standing_rigging: String, $spreaders_level: Float, $spreaders_angle: String, $upwind_sail_area: Float, $downwind_sail_area: Float, $sail_area_type_a: String, $sail_area_type_b: String, $sail_area_type_c: String, $sail_area: Float, $sail_area_b: Float, $sail_area_c: Float, $genoa_type_a: String, $genoa_type_b: String, $genoa_type_c: String, $genoa_sail_area_a: Float, $genoa_sail_area_b: Float, $genoa_sail_area_c: Float, $spinnaker_type_a: String, $spinnaker_type_b: String, $spinnaker_type_c: String, $spinnaker_sail_area_a: Float, $spinnaker_sail_area_b: Float, $spinnaker_sail_area_c: Float, $mainsail: [FieldInput!], $headsail: [FieldInput!], $spinnaker: [FieldInput!], $genoa: [FieldInput!], $engine_manufacturer: String, $engine_manufacturer_site: String, $engine_model: String, $engine_type: String, $engine_power: Float, $engine_power_type: String, $engine_manufacturer_b: String, $engine_manufacturer_site_b: String, $engine_model_b: String, $engine_type_b: String, $engine_power_b: Float, $engine_power_type_b: String, $water_capacity: Float, $water_capacity_tank_b: Float, $fuel_capacity: Float, $fuel_capacity_tank_b: Float, $holding_tank_capacity: Float, $water_heater_capacity: Float, $fuel_tank: [CapacityInput!], $water_tank: [CapacityInput!], $holding_tank: [CapacityInput!], $water_heater: [CapacityInput!], $files: [Int!], $status: Boolean, $boatDetails: BoatDetailsInput!, $fields: [FieldInput!]) {
  fullUpdateBoatDetails(
    boat_detail_id: $boat_detail_id
    unit: $unit
    image_path: $image_path
    image_id: $image_id
    manufacturer_name: $manufacturer_name
    manufacturer_site: $manufacturer_site
    manufacturer_id: $manufacturer_id
    model: $model
    year: $year
    year_first: $year_first
    year_last: $year_last
    version: $version
    reference_price: $reference_price
    currency: $currency
    slug: $slug
    description: $description
    type: $type
    category: $category
    categories: $categories
    activity: $activity
    activities: $activities
    hull_type: $hull_type
    hull_material: $hull_material
    keel_type: $keel_type
    cabins: $cabins
    berths: $berths
    heads: $heads
    appendages: $appendages
    hull_appendages: $hull_appendages
    top_speed: $top_speed
    cruising_speed: $cruising_speed
    mast: $mast
    loa: $loa
    lwl: $lwl
    boa: $boa
    bcl: $bcl
    bh: $bh
    headroom: $headroom
    bdcl: $bdcl
    nom: $nom
    draft_max: $draft_max
    draft_min: $draft_min
    displacement: $displacement
    tonnage_gross: $tonnage_gross
    tonnage_net: $tonnage_net
    ballast_type: $ballast_type
    ballast_weight: $ballast_weight
    helm: $helm
    rudder: $rudder
    cockpit_location: $cockpit_location
    cockpit_type: $cockpit_type
    unsinkable: $unsinkable
    trailerable: $trailerable
    ce_classification: $ce_classification
    designer_name: $designer_name
    designer_site: $designer_site
    exterior_design: $exterior_design
    exterior_site: $exterior_site
    interior_design: $interior_design
    interior_site: $interior_site
    rigging: $rigging
    rotating_spars: $rotating_spars
    mast_position: $mast_position
    mast_configuration: $mast_configuration
    spars: $spars
    standing_rigging: $standing_rigging
    spreaders_level: $spreaders_level
    spreaders_angle: $spreaders_angle
    upwind_sail_area: $upwind_sail_area
    downwind_sail_area: $downwind_sail_area
    sail_area_type_a: $sail_area_type_a
    sail_area_type_b: $sail_area_type_b
    sail_area_type_c: $sail_area_type_c
    sail_area: $sail_area
    sail_area_b: $sail_area_b
    sail_area_c: $sail_area_c
    genoa_type_a: $genoa_type_a
    genoa_type_b: $genoa_type_b
    genoa_type_c: $genoa_type_c
    genoa_sail_area_a: $genoa_sail_area_a
    genoa_sail_area_b: $genoa_sail_area_b
    genoa_sail_area_c: $genoa_sail_area_c
    spinnaker_type_a: $spinnaker_type_a
    spinnaker_type_b: $spinnaker_type_b
    spinnaker_type_c: $spinnaker_type_c
    spinnaker_sail_area_a: $spinnaker_sail_area_a
    spinnaker_sail_area_b: $spinnaker_sail_area_b
    spinnaker_sail_area_c: $spinnaker_sail_area_c
    mainsail: $mainsail
    headsail: $headsail
    spinnaker: $spinnaker
    genoa: $genoa
    engine_manufacturer: $engine_manufacturer
    engine_manufacturer_site: $engine_manufacturer_site
    engine_model: $engine_model
    engine_type: $engine_type
    engine_power: $engine_power
    engine_power_type: $engine_power_type
    engine_manufacturer_b: $engine_manufacturer_b
    engine_manufacturer_site_b: $engine_manufacturer_site_b
    engine_model_b: $engine_model_b
    engine_type_b: $engine_type_b
    engine_power_b: $engine_power_b
    engine_power_type_b: $engine_power_type_b
    water_capacity: $water_capacity
    water_capacity_tank_b: $water_capacity_tank_b
    fuel_capacity: $fuel_capacity
    fuel_capacity_tank_b: $fuel_capacity_tank_b
    holding_tank_capacity: $holding_tank_capacity
    water_heater_capacity: $water_heater_capacity
    fuel_tank: $fuel_tank
    water_tank: $water_tank
    holding_tank: $holding_tank
    water_heater: $water_heater
    files: $files
    status: $status
    boatDetails: $boatDetails
    fields: $fields
  ) {
    id
    userBoatDetails {
      id
      name
      files {
        id
      }
      boat {
        files {
          id
        }
      }
    }
  }
}
    `;

export const useUpdateBoatManually = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpdateBoatManually, TError, UpdateBoatManuallyVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UpdateBoatManually, TError, UpdateBoatManuallyVariables, TContext>({
    mutationKey: ['updateBoatManually'],
    mutationFn: (variables?: UpdateBoatManuallyVariables) =>
      fetcher<UpdateBoatManually, UpdateBoatManuallyVariables>(
        client,
        UpdateBoatManuallyDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useUpdateBoatManually.fetcher = (
  client: GraphQLClient,
  variables: UpdateBoatManuallyVariables,
  headers?: RequestInit['headers'],
) => fetcher<UpdateBoatManually, UpdateBoatManuallyVariables>(client, UpdateBoatManuallyDocument, variables, headers);

export const DeleteBoatDocument = `
    mutation deleteBoat($boat_id: ID!) {
  deleteBoatDetails(id: $boat_id)
}
    `;

export const useDeleteBoat = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<DeleteBoat, TError, DeleteBoatVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<DeleteBoat, TError, DeleteBoatVariables, TContext>({
    mutationKey: ['deleteBoat'],
    mutationFn: (variables?: DeleteBoatVariables) =>
      fetcher<DeleteBoat, DeleteBoatVariables>(client, DeleteBoatDocument, variables, headers)(),
    ...options,
  });
};

useDeleteBoat.fetcher = (client: GraphQLClient, variables: DeleteBoatVariables, headers?: RequestInit['headers']) =>
  fetcher<DeleteBoat, DeleteBoatVariables>(client, DeleteBoatDocument, variables, headers);

export const AddCategoryDocument = `
    mutation addCategory($name: String!, $type: String!) {
  storeCategory(name: $name, type: $type) {
    id
    user_id
    name
    type
    is_user_defined
  }
}
    `;

export const useAddCategory = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<AddCategory, TError, AddCategoryVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<AddCategory, TError, AddCategoryVariables, TContext>({
    mutationKey: ['addCategory'],
    mutationFn: (variables?: AddCategoryVariables) =>
      fetcher<AddCategory, AddCategoryVariables>(client, AddCategoryDocument, variables, headers)(),
    ...options,
  });
};

useAddCategory.fetcher = (client: GraphQLClient, variables: AddCategoryVariables, headers?: RequestInit['headers']) =>
  fetcher<AddCategory, AddCategoryVariables>(client, AddCategoryDocument, variables, headers);

export const UpdateCategoryDocument = `
    mutation updateCategory($id: ID!, $name: String!) {
  updateCategory(id: $id, name: $name) {
    id
    user_id
    name
    type
    is_user_defined
  }
}
    `;

export const useUpdateCategory = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpdateCategory, TError, UpdateCategoryVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UpdateCategory, TError, UpdateCategoryVariables, TContext>({
    mutationKey: ['updateCategory'],
    mutationFn: (variables?: UpdateCategoryVariables) =>
      fetcher<UpdateCategory, UpdateCategoryVariables>(client, UpdateCategoryDocument, variables, headers)(),
    ...options,
  });
};

useUpdateCategory.fetcher = (
  client: GraphQLClient,
  variables: UpdateCategoryVariables,
  headers?: RequestInit['headers'],
) => fetcher<UpdateCategory, UpdateCategoryVariables>(client, UpdateCategoryDocument, variables, headers);

export const DeleteCategoryDocument = `
    mutation deleteCategory($id: ID!) {
  deleteCategory(id: $id)
}
    `;

export const useDeleteCategory = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<DeleteCategory, TError, DeleteCategoryVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<DeleteCategory, TError, DeleteCategoryVariables, TContext>({
    mutationKey: ['deleteCategory'],
    mutationFn: (variables?: DeleteCategoryVariables) =>
      fetcher<DeleteCategory, DeleteCategoryVariables>(client, DeleteCategoryDocument, variables, headers)(),
    ...options,
  });
};

useDeleteCategory.fetcher = (
  client: GraphQLClient,
  variables: DeleteCategoryVariables,
  headers?: RequestInit['headers'],
) => fetcher<DeleteCategory, DeleteCategoryVariables>(client, DeleteCategoryDocument, variables, headers);

export const AddChecklistDocument = `
    mutation addChecklist($title: String!, $description: String, $with_items: Boolean, $private: Boolean, $image_id: ID, $items: [ChecklistItemInput], $files: [ID], $category_id: ID, $related_records: [Checklistable]) {
  storeChecklist(
    title: $title
    description: $description
    with_items: $with_items
    private: $private
    image_id: $image_id
    items: $items
    files: $files
    category_id: $category_id
    linked_records: $related_records
  ) {
    ...ChecklistCompleteItem
  }
}
    ${ChecklistCompleteItem}`;

export const useAddChecklist = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<AddChecklist, TError, AddChecklistVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<AddChecklist, TError, AddChecklistVariables, TContext>({
    mutationKey: ['addChecklist'],
    mutationFn: (variables?: AddChecklistVariables) =>
      fetcher<AddChecklist, AddChecklistVariables>(client, AddChecklistDocument, variables, headers)(),
    ...options,
  });
};

useAddChecklist.fetcher = (client: GraphQLClient, variables: AddChecklistVariables, headers?: RequestInit['headers']) =>
  fetcher<AddChecklist, AddChecklistVariables>(client, AddChecklistDocument, variables, headers);

export const UpdateChecklistDocument = `
    mutation updateChecklist($id: ID!, $title: String!, $description: String, $with_items: Boolean, $private: Boolean, $image_id: ID, $items: [ChecklistItemInput], $files: [ID], $category_id: ID, $related_records: [Checklistable]) {
  updateChecklist(
    id: $id
    title: $title
    description: $description
    with_items: $with_items
    private: $private
    image_id: $image_id
    items: $items
    files: $files
    category_id: $category_id
    linked_records: $related_records
  ) {
    ...ChecklistCompleteItem
  }
}
    ${ChecklistCompleteItem}`;

export const useUpdateChecklist = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpdateChecklist, TError, UpdateChecklistVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UpdateChecklist, TError, UpdateChecklistVariables, TContext>({
    mutationKey: ['updateChecklist'],
    mutationFn: (variables?: UpdateChecklistVariables) =>
      fetcher<UpdateChecklist, UpdateChecklistVariables>(client, UpdateChecklistDocument, variables, headers)(),
    ...options,
  });
};

useUpdateChecklist.fetcher = (
  client: GraphQLClient,
  variables: UpdateChecklistVariables,
  headers?: RequestInit['headers'],
) => fetcher<UpdateChecklist, UpdateChecklistVariables>(client, UpdateChecklistDocument, variables, headers);

export const CopyChecklistDocument = `
    mutation copyChecklist($id: ID!) {
  copyChecklist(id: $id) {
    ...ChecklistCompleteItem
  }
}
    ${ChecklistCompleteItem}`;

export const useCopyChecklist = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<CopyChecklist, TError, CopyChecklistVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<CopyChecklist, TError, CopyChecklistVariables, TContext>({
    mutationKey: ['copyChecklist'],
    mutationFn: (variables?: CopyChecklistVariables) =>
      fetcher<CopyChecklist, CopyChecklistVariables>(client, CopyChecklistDocument, variables, headers)(),
    ...options,
  });
};

useCopyChecklist.fetcher = (
  client: GraphQLClient,
  variables: CopyChecklistVariables,
  headers?: RequestInit['headers'],
) => fetcher<CopyChecklist, CopyChecklistVariables>(client, CopyChecklistDocument, variables, headers);

export const DeleteChecklistDocument = `
    mutation deleteChecklist($id: ID!) {
  deleteChecklist(id: $id)
}
    `;

export const useDeleteChecklist = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<DeleteChecklist, TError, DeleteChecklistVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<DeleteChecklist, TError, DeleteChecklistVariables, TContext>({
    mutationKey: ['deleteChecklist'],
    mutationFn: (variables?: DeleteChecklistVariables) =>
      fetcher<DeleteChecklist, DeleteChecklistVariables>(client, DeleteChecklistDocument, variables, headers)(),
    ...options,
  });
};

useDeleteChecklist.fetcher = (
  client: GraphQLClient,
  variables: DeleteChecklistVariables,
  headers?: RequestInit['headers'],
) => fetcher<DeleteChecklist, DeleteChecklistVariables>(client, DeleteChecklistDocument, variables, headers);

export const FollowChecklistDocument = `
    mutation followChecklist($id: ID!) {
  followChecklist(id: $id)
}
    `;

export const useFollowChecklist = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<FollowChecklist, TError, FollowChecklistVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<FollowChecklist, TError, FollowChecklistVariables, TContext>({
    mutationKey: ['followChecklist'],
    mutationFn: (variables?: FollowChecklistVariables) =>
      fetcher<FollowChecklist, FollowChecklistVariables>(client, FollowChecklistDocument, variables, headers)(),
    ...options,
  });
};

useFollowChecklist.fetcher = (
  client: GraphQLClient,
  variables: FollowChecklistVariables,
  headers?: RequestInit['headers'],
) => fetcher<FollowChecklist, FollowChecklistVariables>(client, FollowChecklistDocument, variables, headers);

export const UnfollowChecklistDocument = `
    mutation unfollowChecklist($id: ID!) {
  unfollowChecklist(id: $id)
}
    `;

export const useUnfollowChecklist = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UnfollowChecklist, TError, UnfollowChecklistVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UnfollowChecklist, TError, UnfollowChecklistVariables, TContext>({
    mutationKey: ['unfollowChecklist'],
    mutationFn: (variables?: UnfollowChecklistVariables) =>
      fetcher<UnfollowChecklist, UnfollowChecklistVariables>(client, UnfollowChecklistDocument, variables, headers)(),
    ...options,
  });
};

useUnfollowChecklist.fetcher = (
  client: GraphQLClient,
  variables: UnfollowChecklistVariables,
  headers?: RequestInit['headers'],
) => fetcher<UnfollowChecklist, UnfollowChecklistVariables>(client, UnfollowChecklistDocument, variables, headers);

export const AddChecklistCommentDocument = `
    mutation addChecklistComment($id: ID!, $text: String!) {
  storeChecklistComment(checklist_id: $id, text: $text) {
    id
    text
  }
}
    `;

export const useAddChecklistComment = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<AddChecklistComment, TError, AddChecklistCommentVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<AddChecklistComment, TError, AddChecklistCommentVariables, TContext>({
    mutationKey: ['addChecklistComment'],
    mutationFn: (variables?: AddChecklistCommentVariables) =>
      fetcher<AddChecklistComment, AddChecklistCommentVariables>(
        client,
        AddChecklistCommentDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useAddChecklistComment.fetcher = (
  client: GraphQLClient,
  variables: AddChecklistCommentVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<AddChecklistComment, AddChecklistCommentVariables>(client, AddChecklistCommentDocument, variables, headers);

export const EditChecklistCommentDocument = `
    mutation editChecklistComment($id: ID!, $text: String!) {
  updateChecklistComment(id: $id, text: $text) {
    id
    text
    updated_at_diff
    user {
      id
      name
      surname
      display_name
    }
  }
}
    `;

export const useEditChecklistComment = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<EditChecklistComment, TError, EditChecklistCommentVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<EditChecklistComment, TError, EditChecklistCommentVariables, TContext>({
    mutationKey: ['editChecklistComment'],
    mutationFn: (variables?: EditChecklistCommentVariables) =>
      fetcher<EditChecklistComment, EditChecklistCommentVariables>(
        client,
        EditChecklistCommentDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useEditChecklistComment.fetcher = (
  client: GraphQLClient,
  variables: EditChecklistCommentVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<EditChecklistComment, EditChecklistCommentVariables>(
    client,
    EditChecklistCommentDocument,
    variables,
    headers,
  );

export const DeleteChecklistCommentDocument = `
    mutation deleteChecklistComment($id: ID!) {
  deleteChecklistComment(id: $id)
}
    `;

export const useDeleteChecklistComment = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<DeleteChecklistComment, TError, DeleteChecklistCommentVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<DeleteChecklistComment, TError, DeleteChecklistCommentVariables, TContext>({
    mutationKey: ['deleteChecklistComment'],
    mutationFn: (variables?: DeleteChecklistCommentVariables) =>
      fetcher<DeleteChecklistComment, DeleteChecklistCommentVariables>(
        client,
        DeleteChecklistCommentDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useDeleteChecklistComment.fetcher = (
  client: GraphQLClient,
  variables: DeleteChecklistCommentVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<DeleteChecklistComment, DeleteChecklistCommentVariables>(
    client,
    DeleteChecklistCommentDocument,
    variables,
    headers,
  );

export const PostCommentMutationDocument = `
    mutation postCommentMutation($id: ID!, $commentable_type: String!, $text: String!) {
  storeComment(
    commentable_id: $id
    commentable_type: $commentable_type
    text: $text
  ) {
    ...CommentFragment
  }
}
    ${CommentFragment}`;

export const usePostCommentMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<PostCommentMutation, TError, PostCommentMutationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<PostCommentMutation, TError, PostCommentMutationVariables, TContext>({
    mutationKey: ['postCommentMutation'],
    mutationFn: (variables?: PostCommentMutationVariables) =>
      fetcher<PostCommentMutation, PostCommentMutationVariables>(
        client,
        PostCommentMutationDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

usePostCommentMutation.fetcher = (
  client: GraphQLClient,
  variables: PostCommentMutationVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<PostCommentMutation, PostCommentMutationVariables>(client, PostCommentMutationDocument, variables, headers);

export const UpdateCommentMutationDocument = `
    mutation updateCommentMutation($id: ID!, $text: String!) {
  updateComment(comment_id: $id, text: $text) {
    ...CommentFragment
  }
}
    ${CommentFragment}`;

export const useUpdateCommentMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpdateCommentMutation, TError, UpdateCommentMutationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UpdateCommentMutation, TError, UpdateCommentMutationVariables, TContext>({
    mutationKey: ['updateCommentMutation'],
    mutationFn: (variables?: UpdateCommentMutationVariables) =>
      fetcher<UpdateCommentMutation, UpdateCommentMutationVariables>(
        client,
        UpdateCommentMutationDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useUpdateCommentMutation.fetcher = (
  client: GraphQLClient,
  variables: UpdateCommentMutationVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<UpdateCommentMutation, UpdateCommentMutationVariables>(
    client,
    UpdateCommentMutationDocument,
    variables,
    headers,
  );

export const DeleteCommentMutationDocument = `
    mutation deleteCommentMutation($id: ID!) {
  deleteComment(id: $id)
}
    `;

export const useDeleteCommentMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<DeleteCommentMutation, TError, DeleteCommentMutationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<DeleteCommentMutation, TError, DeleteCommentMutationVariables, TContext>({
    mutationKey: ['deleteCommentMutation'],
    mutationFn: (variables?: DeleteCommentMutationVariables) =>
      fetcher<DeleteCommentMutation, DeleteCommentMutationVariables>(
        client,
        DeleteCommentMutationDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useDeleteCommentMutation.fetcher = (
  client: GraphQLClient,
  variables: DeleteCommentMutationVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<DeleteCommentMutation, DeleteCommentMutationVariables>(
    client,
    DeleteCommentMutationDocument,
    variables,
    headers,
  );

export const LikeCommentMutationDocument = `
    mutation likeCommentMutation($comment_id: ID!) {
  likeComment(comment_id: $comment_id)
}
    `;

export const useLikeCommentMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<LikeCommentMutation, TError, LikeCommentMutationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<LikeCommentMutation, TError, LikeCommentMutationVariables, TContext>({
    mutationKey: ['likeCommentMutation'],
    mutationFn: (variables?: LikeCommentMutationVariables) =>
      fetcher<LikeCommentMutation, LikeCommentMutationVariables>(
        client,
        LikeCommentMutationDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useLikeCommentMutation.fetcher = (
  client: GraphQLClient,
  variables: LikeCommentMutationVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<LikeCommentMutation, LikeCommentMutationVariables>(client, LikeCommentMutationDocument, variables, headers);

export const UnlikeCommentMutationDocument = `
    mutation unlikeCommentMutation($comment_id: ID!) {
  unlikeComment(comment_id: $comment_id)
}
    `;

export const useUnlikeCommentMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UnlikeCommentMutation, TError, UnlikeCommentMutationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UnlikeCommentMutation, TError, UnlikeCommentMutationVariables, TContext>({
    mutationKey: ['unlikeCommentMutation'],
    mutationFn: (variables?: UnlikeCommentMutationVariables) =>
      fetcher<UnlikeCommentMutation, UnlikeCommentMutationVariables>(
        client,
        UnlikeCommentMutationDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useUnlikeCommentMutation.fetcher = (
  client: GraphQLClient,
  variables: UnlikeCommentMutationVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<UnlikeCommentMutation, UnlikeCommentMutationVariables>(
    client,
    UnlikeCommentMutationDocument,
    variables,
    headers,
  );

export const BlockForUserMutationDocument = `
    mutation blockForUserMutation($id: ID!, $blocker_type: String!, $blocker_id: ID!) {
  blockForUser(
    blockable_id: $id
    blocker_type: $blocker_type
    blocker_id: $blocker_id
  )
}
    `;

export const useBlockForUserMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<BlockForUserMutation, TError, BlockForUserMutationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<BlockForUserMutation, TError, BlockForUserMutationVariables, TContext>({
    mutationKey: ['blockForUserMutation'],
    mutationFn: (variables?: BlockForUserMutationVariables) =>
      fetcher<BlockForUserMutation, BlockForUserMutationVariables>(
        client,
        BlockForUserMutationDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useBlockForUserMutation.fetcher = (
  client: GraphQLClient,
  variables: BlockForUserMutationVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<BlockForUserMutation, BlockForUserMutationVariables>(
    client,
    BlockForUserMutationDocument,
    variables,
    headers,
  );

export const UnblockForUserMutationDocument = `
    mutation unblockForUserMutation($id: ID!, $blocker_type: String!, $blocker_id: ID!) {
  unblockForUser(
    blockable_id: $id
    blocker_type: $blocker_type
    blocker_id: $blocker_id
  )
}
    `;

export const useUnblockForUserMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UnblockForUserMutation, TError, UnblockForUserMutationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UnblockForUserMutation, TError, UnblockForUserMutationVariables, TContext>({
    mutationKey: ['unblockForUserMutation'],
    mutationFn: (variables?: UnblockForUserMutationVariables) =>
      fetcher<UnblockForUserMutation, UnblockForUserMutationVariables>(
        client,
        UnblockForUserMutationDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useUnblockForUserMutation.fetcher = (
  client: GraphQLClient,
  variables: UnblockForUserMutationVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<UnblockForUserMutation, UnblockForUserMutationVariables>(
    client,
    UnblockForUserMutationDocument,
    variables,
    headers,
  );

export const StoreCostDocument = `
    mutation storeCost($boat_detail_id: ID!, $category_id: ID, $name: String!, $type: String!, $date: String, $supplier: String, $vat_percentage: Int, $amount: Float, $vat_type: String, $currency_id: ID!, $files: [Int], $notes: String, $quantity: Int, $costables: [Costable!]!, $is_maintenance_cost: Boolean, $quantity_action: String) {
  storeCost(
    boat_detail_id: $boat_detail_id
    category_id: $category_id
    name: $name
    type: $type
    date: $date
    supplier: $supplier
    vat_percentage: $vat_percentage
    amount: $amount
    vat_type: $vat_type
    currency_id: $currency_id
    files: $files
    notes: $notes
    quantity: $quantity
    costables: $costables
    is_maintenance_cost: $is_maintenance_cost
    quantity_action: $quantity_action
  ) {
    ...CostFragment
  }
}
    ${CostFragment}`;

export const useStoreCost = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<StoreCost, TError, StoreCostVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<StoreCost, TError, StoreCostVariables, TContext>({
    mutationKey: ['storeCost'],
    mutationFn: (variables?: StoreCostVariables) =>
      fetcher<StoreCost, StoreCostVariables>(client, StoreCostDocument, variables, headers)(),
    ...options,
  });
};

useStoreCost.fetcher = (client: GraphQLClient, variables: StoreCostVariables, headers?: RequestInit['headers']) =>
  fetcher<StoreCost, StoreCostVariables>(client, StoreCostDocument, variables, headers);

export const UpdateCostDocument = `
    mutation updateCost($id: ID!, $boat_detail_id: ID!, $category_id: ID, $name: String!, $type: String!, $date: String, $supplier: String, $vat_percentage: Int, $amount: Float, $vat_type: String, $currency_id: ID!, $files: [Int], $notes: String, $quantity: Int, $costables: [Costable!]!, $is_maintenance_cost: Boolean) {
  updateCost(
    id: $id
    boat_detail_id: $boat_detail_id
    category_id: $category_id
    name: $name
    type: $type
    date: $date
    supplier: $supplier
    vat_percentage: $vat_percentage
    amount: $amount
    vat_type: $vat_type
    currency_id: $currency_id
    files: $files
    notes: $notes
    quantity: $quantity
    costables: $costables
    is_maintenance_cost: $is_maintenance_cost
  ) {
    ...CostFragment
  }
}
    ${CostFragment}`;

export const useUpdateCost = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpdateCost, TError, UpdateCostVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UpdateCost, TError, UpdateCostVariables, TContext>({
    mutationKey: ['updateCost'],
    mutationFn: (variables?: UpdateCostVariables) =>
      fetcher<UpdateCost, UpdateCostVariables>(client, UpdateCostDocument, variables, headers)(),
    ...options,
  });
};

useUpdateCost.fetcher = (client: GraphQLClient, variables: UpdateCostVariables, headers?: RequestInit['headers']) =>
  fetcher<UpdateCost, UpdateCostVariables>(client, UpdateCostDocument, variables, headers);

export const DeleteCostDocument = `
    mutation deleteCost($id: ID!) {
  deleteCost(id: $id)
}
    `;

export const useDeleteCost = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<DeleteCost, TError, DeleteCostVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<DeleteCost, TError, DeleteCostVariables, TContext>({
    mutationKey: ['deleteCost'],
    mutationFn: (variables?: DeleteCostVariables) =>
      fetcher<DeleteCost, DeleteCostVariables>(client, DeleteCostDocument, variables, headers)(),
    ...options,
  });
};

useDeleteCost.fetcher = (client: GraphQLClient, variables: DeleteCostVariables, headers?: RequestInit['headers']) =>
  fetcher<DeleteCost, DeleteCostVariables>(client, DeleteCostDocument, variables, headers);

export const StoreFieldDocument = `
    mutation storeField($name: String!, $type: String!, $slug: String!, $module: String, $options: [String]) {
  storeField(
    name: $name
    type: $type
    slug: $slug
    module: $module
    options: $options
  ) {
    id
    user_id
    type
    name
    module
    options_data
    options
    slug
  }
}
    `;

export const useStoreField = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<StoreField, TError, StoreFieldVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<StoreField, TError, StoreFieldVariables, TContext>({
    mutationKey: ['storeField'],
    mutationFn: (variables?: StoreFieldVariables) =>
      fetcher<StoreField, StoreFieldVariables>(client, StoreFieldDocument, variables, headers)(),
    ...options,
  });
};

useStoreField.fetcher = (client: GraphQLClient, variables: StoreFieldVariables, headers?: RequestInit['headers']) =>
  fetcher<StoreField, StoreFieldVariables>(client, StoreFieldDocument, variables, headers);

export const UpdateFieldDocument = `
    mutation updateField($id: ID!, $name: String!, $options: [String]) {
  updateField(id: $id, name: $name, options: $options) {
    id
    user_id
    type
    name
    module
    options_data
    options
    slug
  }
}
    `;

export const useUpdateField = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpdateField, TError, UpdateFieldVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UpdateField, TError, UpdateFieldVariables, TContext>({
    mutationKey: ['updateField'],
    mutationFn: (variables?: UpdateFieldVariables) =>
      fetcher<UpdateField, UpdateFieldVariables>(client, UpdateFieldDocument, variables, headers)(),
    ...options,
  });
};

useUpdateField.fetcher = (client: GraphQLClient, variables: UpdateFieldVariables, headers?: RequestInit['headers']) =>
  fetcher<UpdateField, UpdateFieldVariables>(client, UpdateFieldDocument, variables, headers);

export const DeleteFieldDocument = `
    mutation deleteField($id: ID!) {
  deleteField(id: $id)
}
    `;

export const useDeleteField = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<DeleteField, TError, DeleteFieldVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<DeleteField, TError, DeleteFieldVariables, TContext>({
    mutationKey: ['deleteField'],
    mutationFn: (variables?: DeleteFieldVariables) =>
      fetcher<DeleteField, DeleteFieldVariables>(client, DeleteFieldDocument, variables, headers)(),
    ...options,
  });
};

useDeleteField.fetcher = (client: GraphQLClient, variables: DeleteFieldVariables, headers?: RequestInit['headers']) =>
  fetcher<DeleteField, DeleteFieldVariables>(client, DeleteFieldDocument, variables, headers);

export const DeactivateUserDocument = `
    mutation deactivateUser {
  deactivateUser
}
    `;

export const useDeactivateUser = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<DeactivateUser, TError, DeactivateUserVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<DeactivateUser, TError, DeactivateUserVariables, TContext>({
    mutationKey: ['deactivateUser'],
    mutationFn: (variables?: DeactivateUserVariables) =>
      fetcher<DeactivateUser, DeactivateUserVariables>(client, DeactivateUserDocument, variables, headers)(),
    ...options,
  });
};

useDeactivateUser.fetcher = (
  client: GraphQLClient,
  variables?: DeactivateUserVariables,
  headers?: RequestInit['headers'],
) => fetcher<DeactivateUser, DeactivateUserVariables>(client, DeactivateUserDocument, variables, headers);

export const AddExpenseDocument = `
    mutation addExpense($boat_detail_id: ID!, $item_name: String!, $currency_id: ID, $files: [ID], $type: String, $location: String, $sub_locations: [String], $brand: String, $model: String, $part_number: String, $serial_number: String, $vendor_page: String, $packing: String, $acquisition_date: String, $expiration_date: String, $unit: String, $quantity: Float, $total: Float, $linked_expenses_ids: [String], $notes: String, $voltage: Float, $width: Float, $height: Float, $depth: Float, $weight: Float, $consumption: Float, $supplier: String, $supplier_contact: String, $expiration_time_unit: Int, $expiration_time_unit_type: String, $expiration_is_custom: Boolean, $has_expiration_reminder: Boolean, $warranty_date: String, $warranty_time_unit: Int, $warranty_time_unit_type: String, $warranty_is_custom: Boolean, $has_warranty_reminder: Boolean, $is_recurring: Boolean, $has_usage_reminder: Boolean, $current_usage_value: Float, $usage_threshold: Float, $usage_time_unit: Int, $usage_time_unit_type: String, $usage_is_custom: Boolean, $recurrence_type: String, $threshold_reminder_value: Float, $has_threshold_reminder: Boolean, $usage_recurrence_time_unit: Int, $usage_recurrence_time_unit_type: String, $threshold_recurrence_reminder: Float, $usage_due_date: String, $due_date_time_unit: Int, $due_date_time_unit_type: String, $has_due_date_reminder: Boolean, $usage_recurrence: Float, $task_ids: [ID], $category_id: ID, $location_id: ID, $sub_location_ids: [ID!], $current_amount: Float, $minimum_quantity: Float, $minimum_quantity_reminder: Float, $has_minimum_quantity_reminder: Boolean, $fields: [FieldInput]) {
  storeExpense(
    boat_detail_id: $boat_detail_id
    item_name: $item_name
    currency_id: $currency_id
    files: $files
    type: $type
    location: $location
    sub_locations: $sub_locations
    location_id: $location_id
    sub_location_ids: $sub_location_ids
    brand: $brand
    model: $model
    part_number: $part_number
    serial_number: $serial_number
    vendor_page: $vendor_page
    packing: $packing
    acquisition_date: $acquisition_date
    expiration_date: $expiration_date
    unit: $unit
    quantity: $quantity
    total: $total
    linked_expenses_ids: $linked_expenses_ids
    notes: $notes
    voltage: $voltage
    width: $width
    height: $height
    depth: $depth
    weight: $weight
    consumption: $consumption
    supplier: $supplier
    supplier_contact: $supplier_contact
    expiration_time_unit: $expiration_time_unit
    expiration_time_unit_type: $expiration_time_unit_type
    expiration_is_custom: $expiration_is_custom
    has_expiration_reminder: $has_expiration_reminder
    warranty_date: $warranty_date
    warranty_time_unit: $warranty_time_unit
    warranty_time_unit_type: $warranty_time_unit_type
    warranty_is_custom: $warranty_is_custom
    has_warranty_reminder: $has_warranty_reminder
    is_recurring: $is_recurring
    has_usage_reminder: $has_usage_reminder
    current_usage_value: $current_usage_value
    usage_threshold: $usage_threshold
    usage_time_unit: $usage_time_unit
    usage_time_unit_type: $usage_time_unit_type
    usage_is_custom: $usage_is_custom
    recurrence_type: $recurrence_type
    threshold_reminder_value: $threshold_reminder_value
    has_threshold_reminder: $has_threshold_reminder
    usage_recurrence_time_unit: $usage_recurrence_time_unit
    usage_recurrence_time_unit_type: $usage_recurrence_time_unit_type
    usage_recurrence: $usage_recurrence
    threshold_recurrence_reminder: $threshold_recurrence_reminder
    usage_due_date: $usage_due_date
    due_date_time_unit: $due_date_time_unit
    due_date_time_unit_type: $due_date_time_unit_type
    has_due_date_reminder: $has_due_date_reminder
    task_ids: $task_ids
    category_id: $category_id
    current_amount: $current_amount
    minimum_quantity: $minimum_quantity
    minimum_quantity_reminder: $minimum_quantity_reminder
    has_minimum_quantity_reminder: $has_minimum_quantity_reminder
    fields: $fields
  ) {
    ...ExpenseFragment
  }
}
    ${ExpenseFragment}`;

export const useAddExpense = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<AddExpense, TError, AddExpenseVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<AddExpense, TError, AddExpenseVariables, TContext>({
    mutationKey: ['addExpense'],
    mutationFn: (variables?: AddExpenseVariables) =>
      fetcher<AddExpense, AddExpenseVariables>(client, AddExpenseDocument, variables, headers)(),
    ...options,
  });
};

useAddExpense.fetcher = (client: GraphQLClient, variables: AddExpenseVariables, headers?: RequestInit['headers']) =>
  fetcher<AddExpense, AddExpenseVariables>(client, AddExpenseDocument, variables, headers);

export const EditExpenseDocument = `
    mutation editExpense($id: ID!, $item_name: String!, $currency_id: ID, $files: [ID], $type: String, $location: String, $sub_locations: [String], $brand: String, $model: String, $part_number: String, $serial_number: String, $vendor_page: String, $packing: String, $acquisition_date: String, $expiration_date: String, $unit: String, $quantity: Float, $total: Float, $linked_expenses_ids: [String], $notes: String, $voltage: Float, $width: Float, $height: Float, $depth: Float, $weight: Float, $consumption: Float, $supplier: String, $supplier_contact: String, $expiration_time_unit: Int, $expiration_time_unit_type: String, $expiration_is_custom: Boolean, $has_expiration_reminder: Boolean, $warranty_date: String, $warranty_time_unit: Int, $warranty_time_unit_type: String, $warranty_is_custom: Boolean, $has_warranty_reminder: Boolean, $is_recurring: Boolean, $has_usage_reminder: Boolean, $current_usage_value: Float, $usage_threshold: Float, $usage_time_unit: Int, $usage_time_unit_type: String, $usage_is_custom: Boolean, $recurrence_type: String, $threshold_reminder_value: Float, $has_threshold_reminder: Boolean, $usage_recurrence_time_unit: Int, $usage_recurrence_time_unit_type: String, $threshold_recurrence_reminder: Float, $usage_due_date: String, $due_date_time_unit: Int, $due_date_time_unit_type: String, $has_due_date_reminder: Boolean, $usage_recurrence: Float, $task_ids: [ID], $category_id: ID, $location_id: ID, $sub_location_ids: [ID!], $current_amount: Float, $minimum_quantity: Float, $minimum_quantity_reminder: Float, $has_minimum_quantity_reminder: Boolean, $boat_detail_id: ID!, $fields: [FieldInput]) {
  updateExpense(
    id: $id
    boat_detail_id: $boat_detail_id
    item_name: $item_name
    currency_id: $currency_id
    files: $files
    type: $type
    location: $location
    sub_locations: $sub_locations
    location_id: $location_id
    sub_location_ids: $sub_location_ids
    brand: $brand
    model: $model
    part_number: $part_number
    serial_number: $serial_number
    vendor_page: $vendor_page
    packing: $packing
    acquisition_date: $acquisition_date
    expiration_date: $expiration_date
    unit: $unit
    quantity: $quantity
    total: $total
    linked_expenses_ids: $linked_expenses_ids
    notes: $notes
    voltage: $voltage
    width: $width
    height: $height
    depth: $depth
    weight: $weight
    consumption: $consumption
    supplier: $supplier
    supplier_contact: $supplier_contact
    expiration_time_unit: $expiration_time_unit
    expiration_time_unit_type: $expiration_time_unit_type
    expiration_is_custom: $expiration_is_custom
    has_expiration_reminder: $has_expiration_reminder
    warranty_is_custom: $warranty_is_custom
    warranty_date: $warranty_date
    warranty_time_unit: $warranty_time_unit
    warranty_time_unit_type: $warranty_time_unit_type
    has_warranty_reminder: $has_warranty_reminder
    is_recurring: $is_recurring
    has_usage_reminder: $has_usage_reminder
    current_usage_value: $current_usage_value
    usage_threshold: $usage_threshold
    usage_time_unit: $usage_time_unit
    usage_time_unit_type: $usage_time_unit_type
    usage_is_custom: $usage_is_custom
    recurrence_type: $recurrence_type
    threshold_reminder_value: $threshold_reminder_value
    has_threshold_reminder: $has_threshold_reminder
    usage_recurrence_time_unit: $usage_recurrence_time_unit
    usage_recurrence_time_unit_type: $usage_recurrence_time_unit_type
    usage_recurrence: $usage_recurrence
    threshold_recurrence_reminder: $threshold_recurrence_reminder
    usage_due_date: $usage_due_date
    due_date_time_unit: $due_date_time_unit
    due_date_time_unit_type: $due_date_time_unit_type
    has_due_date_reminder: $has_due_date_reminder
    task_ids: $task_ids
    category_id: $category_id
    current_amount: $current_amount
    minimum_quantity: $minimum_quantity
    minimum_quantity_reminder: $minimum_quantity_reminder
    has_minimum_quantity_reminder: $has_minimum_quantity_reminder
    fields: $fields
  ) {
    ...ExpenseFragment
  }
}
    ${ExpenseFragment}`;

export const useEditExpense = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<EditExpense, TError, EditExpenseVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<EditExpense, TError, EditExpenseVariables, TContext>({
    mutationKey: ['editExpense'],
    mutationFn: (variables?: EditExpenseVariables) =>
      fetcher<EditExpense, EditExpenseVariables>(client, EditExpenseDocument, variables, headers)(),
    ...options,
  });
};

useEditExpense.fetcher = (client: GraphQLClient, variables: EditExpenseVariables, headers?: RequestInit['headers']) =>
  fetcher<EditExpense, EditExpenseVariables>(client, EditExpenseDocument, variables, headers);

export const DeleteExpenseDocument = `
    mutation deleteExpense($id: ID!) {
  deleteExpense(id: $id)
}
    `;

export const useDeleteExpense = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<DeleteExpense, TError, DeleteExpenseVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<DeleteExpense, TError, DeleteExpenseVariables, TContext>({
    mutationKey: ['deleteExpense'],
    mutationFn: (variables?: DeleteExpenseVariables) =>
      fetcher<DeleteExpense, DeleteExpenseVariables>(client, DeleteExpenseDocument, variables, headers)(),
    ...options,
  });
};

useDeleteExpense.fetcher = (
  client: GraphQLClient,
  variables: DeleteExpenseVariables,
  headers?: RequestInit['headers'],
) => fetcher<DeleteExpense, DeleteExpenseVariables>(client, DeleteExpenseDocument, variables, headers);

export const UsageDoneDocument = `
    mutation usageDone($id: ID!) {
  usageDone(id: $id) {
    ...ExpenseFragment
  }
}
    ${ExpenseFragment}`;

export const useUsageDone = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UsageDone, TError, UsageDoneVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UsageDone, TError, UsageDoneVariables, TContext>({
    mutationKey: ['usageDone'],
    mutationFn: (variables?: UsageDoneVariables) =>
      fetcher<UsageDone, UsageDoneVariables>(client, UsageDoneDocument, variables, headers)(),
    ...options,
  });
};

useUsageDone.fetcher = (client: GraphQLClient, variables: UsageDoneVariables, headers?: RequestInit['headers']) =>
  fetcher<UsageDone, UsageDoneVariables>(client, UsageDoneDocument, variables, headers);

export const MassDeleteExpensesMutationDocument = `
    mutation massDeleteExpensesMutation($ids: String) {
  massDeleteExpenses(ids: $ids) {
    deleted
    notDeleted
  }
}
    `;

export const useMassDeleteExpensesMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<MassDeleteExpensesMutation, TError, MassDeleteExpensesMutationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<MassDeleteExpensesMutation, TError, MassDeleteExpensesMutationVariables, TContext>({
    mutationKey: ['massDeleteExpensesMutation'],
    mutationFn: (variables?: MassDeleteExpensesMutationVariables) =>
      fetcher<MassDeleteExpensesMutation, MassDeleteExpensesMutationVariables>(
        client,
        MassDeleteExpensesMutationDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useMassDeleteExpensesMutation.fetcher = (
  client: GraphQLClient,
  variables?: MassDeleteExpensesMutationVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<MassDeleteExpensesMutation, MassDeleteExpensesMutationVariables>(
    client,
    MassDeleteExpensesMutationDocument,
    variables,
    headers,
  );

export const AddToFavoriteDocument = `
    mutation addToFavorite($boat_id: ID!) {
  addToFavorite(boat_id: $boat_id) {
    id
    favorites_count
  }
}
    `;

export const useAddToFavorite = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<AddToFavorite, TError, AddToFavoriteVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<AddToFavorite, TError, AddToFavoriteVariables, TContext>({
    mutationKey: ['addToFavorite'],
    mutationFn: (variables?: AddToFavoriteVariables) =>
      fetcher<AddToFavorite, AddToFavoriteVariables>(client, AddToFavoriteDocument, variables, headers)(),
    ...options,
  });
};

useAddToFavorite.fetcher = (
  client: GraphQLClient,
  variables: AddToFavoriteVariables,
  headers?: RequestInit['headers'],
) => fetcher<AddToFavorite, AddToFavoriteVariables>(client, AddToFavoriteDocument, variables, headers);

export const RemoveFromFavoritesDocument = `
    mutation removeFromFavorites($boat_id: ID!) {
  removeFromFavorite(boat_id: $boat_id)
}
    `;

export const useRemoveFromFavorites = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<RemoveFromFavorites, TError, RemoveFromFavoritesVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<RemoveFromFavorites, TError, RemoveFromFavoritesVariables, TContext>({
    mutationKey: ['removeFromFavorites'],
    mutationFn: (variables?: RemoveFromFavoritesVariables) =>
      fetcher<RemoveFromFavorites, RemoveFromFavoritesVariables>(
        client,
        RemoveFromFavoritesDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useRemoveFromFavorites.fetcher = (
  client: GraphQLClient,
  variables: RemoveFromFavoritesVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<RemoveFromFavorites, RemoveFromFavoritesVariables>(client, RemoveFromFavoritesDocument, variables, headers);

export const UpdateFileMutationDocument = `
    mutation updateFileMutation($id: ID!, $name: String!, $folder_id: ID, $filename: String, $issued_by: String, $issuance_date: DateTime, $boat_detail_id: ID, $expiration_date: DateTime, $expiration_date_time_unit: Int, $expiration_date_time_unit_type: String, $has_expiration_date_reminder: Boolean, $notes: String) {
  updateFile(
    id: $id
    name: $name
    folder_id: $folder_id
    filename: $filename
    issued_by: $issued_by
    issuance_date: $issuance_date
    boat_detail_id: $boat_detail_id
    expiration_date: $expiration_date
    expiration_date_time_unit: $expiration_date_time_unit
    expiration_date_time_unit_type: $expiration_date_time_unit_type
    has_expiration_date_reminder: $has_expiration_date_reminder
    notes: $notes
  ) {
    ...RequiredFileFields
  }
}
    ${RequiredFileFields}`;

export const useUpdateFileMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpdateFileMutation, TError, UpdateFileMutationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UpdateFileMutation, TError, UpdateFileMutationVariables, TContext>({
    mutationKey: ['updateFileMutation'],
    mutationFn: (variables?: UpdateFileMutationVariables) =>
      fetcher<UpdateFileMutation, UpdateFileMutationVariables>(
        client,
        UpdateFileMutationDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useUpdateFileMutation.fetcher = (
  client: GraphQLClient,
  variables: UpdateFileMutationVariables,
  headers?: RequestInit['headers'],
) => fetcher<UpdateFileMutation, UpdateFileMutationVariables>(client, UpdateFileMutationDocument, variables, headers);

export const UploadFileDocument = `
    mutation uploadFile($file: Upload!, $folder_id: ID) {
  upload(file: $file, folder_id: $folder_id) {
    ...RequiredFileFields
  }
}
    ${RequiredFileFields}`;

export const useUploadFile = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UploadFile, TError, UploadFileVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UploadFile, TError, UploadFileVariables, TContext>({
    mutationKey: ['uploadFile'],
    mutationFn: (variables?: UploadFileVariables) =>
      fetcher<UploadFile, UploadFileVariables>(client, UploadFileDocument, variables, headers)(),
    ...options,
  });
};

useUploadFile.fetcher = (client: GraphQLClient, variables: UploadFileVariables, headers?: RequestInit['headers']) =>
  fetcher<UploadFile, UploadFileVariables>(client, UploadFileDocument, variables, headers);

export const ValidateFileSizeDocument = `
    mutation validateFileSize($size: Int!) {
  validateFileSize(size: $size) {
    status
    message
  }
}
    `;

export const useValidateFileSize = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<ValidateFileSize, TError, ValidateFileSizeVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<ValidateFileSize, TError, ValidateFileSizeVariables, TContext>({
    mutationKey: ['validateFileSize'],
    mutationFn: (variables?: ValidateFileSizeVariables) =>
      fetcher<ValidateFileSize, ValidateFileSizeVariables>(client, ValidateFileSizeDocument, variables, headers)(),
    ...options,
  });
};

useValidateFileSize.fetcher = (
  client: GraphQLClient,
  variables: ValidateFileSizeVariables,
  headers?: RequestInit['headers'],
) => fetcher<ValidateFileSize, ValidateFileSizeVariables>(client, ValidateFileSizeDocument, variables, headers);

export const MassDeleteFilesDocument = `
    mutation massDeleteFiles($ids: String!) {
  massDeleteFiles(ids: $ids) {
    deleted
    notDeleted
  }
}
    `;

export const useMassDeleteFiles = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<MassDeleteFiles, TError, MassDeleteFilesVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<MassDeleteFiles, TError, MassDeleteFilesVariables, TContext>({
    mutationKey: ['massDeleteFiles'],
    mutationFn: (variables?: MassDeleteFilesVariables) =>
      fetcher<MassDeleteFiles, MassDeleteFilesVariables>(client, MassDeleteFilesDocument, variables, headers)(),
    ...options,
  });
};

useMassDeleteFiles.fetcher = (
  client: GraphQLClient,
  variables: MassDeleteFilesVariables,
  headers?: RequestInit['headers'],
) => fetcher<MassDeleteFiles, MassDeleteFilesVariables>(client, MassDeleteFilesDocument, variables, headers);

export const DeleteFileMutationDocument = `
    mutation deleteFileMutation($id: ID!) {
  deleteFile(id: $id)
}
    `;

export const useDeleteFileMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<DeleteFileMutation, TError, DeleteFileMutationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<DeleteFileMutation, TError, DeleteFileMutationVariables, TContext>({
    mutationKey: ['deleteFileMutation'],
    mutationFn: (variables?: DeleteFileMutationVariables) =>
      fetcher<DeleteFileMutation, DeleteFileMutationVariables>(
        client,
        DeleteFileMutationDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useDeleteFileMutation.fetcher = (
  client: GraphQLClient,
  variables: DeleteFileMutationVariables,
  headers?: RequestInit['headers'],
) => fetcher<DeleteFileMutation, DeleteFileMutationVariables>(client, DeleteFileMutationDocument, variables, headers);

export const AddFolderDocument = `
    mutation addFolder($name: String!, $parent_id: ID) {
  storeFolder(name: $name, parent_id: $parent_id) {
    ...FolderFragment
  }
}
    ${FolderFragment}`;

export const useAddFolder = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<AddFolder, TError, AddFolderVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<AddFolder, TError, AddFolderVariables, TContext>({
    mutationKey: ['addFolder'],
    mutationFn: (variables?: AddFolderVariables) =>
      fetcher<AddFolder, AddFolderVariables>(client, AddFolderDocument, variables, headers)(),
    ...options,
  });
};

useAddFolder.fetcher = (client: GraphQLClient, variables: AddFolderVariables, headers?: RequestInit['headers']) =>
  fetcher<AddFolder, AddFolderVariables>(client, AddFolderDocument, variables, headers);

export const UpdateFolderDocument = `
    mutation updateFolder($id: ID!, $name: String!, $parent_id: ID) {
  updateFolder(id: $id, name: $name, parent_id: $parent_id) {
    ...FolderFragment
  }
}
    ${FolderFragment}`;

export const useUpdateFolder = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpdateFolder, TError, UpdateFolderVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UpdateFolder, TError, UpdateFolderVariables, TContext>({
    mutationKey: ['updateFolder'],
    mutationFn: (variables?: UpdateFolderVariables) =>
      fetcher<UpdateFolder, UpdateFolderVariables>(client, UpdateFolderDocument, variables, headers)(),
    ...options,
  });
};

useUpdateFolder.fetcher = (client: GraphQLClient, variables: UpdateFolderVariables, headers?: RequestInit['headers']) =>
  fetcher<UpdateFolder, UpdateFolderVariables>(client, UpdateFolderDocument, variables, headers);

export const DeleteFolderDocument = `
    mutation deleteFolder($id: ID!) {
  deleteFolder(id: $id)
}
    `;

export const useDeleteFolder = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<DeleteFolder, TError, DeleteFolderVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<DeleteFolder, TError, DeleteFolderVariables, TContext>({
    mutationKey: ['deleteFolder'],
    mutationFn: (variables?: DeleteFolderVariables) =>
      fetcher<DeleteFolder, DeleteFolderVariables>(client, DeleteFolderDocument, variables, headers)(),
    ...options,
  });
};

useDeleteFolder.fetcher = (client: GraphQLClient, variables: DeleteFolderVariables, headers?: RequestInit['headers']) =>
  fetcher<DeleteFolder, DeleteFolderVariables>(client, DeleteFolderDocument, variables, headers);

export const MassDeleteFoldersDocument = `
    mutation massDeleteFolders($ids: String) {
  massDeleteFolders(ids: $ids) {
    deleted
    notDeleted
  }
}
    `;

export const useMassDeleteFolders = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<MassDeleteFolders, TError, MassDeleteFoldersVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<MassDeleteFolders, TError, MassDeleteFoldersVariables, TContext>({
    mutationKey: ['massDeleteFolders'],
    mutationFn: (variables?: MassDeleteFoldersVariables) =>
      fetcher<MassDeleteFolders, MassDeleteFoldersVariables>(client, MassDeleteFoldersDocument, variables, headers)(),
    ...options,
  });
};

useMassDeleteFolders.fetcher = (
  client: GraphQLClient,
  variables?: MassDeleteFoldersVariables,
  headers?: RequestInit['headers'],
) => fetcher<MassDeleteFolders, MassDeleteFoldersVariables>(client, MassDeleteFoldersDocument, variables, headers);

export const MassMoveDocument = `
    mutation massMove($file_ids: [ID!], $folder_ids: [ID!], $destination_id: ID) {
  massMove(
    file_ids: $file_ids
    folder_ids: $folder_ids
    destination_id: $destination_id
  ) {
    ...FolderFragment
  }
}
    ${FolderFragment}`;

export const useMassMove = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<MassMove, TError, MassMoveVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<MassMove, TError, MassMoveVariables, TContext>({
    mutationKey: ['massMove'],
    mutationFn: (variables?: MassMoveVariables) =>
      fetcher<MassMove, MassMoveVariables>(client, MassMoveDocument, variables, headers)(),
    ...options,
  });
};

useMassMove.fetcher = (client: GraphQLClient, variables?: MassMoveVariables, headers?: RequestInit['headers']) =>
  fetcher<MassMove, MassMoveVariables>(client, MassMoveDocument, variables, headers);

export const AddLocationDocument = `
    mutation addLocation($name: String!, $is_sub_location: Boolean) {
  storeLocation(name: $name, is_sub_location: $is_sub_location) {
    id
    name
    is_sub_location
  }
}
    `;

export const useAddLocation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<AddLocation, TError, AddLocationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<AddLocation, TError, AddLocationVariables, TContext>({
    mutationKey: ['addLocation'],
    mutationFn: (variables?: AddLocationVariables) =>
      fetcher<AddLocation, AddLocationVariables>(client, AddLocationDocument, variables, headers)(),
    ...options,
  });
};

useAddLocation.fetcher = (client: GraphQLClient, variables: AddLocationVariables, headers?: RequestInit['headers']) =>
  fetcher<AddLocation, AddLocationVariables>(client, AddLocationDocument, variables, headers);

export const EditLocationDocument = `
    mutation editLocation($id: ID!, $name: String!, $is_sub_location: Boolean) {
  updateLocation(id: $id, name: $name, is_sub_location: $is_sub_location) {
    id
    name
    is_sub_location
  }
}
    `;

export const useEditLocation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<EditLocation, TError, EditLocationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<EditLocation, TError, EditLocationVariables, TContext>({
    mutationKey: ['editLocation'],
    mutationFn: (variables?: EditLocationVariables) =>
      fetcher<EditLocation, EditLocationVariables>(client, EditLocationDocument, variables, headers)(),
    ...options,
  });
};

useEditLocation.fetcher = (client: GraphQLClient, variables: EditLocationVariables, headers?: RequestInit['headers']) =>
  fetcher<EditLocation, EditLocationVariables>(client, EditLocationDocument, variables, headers);

export const DeleteLocationDocument = `
    mutation deleteLocation($id: ID!) {
  deleteLocation(id: $id)
}
    `;

export const useDeleteLocation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<DeleteLocation, TError, DeleteLocationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<DeleteLocation, TError, DeleteLocationVariables, TContext>({
    mutationKey: ['deleteLocation'],
    mutationFn: (variables?: DeleteLocationVariables) =>
      fetcher<DeleteLocation, DeleteLocationVariables>(client, DeleteLocationDocument, variables, headers)(),
    ...options,
  });
};

useDeleteLocation.fetcher = (
  client: GraphQLClient,
  variables: DeleteLocationVariables,
  headers?: RequestInit['headers'],
) => fetcher<DeleteLocation, DeleteLocationVariables>(client, DeleteLocationDocument, variables, headers);

export const AddLogDocument = `
    mutation addLog($log: StoreLogInput!) {
  storeLog(log: $log) {
    id
    later
    datetime
    latitude
    longitude
    log
    type
    created_at
    updated_at
  }
}
    `;

export const useAddLog = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<AddLog, TError, AddLogVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<AddLog, TError, AddLogVariables, TContext>({
    mutationKey: ['addLog'],
    mutationFn: (variables?: AddLogVariables) =>
      fetcher<AddLog, AddLogVariables>(client, AddLogDocument, variables, headers)(),
    ...options,
  });
};

useAddLog.fetcher = (client: GraphQLClient, variables: AddLogVariables, headers?: RequestInit['headers']) =>
  fetcher<AddLog, AddLogVariables>(client, AddLogDocument, variables, headers);

export const StoreMultipleLogsDocument = `
    mutation storeMultipleLogs($logs: [StoreLogInput!]!) {
  storeBulkLog(logs: $logs) {
    id
    later
    datetime
    latitude
    longitude
    log
    type
    created_at
    updated_at
  }
}
    `;

export const useStoreMultipleLogs = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<StoreMultipleLogs, TError, StoreMultipleLogsVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<StoreMultipleLogs, TError, StoreMultipleLogsVariables, TContext>({
    mutationKey: ['storeMultipleLogs'],
    mutationFn: (variables?: StoreMultipleLogsVariables) =>
      fetcher<StoreMultipleLogs, StoreMultipleLogsVariables>(client, StoreMultipleLogsDocument, variables, headers)(),
    ...options,
  });
};

useStoreMultipleLogs.fetcher = (
  client: GraphQLClient,
  variables: StoreMultipleLogsVariables,
  headers?: RequestInit['headers'],
) => fetcher<StoreMultipleLogs, StoreMultipleLogsVariables>(client, StoreMultipleLogsDocument, variables, headers);

export const UpdateLogDocument = `
    mutation updateLog($id: ID!, $name: String, $boat_detail_id: ID, $datetime: String!, $latitude: Float!, $longitude: Float!, $type: String!, $notes: String, $caption: String, $sea_area: String, $imminent: String, $later: String, $outlook: String, $channel: String, $station: String, $message: String, $event: String, $heading: Int, $cog: Int, $helm: String, $speed: Float, $sog: Float, $log: Float, $depth: Float, $bar: Float, $wind_speed: Float, $wind_direction: Int, $sky: Int, $precipitation: String, $sea_state: Int, $visibility: Float, $air_temp: Float, $sea_temp: Float, $sails: String, $diesel_generator_status: Boolean, $diesel_generator_hours: Float, $diesel_generator_rpm: Int, $diesel_generator_fuel_check: Boolean, $diesel_generator_oil_check: Boolean, $diesel_generator_water_check: Boolean, $diesel_generator_exhaust_check: Boolean, $battery1: Float, $battery2: Float, $boat_water: Float, $fuel: Float, $gas: Float, $bilge: Boolean, $files: [Int], $usage: [UsageInput], $category_id: ID, $cost_type: String, $vat_percentage: Int, $amount: Float, $vat_type: String, $currency_id: ID, $quantity: Float, $supplier: String, $has_cost: Boolean, $engine_logs: [EngineLogInput]) {
  updateLog(
    id: $id
    engine_logs: $engine_logs
    name: $name
    boat_detail_id: $boat_detail_id
    datetime: $datetime
    latitude: $latitude
    longitude: $longitude
    type: $type
    notes: $notes
    log: $log
    caption: $caption
    sea_area: $sea_area
    imminent: $imminent
    later: $later
    outlook: $outlook
    channel: $channel
    station: $station
    message: $message
    event: $event
    heading: $heading
    cog: $cog
    helm: $helm
    speed: $speed
    sog: $sog
    depth: $depth
    bar: $bar
    wind_speed: $wind_speed
    wind_direction: $wind_direction
    sky: $sky
    precipitation: $precipitation
    sea_state: $sea_state
    visibility: $visibility
    air_temp: $air_temp
    sea_temp: $sea_temp
    sails: $sails
    diesel_generator_status: $diesel_generator_status
    diesel_generator_hours: $diesel_generator_hours
    diesel_generator_rpm: $diesel_generator_rpm
    diesel_generator_fuel_check: $diesel_generator_fuel_check
    diesel_generator_oil_check: $diesel_generator_oil_check
    diesel_generator_water_check: $diesel_generator_water_check
    diesel_generator_exhaust_check: $diesel_generator_exhaust_check
    battery1: $battery1
    battery2: $battery2
    boat_water: $boat_water
    fuel: $fuel
    gas: $gas
    bilge: $bilge
    files: $files
    usage: $usage
    amount: $amount
    category_id: $category_id
    cost_type: $cost_type
    vat_percentage: $vat_percentage
    vat_type: $vat_type
    currency_id: $currency_id
    supplier: $supplier
    quantity: $quantity
    has_cost: $has_cost
  ) {
    id
    notes
    datetime
  }
}
    `;

export const useUpdateLog = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpdateLog, TError, UpdateLogVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UpdateLog, TError, UpdateLogVariables, TContext>({
    mutationKey: ['updateLog'],
    mutationFn: (variables?: UpdateLogVariables) =>
      fetcher<UpdateLog, UpdateLogVariables>(client, UpdateLogDocument, variables, headers)(),
    ...options,
  });
};

useUpdateLog.fetcher = (client: GraphQLClient, variables: UpdateLogVariables, headers?: RequestInit['headers']) =>
  fetcher<UpdateLog, UpdateLogVariables>(client, UpdateLogDocument, variables, headers);

export const DeleteLogDocument = `
    mutation deleteLog($id: ID!) {
  deleteLog(id: $id)
}
    `;

export const useDeleteLog = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<DeleteLog, TError, DeleteLogVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<DeleteLog, TError, DeleteLogVariables, TContext>({
    mutationKey: ['deleteLog'],
    mutationFn: (variables?: DeleteLogVariables) =>
      fetcher<DeleteLog, DeleteLogVariables>(client, DeleteLogDocument, variables, headers)(),
    ...options,
  });
};

useDeleteLog.fetcher = (client: GraphQLClient, variables: DeleteLogVariables, headers?: RequestInit['headers']) =>
  fetcher<DeleteLog, DeleteLogVariables>(client, DeleteLogDocument, variables, headers);

export const UpdateAuthUserDocument = `
    mutation updateAuthUser($image_id: ID, $name: String, $surname: String, $display_name: String, $email: String, $phone: String, $birthday: String, $gender: String, $auth0UserMetadata: Auth0UserMetaData, $country_id: ID, $currency_id: ID, $base_currency_id: ID) {
  updateAuthUser(
    image_id: $image_id
    name: $name
    surname: $surname
    display_name: $display_name
    email: $email
    phone: $phone
    birthday: $birthday
    gender: $gender
    country_id: $country_id
    currency_id: $currency_id
    base_currency_id: $base_currency_id
    auth0UserMetadata: $auth0UserMetadata
  ) {
    image_id
    name
    surname
    display_name
    email
    phone
    birthday
    gender
    country {
      id
    }
  }
}
    `;

export const useUpdateAuthUser = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpdateAuthUser, TError, UpdateAuthUserVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UpdateAuthUser, TError, UpdateAuthUserVariables, TContext>({
    mutationKey: ['updateAuthUser'],
    mutationFn: (variables?: UpdateAuthUserVariables) =>
      fetcher<UpdateAuthUser, UpdateAuthUserVariables>(client, UpdateAuthUserDocument, variables, headers)(),
    ...options,
  });
};

useUpdateAuthUser.fetcher = (
  client: GraphQLClient,
  variables?: UpdateAuthUserVariables,
  headers?: RequestInit['headers'],
) => fetcher<UpdateAuthUser, UpdateAuthUserVariables>(client, UpdateAuthUserDocument, variables, headers);

export const UpdateUserSettingsDocument = `
    mutation updateUserSettings($language_id: ID, $date_format: String, $time_format: String, $timezone_id: ID, $first_day_of_week: Int, $unit: String, $decimal_symbol: String, $digit_grouping_symbol: String) {
  updateUserSettings(
    language_id: $language_id
    date_format: $date_format
    time_format: $time_format
    timezone_id: $timezone_id
    first_day_of_week: $first_day_of_week
    unit: $unit
    decimal_symbol: $decimal_symbol
    digit_grouping_symbol: $digit_grouping_symbol
  ) {
    key
    value
  }
}
    `;

export const useUpdateUserSettings = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpdateUserSettings, TError, UpdateUserSettingsVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UpdateUserSettings, TError, UpdateUserSettingsVariables, TContext>({
    mutationKey: ['updateUserSettings'],
    mutationFn: (variables?: UpdateUserSettingsVariables) =>
      fetcher<UpdateUserSettings, UpdateUserSettingsVariables>(
        client,
        UpdateUserSettingsDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useUpdateUserSettings.fetcher = (
  client: GraphQLClient,
  variables?: UpdateUserSettingsVariables,
  headers?: RequestInit['headers'],
) => fetcher<UpdateUserSettings, UpdateUserSettingsVariables>(client, UpdateUserSettingsDocument, variables, headers);

export const UpdateOrCreateAddressDocument = `
    mutation updateOrCreateAddress($city: String!, $postal_code: String!, $state: String!, $street: String!, $country: String!) {
  updateOrCreateAddress(
    city: $city
    postal_code: $postal_code
    state: $state
    street: $street
    country: $country
  ) {
    id
  }
}
    `;

export const useUpdateOrCreateAddress = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpdateOrCreateAddress, TError, UpdateOrCreateAddressVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UpdateOrCreateAddress, TError, UpdateOrCreateAddressVariables, TContext>({
    mutationKey: ['updateOrCreateAddress'],
    mutationFn: (variables?: UpdateOrCreateAddressVariables) =>
      fetcher<UpdateOrCreateAddress, UpdateOrCreateAddressVariables>(
        client,
        UpdateOrCreateAddressDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useUpdateOrCreateAddress.fetcher = (
  client: GraphQLClient,
  variables: UpdateOrCreateAddressVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<UpdateOrCreateAddress, UpdateOrCreateAddressVariables>(
    client,
    UpdateOrCreateAddressDocument,
    variables,
    headers,
  );

export const SharedWithDocument = `
    mutation sharedWith($model_id: ID!, $model_type: String!) {
  sharedWith(model_id: $model_id, model_type: $model_type) {
    id
    model_id
    model_type
    permission_type
    inherited_from
    display_name
    email
    shareable_type
    user {
      id
      display_name
      email
      name
      surname
      image {
        url
        public_url
      }
    }
    user_id
  }
}
    `;

export const useSharedWith = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<SharedWith, TError, SharedWithVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<SharedWith, TError, SharedWithVariables, TContext>({
    mutationKey: ['sharedWith'],
    mutationFn: (variables?: SharedWithVariables) =>
      fetcher<SharedWith, SharedWithVariables>(client, SharedWithDocument, variables, headers)(),
    ...options,
  });
};

useSharedWith.fetcher = (client: GraphQLClient, variables: SharedWithVariables, headers?: RequestInit['headers']) =>
  fetcher<SharedWith, SharedWithVariables>(client, SharedWithDocument, variables, headers);

export const RemoveShareDocument = `
    mutation removeShare($id: ID!) {
  deleteShare(id: $id)
}
    `;

export const useRemoveShare = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<RemoveShare, TError, RemoveShareVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<RemoveShare, TError, RemoveShareVariables, TContext>({
    mutationKey: ['removeShare'],
    mutationFn: (variables?: RemoveShareVariables) =>
      fetcher<RemoveShare, RemoveShareVariables>(client, RemoveShareDocument, variables, headers)(),
    ...options,
  });
};

useRemoveShare.fetcher = (client: GraphQLClient, variables: RemoveShareVariables, headers?: RequestInit['headers']) =>
  fetcher<RemoveShare, RemoveShareVariables>(client, RemoveShareDocument, variables, headers);

export const AddOrEditShareDocument = `
    mutation addOrEditShare($model_ids: [ID!], $model_type: String!, $permission_type: String!, $userEmail: [String!]!) {
  shareItem(
    model_ids: $model_ids
    model_type: $model_type
    permission_type: $permission_type
    user: $userEmail
  ) {
    id
    email
    display_name
    permission_type
  }
}
    `;

export const useAddOrEditShare = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<AddOrEditShare, TError, AddOrEditShareVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<AddOrEditShare, TError, AddOrEditShareVariables, TContext>({
    mutationKey: ['addOrEditShare'],
    mutationFn: (variables?: AddOrEditShareVariables) =>
      fetcher<AddOrEditShare, AddOrEditShareVariables>(client, AddOrEditShareDocument, variables, headers)(),
    ...options,
  });
};

useAddOrEditShare.fetcher = (
  client: GraphQLClient,
  variables: AddOrEditShareVariables,
  headers?: RequestInit['headers'],
) => fetcher<AddOrEditShare, AddOrEditShareVariables>(client, AddOrEditShareDocument, variables, headers);

export const ResendShareInviteDocument = `
    mutation resendShareInvite($userEmail: String!, $id: ID!) {
  resendInvite(email: $userEmail, share: $id)
}
    `;

export const useResendShareInvite = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<ResendShareInvite, TError, ResendShareInviteVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<ResendShareInvite, TError, ResendShareInviteVariables, TContext>({
    mutationKey: ['resendShareInvite'],
    mutationFn: (variables?: ResendShareInviteVariables) =>
      fetcher<ResendShareInvite, ResendShareInviteVariables>(client, ResendShareInviteDocument, variables, headers)(),
    ...options,
  });
};

useResendShareInvite.fetcher = (
  client: GraphQLClient,
  variables: ResendShareInviteVariables,
  headers?: RequestInit['headers'],
) => fetcher<ResendShareInvite, ResendShareInviteVariables>(client, ResendShareInviteDocument, variables, headers);

export const GenerateCheckoutSessionDocument = `
    mutation generateCheckoutSession($planId: ID!, $quantity: Int!, $success_url: String, $returnUrl: String, $cancel_url: String, $ui_mode: ModeEnum!) {
  generateCheckoutSession(
    plan_id: $planId
    quantity: $quantity
    success_url: $success_url
    cancel_url: $cancel_url
    ui_mode: $ui_mode
    return_url: $returnUrl
  ) {
    id
    client_secret
  }
}
    `;

export const useGenerateCheckoutSession = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<GenerateCheckoutSession, TError, GenerateCheckoutSessionVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<GenerateCheckoutSession, TError, GenerateCheckoutSessionVariables, TContext>({
    mutationKey: ['generateCheckoutSession'],
    mutationFn: (variables?: GenerateCheckoutSessionVariables) =>
      fetcher<GenerateCheckoutSession, GenerateCheckoutSessionVariables>(
        client,
        GenerateCheckoutSessionDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useGenerateCheckoutSession.fetcher = (
  client: GraphQLClient,
  variables: GenerateCheckoutSessionVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GenerateCheckoutSession, GenerateCheckoutSessionVariables>(
    client,
    GenerateCheckoutSessionDocument,
    variables,
    headers,
  );

export const GetGeneratedPortalSessionDocument = `
    mutation getGeneratedPortalSession($returnUrl: String!) {
  generatePortalSession(return_url: $returnUrl)
}
    `;

export const useGetGeneratedPortalSession = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<GetGeneratedPortalSession, TError, GetGeneratedPortalSessionVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<GetGeneratedPortalSession, TError, GetGeneratedPortalSessionVariables, TContext>({
    mutationKey: ['getGeneratedPortalSession'],
    mutationFn: (variables?: GetGeneratedPortalSessionVariables) =>
      fetcher<GetGeneratedPortalSession, GetGeneratedPortalSessionVariables>(
        client,
        GetGeneratedPortalSessionDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useGetGeneratedPortalSession.fetcher = (
  client: GraphQLClient,
  variables: GetGeneratedPortalSessionVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetGeneratedPortalSession, GetGeneratedPortalSessionVariables>(
    client,
    GetGeneratedPortalSessionDocument,
    variables,
    headers,
  );

export const AssignLicenseToBoatsDocument = `
    mutation assignLicenseToBoats($plan_id: ID, $boat_details_ids: [ID!]!) {
  assignLicense(plan_id: $plan_id, boat_details_ids: $boat_details_ids) {
    id
    status
    name
  }
}
    `;

export const useAssignLicenseToBoats = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<AssignLicenseToBoats, TError, AssignLicenseToBoatsVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<AssignLicenseToBoats, TError, AssignLicenseToBoatsVariables, TContext>({
    mutationKey: ['assignLicenseToBoats'],
    mutationFn: (variables?: AssignLicenseToBoatsVariables) =>
      fetcher<AssignLicenseToBoats, AssignLicenseToBoatsVariables>(
        client,
        AssignLicenseToBoatsDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useAssignLicenseToBoats.fetcher = (
  client: GraphQLClient,
  variables: AssignLicenseToBoatsVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<AssignLicenseToBoats, AssignLicenseToBoatsVariables>(
    client,
    AssignLicenseToBoatsDocument,
    variables,
    headers,
  );

export const ChangePlanQuantityDocument = `
    mutation changePlanQuantity($plan_id: ID!, $quantity: Int!) {
  changeQuantity(plan_id: $plan_id, quantity: $quantity)
}
    `;

export const useChangePlanQuantity = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<ChangePlanQuantity, TError, ChangePlanQuantityVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<ChangePlanQuantity, TError, ChangePlanQuantityVariables, TContext>({
    mutationKey: ['changePlanQuantity'],
    mutationFn: (variables?: ChangePlanQuantityVariables) =>
      fetcher<ChangePlanQuantity, ChangePlanQuantityVariables>(
        client,
        ChangePlanQuantityDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useChangePlanQuantity.fetcher = (
  client: GraphQLClient,
  variables: ChangePlanQuantityVariables,
  headers?: RequestInit['headers'],
) => fetcher<ChangePlanQuantity, ChangePlanQuantityVariables>(client, ChangePlanQuantityDocument, variables, headers);

export const HardResetSubscriptionDocument = `
    mutation hardResetSubscription {
  resetSubscription
}
    `;

export const useHardResetSubscription = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<HardResetSubscription, TError, HardResetSubscriptionVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<HardResetSubscription, TError, HardResetSubscriptionVariables, TContext>({
    mutationKey: ['hardResetSubscription'],
    mutationFn: (variables?: HardResetSubscriptionVariables) =>
      fetcher<HardResetSubscription, HardResetSubscriptionVariables>(
        client,
        HardResetSubscriptionDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useHardResetSubscription.fetcher = (
  client: GraphQLClient,
  variables?: HardResetSubscriptionVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<HardResetSubscription, HardResetSubscriptionVariables>(
    client,
    HardResetSubscriptionDocument,
    variables,
    headers,
  );

export const HardResetTrialDocument = `
    mutation hardResetTrial {
  resetTrial
}
    `;

export const useHardResetTrial = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<HardResetTrial, TError, HardResetTrialVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<HardResetTrial, TError, HardResetTrialVariables, TContext>({
    mutationKey: ['hardResetTrial'],
    mutationFn: (variables?: HardResetTrialVariables) =>
      fetcher<HardResetTrial, HardResetTrialVariables>(client, HardResetTrialDocument, variables, headers)(),
    ...options,
  });
};

useHardResetTrial.fetcher = (
  client: GraphQLClient,
  variables?: HardResetTrialVariables,
  headers?: RequestInit['headers'],
) => fetcher<HardResetTrial, HardResetTrialVariables>(client, HardResetTrialDocument, variables, headers);

export const RemoveBoatLicenseDocument = `
    mutation removeBoatLicense($boat_details_id: ID!) {
  removeLicense(boat_details_id: $boat_details_id) {
    id
  }
}
    `;

export const useRemoveBoatLicense = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<RemoveBoatLicense, TError, RemoveBoatLicenseVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<RemoveBoatLicense, TError, RemoveBoatLicenseVariables, TContext>({
    mutationKey: ['removeBoatLicense'],
    mutationFn: (variables?: RemoveBoatLicenseVariables) =>
      fetcher<RemoveBoatLicense, RemoveBoatLicenseVariables>(client, RemoveBoatLicenseDocument, variables, headers)(),
    ...options,
  });
};

useRemoveBoatLicense.fetcher = (
  client: GraphQLClient,
  variables: RemoveBoatLicenseVariables,
  headers?: RequestInit['headers'],
) => fetcher<RemoveBoatLicense, RemoveBoatLicenseVariables>(client, RemoveBoatLicenseDocument, variables, headers);

export const CancelBoatSubscriptionDocument = `
    mutation cancelBoatSubscription($plan_id: ID!) {
  cancelSubscription(plan_id: $plan_id)
}
    `;

export const useCancelBoatSubscription = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<CancelBoatSubscription, TError, CancelBoatSubscriptionVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<CancelBoatSubscription, TError, CancelBoatSubscriptionVariables, TContext>({
    mutationKey: ['cancelBoatSubscription'],
    mutationFn: (variables?: CancelBoatSubscriptionVariables) =>
      fetcher<CancelBoatSubscription, CancelBoatSubscriptionVariables>(
        client,
        CancelBoatSubscriptionDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useCancelBoatSubscription.fetcher = (
  client: GraphQLClient,
  variables: CancelBoatSubscriptionVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<CancelBoatSubscription, CancelBoatSubscriptionVariables>(
    client,
    CancelBoatSubscriptionDocument,
    variables,
    headers,
  );

export const ResumeBoatSubscriptionDocument = `
    mutation resumeBoatSubscription($plan_id: ID!) {
  resumeSubscription(plan_id: $plan_id)
}
    `;

export const useResumeBoatSubscription = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<ResumeBoatSubscription, TError, ResumeBoatSubscriptionVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<ResumeBoatSubscription, TError, ResumeBoatSubscriptionVariables, TContext>({
    mutationKey: ['resumeBoatSubscription'],
    mutationFn: (variables?: ResumeBoatSubscriptionVariables) =>
      fetcher<ResumeBoatSubscription, ResumeBoatSubscriptionVariables>(
        client,
        ResumeBoatSubscriptionDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useResumeBoatSubscription.fetcher = (
  client: GraphQLClient,
  variables: ResumeBoatSubscriptionVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<ResumeBoatSubscription, ResumeBoatSubscriptionVariables>(
    client,
    ResumeBoatSubscriptionDocument,
    variables,
    headers,
  );

export const UpgradePlanMutationDocument = `
    mutation upgradePlanMutation($planId: ID!, $quantity: Int) {
  upgradePlan(plan_id: $planId, quantity: $quantity)
}
    `;

export const useUpgradePlanMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpgradePlanMutation, TError, UpgradePlanMutationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<UpgradePlanMutation, TError, UpgradePlanMutationVariables, TContext>({
    mutationKey: ['upgradePlanMutation'],
    mutationFn: (variables?: UpgradePlanMutationVariables) =>
      fetcher<UpgradePlanMutation, UpgradePlanMutationVariables>(
        client,
        UpgradePlanMutationDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useUpgradePlanMutation.fetcher = (
  client: GraphQLClient,
  variables: UpgradePlanMutationVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<UpgradePlanMutation, UpgradePlanMutationVariables>(client, UpgradePlanMutationDocument, variables, headers);

export const DowngradePlanMutationDocument = `
    mutation downgradePlanMutation($planId: ID!, $quantity: Int) {
  downgradePlan(plan_id: $planId, quantity: $quantity)
}
    `;

export const useDowngradePlanMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<DowngradePlanMutation, TError, DowngradePlanMutationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<DowngradePlanMutation, TError, DowngradePlanMutationVariables, TContext>({
    mutationKey: ['downgradePlanMutation'],
    mutationFn: (variables?: DowngradePlanMutationVariables) =>
      fetcher<DowngradePlanMutation, DowngradePlanMutationVariables>(
        client,
        DowngradePlanMutationDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useDowngradePlanMutation.fetcher = (
  client: GraphQLClient,
  variables: DowngradePlanMutationVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<DowngradePlanMutation, DowngradePlanMutationVariables>(
    client,
    DowngradePlanMutationDocument,
    variables,
    headers,
  );

export const RetrieveSessionDataDocument = `
    mutation retrieveSessionData($sessionId: String!) {
  retrieveSessionData(session_id: $sessionId) {
    plan_id
    plan_name
    renewal_date
    quantity
    price
    total_price
    status
  }
}
    `;

export const useRetrieveSessionData = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<RetrieveSessionData, TError, RetrieveSessionDataVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<RetrieveSessionData, TError, RetrieveSessionDataVariables, TContext>({
    mutationKey: ['retrieveSessionData'],
    mutationFn: (variables?: RetrieveSessionDataVariables) =>
      fetcher<RetrieveSessionData, RetrieveSessionDataVariables>(
        client,
        RetrieveSessionDataDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useRetrieveSessionData.fetcher = (
  client: GraphQLClient,
  variables: RetrieveSessionDataVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<RetrieveSessionData, RetrieveSessionDataVariables>(client, RetrieveSessionDataDocument, variables, headers);

export const CancelScheduledUpdateMutationDocument = `
    mutation cancelScheduledUpdateMutation {
  cancelScheduledUpdate
}
    `;

export const useCancelScheduledUpdateMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<CancelScheduledUpdateMutation, TError, CancelScheduledUpdateMutationVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<CancelScheduledUpdateMutation, TError, CancelScheduledUpdateMutationVariables, TContext>({
    mutationKey: ['cancelScheduledUpdateMutation'],
    mutationFn: (variables?: CancelScheduledUpdateMutationVariables) =>
      fetcher<CancelScheduledUpdateMutation, CancelScheduledUpdateMutationVariables>(
        client,
        CancelScheduledUpdateMutationDocument,
        variables,
        headers,
      )(),
    ...options,
  });
};

useCancelScheduledUpdateMutation.fetcher = (
  client: GraphQLClient,
  variables?: CancelScheduledUpdateMutationVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<CancelScheduledUpdateMutation, CancelScheduledUpdateMutationVariables>(
    client,
    CancelScheduledUpdateMutationDocument,
    variables,
    headers,
  );

export const AddTaskDocument = `
    mutation addTask($name: String!, $boat_detail_id: ID!, $taxonomy: Int, $category_id: ID, $type: String, $status: String, $is_recurring: Int, $frequency: String, $priority: Int, $assignee_ids: [String!], $files: [Int], $parent_id: Int, $notes: String, $due_date: String, $completed_at: String, $has_notification: Boolean, $time_unit: Int, $time_unit_type: String, $linked_expense_id: Int, $marked_as_maintenance: Boolean, $usage_is_custom: Boolean, $usage_time_unit_type: String, $usage_time_unit: Int, $usage_recurrence_time_unit: Int, $usage_recurrence_time_unit_type: String, $has_usage_reminder: Boolean, $recurrence_type: String, $usage_recurrence: Float, $threshold_recurrence_reminder: Float, $cost_type: String, $vat_percentage: Int, $amount: Float, $vat_type: String, $currency_id: ID, $quantity: Float, $supplier: String, $has_cost: Boolean) {
  storeTask(
    name: $name
    boat_detail_id: $boat_detail_id
    taxonomy: $taxonomy
    category_id: $category_id
    type: $type
    status: $status
    due_date: $due_date
    has_notification: $has_notification
    completed_at: $completed_at
    time_unit: $time_unit
    time_unit_type: $time_unit_type
    linked_expense_id: $linked_expense_id
    marked_as_maintenance: $marked_as_maintenance
    usage_is_custom: $usage_is_custom
    usage_time_unit_type: $usage_time_unit_type
    usage_time_unit: $usage_time_unit
    usage_recurrence_time_unit: $usage_recurrence_time_unit
    usage_recurrence_time_unit_type: $usage_recurrence_time_unit_type
    has_usage_reminder: $has_usage_reminder
    recurrence_type: $recurrence_type
    usage_recurrence: $usage_recurrence
    threshold_recurrence_reminder: $threshold_recurrence_reminder
    is_recurring: $is_recurring
    frequency: $frequency
    priority: $priority
    assignee_ids: $assignee_ids
    files: $files
    parent_id: $parent_id
    notes: $notes
    cost_type: $cost_type
    vat_percentage: $vat_percentage
    amount: $amount
    vat_type: $vat_type
    currency_id: $currency_id
    quantity: $quantity
    supplier: $supplier
    has_cost: $has_cost
  ) {
    ...taskFields
  }
}
    ${TaskFields}`;

export const useAddTask = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<AddTask, TError, AddTaskVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<AddTask, TError, AddTaskVariables, TContext>({
    mutationKey: ['addTask'],
    mutationFn: (variables?: AddTaskVariables) =>
      fetcher<AddTask, AddTaskVariables>(client, AddTaskDocument, variables, headers)(),
    ...options,
  });
};

useAddTask.fetcher = (client: GraphQLClient, variables: AddTaskVariables, headers?: RequestInit['headers']) =>
  fetcher<AddTask, AddTaskVariables>(client, AddTaskDocument, variables, headers);

export const EditTaskDocument = `
    mutation editTask($id: ID!, $name: String!, $taxonomy: Int, $category_id: ID, $type: String, $status: String, $is_recurring: Int, $frequency: String, $priority: Int, $assignee_ids: [String!], $files: [Int], $notes: String, $due_date: String, $completed_at: String, $has_notification: Boolean, $time_unit: Int, $time_unit_type: String, $linked_expense_id: Int, $marked_as_maintenance: Boolean, $usage_is_custom: Boolean, $usage_time_unit_type: String, $usage_time_unit: Int, $usage_recurrence_time_unit: Int, $usage_recurrence_time_unit_type: String, $has_usage_reminder: Boolean, $recurrence_type: String, $usage_recurrence: Float, $threshold_recurrence_reminder: Float, $cost_type: String, $vat_percentage: Int, $amount: Float, $vat_type: String, $currency_id: ID, $quantity: Float, $supplier: String, $has_cost: Boolean, $boat_detail_id: ID!) {
  updateTask(
    id: $id
    boat_detail_id: $boat_detail_id
    name: $name
    taxonomy: $taxonomy
    category_id: $category_id
    type: $type
    status: $status
    is_recurring: $is_recurring
    frequency: $frequency
    priority: $priority
    assignee_ids: $assignee_ids
    files: $files
    notes: $notes
    due_date: $due_date
    has_notification: $has_notification
    completed_at: $completed_at
    time_unit: $time_unit
    time_unit_type: $time_unit_type
    linked_expense_id: $linked_expense_id
    marked_as_maintenance: $marked_as_maintenance
    usage_is_custom: $usage_is_custom
    usage_time_unit_type: $usage_time_unit_type
    usage_time_unit: $usage_time_unit
    usage_recurrence_time_unit: $usage_recurrence_time_unit
    usage_recurrence_time_unit_type: $usage_recurrence_time_unit_type
    has_usage_reminder: $has_usage_reminder
    recurrence_type: $recurrence_type
    usage_recurrence: $usage_recurrence
    threshold_recurrence_reminder: $threshold_recurrence_reminder
    cost_type: $cost_type
    vat_percentage: $vat_percentage
    amount: $amount
    vat_type: $vat_type
    currency_id: $currency_id
    quantity: $quantity
    supplier: $supplier
    has_cost: $has_cost
  ) {
    ...taskFields
  }
}
    ${TaskFields}`;

export const useEditTask = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<EditTask, TError, EditTaskVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<EditTask, TError, EditTaskVariables, TContext>({
    mutationKey: ['editTask'],
    mutationFn: (variables?: EditTaskVariables) =>
      fetcher<EditTask, EditTaskVariables>(client, EditTaskDocument, variables, headers)(),
    ...options,
  });
};

useEditTask.fetcher = (client: GraphQLClient, variables: EditTaskVariables, headers?: RequestInit['headers']) =>
  fetcher<EditTask, EditTaskVariables>(client, EditTaskDocument, variables, headers);

export const DeleteTaskDocument = `
    mutation deleteTask($id: ID!) {
  deleteTask(id: $id)
}
    `;

export const useDeleteTask = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<DeleteTask, TError, DeleteTaskVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<DeleteTask, TError, DeleteTaskVariables, TContext>({
    mutationKey: ['deleteTask'],
    mutationFn: (variables?: DeleteTaskVariables) =>
      fetcher<DeleteTask, DeleteTaskVariables>(client, DeleteTaskDocument, variables, headers)(),
    ...options,
  });
};

useDeleteTask.fetcher = (client: GraphQLClient, variables: DeleteTaskVariables, headers?: RequestInit['headers']) =>
  fetcher<DeleteTask, DeleteTaskVariables>(client, DeleteTaskDocument, variables, headers);

export const CompleteTaskDocument = `
    mutation completeTask($id: ID!) {
  completeTask(id: $id)
}
    `;

export const useCompleteTask = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<CompleteTask, TError, CompleteTaskVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<CompleteTask, TError, CompleteTaskVariables, TContext>({
    mutationKey: ['completeTask'],
    mutationFn: (variables?: CompleteTaskVariables) =>
      fetcher<CompleteTask, CompleteTaskVariables>(client, CompleteTaskDocument, variables, headers)(),
    ...options,
  });
};

useCompleteTask.fetcher = (client: GraphQLClient, variables: CompleteTaskVariables, headers?: RequestInit['headers']) =>
  fetcher<CompleteTask, CompleteTaskVariables>(client, CompleteTaskDocument, variables, headers);

export const AddTripDocument = `
    mutation addTrip($name: String!, $boat_detail_id: ID!, $started_at: String!, $closed_at: String, $skipper_id: ID, $notes: String, $origin_latitude: Float!, $origin_longitude: Float!, $destination_latitude: Float, $destination_longitude: Float, $crewman_id: ID, $image_id: ID, $member_ids: [String]) {
  storeTrip(
    name: $name
    boat_detail_id: $boat_detail_id
    started_at: $started_at
    closed_at: $closed_at
    skipper_id: $skipper_id
    notes: $notes
    origin_latitude: $origin_latitude
    origin_longitude: $origin_longitude
    destination_latitude: $destination_latitude
    destination_longitude: $destination_longitude
    crewman_id: $crewman_id
    image_id: $image_id
    member_ids: $member_ids
  ) {
    ...TripFields
  }
}
    ${TripFields}`;

export const useAddTrip = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<AddTrip, TError, AddTripVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<AddTrip, TError, AddTripVariables, TContext>({
    mutationKey: ['addTrip'],
    mutationFn: (variables?: AddTripVariables) =>
      fetcher<AddTrip, AddTripVariables>(client, AddTripDocument, variables, headers)(),
    ...options,
  });
};

useAddTrip.fetcher = (client: GraphQLClient, variables: AddTripVariables, headers?: RequestInit['headers']) =>
  fetcher<AddTrip, AddTripVariables>(client, AddTripDocument, variables, headers);

export const EditTripDocument = `
    mutation editTrip($trip_id: ID!, $name: String!, $started_at: String!, $closed_at: String, $skipper_id: ID, $notes: String, $origin_latitude: Float!, $origin_longitude: Float!, $destination_latitude: Float, $destination_longitude: Float, $crewman_id: ID, $image_id: ID, $member_ids: [String]) {
  updateTrip(
    id: $trip_id
    name: $name
    started_at: $started_at
    closed_at: $closed_at
    skipper_id: $skipper_id
    notes: $notes
    origin_latitude: $origin_latitude
    origin_longitude: $origin_longitude
    destination_latitude: $destination_latitude
    destination_longitude: $destination_longitude
    crewman_id: $crewman_id
    image_id: $image_id
    member_ids: $member_ids
  ) {
    ...TripFields
  }
}
    ${TripFields}`;

export const useEditTrip = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<EditTrip, TError, EditTripVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<EditTrip, TError, EditTripVariables, TContext>({
    mutationKey: ['editTrip'],
    mutationFn: (variables?: EditTripVariables) =>
      fetcher<EditTrip, EditTripVariables>(client, EditTripDocument, variables, headers)(),
    ...options,
  });
};

useEditTrip.fetcher = (client: GraphQLClient, variables: EditTripVariables, headers?: RequestInit['headers']) =>
  fetcher<EditTrip, EditTripVariables>(client, EditTripDocument, variables, headers);

export const DeleteTripDocument = `
    mutation deleteTrip($tripId: ID!) {
  deleteTrip(id: $tripId)
}
    `;

export const useDeleteTrip = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<DeleteTrip, TError, DeleteTripVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<DeleteTrip, TError, DeleteTripVariables, TContext>({
    mutationKey: ['deleteTrip'],
    mutationFn: (variables?: DeleteTripVariables) =>
      fetcher<DeleteTrip, DeleteTripVariables>(client, DeleteTripDocument, variables, headers)(),
    ...options,
  });
};

useDeleteTrip.fetcher = (client: GraphQLClient, variables: DeleteTripVariables, headers?: RequestInit['headers']) =>
  fetcher<DeleteTrip, DeleteTripVariables>(client, DeleteTripDocument, variables, headers);

export const FinishTripDocument = `
    mutation finishTrip($tripId: ID!, $dateTime: String, $latitude: Float, $longitude: Float) {
  finishTrip(
    id: $tripId
    datetime: $dateTime
    latitude: $latitude
    longitude: $longitude
  )
}
    `;

export const useFinishTrip = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<FinishTrip, TError, FinishTripVariables, TContext>,
  headers?: RequestInit['headers'],
) => {
  return useMutation<FinishTrip, TError, FinishTripVariables, TContext>({
    mutationKey: ['finishTrip'],
    mutationFn: (variables?: FinishTripVariables) =>
      fetcher<FinishTrip, FinishTripVariables>(client, FinishTripDocument, variables, headers)(),
    ...options,
  });
};

useFinishTrip.fetcher = (client: GraphQLClient, variables: FinishTripVariables, headers?: RequestInit['headers']) =>
  fetcher<FinishTrip, FinishTripVariables>(client, FinishTripDocument, variables, headers);

export const GetActivityLogsDocument = `
    query getActivityLogs($page: Int, $first: Int) {
  activityLogs(page: $page, first: $first) {
    data {
      id
      log_name
      log_message
      description
      subject_id
      subject_type
      causer_id
      causer_type
      properties
      client_ip
      client_ips
      user_agent
      is_api
      boat_detail_id
      created_at
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

export const useGetActivityLogs = <TData = GetActivityLogs, TError = unknown>(
  client: GraphQLClient,
  variables?: GetActivityLogsVariables,
  options?: Omit<UseQueryOptions<GetActivityLogs, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetActivityLogs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetActivityLogs, TError, TData>({
    queryKey: variables === undefined ? ['getActivityLogs'] : ['getActivityLogs', variables],
    queryFn: fetcher<GetActivityLogs, GetActivityLogsVariables>(client, GetActivityLogsDocument, variables, headers),
    ...options,
  });
};

useGetActivityLogs.getKey = (variables?: GetActivityLogsVariables) =>
  variables === undefined ? ['getActivityLogs'] : ['getActivityLogs', variables];

export const useInfiniteGetActivityLogs = <TData = InfiniteData<GetActivityLogs>, TError = unknown>(
  client: GraphQLClient,
  variables: GetActivityLogsVariables,
  options: Omit<UseInfiniteQueryOptions<GetActivityLogs, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetActivityLogs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetActivityLogs, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getActivityLogs.infinite']
            : ['getActivityLogs.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetActivityLogs, GetActivityLogsVariables>(
            client,
            GetActivityLogsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetActivityLogs.getKey = (variables?: GetActivityLogsVariables) =>
  variables === undefined ? ['getActivityLogs.infinite'] : ['getActivityLogs.infinite', variables];

useGetActivityLogs.fetcher = (
  client: GraphQLClient,
  variables?: GetActivityLogsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetActivityLogs, GetActivityLogsVariables>(client, GetActivityLogsDocument, variables, headers);

export const GetAlertsDocument = `
    query getAlerts($keyword: String, $page: Int, $first: Int, $orderBy: [OrderByClause], $boat_detail_id: ID, $with_disabled: Boolean, $type: String, $filterByStatus: AlertFilter, $due_date_range: [String]) {
  alerts(
    keyword: $keyword
    page: $page
    first: $first
    orderBy: $orderBy
    boat_detail_id: $boat_detail_id
    with_disabled: $with_disabled
    type: $type
    filterByStatus: $filterByStatus
    due_date_range: $due_date_range
  ) {
    data {
      ...AlertsListItem
    }
    paginatorInfo {
      ...DefaultPagination
    }
  }
}
    ${AlertsListItem}
${DefaultPagination}`;

export const useGetAlerts = <TData = GetAlerts, TError = unknown>(
  client: GraphQLClient,
  variables?: GetAlertsVariables,
  options?: Omit<UseQueryOptions<GetAlerts, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetAlerts, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetAlerts, TError, TData>({
    queryKey: variables === undefined ? ['getAlerts'] : ['getAlerts', variables],
    queryFn: fetcher<GetAlerts, GetAlertsVariables>(client, GetAlertsDocument, variables, headers),
    ...options,
  });
};

useGetAlerts.getKey = (variables?: GetAlertsVariables) =>
  variables === undefined ? ['getAlerts'] : ['getAlerts', variables];

export const useInfiniteGetAlerts = <TData = InfiniteData<GetAlerts>, TError = unknown>(
  client: GraphQLClient,
  variables: GetAlertsVariables,
  options: Omit<UseInfiniteQueryOptions<GetAlerts, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetAlerts, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetAlerts, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined) ? ['getAlerts.infinite'] : ['getAlerts.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetAlerts, GetAlertsVariables>(
            client,
            GetAlertsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetAlerts.getKey = (variables?: GetAlertsVariables) =>
  variables === undefined ? ['getAlerts.infinite'] : ['getAlerts.infinite', variables];

useGetAlerts.fetcher = (client: GraphQLClient, variables?: GetAlertsVariables, headers?: RequestInit['headers']) =>
  fetcher<GetAlerts, GetAlertsVariables>(client, GetAlertsDocument, variables, headers);

export const GetInfiniteAlertsDocument = `
    query getInfiniteAlerts($keyword: String, $page: Int, $first: Int, $orderBy: [OrderByClause], $boat_detail_id: ID, $with_disabled: Boolean) {
  alerts(
    keyword: $keyword
    page: $page
    first: $first
    orderBy: $orderBy
    boat_detail_id: $boat_detail_id
    with_disabled: $with_disabled
  ) {
    data {
      id
      title
      boat_detail_id
      boat_detail {
        id
        name
        flag
      }
      alertable_type
      alertable_id
      created_at
      active
      priority
      date
      can_share
      threshold
      quantity
      category
      user {
        id
        name
        surname
        display_name
        email
      }
    }
    paginatorInfo {
      count
      firstItem
      lastItem
      currentPage
      perPage
      total
      hasMorePages
    }
  }
}
    `;

export const useGetInfiniteAlerts = <TData = GetInfiniteAlerts, TError = unknown>(
  client: GraphQLClient,
  variables?: GetInfiniteAlertsVariables,
  options?: Omit<UseQueryOptions<GetInfiniteAlerts, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetInfiniteAlerts, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetInfiniteAlerts, TError, TData>({
    queryKey: variables === undefined ? ['getInfiniteAlerts'] : ['getInfiniteAlerts', variables],
    queryFn: fetcher<GetInfiniteAlerts, GetInfiniteAlertsVariables>(
      client,
      GetInfiniteAlertsDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetInfiniteAlerts.getKey = (variables?: GetInfiniteAlertsVariables) =>
  variables === undefined ? ['getInfiniteAlerts'] : ['getInfiniteAlerts', variables];

export const useInfiniteGetInfiniteAlerts = <TData = InfiniteData<GetInfiniteAlerts>, TError = unknown>(
  client: GraphQLClient,
  variables: GetInfiniteAlertsVariables,
  options: Omit<UseInfiniteQueryOptions<GetInfiniteAlerts, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetInfiniteAlerts, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetInfiniteAlerts, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getInfiniteAlerts.infinite']
            : ['getInfiniteAlerts.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetInfiniteAlerts, GetInfiniteAlertsVariables>(
            client,
            GetInfiniteAlertsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetInfiniteAlerts.getKey = (variables?: GetInfiniteAlertsVariables) =>
  variables === undefined ? ['getInfiniteAlerts.infinite'] : ['getInfiniteAlerts.infinite', variables];

useGetInfiniteAlerts.fetcher = (
  client: GraphQLClient,
  variables?: GetInfiniteAlertsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetInfiniteAlerts, GetInfiniteAlertsVariables>(client, GetInfiniteAlertsDocument, variables, headers);

export const GetAlertDocument = `
    query getAlert($id: ID!) {
  alert(id: $id) {
    id
    title
    active
    date
    priority
    alertable_type
    alertable_id
    boat_detail_id
    threshold
    quantity
    category
    boat_detail {
      id
      name
      flag
    }
    user {
      id
      name
      surname
      display_name
      email
    }
  }
}
    `;

export const useGetAlert = <TData = GetAlert, TError = unknown>(
  client: GraphQLClient,
  variables: GetAlertVariables,
  options?: Omit<UseQueryOptions<GetAlert, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetAlert, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetAlert, TError, TData>({
    queryKey: ['getAlert', variables],
    queryFn: fetcher<GetAlert, GetAlertVariables>(client, GetAlertDocument, variables, headers),
    ...options,
  });
};

useGetAlert.getKey = (variables: GetAlertVariables) => ['getAlert', variables];

export const useInfiniteGetAlert = <TData = InfiniteData<GetAlert>, TError = unknown>(
  client: GraphQLClient,
  variables: GetAlertVariables,
  options: Omit<UseInfiniteQueryOptions<GetAlert, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetAlert, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetAlert, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getAlert.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetAlert, GetAlertVariables>(
            client,
            GetAlertDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetAlert.getKey = (variables: GetAlertVariables) => ['getAlert.infinite', variables];

useGetAlert.fetcher = (client: GraphQLClient, variables: GetAlertVariables, headers?: RequestInit['headers']) =>
  fetcher<GetAlert, GetAlertVariables>(client, GetAlertDocument, variables, headers);

export const AlertQueryDocument = `
    query alertQuery($id: ID!) {
  alert(id: $id) {
    ...AlertDetailsFragment
  }
}
    ${AlertDetailsFragment}`;

export const useAlertQuery = <TData = AlertQuery, TError = unknown>(
  client: GraphQLClient,
  variables: AlertQueryVariables,
  options?: Omit<UseQueryOptions<AlertQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<AlertQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<AlertQuery, TError, TData>({
    queryKey: ['alertQuery', variables],
    queryFn: fetcher<AlertQuery, AlertQueryVariables>(client, AlertQueryDocument, variables, headers),
    ...options,
  });
};

useAlertQuery.getKey = (variables: AlertQueryVariables) => ['alertQuery', variables];

export const useInfiniteAlertQuery = <TData = InfiniteData<AlertQuery>, TError = unknown>(
  client: GraphQLClient,
  variables: AlertQueryVariables,
  options: Omit<UseInfiniteQueryOptions<AlertQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<AlertQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<AlertQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['alertQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<AlertQuery, AlertQueryVariables>(
            client,
            AlertQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteAlertQuery.getKey = (variables: AlertQueryVariables) => ['alertQuery.infinite', variables];

useAlertQuery.fetcher = (client: GraphQLClient, variables: AlertQueryVariables, headers?: RequestInit['headers']) =>
  fetcher<AlertQuery, AlertQueryVariables>(client, AlertQueryDocument, variables, headers);

export const GetBoatDetailsDocument = `
    query getBoatDetails($id: ID!) {
  boatDetail(id: $id) {
    id
    user_id
    boat_id
    strapi_ref_document_id
    name
    description
    flag
    acquisition_date
    acquisition_type
    year
    nr_past_owners
    ownership_order
    mmsi
    is_vat_paid
    currency
    price
    price_formated
    location
    service_loads
    engine_battery_voltage
    engine_battery_capacity
    service_battery_voltage
    service_battery_capacity
    battery_power
    inverter_power
    solar_power
    wind_power
    dg_power
    tender_name
    tender_vendor
    tender_model
    tender_length
    status
    hull_sn
    callsign
    epirb
    in_reach_tracker_id
    spot_tracker_id
    satellite_phone
    mobile_phone
    image {
      ...RequiredFileFields
      user_id
    }
    user {
      id
      name
      surname
      display_name
    }
    engines {
      id
      maker
      website
      model
      type
      drive
      fuel
      power
      power_type
    }
    files {
      ...RequiredFileFields
    }
    boat {
      id
      user_id
      image {
        ...RequiredFileFields
        user_id
      }
      files {
        ...RequiredFileFields
      }
      unit
      categories {
        name
        id
      }
      activities {
        id
        name
      }
      manufacturer {
        id
        name
        website
      }
      model
      hull_appendages {
        name
        value
      }
      mainsail {
        name
        value
      }
      headsail {
        name
        value
      }
      spinnaker {
        name
        value
      }
      fuel_tank {
        capacity
      }
      water_tank {
        capacity
      }
      holding_tank {
        capacity
      }
      water_heater {
        capacity
      }
      year_first
      year_last
      version
      reference_price
      currency
      reference_price_formated
      price_html
      is_favorited
      slug
      description
      meta_title
      meta_description
      og_title
      og_description
      og_image
      og_url
      type
      hull_type
      hull_material
      keel_type
      cabins
      berths
      heads
      top_speed
      cruising_speed
      mast
      loa
      lwl
      boa
      bcl
      bh
      headroom
      bdcl
      nom
      draft_max
      draft_min
      displacement
      tonnage_gross
      tonnage_net
      ballast_type
      ballast_weight
      helm
      rudder
      cockpit_type
      cockpit_location
      unsinkable
      trailerable
      ce_classification
      designer_name
      designer_site
      exterior_design
      exterior_site
      interior_design
      interior_site
      rigging
      rotating_spars
      mast_configuration
      mast
      spars
      standing_rigging
      spreaders_level
      spreaders_angle
      upwind_sail_area
      downwind_sail_area
      sail_area_displacement
      upwind_sail_area_displacement
      downwind_sail_area_displacement
      ballast_length
      ballast_displacement
      csf
      sspd
      ksi
      displacement_hull_speed
      displacement_length
      favorites_count
      mainsail {
        name
        value
      }
      status
      is_featured
      can_update
      can_delete
      approved_at
      created_at
      updated_at
    }
    fields {
      ...FieldsListFragment
    }
    plan {
      id
      name
      status
      available
      gateway_id
      slug
    }
    can_share
    can_update
    can_delete
    created_at
    updated_at
    subscription_id
    status
  }
}
    ${RequiredFileFields}
${FieldsListFragment}`;

export const useGetBoatDetails = <TData = GetBoatDetails, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatDetailsVariables,
  options?: Omit<UseQueryOptions<GetBoatDetails, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetBoatDetails, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetBoatDetails, TError, TData>({
    queryKey: ['getBoatDetails', variables],
    queryFn: fetcher<GetBoatDetails, GetBoatDetailsVariables>(client, GetBoatDetailsDocument, variables, headers),
    ...options,
  });
};

useGetBoatDetails.getKey = (variables: GetBoatDetailsVariables) => ['getBoatDetails', variables];

export const useInfiniteGetBoatDetails = <TData = InfiniteData<GetBoatDetails>, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatDetailsVariables,
  options: Omit<UseInfiniteQueryOptions<GetBoatDetails, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetBoatDetails, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetBoatDetails, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getBoatDetails.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetBoatDetails, GetBoatDetailsVariables>(
            client,
            GetBoatDetailsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetBoatDetails.getKey = (variables: GetBoatDetailsVariables) => ['getBoatDetails.infinite', variables];

useGetBoatDetails.fetcher = (
  client: GraphQLClient,
  variables: GetBoatDetailsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetBoatDetails, GetBoatDetailsVariables>(client, GetBoatDetailsDocument, variables, headers);

export const GetCategoriesDocument = `
    query getCategories($keyword: String, $type: String, $orderBy: [OrderByClause], $filter: Filter, $first: Int = 15, $page: Int) {
  categories(
    keyword: $keyword
    type: $type
    orderBy: $orderBy
    filter: $filter
    first: $first
    page: $page
  ) {
    data {
      id
      user_id
      name
      name
      is_user_defined
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

export const useGetCategories = <TData = GetCategories, TError = unknown>(
  client: GraphQLClient,
  variables?: GetCategoriesVariables,
  options?: Omit<UseQueryOptions<GetCategories, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetCategories, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetCategories, TError, TData>({
    queryKey: variables === undefined ? ['getCategories'] : ['getCategories', variables],
    queryFn: fetcher<GetCategories, GetCategoriesVariables>(client, GetCategoriesDocument, variables, headers),
    ...options,
  });
};

useGetCategories.getKey = (variables?: GetCategoriesVariables) =>
  variables === undefined ? ['getCategories'] : ['getCategories', variables];

export const useInfiniteGetCategories = <TData = InfiniteData<GetCategories>, TError = unknown>(
  client: GraphQLClient,
  variables: GetCategoriesVariables,
  options: Omit<UseInfiniteQueryOptions<GetCategories, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetCategories, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetCategories, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getCategories.infinite']
            : ['getCategories.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetCategories, GetCategoriesVariables>(
            client,
            GetCategoriesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetCategories.getKey = (variables?: GetCategoriesVariables) =>
  variables === undefined ? ['getCategories.infinite'] : ['getCategories.infinite', variables];

useGetCategories.fetcher = (
  client: GraphQLClient,
  variables?: GetCategoriesVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetCategories, GetCategoriesVariables>(client, GetCategoriesDocument, variables, headers);

export const GetPublicChecklistDocument = `
    query getPublicChecklist($page: Int, $keyword: String, $first: Int = 15) {
  publicChecklists(page: $page, keyword: $keyword, first: $first) {
    data {
      ...ChecklistFragment
    }
    paginatorInfo {
      firstItem
      lastItem
      currentPage
      hasMorePages
      count
      perPage
      total
    }
  }
}
    ${ChecklistFragment}`;

export const useGetPublicChecklist = <TData = GetPublicChecklist, TError = unknown>(
  client: GraphQLClient,
  variables?: GetPublicChecklistVariables,
  options?: Omit<UseQueryOptions<GetPublicChecklist, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPublicChecklist, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetPublicChecklist, TError, TData>({
    queryKey: variables === undefined ? ['getPublicChecklist'] : ['getPublicChecklist', variables],
    queryFn: fetcher<GetPublicChecklist, GetPublicChecklistVariables>(
      client,
      GetPublicChecklistDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetPublicChecklist.getKey = (variables?: GetPublicChecklistVariables) =>
  variables === undefined ? ['getPublicChecklist'] : ['getPublicChecklist', variables];

export const useInfiniteGetPublicChecklist = <TData = InfiniteData<GetPublicChecklist>, TError = unknown>(
  client: GraphQLClient,
  variables: GetPublicChecklistVariables,
  options: Omit<UseInfiniteQueryOptions<GetPublicChecklist, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetPublicChecklist, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetPublicChecklist, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getPublicChecklist.infinite']
            : ['getPublicChecklist.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetPublicChecklist, GetPublicChecklistVariables>(
            client,
            GetPublicChecklistDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetPublicChecklist.getKey = (variables?: GetPublicChecklistVariables) =>
  variables === undefined ? ['getPublicChecklist.infinite'] : ['getPublicChecklist.infinite', variables];

useGetPublicChecklist.fetcher = (
  client: GraphQLClient,
  variables?: GetPublicChecklistVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetPublicChecklist, GetPublicChecklistVariables>(client, GetPublicChecklistDocument, variables, headers);

export const GetMyChecklistsDocument = `
    query getMyChecklists($page: Int, $keyword: String, $first: Int = 15, $orderBy: [OrderByClause]) {
  myChecklists(page: $page, keyword: $keyword, first: $first, orderBy: $orderBy) {
    data {
      ...ChecklistFragment
    }
    paginatorInfo {
      firstItem
      lastItem
      currentPage
      hasMorePages
      count
      perPage
      total
    }
  }
}
    ${ChecklistFragment}`;

export const useGetMyChecklists = <TData = GetMyChecklists, TError = unknown>(
  client: GraphQLClient,
  variables?: GetMyChecklistsVariables,
  options?: Omit<UseQueryOptions<GetMyChecklists, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetMyChecklists, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetMyChecklists, TError, TData>({
    queryKey: variables === undefined ? ['getMyChecklists'] : ['getMyChecklists', variables],
    queryFn: fetcher<GetMyChecklists, GetMyChecklistsVariables>(client, GetMyChecklistsDocument, variables, headers),
    ...options,
  });
};

useGetMyChecklists.getKey = (variables?: GetMyChecklistsVariables) =>
  variables === undefined ? ['getMyChecklists'] : ['getMyChecklists', variables];

export const useInfiniteGetMyChecklists = <TData = InfiniteData<GetMyChecklists>, TError = unknown>(
  client: GraphQLClient,
  variables: GetMyChecklistsVariables,
  options: Omit<UseInfiniteQueryOptions<GetMyChecklists, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetMyChecklists, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetMyChecklists, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getMyChecklists.infinite']
            : ['getMyChecklists.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetMyChecklists, GetMyChecklistsVariables>(
            client,
            GetMyChecklistsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetMyChecklists.getKey = (variables?: GetMyChecklistsVariables) =>
  variables === undefined ? ['getMyChecklists.infinite'] : ['getMyChecklists.infinite', variables];

useGetMyChecklists.fetcher = (
  client: GraphQLClient,
  variables?: GetMyChecklistsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetMyChecklists, GetMyChecklistsVariables>(client, GetMyChecklistsDocument, variables, headers);

export const GetChecklistDocument = `
    query getChecklist($id: ID) {
  checklist(id: $id) {
    ...ChecklistFragment
  }
}
    ${ChecklistFragment}`;

export const useGetChecklist = <TData = GetChecklist, TError = unknown>(
  client: GraphQLClient,
  variables?: GetChecklistVariables,
  options?: Omit<UseQueryOptions<GetChecklist, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetChecklist, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetChecklist, TError, TData>({
    queryKey: variables === undefined ? ['getChecklist'] : ['getChecklist', variables],
    queryFn: fetcher<GetChecklist, GetChecklistVariables>(client, GetChecklistDocument, variables, headers),
    ...options,
  });
};

useGetChecklist.getKey = (variables?: GetChecklistVariables) =>
  variables === undefined ? ['getChecklist'] : ['getChecklist', variables];

export const useInfiniteGetChecklist = <TData = InfiniteData<GetChecklist>, TError = unknown>(
  client: GraphQLClient,
  variables: GetChecklistVariables,
  options: Omit<UseInfiniteQueryOptions<GetChecklist, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetChecklist, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetChecklist, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getChecklist.infinite']
            : ['getChecklist.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetChecklist, GetChecklistVariables>(
            client,
            GetChecklistDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetChecklist.getKey = (variables?: GetChecklistVariables) =>
  variables === undefined ? ['getChecklist.infinite'] : ['getChecklist.infinite', variables];

useGetChecklist.fetcher = (
  client: GraphQLClient,
  variables?: GetChecklistVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetChecklist, GetChecklistVariables>(client, GetChecklistDocument, variables, headers);

export const GetChecklistCommentsDocument = `
    query getChecklistComments($id: ID!) {
  checklistComments(checklist_id: $id) {
    data {
      id
      text
      updated_at_diff
      user {
        id
        name
        surname
        display_name
        image {
          id
          public_url
        }
      }
    }
    paginatorInfo {
      currentPage
      count
      perPage
      total
    }
  }
}
    `;

export const useGetChecklistComments = <TData = GetChecklistComments, TError = unknown>(
  client: GraphQLClient,
  variables: GetChecklistCommentsVariables,
  options?: Omit<UseQueryOptions<GetChecklistComments, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetChecklistComments, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetChecklistComments, TError, TData>({
    queryKey: ['getChecklistComments', variables],
    queryFn: fetcher<GetChecklistComments, GetChecklistCommentsVariables>(
      client,
      GetChecklistCommentsDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetChecklistComments.getKey = (variables: GetChecklistCommentsVariables) => ['getChecklistComments', variables];

export const useInfiniteGetChecklistComments = <TData = InfiniteData<GetChecklistComments>, TError = unknown>(
  client: GraphQLClient,
  variables: GetChecklistCommentsVariables,
  options: Omit<UseInfiniteQueryOptions<GetChecklistComments, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetChecklistComments, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetChecklistComments, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getChecklistComments.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetChecklistComments, GetChecklistCommentsVariables>(
            client,
            GetChecklistCommentsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetChecklistComments.getKey = (variables: GetChecklistCommentsVariables) => [
  'getChecklistComments.infinite',
  variables,
];

useGetChecklistComments.fetcher = (
  client: GraphQLClient,
  variables: GetChecklistCommentsVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetChecklistComments, GetChecklistCommentsVariables>(
    client,
    GetChecklistCommentsDocument,
    variables,
    headers,
  );

export const GetChecklistFollowersDocument = `
    query getChecklistFollowers($id: ID!) {
  checklistFollowers(checklist_id: $id) {
    data {
      id
      code
      display_name
      email
      gender
      image_url
    }
    paginatorInfo {
      currentPage
      count
      perPage
      total
    }
  }
}
    `;

export const useGetChecklistFollowers = <TData = GetChecklistFollowers, TError = unknown>(
  client: GraphQLClient,
  variables: GetChecklistFollowersVariables,
  options?: Omit<UseQueryOptions<GetChecklistFollowers, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetChecklistFollowers, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetChecklistFollowers, TError, TData>({
    queryKey: ['getChecklistFollowers', variables],
    queryFn: fetcher<GetChecklistFollowers, GetChecklistFollowersVariables>(
      client,
      GetChecklistFollowersDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetChecklistFollowers.getKey = (variables: GetChecklistFollowersVariables) => ['getChecklistFollowers', variables];

export const useInfiniteGetChecklistFollowers = <TData = InfiniteData<GetChecklistFollowers>, TError = unknown>(
  client: GraphQLClient,
  variables: GetChecklistFollowersVariables,
  options: Omit<UseInfiniteQueryOptions<GetChecklistFollowers, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetChecklistFollowers, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetChecklistFollowers, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getChecklistFollowers.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetChecklistFollowers, GetChecklistFollowersVariables>(
            client,
            GetChecklistFollowersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetChecklistFollowers.getKey = (variables: GetChecklistFollowersVariables) => [
  'getChecklistFollowers.infinite',
  variables,
];

useGetChecklistFollowers.fetcher = (
  client: GraphQLClient,
  variables: GetChecklistFollowersVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetChecklistFollowers, GetChecklistFollowersVariables>(
    client,
    GetChecklistFollowersDocument,
    variables,
    headers,
  );

export const ChecklistBlockedFollowersQueryDocument = `
    query checklistBlockedFollowersQuery($id: ID!) {
  checklistBlockedFollowers(checklist_id: $id) {
    data {
      id
      display_name
      image_url
    }
    paginatorInfo {
      currentPage
      count
      perPage
      total
    }
  }
}
    `;

export const useChecklistBlockedFollowersQuery = <TData = ChecklistBlockedFollowersQuery, TError = unknown>(
  client: GraphQLClient,
  variables: ChecklistBlockedFollowersQueryVariables,
  options?: Omit<UseQueryOptions<ChecklistBlockedFollowersQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ChecklistBlockedFollowersQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<ChecklistBlockedFollowersQuery, TError, TData>({
    queryKey: ['checklistBlockedFollowersQuery', variables],
    queryFn: fetcher<ChecklistBlockedFollowersQuery, ChecklistBlockedFollowersQueryVariables>(
      client,
      ChecklistBlockedFollowersQueryDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useChecklistBlockedFollowersQuery.getKey = (variables: ChecklistBlockedFollowersQueryVariables) => [
  'checklistBlockedFollowersQuery',
  variables,
];

export const useInfiniteChecklistBlockedFollowersQuery = <
  TData = InfiniteData<ChecklistBlockedFollowersQuery>,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: ChecklistBlockedFollowersQueryVariables,
  options: Omit<UseInfiniteQueryOptions<ChecklistBlockedFollowersQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<ChecklistBlockedFollowersQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<ChecklistBlockedFollowersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['checklistBlockedFollowersQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<ChecklistBlockedFollowersQuery, ChecklistBlockedFollowersQueryVariables>(
            client,
            ChecklistBlockedFollowersQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteChecklistBlockedFollowersQuery.getKey = (variables: ChecklistBlockedFollowersQueryVariables) => [
  'checklistBlockedFollowersQuery.infinite',
  variables,
];

useChecklistBlockedFollowersQuery.fetcher = (
  client: GraphQLClient,
  variables: ChecklistBlockedFollowersQueryVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<ChecklistBlockedFollowersQuery, ChecklistBlockedFollowersQueryVariables>(
    client,
    ChecklistBlockedFollowersQueryDocument,
    variables,
    headers,
  );

export const GetPublishableChecklistsDocument = `
    query getPublishableChecklists($keyword: String, $first: Int = 15, $page: Int) {
  publishableChecklists(keyword: $keyword, first: $first, page: $page) {
    data {
      ...PublishableChecklistFragment
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    ${PublishableChecklistFragment}`;

export const useGetPublishableChecklists = <TData = GetPublishableChecklists, TError = unknown>(
  client: GraphQLClient,
  variables?: GetPublishableChecklistsVariables,
  options?: Omit<UseQueryOptions<GetPublishableChecklists, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPublishableChecklists, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetPublishableChecklists, TError, TData>({
    queryKey: variables === undefined ? ['getPublishableChecklists'] : ['getPublishableChecklists', variables],
    queryFn: fetcher<GetPublishableChecklists, GetPublishableChecklistsVariables>(
      client,
      GetPublishableChecklistsDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetPublishableChecklists.getKey = (variables?: GetPublishableChecklistsVariables) =>
  variables === undefined ? ['getPublishableChecklists'] : ['getPublishableChecklists', variables];

export const useInfiniteGetPublishableChecklists = <TData = InfiniteData<GetPublishableChecklists>, TError = unknown>(
  client: GraphQLClient,
  variables: GetPublishableChecklistsVariables,
  options: Omit<UseInfiniteQueryOptions<GetPublishableChecklists, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetPublishableChecklists, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetPublishableChecklists, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getPublishableChecklists.infinite']
            : ['getPublishableChecklists.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetPublishableChecklists, GetPublishableChecklistsVariables>(
            client,
            GetPublishableChecklistsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetPublishableChecklists.getKey = (variables?: GetPublishableChecklistsVariables) =>
  variables === undefined ? ['getPublishableChecklists.infinite'] : ['getPublishableChecklists.infinite', variables];

useGetPublishableChecklists.fetcher = (
  client: GraphQLClient,
  variables?: GetPublishableChecklistsVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetPublishableChecklists, GetPublishableChecklistsVariables>(
    client,
    GetPublishableChecklistsDocument,
    variables,
    headers,
  );

export const GetPublishableChecklistDocument = `
    query getPublishableChecklist($id: ID!) {
  publishableChecklist(id: $id) {
    ...PublishableChecklistFragment
  }
}
    ${PublishableChecklistFragment}`;

export const useGetPublishableChecklist = <TData = GetPublishableChecklist, TError = unknown>(
  client: GraphQLClient,
  variables: GetPublishableChecklistVariables,
  options?: Omit<UseQueryOptions<GetPublishableChecklist, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPublishableChecklist, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetPublishableChecklist, TError, TData>({
    queryKey: ['getPublishableChecklist', variables],
    queryFn: fetcher<GetPublishableChecklist, GetPublishableChecklistVariables>(
      client,
      GetPublishableChecklistDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetPublishableChecklist.getKey = (variables: GetPublishableChecklistVariables) => [
  'getPublishableChecklist',
  variables,
];

export const useInfiniteGetPublishableChecklist = <TData = InfiniteData<GetPublishableChecklist>, TError = unknown>(
  client: GraphQLClient,
  variables: GetPublishableChecklistVariables,
  options: Omit<UseInfiniteQueryOptions<GetPublishableChecklist, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetPublishableChecklist, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetPublishableChecklist, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getPublishableChecklist.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetPublishableChecklist, GetPublishableChecklistVariables>(
            client,
            GetPublishableChecklistDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetPublishableChecklist.getKey = (variables: GetPublishableChecklistVariables) => [
  'getPublishableChecklist.infinite',
  variables,
];

useGetPublishableChecklist.fetcher = (
  client: GraphQLClient,
  variables: GetPublishableChecklistVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetPublishableChecklist, GetPublishableChecklistVariables>(
    client,
    GetPublishableChecklistDocument,
    variables,
    headers,
  );

export const GetCollectionInfoDocument = `
    query getCollectionInfo {
  info {
    categories {
      id
      parent_id
      image_id
      slug
      name
      description
      type
      is_displayed
      publicBoatCount
    }
    activities {
      id
      parent_id
      image_id
      slug
      name
      description
      type
      is_displayed
    }
    type
    hull_type
    hull_material
  }
}
    `;

export const useGetCollectionInfo = <TData = GetCollectionInfo, TError = unknown>(
  client: GraphQLClient,
  variables?: GetCollectionInfoVariables,
  options?: Omit<UseQueryOptions<GetCollectionInfo, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetCollectionInfo, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetCollectionInfo, TError, TData>({
    queryKey: variables === undefined ? ['getCollectionInfo'] : ['getCollectionInfo', variables],
    queryFn: fetcher<GetCollectionInfo, GetCollectionInfoVariables>(
      client,
      GetCollectionInfoDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetCollectionInfo.getKey = (variables?: GetCollectionInfoVariables) =>
  variables === undefined ? ['getCollectionInfo'] : ['getCollectionInfo', variables];

export const useInfiniteGetCollectionInfo = <TData = InfiniteData<GetCollectionInfo>, TError = unknown>(
  client: GraphQLClient,
  variables: GetCollectionInfoVariables,
  options: Omit<UseInfiniteQueryOptions<GetCollectionInfo, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetCollectionInfo, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetCollectionInfo, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getCollectionInfo.infinite']
            : ['getCollectionInfo.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetCollectionInfo, GetCollectionInfoVariables>(
            client,
            GetCollectionInfoDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetCollectionInfo.getKey = (variables?: GetCollectionInfoVariables) =>
  variables === undefined ? ['getCollectionInfo.infinite'] : ['getCollectionInfo.infinite', variables];

useGetCollectionInfo.fetcher = (
  client: GraphQLClient,
  variables?: GetCollectionInfoVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetCollectionInfo, GetCollectionInfoVariables>(client, GetCollectionInfoDocument, variables, headers);

export const GetFormInfoDocument = `
    query getFormInfo {
  info {
    categories {
      id
      name
    }
    activities {
      id
      name
    }
  }
}
    `;

export const useGetFormInfo = <TData = GetFormInfo, TError = unknown>(
  client: GraphQLClient,
  variables?: GetFormInfoVariables,
  options?: Omit<UseQueryOptions<GetFormInfo, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetFormInfo, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetFormInfo, TError, TData>({
    queryKey: variables === undefined ? ['getFormInfo'] : ['getFormInfo', variables],
    queryFn: fetcher<GetFormInfo, GetFormInfoVariables>(client, GetFormInfoDocument, variables, headers),
    ...options,
  });
};

useGetFormInfo.getKey = (variables?: GetFormInfoVariables) =>
  variables === undefined ? ['getFormInfo'] : ['getFormInfo', variables];

export const useInfiniteGetFormInfo = <TData = InfiniteData<GetFormInfo>, TError = unknown>(
  client: GraphQLClient,
  variables: GetFormInfoVariables,
  options: Omit<UseInfiniteQueryOptions<GetFormInfo, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetFormInfo, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetFormInfo, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined) ? ['getFormInfo.infinite'] : ['getFormInfo.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetFormInfo, GetFormInfoVariables>(
            client,
            GetFormInfoDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetFormInfo.getKey = (variables?: GetFormInfoVariables) =>
  variables === undefined ? ['getFormInfo.infinite'] : ['getFormInfo.infinite', variables];

useGetFormInfo.fetcher = (client: GraphQLClient, variables?: GetFormInfoVariables, headers?: RequestInit['headers']) =>
  fetcher<GetFormInfo, GetFormInfoVariables>(client, GetFormInfoDocument, variables, headers);

export const GetCommentsDocument = `
    query getComments($id: ID!, $commentable_type: String!, $orderBy: [OrderByClause], $perPage: Int, $page: Int) {
  viewComments(
    commentable_id: $id
    commentable_type: $commentable_type
    orderBy: $orderBy
    first: $perPage
    page: $page
  ) {
    data {
      ...CommentFragment
    }
    paginatorInfo {
      currentPage
      hasMorePages
      count
    }
  }
}
    ${CommentFragment}`;

export const useGetComments = <TData = GetComments, TError = unknown>(
  client: GraphQLClient,
  variables: GetCommentsVariables,
  options?: Omit<UseQueryOptions<GetComments, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetComments, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetComments, TError, TData>({
    queryKey: ['getComments', variables],
    queryFn: fetcher<GetComments, GetCommentsVariables>(client, GetCommentsDocument, variables, headers),
    ...options,
  });
};

useGetComments.getKey = (variables: GetCommentsVariables) => ['getComments', variables];

export const useInfiniteGetComments = <TData = InfiniteData<GetComments>, TError = unknown>(
  client: GraphQLClient,
  variables: GetCommentsVariables,
  options: Omit<UseInfiniteQueryOptions<GetComments, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetComments, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetComments, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getComments.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetComments, GetCommentsVariables>(
            client,
            GetCommentsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetComments.getKey = (variables: GetCommentsVariables) => ['getComments.infinite', variables];

useGetComments.fetcher = (client: GraphQLClient, variables: GetCommentsVariables, headers?: RequestInit['headers']) =>
  fetcher<GetComments, GetCommentsVariables>(client, GetCommentsDocument, variables, headers);

export const GetCostsDocument = `
    query getCosts($keyword: String, $orderBy: [OrderByClause], $filter: Filter, $first: Int, $page: Int, $record_id: ID, $record_type: String, $with_disabled: Boolean) {
  costs(
    keyword: $keyword
    orderBy: $orderBy
    filter: $filter
    first: $first
    page: $page
    record_id: $record_id
    record_type: $record_type
    with_disabled: $with_disabled
  ) {
    data {
      ...CostFragment
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    ${CostFragment}`;

export const useGetCosts = <TData = GetCosts, TError = unknown>(
  client: GraphQLClient,
  variables?: GetCostsVariables,
  options?: Omit<UseQueryOptions<GetCosts, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetCosts, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetCosts, TError, TData>({
    queryKey: variables === undefined ? ['getCosts'] : ['getCosts', variables],
    queryFn: fetcher<GetCosts, GetCostsVariables>(client, GetCostsDocument, variables, headers),
    ...options,
  });
};

useGetCosts.getKey = (variables?: GetCostsVariables) =>
  variables === undefined ? ['getCosts'] : ['getCosts', variables];

export const useInfiniteGetCosts = <TData = InfiniteData<GetCosts>, TError = unknown>(
  client: GraphQLClient,
  variables: GetCostsVariables,
  options: Omit<UseInfiniteQueryOptions<GetCosts, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetCosts, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetCosts, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined) ? ['getCosts.infinite'] : ['getCosts.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetCosts, GetCostsVariables>(
            client,
            GetCostsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetCosts.getKey = (variables?: GetCostsVariables) =>
  variables === undefined ? ['getCosts.infinite'] : ['getCosts.infinite', variables];

useGetCosts.fetcher = (client: GraphQLClient, variables?: GetCostsVariables, headers?: RequestInit['headers']) =>
  fetcher<GetCosts, GetCostsVariables>(client, GetCostsDocument, variables, headers);

export const GetCostDocument = `
    query getCost($id: ID!) {
  cost(id: $id) {
    ...CostFragment
  }
}
    ${CostFragment}`;

export const useGetCost = <TData = GetCost, TError = unknown>(
  client: GraphQLClient,
  variables: GetCostVariables,
  options?: Omit<UseQueryOptions<GetCost, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetCost, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetCost, TError, TData>({
    queryKey: ['getCost', variables],
    queryFn: fetcher<GetCost, GetCostVariables>(client, GetCostDocument, variables, headers),
    ...options,
  });
};

useGetCost.getKey = (variables: GetCostVariables) => ['getCost', variables];

export const useInfiniteGetCost = <TData = InfiniteData<GetCost>, TError = unknown>(
  client: GraphQLClient,
  variables: GetCostVariables,
  options: Omit<UseInfiniteQueryOptions<GetCost, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetCost, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetCost, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getCost.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetCost, GetCostVariables>(
            client,
            GetCostDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetCost.getKey = (variables: GetCostVariables) => ['getCost.infinite', variables];

useGetCost.fetcher = (client: GraphQLClient, variables: GetCostVariables, headers?: RequestInit['headers']) =>
  fetcher<GetCost, GetCostVariables>(client, GetCostDocument, variables, headers);

export const GetUnpaginatedCostsDocument = `
    query getUnpaginatedCosts($keyword: String, $orderBy: [OrderByClause], $filter: Filter, $record_type: String, $record_id: ID, $start_date: String, $end_date: String, $boat_details_id: ID) {
  unpaginatedCosts(
    keyword: $keyword
    orderBy: $orderBy
    filter: $filter
    record_type: $record_type
    record_id: $record_id
    start_date: $start_date
    end_date: $end_date
    boat_details_id: $boat_details_id
  ) {
    ...CostFragment
  }
}
    ${CostFragment}`;

export const useGetUnpaginatedCosts = <TData = GetUnpaginatedCosts, TError = unknown>(
  client: GraphQLClient,
  variables?: GetUnpaginatedCostsVariables,
  options?: Omit<UseQueryOptions<GetUnpaginatedCosts, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetUnpaginatedCosts, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetUnpaginatedCosts, TError, TData>({
    queryKey: variables === undefined ? ['getUnpaginatedCosts'] : ['getUnpaginatedCosts', variables],
    queryFn: fetcher<GetUnpaginatedCosts, GetUnpaginatedCostsVariables>(
      client,
      GetUnpaginatedCostsDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetUnpaginatedCosts.getKey = (variables?: GetUnpaginatedCostsVariables) =>
  variables === undefined ? ['getUnpaginatedCosts'] : ['getUnpaginatedCosts', variables];

export const useInfiniteGetUnpaginatedCosts = <TData = InfiniteData<GetUnpaginatedCosts>, TError = unknown>(
  client: GraphQLClient,
  variables: GetUnpaginatedCostsVariables,
  options: Omit<UseInfiniteQueryOptions<GetUnpaginatedCosts, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetUnpaginatedCosts, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetUnpaginatedCosts, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getUnpaginatedCosts.infinite']
            : ['getUnpaginatedCosts.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetUnpaginatedCosts, GetUnpaginatedCostsVariables>(
            client,
            GetUnpaginatedCostsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetUnpaginatedCosts.getKey = (variables?: GetUnpaginatedCostsVariables) =>
  variables === undefined ? ['getUnpaginatedCosts.infinite'] : ['getUnpaginatedCosts.infinite', variables];

useGetUnpaginatedCosts.fetcher = (
  client: GraphQLClient,
  variables?: GetUnpaginatedCostsVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetUnpaginatedCosts, GetUnpaginatedCostsVariables>(client, GetUnpaginatedCostsDocument, variables, headers);

export const GetCountriesDocument = `
    query getCountries {
  countries(first: 250) {
    data {
      id
      name
      iso_code
      iso_code
    }
  }
}
    `;

export const useGetCountries = <TData = GetCountries, TError = unknown>(
  client: GraphQLClient,
  variables?: GetCountriesVariables,
  options?: Omit<UseQueryOptions<GetCountries, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetCountries, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetCountries, TError, TData>({
    queryKey: variables === undefined ? ['getCountries'] : ['getCountries', variables],
    queryFn: fetcher<GetCountries, GetCountriesVariables>(client, GetCountriesDocument, variables, headers),
    ...options,
  });
};

useGetCountries.getKey = (variables?: GetCountriesVariables) =>
  variables === undefined ? ['getCountries'] : ['getCountries', variables];

export const useInfiniteGetCountries = <TData = InfiniteData<GetCountries>, TError = unknown>(
  client: GraphQLClient,
  variables: GetCountriesVariables,
  options: Omit<UseInfiniteQueryOptions<GetCountries, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetCountries, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetCountries, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getCountries.infinite']
            : ['getCountries.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetCountries, GetCountriesVariables>(
            client,
            GetCountriesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetCountries.getKey = (variables?: GetCountriesVariables) =>
  variables === undefined ? ['getCountries.infinite'] : ['getCountries.infinite', variables];

useGetCountries.fetcher = (
  client: GraphQLClient,
  variables?: GetCountriesVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetCountries, GetCountriesVariables>(client, GetCountriesDocument, variables, headers);

export const GetCurrenciesDocument = `
    query getCurrencies {
  currencies(first: 5000) {
    data {
      id
      iso_code
      symbol
      is_default
    }
  }
}
    `;

export const useGetCurrencies = <TData = GetCurrencies, TError = unknown>(
  client: GraphQLClient,
  variables?: GetCurrenciesVariables,
  options?: Omit<UseQueryOptions<GetCurrencies, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetCurrencies, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetCurrencies, TError, TData>({
    queryKey: variables === undefined ? ['getCurrencies'] : ['getCurrencies', variables],
    queryFn: fetcher<GetCurrencies, GetCurrenciesVariables>(client, GetCurrenciesDocument, variables, headers),
    ...options,
  });
};

useGetCurrencies.getKey = (variables?: GetCurrenciesVariables) =>
  variables === undefined ? ['getCurrencies'] : ['getCurrencies', variables];

export const useInfiniteGetCurrencies = <TData = InfiniteData<GetCurrencies>, TError = unknown>(
  client: GraphQLClient,
  variables: GetCurrenciesVariables,
  options: Omit<UseInfiniteQueryOptions<GetCurrencies, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetCurrencies, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetCurrencies, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getCurrencies.infinite']
            : ['getCurrencies.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetCurrencies, GetCurrenciesVariables>(
            client,
            GetCurrenciesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetCurrencies.getKey = (variables?: GetCurrenciesVariables) =>
  variables === undefined ? ['getCurrencies.infinite'] : ['getCurrencies.infinite', variables];

useGetCurrencies.fetcher = (
  client: GraphQLClient,
  variables?: GetCurrenciesVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetCurrencies, GetCurrenciesVariables>(client, GetCurrenciesDocument, variables, headers);

export const FieldsDocument = `
    query fields($module: ModuleType!) {
  fields(module: $module) {
    id
    name
    options
    type
    options_data
    options
  }
}
    `;

export const useFields = <TData = Fields, TError = unknown>(
  client: GraphQLClient,
  variables: FieldsVariables,
  options?: Omit<UseQueryOptions<Fields, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Fields, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<Fields, TError, TData>({
    queryKey: ['fields', variables],
    queryFn: fetcher<Fields, FieldsVariables>(client, FieldsDocument, variables, headers),
    ...options,
  });
};

useFields.getKey = (variables: FieldsVariables) => ['fields', variables];

export const useInfiniteFields = <TData = InfiniteData<Fields>, TError = unknown>(
  client: GraphQLClient,
  variables: FieldsVariables,
  options: Omit<UseInfiniteQueryOptions<Fields, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<Fields, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<Fields, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['fields.infinite', variables],
        queryFn: (metaData) =>
          fetcher<Fields, FieldsVariables>(
            client,
            FieldsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteFields.getKey = (variables: FieldsVariables) => ['fields.infinite', variables];

useFields.fetcher = (client: GraphQLClient, variables: FieldsVariables, headers?: RequestInit['headers']) =>
  fetcher<Fields, FieldsVariables>(client, FieldsDocument, variables, headers);

export const GetBoatEngineByIdDocument = `
    query getBoatEngineById($boat_detail_id: ID!) {
  engines(boat_detail_id: $boat_detail_id) {
    id
    maker
    website
    model
    drive
    fuel
    boat_detail_id
  }
}
    `;

export const useGetBoatEngineById = <TData = GetBoatEngineById, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatEngineByIdVariables,
  options?: Omit<UseQueryOptions<GetBoatEngineById, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetBoatEngineById, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetBoatEngineById, TError, TData>({
    queryKey: ['getBoatEngineById', variables],
    queryFn: fetcher<GetBoatEngineById, GetBoatEngineByIdVariables>(
      client,
      GetBoatEngineByIdDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetBoatEngineById.getKey = (variables: GetBoatEngineByIdVariables) => ['getBoatEngineById', variables];

export const useInfiniteGetBoatEngineById = <TData = InfiniteData<GetBoatEngineById>, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatEngineByIdVariables,
  options: Omit<UseInfiniteQueryOptions<GetBoatEngineById, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetBoatEngineById, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetBoatEngineById, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getBoatEngineById.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetBoatEngineById, GetBoatEngineByIdVariables>(
            client,
            GetBoatEngineByIdDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetBoatEngineById.getKey = (variables: GetBoatEngineByIdVariables) => [
  'getBoatEngineById.infinite',
  variables,
];

useGetBoatEngineById.fetcher = (
  client: GraphQLClient,
  variables: GetBoatEngineByIdVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetBoatEngineById, GetBoatEngineByIdVariables>(client, GetBoatEngineByIdDocument, variables, headers);

export const GetEngineLogsDocument = `
    query getEngineLogs($engine_id: Int!) {
  engineLogs(engine_id: $engine_id) {
    id
    engine_id
    status
    hours
    rpm
    fuel_check
    oil_check
    water_check
    exhaust_check
    datetime
    log_id
  }
}
    `;

export const useGetEngineLogs = <TData = GetEngineLogs, TError = unknown>(
  client: GraphQLClient,
  variables: GetEngineLogsVariables,
  options?: Omit<UseQueryOptions<GetEngineLogs, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetEngineLogs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetEngineLogs, TError, TData>({
    queryKey: ['getEngineLogs', variables],
    queryFn: fetcher<GetEngineLogs, GetEngineLogsVariables>(client, GetEngineLogsDocument, variables, headers),
    ...options,
  });
};

useGetEngineLogs.getKey = (variables: GetEngineLogsVariables) => ['getEngineLogs', variables];

export const useInfiniteGetEngineLogs = <TData = InfiniteData<GetEngineLogs>, TError = unknown>(
  client: GraphQLClient,
  variables: GetEngineLogsVariables,
  options: Omit<UseInfiniteQueryOptions<GetEngineLogs, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetEngineLogs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetEngineLogs, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getEngineLogs.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetEngineLogs, GetEngineLogsVariables>(
            client,
            GetEngineLogsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetEngineLogs.getKey = (variables: GetEngineLogsVariables) => ['getEngineLogs.infinite', variables];

useGetEngineLogs.fetcher = (
  client: GraphQLClient,
  variables: GetEngineLogsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetEngineLogs, GetEngineLogsVariables>(client, GetEngineLogsDocument, variables, headers);

export const GetExpensesDocument = `
    query getExpenses($keyword: String, $page: Int, $first: Int, $orderBy: [OrderByClause], $with_disabled: Boolean, $start_date: String, $end_date: String) {
  expenses(
    keyword: $keyword
    page: $page
    first: $first
    orderBy: $orderBy
    with_disabled: $with_disabled
    start_date: $start_date
    end_date: $end_date
  ) {
    data {
      ...ExpenseFragment
    }
    paginatorInfo {
      firstItem
      lastItem
      count
      currentPage
      perPage
      total
      hasMorePages
    }
  }
}
    ${ExpenseFragment}`;

export const useGetExpenses = <TData = GetExpenses, TError = unknown>(
  client: GraphQLClient,
  variables?: GetExpensesVariables,
  options?: Omit<UseQueryOptions<GetExpenses, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetExpenses, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetExpenses, TError, TData>({
    queryKey: variables === undefined ? ['getExpenses'] : ['getExpenses', variables],
    queryFn: fetcher<GetExpenses, GetExpensesVariables>(client, GetExpensesDocument, variables, headers),
    ...options,
  });
};

useGetExpenses.getKey = (variables?: GetExpensesVariables) =>
  variables === undefined ? ['getExpenses'] : ['getExpenses', variables];

export const useInfiniteGetExpenses = <TData = InfiniteData<GetExpenses>, TError = unknown>(
  client: GraphQLClient,
  variables: GetExpensesVariables,
  options: Omit<UseInfiniteQueryOptions<GetExpenses, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetExpenses, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetExpenses, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined) ? ['getExpenses.infinite'] : ['getExpenses.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetExpenses, GetExpensesVariables>(
            client,
            GetExpensesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetExpenses.getKey = (variables?: GetExpensesVariables) =>
  variables === undefined ? ['getExpenses.infinite'] : ['getExpenses.infinite', variables];

useGetExpenses.fetcher = (client: GraphQLClient, variables?: GetExpensesVariables, headers?: RequestInit['headers']) =>
  fetcher<GetExpenses, GetExpensesVariables>(client, GetExpensesDocument, variables, headers);

export const GetExpenseDocument = `
    query getExpense($id: ID) {
  expense(id: $id) {
    ...ExpenseFragment
  }
}
    ${ExpenseFragment}`;

export const useGetExpense = <TData = GetExpense, TError = unknown>(
  client: GraphQLClient,
  variables?: GetExpenseVariables,
  options?: Omit<UseQueryOptions<GetExpense, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetExpense, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetExpense, TError, TData>({
    queryKey: variables === undefined ? ['getExpense'] : ['getExpense', variables],
    queryFn: fetcher<GetExpense, GetExpenseVariables>(client, GetExpenseDocument, variables, headers),
    ...options,
  });
};

useGetExpense.getKey = (variables?: GetExpenseVariables) =>
  variables === undefined ? ['getExpense'] : ['getExpense', variables];

export const useInfiniteGetExpense = <TData = InfiniteData<GetExpense>, TError = unknown>(
  client: GraphQLClient,
  variables: GetExpenseVariables,
  options: Omit<UseInfiniteQueryOptions<GetExpense, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetExpense, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetExpense, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined) ? ['getExpense.infinite'] : ['getExpense.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetExpense, GetExpenseVariables>(
            client,
            GetExpenseDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetExpense.getKey = (variables?: GetExpenseVariables) =>
  variables === undefined ? ['getExpense.infinite'] : ['getExpense.infinite', variables];

useGetExpense.fetcher = (client: GraphQLClient, variables?: GetExpenseVariables, headers?: RequestInit['headers']) =>
  fetcher<GetExpense, GetExpenseVariables>(client, GetExpenseDocument, variables, headers);

export const GetFavoritesDocument = `
    query getFavorites($search: String, $orderBy: OrderByClause, $first: Int, $page: Int) {
  favorites(search: $search, orderBy: $orderBy, first: $first, page: $page) {
    paginatorInfo {
      currentPage
      count
      total
    }
    data {
      id
      user_id
      favoritable_type
      favoritable_id
      favoritable {
        ...FavoritableBoatFields
      }
    }
  }
}
    ${FavoritableBoatFields}`;

export const useGetFavorites = <TData = GetFavorites, TError = unknown>(
  client: GraphQLClient,
  variables?: GetFavoritesVariables,
  options?: Omit<UseQueryOptions<GetFavorites, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetFavorites, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetFavorites, TError, TData>({
    queryKey: variables === undefined ? ['getFavorites'] : ['getFavorites', variables],
    queryFn: fetcher<GetFavorites, GetFavoritesVariables>(client, GetFavoritesDocument, variables, headers),
    ...options,
  });
};

useGetFavorites.getKey = (variables?: GetFavoritesVariables) =>
  variables === undefined ? ['getFavorites'] : ['getFavorites', variables];

export const useInfiniteGetFavorites = <TData = InfiniteData<GetFavorites>, TError = unknown>(
  client: GraphQLClient,
  variables: GetFavoritesVariables,
  options: Omit<UseInfiniteQueryOptions<GetFavorites, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetFavorites, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetFavorites, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getFavorites.infinite']
            : ['getFavorites.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetFavorites, GetFavoritesVariables>(
            client,
            GetFavoritesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetFavorites.getKey = (variables?: GetFavoritesVariables) =>
  variables === undefined ? ['getFavorites.infinite'] : ['getFavorites.infinite', variables];

useGetFavorites.fetcher = (
  client: GraphQLClient,
  variables?: GetFavoritesVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetFavorites, GetFavoritesVariables>(client, GetFavoritesDocument, variables, headers);

export const GetFeaturedBoatsByDocument = `
    query getFeaturedBoatsBy($type: FeaturedType!, $id: ID!, $query: String, $orderBy: OrderTypes) {
  featuredBoatsBy(type: $type, id: $id, query: $query, orderBy: $orderBy) {
    id
    type
    slug
    image {
      public_url
    }
    is_favorited
    total_views
    favorites_count
    model
    manufacturer {
      id
      name
      slug
      website
    }
    year_first
  }
}
    `;

export const useGetFeaturedBoatsBy = <TData = GetFeaturedBoatsBy, TError = unknown>(
  client: GraphQLClient,
  variables: GetFeaturedBoatsByVariables,
  options?: Omit<UseQueryOptions<GetFeaturedBoatsBy, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetFeaturedBoatsBy, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetFeaturedBoatsBy, TError, TData>({
    queryKey: ['getFeaturedBoatsBy', variables],
    queryFn: fetcher<GetFeaturedBoatsBy, GetFeaturedBoatsByVariables>(
      client,
      GetFeaturedBoatsByDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetFeaturedBoatsBy.getKey = (variables: GetFeaturedBoatsByVariables) => ['getFeaturedBoatsBy', variables];

export const useInfiniteGetFeaturedBoatsBy = <TData = InfiniteData<GetFeaturedBoatsBy>, TError = unknown>(
  client: GraphQLClient,
  variables: GetFeaturedBoatsByVariables,
  options: Omit<UseInfiniteQueryOptions<GetFeaturedBoatsBy, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetFeaturedBoatsBy, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetFeaturedBoatsBy, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getFeaturedBoatsBy.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetFeaturedBoatsBy, GetFeaturedBoatsByVariables>(
            client,
            GetFeaturedBoatsByDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetFeaturedBoatsBy.getKey = (variables: GetFeaturedBoatsByVariables) => [
  'getFeaturedBoatsBy.infinite',
  variables,
];

useGetFeaturedBoatsBy.fetcher = (
  client: GraphQLClient,
  variables: GetFeaturedBoatsByVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetFeaturedBoatsBy, GetFeaturedBoatsByVariables>(client, GetFeaturedBoatsByDocument, variables, headers);

export const GetFilesDocument = `
    query getFiles($type: [String!], $page: Int, $is_filepicker: Boolean = true, $folder_id: ID, $perPage: Int = 30) {
  files(
    type: $type
    page: $page
    orderBy: {column: "id", order: DESC}
    first: $perPage
    is_filepicker: $is_filepicker
    folder_id: $folder_id
  ) {
    data {
      ...FileFields
    }
    paginatorInfo {
      currentPage
      count
      perPage
      total
      hasMorePages
    }
  }
}
    ${FileFields}`;

export const useGetFiles = <TData = GetFiles, TError = unknown>(
  client: GraphQLClient,
  variables?: GetFilesVariables,
  options?: Omit<UseQueryOptions<GetFiles, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetFiles, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetFiles, TError, TData>({
    queryKey: variables === undefined ? ['getFiles'] : ['getFiles', variables],
    queryFn: fetcher<GetFiles, GetFilesVariables>(client, GetFilesDocument, variables, headers),
    ...options,
  });
};

useGetFiles.getKey = (variables?: GetFilesVariables) =>
  variables === undefined ? ['getFiles'] : ['getFiles', variables];

export const useInfiniteGetFiles = <TData = InfiniteData<GetFiles>, TError = unknown>(
  client: GraphQLClient,
  variables: GetFilesVariables,
  options: Omit<UseInfiniteQueryOptions<GetFiles, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetFiles, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetFiles, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined) ? ['getFiles.infinite'] : ['getFiles.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetFiles, GetFilesVariables>(
            client,
            GetFilesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetFiles.getKey = (variables?: GetFilesVariables) =>
  variables === undefined ? ['getFiles.infinite'] : ['getFiles.infinite', variables];

useGetFiles.fetcher = (client: GraphQLClient, variables?: GetFilesVariables, headers?: RequestInit['headers']) =>
  fetcher<GetFiles, GetFilesVariables>(client, GetFilesDocument, variables, headers);

export const GetPaginatedFilesDocument = `
    query getPaginatedFiles($type: [String!], $page: Int, $orderBy: [OrderByClause], $first: Int, $filter: Filter, $folder_id: ID, $is_filepicker: Boolean, $keyword: String) {
  files(
    type: $type
    page: $page
    orderBy: $orderBy
    first: $first
    filter: $filter
    folder_id: $folder_id
    is_filepicker: $is_filepicker
    keyword: $keyword
  ) {
    data {
      ...FileFields
    }
    paginatorInfo {
      currentPage
      count
      perPage
      total
      hasMorePages
      firstItem
      lastItem
    }
  }
}
    ${FileFields}`;

export const useGetPaginatedFiles = <TData = GetPaginatedFiles, TError = unknown>(
  client: GraphQLClient,
  variables?: GetPaginatedFilesVariables,
  options?: Omit<UseQueryOptions<GetPaginatedFiles, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPaginatedFiles, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetPaginatedFiles, TError, TData>({
    queryKey: variables === undefined ? ['getPaginatedFiles'] : ['getPaginatedFiles', variables],
    queryFn: fetcher<GetPaginatedFiles, GetPaginatedFilesVariables>(
      client,
      GetPaginatedFilesDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetPaginatedFiles.getKey = (variables?: GetPaginatedFilesVariables) =>
  variables === undefined ? ['getPaginatedFiles'] : ['getPaginatedFiles', variables];

export const useInfiniteGetPaginatedFiles = <TData = InfiniteData<GetPaginatedFiles>, TError = unknown>(
  client: GraphQLClient,
  variables: GetPaginatedFilesVariables,
  options: Omit<UseInfiniteQueryOptions<GetPaginatedFiles, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetPaginatedFiles, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetPaginatedFiles, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getPaginatedFiles.infinite']
            : ['getPaginatedFiles.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetPaginatedFiles, GetPaginatedFilesVariables>(
            client,
            GetPaginatedFilesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetPaginatedFiles.getKey = (variables?: GetPaginatedFilesVariables) =>
  variables === undefined ? ['getPaginatedFiles.infinite'] : ['getPaginatedFiles.infinite', variables];

useGetPaginatedFiles.fetcher = (
  client: GraphQLClient,
  variables?: GetPaginatedFilesVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetPaginatedFiles, GetPaginatedFilesVariables>(client, GetPaginatedFilesDocument, variables, headers);

export const GetFileDocument = `
    query getFile($id: ID) {
  file(id: $id) {
    ...FileFields
  }
}
    ${FileFields}`;

export const useGetFile = <TData = GetFile, TError = unknown>(
  client: GraphQLClient,
  variables?: GetFileVariables,
  options?: Omit<UseQueryOptions<GetFile, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetFile, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetFile, TError, TData>({
    queryKey: variables === undefined ? ['getFile'] : ['getFile', variables],
    queryFn: fetcher<GetFile, GetFileVariables>(client, GetFileDocument, variables, headers),
    ...options,
  });
};

useGetFile.getKey = (variables?: GetFileVariables) => (variables === undefined ? ['getFile'] : ['getFile', variables]);

export const useInfiniteGetFile = <TData = InfiniteData<GetFile>, TError = unknown>(
  client: GraphQLClient,
  variables: GetFileVariables,
  options: Omit<UseInfiniteQueryOptions<GetFile, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetFile, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetFile, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: (optionsQueryKey ?? variables === undefined) ? ['getFile.infinite'] : ['getFile.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetFile, GetFileVariables>(
            client,
            GetFileDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetFile.getKey = (variables?: GetFileVariables) =>
  variables === undefined ? ['getFile.infinite'] : ['getFile.infinite', variables];

useGetFile.fetcher = (client: GraphQLClient, variables?: GetFileVariables, headers?: RequestInit['headers']) =>
  fetcher<GetFile, GetFileVariables>(client, GetFileDocument, variables, headers);

export const FileQueryDocument = `
    query fileQuery($id: ID) {
  file(id: $id) {
    ...FileDetailsFragment
  }
}
    ${FileDetailsFragment}`;

export const useFileQuery = <TData = FileQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: FileQueryVariables,
  options?: Omit<UseQueryOptions<FileQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<FileQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<FileQuery, TError, TData>({
    queryKey: variables === undefined ? ['fileQuery'] : ['fileQuery', variables],
    queryFn: fetcher<FileQuery, FileQueryVariables>(client, FileQueryDocument, variables, headers),
    ...options,
  });
};

useFileQuery.getKey = (variables?: FileQueryVariables) =>
  variables === undefined ? ['fileQuery'] : ['fileQuery', variables];

export const useInfiniteFileQuery = <TData = InfiniteData<FileQuery>, TError = unknown>(
  client: GraphQLClient,
  variables: FileQueryVariables,
  options: Omit<UseInfiniteQueryOptions<FileQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<FileQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<FileQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined) ? ['fileQuery.infinite'] : ['fileQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<FileQuery, FileQueryVariables>(
            client,
            FileQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteFileQuery.getKey = (variables?: FileQueryVariables) =>
  variables === undefined ? ['fileQuery.infinite'] : ['fileQuery.infinite', variables];

useFileQuery.fetcher = (client: GraphQLClient, variables?: FileQueryVariables, headers?: RequestInit['headers']) =>
  fetcher<FileQuery, FileQueryVariables>(client, FileQueryDocument, variables, headers);

export const FilesCardQueryDocument = `
    query filesCardQuery($type: [String!], $page: Int, $is_filepicker: Boolean = true, $folder_id: ID, $perPage: Int = 30, $orderBy: [OrderByClause] = [{column: "created_at", order: DESC}], $keyword: String) {
  files(
    type: $type
    page: $page
    orderBy: $orderBy
    first: $perPage
    is_filepicker: $is_filepicker
    folder_id: $folder_id
    keyword: $keyword
  ) {
    data {
      ...FileCard
    }
    paginatorInfo {
      currentPage
      count
      perPage
      total
      hasMorePages
    }
  }
}
    ${FileCard}`;

export const useFilesCardQuery = <TData = FilesCardQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: FilesCardQueryVariables,
  options?: Omit<UseQueryOptions<FilesCardQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<FilesCardQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<FilesCardQuery, TError, TData>({
    queryKey: variables === undefined ? ['filesCardQuery'] : ['filesCardQuery', variables],
    queryFn: fetcher<FilesCardQuery, FilesCardQueryVariables>(client, FilesCardQueryDocument, variables, headers),
    ...options,
  });
};

useFilesCardQuery.getKey = (variables?: FilesCardQueryVariables) =>
  variables === undefined ? ['filesCardQuery'] : ['filesCardQuery', variables];

export const useInfiniteFilesCardQuery = <TData = InfiniteData<FilesCardQuery>, TError = unknown>(
  client: GraphQLClient,
  variables: FilesCardQueryVariables,
  options: Omit<UseInfiniteQueryOptions<FilesCardQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<FilesCardQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<FilesCardQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['filesCardQuery.infinite']
            : ['filesCardQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<FilesCardQuery, FilesCardQueryVariables>(
            client,
            FilesCardQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteFilesCardQuery.getKey = (variables?: FilesCardQueryVariables) =>
  variables === undefined ? ['filesCardQuery.infinite'] : ['filesCardQuery.infinite', variables];

useFilesCardQuery.fetcher = (
  client: GraphQLClient,
  variables?: FilesCardQueryVariables,
  headers?: RequestInit['headers'],
) => fetcher<FilesCardQuery, FilesCardQueryVariables>(client, FilesCardQueryDocument, variables, headers);

export const GetFilteredBoatsDocument = `
    query getFilteredBoats($filters: SearchFilters, $orderBy: OrderTypes, $page: Int, $first: Int) {
  filterBoats(filters: $filters, orderBy: $orderBy, page: $page, first: $first) {
    paginatorInfo {
      currentPage
      count
      total
      perPage
      lastPage
    }
    data {
      id
      type
      slug
      manufacturer {
        id
        name
      }
      image {
        public_url
      }
      is_favorited
      total_views
      favorites_count
      model
      hull_type
      year_first
    }
  }
}
    `;

export const useGetFilteredBoats = <TData = GetFilteredBoats, TError = unknown>(
  client: GraphQLClient,
  variables?: GetFilteredBoatsVariables,
  options?: Omit<UseQueryOptions<GetFilteredBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetFilteredBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetFilteredBoats, TError, TData>({
    queryKey: variables === undefined ? ['getFilteredBoats'] : ['getFilteredBoats', variables],
    queryFn: fetcher<GetFilteredBoats, GetFilteredBoatsVariables>(client, GetFilteredBoatsDocument, variables, headers),
    ...options,
  });
};

useGetFilteredBoats.getKey = (variables?: GetFilteredBoatsVariables) =>
  variables === undefined ? ['getFilteredBoats'] : ['getFilteredBoats', variables];

export const useInfiniteGetFilteredBoats = <TData = InfiniteData<GetFilteredBoats>, TError = unknown>(
  client: GraphQLClient,
  variables: GetFilteredBoatsVariables,
  options: Omit<UseInfiniteQueryOptions<GetFilteredBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetFilteredBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetFilteredBoats, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getFilteredBoats.infinite']
            : ['getFilteredBoats.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetFilteredBoats, GetFilteredBoatsVariables>(
            client,
            GetFilteredBoatsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetFilteredBoats.getKey = (variables?: GetFilteredBoatsVariables) =>
  variables === undefined ? ['getFilteredBoats.infinite'] : ['getFilteredBoats.infinite', variables];

useGetFilteredBoats.fetcher = (
  client: GraphQLClient,
  variables?: GetFilteredBoatsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetFilteredBoats, GetFilteredBoatsVariables>(client, GetFilteredBoatsDocument, variables, headers);

export const GetFoldersDocument = `
    query getFolders($initialValues: [ID!], $keyword: String, $orderBy: [OrderByClause], $filter: Filter, $parent_id: ID, $is_filepicker: Boolean, $first: Int = 15, $page: Int) {
  folders(
    initialValues: $initialValues
    keyword: $keyword
    orderBy: $orderBy
    filter: $filter
    parent_id: $parent_id
    is_filepicker: $is_filepicker
    first: $first
    page: $page
  ) {
    data {
      ...FolderFragment
    }
  }
}
    ${FolderFragment}`;

export const useGetFolders = <TData = GetFolders, TError = unknown>(
  client: GraphQLClient,
  variables?: GetFoldersVariables,
  options?: Omit<UseQueryOptions<GetFolders, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetFolders, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetFolders, TError, TData>({
    queryKey: variables === undefined ? ['getFolders'] : ['getFolders', variables],
    queryFn: fetcher<GetFolders, GetFoldersVariables>(client, GetFoldersDocument, variables, headers),
    ...options,
  });
};

useGetFolders.getKey = (variables?: GetFoldersVariables) =>
  variables === undefined ? ['getFolders'] : ['getFolders', variables];

export const useInfiniteGetFolders = <TData = InfiniteData<GetFolders>, TError = unknown>(
  client: GraphQLClient,
  variables: GetFoldersVariables,
  options: Omit<UseInfiniteQueryOptions<GetFolders, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetFolders, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetFolders, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined) ? ['getFolders.infinite'] : ['getFolders.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetFolders, GetFoldersVariables>(
            client,
            GetFoldersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetFolders.getKey = (variables?: GetFoldersVariables) =>
  variables === undefined ? ['getFolders.infinite'] : ['getFolders.infinite', variables];

useGetFolders.fetcher = (client: GraphQLClient, variables?: GetFoldersVariables, headers?: RequestInit['headers']) =>
  fetcher<GetFolders, GetFoldersVariables>(client, GetFoldersDocument, variables, headers);

export const GetFolderDocument = `
    query getFolder($id: ID) {
  folder(id: $id) {
    ...FolderFragment
  }
}
    ${FolderFragment}`;

export const useGetFolder = <TData = GetFolder, TError = unknown>(
  client: GraphQLClient,
  variables?: GetFolderVariables,
  options?: Omit<UseQueryOptions<GetFolder, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetFolder, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetFolder, TError, TData>({
    queryKey: variables === undefined ? ['getFolder'] : ['getFolder', variables],
    queryFn: fetcher<GetFolder, GetFolderVariables>(client, GetFolderDocument, variables, headers),
    ...options,
  });
};

useGetFolder.getKey = (variables?: GetFolderVariables) =>
  variables === undefined ? ['getFolder'] : ['getFolder', variables];

export const useInfiniteGetFolder = <TData = InfiniteData<GetFolder>, TError = unknown>(
  client: GraphQLClient,
  variables: GetFolderVariables,
  options: Omit<UseInfiniteQueryOptions<GetFolder, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetFolder, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetFolder, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined) ? ['getFolder.infinite'] : ['getFolder.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetFolder, GetFolderVariables>(
            client,
            GetFolderDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetFolder.getKey = (variables?: GetFolderVariables) =>
  variables === undefined ? ['getFolder.infinite'] : ['getFolder.infinite', variables];

useGetFolder.fetcher = (client: GraphQLClient, variables?: GetFolderVariables, headers?: RequestInit['headers']) =>
  fetcher<GetFolder, GetFolderVariables>(client, GetFolderDocument, variables, headers);

export const FolderBreadcrumbsQueryDocument = `
    query FolderBreadcrumbsQuery($id: ID) {
  folder(id: $id) {
    ...FolderBreadcrumbs
  }
}
    ${FolderBreadcrumbs}`;

export const useFolderBreadcrumbsQuery = <TData = FolderBreadcrumbsQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: FolderBreadcrumbsQueryVariables,
  options?: Omit<UseQueryOptions<FolderBreadcrumbsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<FolderBreadcrumbsQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<FolderBreadcrumbsQuery, TError, TData>({
    queryKey: variables === undefined ? ['FolderBreadcrumbsQuery'] : ['FolderBreadcrumbsQuery', variables],
    queryFn: fetcher<FolderBreadcrumbsQuery, FolderBreadcrumbsQueryVariables>(
      client,
      FolderBreadcrumbsQueryDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useFolderBreadcrumbsQuery.getKey = (variables?: FolderBreadcrumbsQueryVariables) =>
  variables === undefined ? ['FolderBreadcrumbsQuery'] : ['FolderBreadcrumbsQuery', variables];

export const useInfiniteFolderBreadcrumbsQuery = <TData = InfiniteData<FolderBreadcrumbsQuery>, TError = unknown>(
  client: GraphQLClient,
  variables: FolderBreadcrumbsQueryVariables,
  options: Omit<UseInfiniteQueryOptions<FolderBreadcrumbsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<FolderBreadcrumbsQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<FolderBreadcrumbsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['FolderBreadcrumbsQuery.infinite']
            : ['FolderBreadcrumbsQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<FolderBreadcrumbsQuery, FolderBreadcrumbsQueryVariables>(
            client,
            FolderBreadcrumbsQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteFolderBreadcrumbsQuery.getKey = (variables?: FolderBreadcrumbsQueryVariables) =>
  variables === undefined ? ['FolderBreadcrumbsQuery.infinite'] : ['FolderBreadcrumbsQuery.infinite', variables];

useFolderBreadcrumbsQuery.fetcher = (
  client: GraphQLClient,
  variables?: FolderBreadcrumbsQueryVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<FolderBreadcrumbsQuery, FolderBreadcrumbsQueryVariables>(
    client,
    FolderBreadcrumbsQueryDocument,
    variables,
    headers,
  );

export const GetLimitsDocument = `
    query getLimits($boat_details_id: ID, $trip_id: ID) {
  limits(boat_details_id: $boat_details_id, trip_id: $trip_id) {
    name
    total
    type
    used
    is_allowed
  }
}
    `;

export const useGetLimits = <TData = GetLimits, TError = unknown>(
  client: GraphQLClient,
  variables?: GetLimitsVariables,
  options?: Omit<UseQueryOptions<GetLimits, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetLimits, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetLimits, TError, TData>({
    queryKey: variables === undefined ? ['getLimits'] : ['getLimits', variables],
    queryFn: fetcher<GetLimits, GetLimitsVariables>(client, GetLimitsDocument, variables, headers),
    ...options,
  });
};

useGetLimits.getKey = (variables?: GetLimitsVariables) =>
  variables === undefined ? ['getLimits'] : ['getLimits', variables];

export const useInfiniteGetLimits = <TData = InfiniteData<GetLimits>, TError = unknown>(
  client: GraphQLClient,
  variables: GetLimitsVariables,
  options: Omit<UseInfiniteQueryOptions<GetLimits, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetLimits, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetLimits, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined) ? ['getLimits.infinite'] : ['getLimits.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetLimits, GetLimitsVariables>(
            client,
            GetLimitsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetLimits.getKey = (variables?: GetLimitsVariables) =>
  variables === undefined ? ['getLimits.infinite'] : ['getLimits.infinite', variables];

useGetLimits.fetcher = (client: GraphQLClient, variables?: GetLimitsVariables, headers?: RequestInit['headers']) =>
  fetcher<GetLimits, GetLimitsVariables>(client, GetLimitsDocument, variables, headers);

export const GetLocationsDocument = `
    query getLocations($keyword: String, $orderBy: [OrderByClause], $is_sub_location: Boolean, $first: Int = 15, $page: Int) {
  locations(
    keyword: $keyword
    orderBy: $orderBy
    is_sub_location: $is_sub_location
    first: $first
    page: $page
  ) {
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
    data {
      __typename
      id
      name
      is_sub_location
      user_id
    }
  }
}
    `;

export const useGetLocations = <TData = GetLocations, TError = unknown>(
  client: GraphQLClient,
  variables?: GetLocationsVariables,
  options?: Omit<UseQueryOptions<GetLocations, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetLocations, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetLocations, TError, TData>({
    queryKey: variables === undefined ? ['getLocations'] : ['getLocations', variables],
    queryFn: fetcher<GetLocations, GetLocationsVariables>(client, GetLocationsDocument, variables, headers),
    ...options,
  });
};

useGetLocations.getKey = (variables?: GetLocationsVariables) =>
  variables === undefined ? ['getLocations'] : ['getLocations', variables];

export const useInfiniteGetLocations = <TData = InfiniteData<GetLocations>, TError = unknown>(
  client: GraphQLClient,
  variables: GetLocationsVariables,
  options: Omit<UseInfiniteQueryOptions<GetLocations, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetLocations, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetLocations, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getLocations.infinite']
            : ['getLocations.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetLocations, GetLocationsVariables>(
            client,
            GetLocationsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetLocations.getKey = (variables?: GetLocationsVariables) =>
  variables === undefined ? ['getLocations.infinite'] : ['getLocations.infinite', variables];

useGetLocations.fetcher = (
  client: GraphQLClient,
  variables?: GetLocationsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetLocations, GetLocationsVariables>(client, GetLocationsDocument, variables, headers);

export const GetTripLogsDocument = `
    query getTripLogs($trip_id: ID!, $keyword: String, $first: Int, $filter: Filter, $orderBy: [OrderByClause], $page: Int) {
  logsOfTrip(
    trip_id: $trip_id
    keyword: $keyword
    first: $first
    filter: $filter
    orderBy: $orderBy
    page: $page
  ) {
    data {
      id
      name
      datetime
      latitude
      longitude
      log
      type
      created_at
      updated_at
      notes
      type
      created_at
      updated_at
      category_id
      category {
        id
        name
      }
    }
    paginatorInfo {
      count
      total
      hasMorePages
      firstItem
      currentPage
      lastItem
      lastPage
    }
  }
}
    `;

export const useGetTripLogs = <TData = GetTripLogs, TError = unknown>(
  client: GraphQLClient,
  variables: GetTripLogsVariables,
  options?: Omit<UseQueryOptions<GetTripLogs, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetTripLogs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetTripLogs, TError, TData>({
    queryKey: ['getTripLogs', variables],
    queryFn: fetcher<GetTripLogs, GetTripLogsVariables>(client, GetTripLogsDocument, variables, headers),
    ...options,
  });
};

useGetTripLogs.getKey = (variables: GetTripLogsVariables) => ['getTripLogs', variables];

export const useInfiniteGetTripLogs = <TData = InfiniteData<GetTripLogs>, TError = unknown>(
  client: GraphQLClient,
  variables: GetTripLogsVariables,
  options: Omit<UseInfiniteQueryOptions<GetTripLogs, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetTripLogs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetTripLogs, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getTripLogs.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetTripLogs, GetTripLogsVariables>(
            client,
            GetTripLogsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetTripLogs.getKey = (variables: GetTripLogsVariables) => ['getTripLogs.infinite', variables];

useGetTripLogs.fetcher = (client: GraphQLClient, variables: GetTripLogsVariables, headers?: RequestInit['headers']) =>
  fetcher<GetTripLogs, GetTripLogsVariables>(client, GetTripLogsDocument, variables, headers);

export const TotalTripLogsQueryDocument = `
    query totalTripLogsQuery($trip_id: ID!) {
  logsOfTrip(trip_id: $trip_id) {
    paginatorInfo {
      count
      total
    }
  }
}
    `;

export const useTotalTripLogsQuery = <TData = TotalTripLogsQuery, TError = unknown>(
  client: GraphQLClient,
  variables: TotalTripLogsQueryVariables,
  options?: Omit<UseQueryOptions<TotalTripLogsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<TotalTripLogsQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<TotalTripLogsQuery, TError, TData>({
    queryKey: ['totalTripLogsQuery', variables],
    queryFn: fetcher<TotalTripLogsQuery, TotalTripLogsQueryVariables>(
      client,
      TotalTripLogsQueryDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useTotalTripLogsQuery.getKey = (variables: TotalTripLogsQueryVariables) => ['totalTripLogsQuery', variables];

export const useInfiniteTotalTripLogsQuery = <TData = InfiniteData<TotalTripLogsQuery>, TError = unknown>(
  client: GraphQLClient,
  variables: TotalTripLogsQueryVariables,
  options: Omit<UseInfiniteQueryOptions<TotalTripLogsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<TotalTripLogsQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<TotalTripLogsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['totalTripLogsQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<TotalTripLogsQuery, TotalTripLogsQueryVariables>(
            client,
            TotalTripLogsQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteTotalTripLogsQuery.getKey = (variables: TotalTripLogsQueryVariables) => [
  'totalTripLogsQuery.infinite',
  variables,
];

useTotalTripLogsQuery.fetcher = (
  client: GraphQLClient,
  variables: TotalTripLogsQueryVariables,
  headers?: RequestInit['headers'],
) => fetcher<TotalTripLogsQuery, TotalTripLogsQueryVariables>(client, TotalTripLogsQueryDocument, variables, headers);

export const GetLogDocument = `
    query getLog($id: ID!) {
  log(id: $id) {
    id
    name
    boat_detail_id
    boat_detail {
      id
      name
      flag
    }
    trip_id
    user_id
    datetime
    latitude
    longitude
    type
    comments {
      id
      text
      created_at_diff
      created_at
      updated_at_diff
      updated_at
      can_update
      can_unlike
      can_delete
      can_like
    }
    files {
      ...FileCardGallery
    }
    notes
    caption
    sea_area
    imminent
    later
    outlook
    channel
    station
    message
    event
    heading
    cog
    helm
    speed
    sog
    log
    depth
    bar
    wind_speed
    wind_direction
    sky
    precipitation
    sea_state
    visibility
    air_temp
    sea_temp
    sails
    engine_logs {
      id
      engine_id
      status
      hours
      rpm
      fuel_check
      oil_check
      water_check
      exhaust_check
    }
    engine_status1
    engine_hours1
    engine_rpm1
    engine_fuel_check1
    engine_oil_check1
    engine_water_check1
    engine_exhaust_check1
    engine_status2
    engine_hours2
    engine_rpm2
    engine_fuel_check2
    engine_oil_check2
    engine_water_check2
    engine_exhaust_check2
    diesel_generator_status
    diesel_generator_hours
    diesel_generator_rpm
    diesel_generator_fuel_check
    diesel_generator_oil_check
    diesel_generator_water_check
    diesel_generator_exhaust_check
    battery1
    battery2
    boat_water
    fuel
    gas
    bilge
    category_id
    category {
      id
      name
    }
    expenses {
      ...ExpenseItemHistoryFragment
      pivot {
        usage_log_name
        usage_value
        quantity
        quantity_action
      }
    }
    trip {
      boat_detail {
        name
        flag
        id
      }
      id
    }
    user {
      id
      display_name
      name
      surname
    }
    costs {
      id
      amount
      currency_id
      currency {
        id
        name
        iso_code
      }
      vat_percentage
      vat_type
      type
      supplier
    }
    cost {
      id
      amount
      currency_id
      currency {
        id
        name
        iso_code
      }
      vat_percentage
      vat_type
      type
      supplier
      category {
        id
        name
      }
    }
    can_delete
    can_update
    creation_type
    creator_agent_name
    created_at
    updated_at
  }
}
    ${FileCardGallery}
${ExpenseItemHistoryFragment}`;

export const useGetLog = <TData = GetLog, TError = unknown>(
  client: GraphQLClient,
  variables: GetLogVariables,
  options?: Omit<UseQueryOptions<GetLog, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetLog, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetLog, TError, TData>({
    queryKey: ['getLog', variables],
    queryFn: fetcher<GetLog, GetLogVariables>(client, GetLogDocument, variables, headers),
    ...options,
  });
};

useGetLog.getKey = (variables: GetLogVariables) => ['getLog', variables];

export const useInfiniteGetLog = <TData = InfiniteData<GetLog>, TError = unknown>(
  client: GraphQLClient,
  variables: GetLogVariables,
  options: Omit<UseInfiniteQueryOptions<GetLog, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetLog, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetLog, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getLog.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetLog, GetLogVariables>(
            client,
            GetLogDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetLog.getKey = (variables: GetLogVariables) => ['getLog.infinite', variables];

useGetLog.fetcher = (client: GraphQLClient, variables: GetLogVariables, headers?: RequestInit['headers']) =>
  fetcher<GetLog, GetLogVariables>(client, GetLogDocument, variables, headers);

export const GetAllLogsDocument = `
    query getAllLogs($keyword: String, $page: Int, $first: Int, $orderBy: [OrderByClause], $expense_id: ID, $with_disabled: Boolean, $filter: Filter) {
  flatLogs(
    keyword: $keyword
    page: $page
    first: $first
    orderBy: $orderBy
    expense_id: $expense_id
    with_disabled: $with_disabled
    filter: $filter
  ) {
    data {
      id
      name
      boat_detail_id
      boat_detail {
        id
        name
        flag
      }
      log
      datetime
      type
      notes
      latitude
      longitude
      trip {
        boat_detail {
          name
          flag
          id
        }
        name
        id
      }
      caption
      sea_area
      imminent
      later
      outlook
      channel
      station
      message
      event
      heading
      cog
      helm
      speed
      sog
      depth
      bar
      wind_speed
      wind_direction
      sky
      precipitation
      sea_state
      visibility
      air_temp
      sea_temp
      sails
      engine_status1
      engine_hours1
      engine_rpm1
      engine_fuel_check1
      engine_oil_check1
      engine_water_check1
      engine_exhaust_check1
      engine_status2
      engine_hours2
      engine_rpm2
      engine_fuel_check2
      engine_oil_check2
      engine_water_check2
      engine_exhaust_check2
      diesel_generator_status
      diesel_generator_hours
      diesel_generator_rpm
      diesel_generator_fuel_check
      diesel_generator_oil_check
      diesel_generator_water_check
      diesel_generator_exhaust_check
      battery1
      battery2
      boat_water
      fuel
      gas
      bilge
      created_at
      updated_at
      can_delete
      can_update
      expenses {
        id
        item_name
        pivot {
          usage_log_name
          usage_value
          quantity
          quantity_action
        }
      }
      user {
        name
        surname
      }
      files {
        id
        name
        url
      }
      costs {
        id
        amount
        currency_id
        currency {
          id
          name
          iso_code
        }
        vat_percentage
        vat_type
        type
        supplier
      }
      cost {
        id
        amount
        currency_id
        currency {
          id
          name
          iso_code
        }
        vat_percentage
        vat_type
        type
        supplier
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

export const useGetAllLogs = <TData = GetAllLogs, TError = unknown>(
  client: GraphQLClient,
  variables?: GetAllLogsVariables,
  options?: Omit<UseQueryOptions<GetAllLogs, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetAllLogs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetAllLogs, TError, TData>({
    queryKey: variables === undefined ? ['getAllLogs'] : ['getAllLogs', variables],
    queryFn: fetcher<GetAllLogs, GetAllLogsVariables>(client, GetAllLogsDocument, variables, headers),
    ...options,
  });
};

useGetAllLogs.getKey = (variables?: GetAllLogsVariables) =>
  variables === undefined ? ['getAllLogs'] : ['getAllLogs', variables];

export const useInfiniteGetAllLogs = <TData = InfiniteData<GetAllLogs>, TError = unknown>(
  client: GraphQLClient,
  variables: GetAllLogsVariables,
  options: Omit<UseInfiniteQueryOptions<GetAllLogs, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetAllLogs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetAllLogs, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined) ? ['getAllLogs.infinite'] : ['getAllLogs.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetAllLogs, GetAllLogsVariables>(
            client,
            GetAllLogsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetAllLogs.getKey = (variables?: GetAllLogsVariables) =>
  variables === undefined ? ['getAllLogs.infinite'] : ['getAllLogs.infinite', variables];

useGetAllLogs.fetcher = (client: GraphQLClient, variables?: GetAllLogsVariables, headers?: RequestInit['headers']) =>
  fetcher<GetAllLogs, GetAllLogsVariables>(client, GetAllLogsDocument, variables, headers);

export const GetManufacturersDocument = `
    query getManufacturers($page: Int, $first: Int) {
  manufacturers(first: $first, page: $page) {
    data {
      id
      name
      website
      publicBoatCount
      slug
      logo {
        public_url
      }
    }
    paginatorInfo {
      count
      currentPage
      perPage
      total
    }
  }
}
    `;

export const useGetManufacturers = <TData = GetManufacturers, TError = unknown>(
  client: GraphQLClient,
  variables?: GetManufacturersVariables,
  options?: Omit<UseQueryOptions<GetManufacturers, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetManufacturers, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetManufacturers, TError, TData>({
    queryKey: variables === undefined ? ['getManufacturers'] : ['getManufacturers', variables],
    queryFn: fetcher<GetManufacturers, GetManufacturersVariables>(client, GetManufacturersDocument, variables, headers),
    ...options,
  });
};

useGetManufacturers.getKey = (variables?: GetManufacturersVariables) =>
  variables === undefined ? ['getManufacturers'] : ['getManufacturers', variables];

export const useInfiniteGetManufacturers = <TData = InfiniteData<GetManufacturers>, TError = unknown>(
  client: GraphQLClient,
  variables: GetManufacturersVariables,
  options: Omit<UseInfiniteQueryOptions<GetManufacturers, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetManufacturers, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetManufacturers, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getManufacturers.infinite']
            : ['getManufacturers.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetManufacturers, GetManufacturersVariables>(
            client,
            GetManufacturersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetManufacturers.getKey = (variables?: GetManufacturersVariables) =>
  variables === undefined ? ['getManufacturers.infinite'] : ['getManufacturers.infinite', variables];

useGetManufacturers.fetcher = (
  client: GraphQLClient,
  variables?: GetManufacturersVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetManufacturers, GetManufacturersVariables>(client, GetManufacturersDocument, variables, headers);

export const GetMakersDocument = `
    query getMakers($page: Int, $first: Int) {
  manufacturers(first: $first, page: $page) {
    data {
      id
      website
      name
    }
  }
}
    `;

export const useGetMakers = <TData = GetMakers, TError = unknown>(
  client: GraphQLClient,
  variables?: GetMakersVariables,
  options?: Omit<UseQueryOptions<GetMakers, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetMakers, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetMakers, TError, TData>({
    queryKey: variables === undefined ? ['getMakers'] : ['getMakers', variables],
    queryFn: fetcher<GetMakers, GetMakersVariables>(client, GetMakersDocument, variables, headers),
    ...options,
  });
};

useGetMakers.getKey = (variables?: GetMakersVariables) =>
  variables === undefined ? ['getMakers'] : ['getMakers', variables];

export const useInfiniteGetMakers = <TData = InfiniteData<GetMakers>, TError = unknown>(
  client: GraphQLClient,
  variables: GetMakersVariables,
  options: Omit<UseInfiniteQueryOptions<GetMakers, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetMakers, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetMakers, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined) ? ['getMakers.infinite'] : ['getMakers.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetMakers, GetMakersVariables>(
            client,
            GetMakersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetMakers.getKey = (variables?: GetMakersVariables) =>
  variables === undefined ? ['getMakers.infinite'] : ['getMakers.infinite', variables];

useGetMakers.fetcher = (client: GraphQLClient, variables?: GetMakersVariables, headers?: RequestInit['headers']) =>
  fetcher<GetMakers, GetMakersVariables>(client, GetMakersDocument, variables, headers);

export const GetCurrentUserDataDocument = `
    query getCurrentUserData {
  authUser {
    id
    display_name
    birthday
    gender
    image_id
    image {
      ...UserProfileImage
    }
    name
    surname
    email
    phone
    unit
    memory_usage_percentage
    novu_id
    timezone {
      id
      name
    }
    country {
      id
    }
    currency {
      id
      iso_code
    }
    base_currency_id
    base_currency {
      id
      iso_code
      symbol
    }
    card_last_four
    card_brand
    address {
      id
      street
      city
      state
      postal_code
      country
    }
    created_at
  }
}
    ${UserProfileImage}`;

export const useGetCurrentUserData = <TData = GetCurrentUserData, TError = unknown>(
  client: GraphQLClient,
  variables?: GetCurrentUserDataVariables,
  options?: Omit<UseQueryOptions<GetCurrentUserData, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetCurrentUserData, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetCurrentUserData, TError, TData>({
    queryKey: variables === undefined ? ['getCurrentUserData'] : ['getCurrentUserData', variables],
    queryFn: fetcher<GetCurrentUserData, GetCurrentUserDataVariables>(
      client,
      GetCurrentUserDataDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetCurrentUserData.getKey = (variables?: GetCurrentUserDataVariables) =>
  variables === undefined ? ['getCurrentUserData'] : ['getCurrentUserData', variables];

export const useInfiniteGetCurrentUserData = <TData = InfiniteData<GetCurrentUserData>, TError = unknown>(
  client: GraphQLClient,
  variables: GetCurrentUserDataVariables,
  options: Omit<UseInfiniteQueryOptions<GetCurrentUserData, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetCurrentUserData, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetCurrentUserData, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getCurrentUserData.infinite']
            : ['getCurrentUserData.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetCurrentUserData, GetCurrentUserDataVariables>(
            client,
            GetCurrentUserDataDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetCurrentUserData.getKey = (variables?: GetCurrentUserDataVariables) =>
  variables === undefined ? ['getCurrentUserData.infinite'] : ['getCurrentUserData.infinite', variables];

useGetCurrentUserData.fetcher = (
  client: GraphQLClient,
  variables?: GetCurrentUserDataVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetCurrentUserData, GetCurrentUserDataVariables>(client, GetCurrentUserDataDocument, variables, headers);

export const NovuDeviceTokensQueryDocument = `
    query novuDeviceTokensQuery {
  novuDeviceTokens
}
    `;

export const useNovuDeviceTokensQuery = <TData = NovuDeviceTokensQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: NovuDeviceTokensQueryVariables,
  options?: Omit<UseQueryOptions<NovuDeviceTokensQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<NovuDeviceTokensQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<NovuDeviceTokensQuery, TError, TData>({
    queryKey: variables === undefined ? ['novuDeviceTokensQuery'] : ['novuDeviceTokensQuery', variables],
    queryFn: fetcher<NovuDeviceTokensQuery, NovuDeviceTokensQueryVariables>(
      client,
      NovuDeviceTokensQueryDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useNovuDeviceTokensQuery.getKey = (variables?: NovuDeviceTokensQueryVariables) =>
  variables === undefined ? ['novuDeviceTokensQuery'] : ['novuDeviceTokensQuery', variables];

export const useInfiniteNovuDeviceTokensQuery = <TData = InfiniteData<NovuDeviceTokensQuery>, TError = unknown>(
  client: GraphQLClient,
  variables: NovuDeviceTokensQueryVariables,
  options: Omit<UseInfiniteQueryOptions<NovuDeviceTokensQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<NovuDeviceTokensQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<NovuDeviceTokensQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['novuDeviceTokensQuery.infinite']
            : ['novuDeviceTokensQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<NovuDeviceTokensQuery, NovuDeviceTokensQueryVariables>(
            client,
            NovuDeviceTokensQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteNovuDeviceTokensQuery.getKey = (variables?: NovuDeviceTokensQueryVariables) =>
  variables === undefined ? ['novuDeviceTokensQuery.infinite'] : ['novuDeviceTokensQuery.infinite', variables];

useNovuDeviceTokensQuery.fetcher = (
  client: GraphQLClient,
  variables?: NovuDeviceTokensQueryVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<NovuDeviceTokensQuery, NovuDeviceTokensQueryVariables>(
    client,
    NovuDeviceTokensQueryDocument,
    variables,
    headers,
  );

export const DeviceTokenStatusQueryDocument = `
    query deviceTokenStatusQuery($provider: String!, $token: String!) {
  deviceTokenStatus(provider: $provider, token: $token)
}
    `;

export const useDeviceTokenStatusQuery = <TData = DeviceTokenStatusQuery, TError = unknown>(
  client: GraphQLClient,
  variables: DeviceTokenStatusQueryVariables,
  options?: Omit<UseQueryOptions<DeviceTokenStatusQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<DeviceTokenStatusQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<DeviceTokenStatusQuery, TError, TData>({
    queryKey: ['deviceTokenStatusQuery', variables],
    queryFn: fetcher<DeviceTokenStatusQuery, DeviceTokenStatusQueryVariables>(
      client,
      DeviceTokenStatusQueryDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useDeviceTokenStatusQuery.getKey = (variables: DeviceTokenStatusQueryVariables) => [
  'deviceTokenStatusQuery',
  variables,
];

export const useInfiniteDeviceTokenStatusQuery = <TData = InfiniteData<DeviceTokenStatusQuery>, TError = unknown>(
  client: GraphQLClient,
  variables: DeviceTokenStatusQueryVariables,
  options: Omit<UseInfiniteQueryOptions<DeviceTokenStatusQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<DeviceTokenStatusQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<DeviceTokenStatusQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['deviceTokenStatusQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<DeviceTokenStatusQuery, DeviceTokenStatusQueryVariables>(
            client,
            DeviceTokenStatusQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteDeviceTokenStatusQuery.getKey = (variables: DeviceTokenStatusQueryVariables) => [
  'deviceTokenStatusQuery.infinite',
  variables,
];

useDeviceTokenStatusQuery.fetcher = (
  client: GraphQLClient,
  variables: DeviceTokenStatusQueryVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<DeviceTokenStatusQuery, DeviceTokenStatusQueryVariables>(
    client,
    DeviceTokenStatusQueryDocument,
    variables,
    headers,
  );

export const GetPlanOfUserDocument = `
    query getPlanOfUser($id: ID, $slug: String) {
  planOfUser(id: $id, slug: $slug) {
    ...PlanOfAUserFragment
  }
}
    ${PlanOfAUserFragment}`;

export const useGetPlanOfUser = <TData = GetPlanOfUser, TError = unknown>(
  client: GraphQLClient,
  variables?: GetPlanOfUserVariables,
  options?: Omit<UseQueryOptions<GetPlanOfUser, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPlanOfUser, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetPlanOfUser, TError, TData>({
    queryKey: variables === undefined ? ['getPlanOfUser'] : ['getPlanOfUser', variables],
    queryFn: fetcher<GetPlanOfUser, GetPlanOfUserVariables>(client, GetPlanOfUserDocument, variables, headers),
    ...options,
  });
};

useGetPlanOfUser.getKey = (variables?: GetPlanOfUserVariables) =>
  variables === undefined ? ['getPlanOfUser'] : ['getPlanOfUser', variables];

export const useInfiniteGetPlanOfUser = <TData = InfiniteData<GetPlanOfUser>, TError = unknown>(
  client: GraphQLClient,
  variables: GetPlanOfUserVariables,
  options: Omit<UseInfiniteQueryOptions<GetPlanOfUser, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetPlanOfUser, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetPlanOfUser, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getPlanOfUser.infinite']
            : ['getPlanOfUser.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetPlanOfUser, GetPlanOfUserVariables>(
            client,
            GetPlanOfUserDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetPlanOfUser.getKey = (variables?: GetPlanOfUserVariables) =>
  variables === undefined ? ['getPlanOfUser.infinite'] : ['getPlanOfUser.infinite', variables];

useGetPlanOfUser.fetcher = (
  client: GraphQLClient,
  variables?: GetPlanOfUserVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetPlanOfUser, GetPlanOfUserVariables>(client, GetPlanOfUserDocument, variables, headers);

export const GetCheckoutDataDocument = `
    query getCheckoutData($sessionId: String!) {
  retrieveCheckoutData(session_id: $sessionId) {
    plan_id
    plan_name
    renewal_date
  }
}
    `;

export const useGetCheckoutData = <TData = GetCheckoutData, TError = unknown>(
  client: GraphQLClient,
  variables: GetCheckoutDataVariables,
  options?: Omit<UseQueryOptions<GetCheckoutData, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetCheckoutData, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetCheckoutData, TError, TData>({
    queryKey: ['getCheckoutData', variables],
    queryFn: fetcher<GetCheckoutData, GetCheckoutDataVariables>(client, GetCheckoutDataDocument, variables, headers),
    ...options,
  });
};

useGetCheckoutData.getKey = (variables: GetCheckoutDataVariables) => ['getCheckoutData', variables];

export const useInfiniteGetCheckoutData = <TData = InfiniteData<GetCheckoutData>, TError = unknown>(
  client: GraphQLClient,
  variables: GetCheckoutDataVariables,
  options: Omit<UseInfiniteQueryOptions<GetCheckoutData, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetCheckoutData, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetCheckoutData, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getCheckoutData.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetCheckoutData, GetCheckoutDataVariables>(
            client,
            GetCheckoutDataDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetCheckoutData.getKey = (variables: GetCheckoutDataVariables) => ['getCheckoutData.infinite', variables];

useGetCheckoutData.fetcher = (
  client: GraphQLClient,
  variables: GetCheckoutDataVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetCheckoutData, GetCheckoutDataVariables>(client, GetCheckoutDataDocument, variables, headers);

export const PlansQueryDocument = `
    query plansQuery {
  plans {
    ...PlanFragment
  }
}
    ${PlanFragment}`;

export const usePlansQuery = <TData = PlansQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: PlansQueryVariables,
  options?: Omit<UseQueryOptions<PlansQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<PlansQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<PlansQuery, TError, TData>({
    queryKey: variables === undefined ? ['plansQuery'] : ['plansQuery', variables],
    queryFn: fetcher<PlansQuery, PlansQueryVariables>(client, PlansQueryDocument, variables, headers),
    ...options,
  });
};

usePlansQuery.getKey = (variables?: PlansQueryVariables) =>
  variables === undefined ? ['plansQuery'] : ['plansQuery', variables];

export const useInfinitePlansQuery = <TData = InfiniteData<PlansQuery>, TError = unknown>(
  client: GraphQLClient,
  variables: PlansQueryVariables,
  options: Omit<UseInfiniteQueryOptions<PlansQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<PlansQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<PlansQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined) ? ['plansQuery.infinite'] : ['plansQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<PlansQuery, PlansQueryVariables>(
            client,
            PlansQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfinitePlansQuery.getKey = (variables?: PlansQueryVariables) =>
  variables === undefined ? ['plansQuery.infinite'] : ['plansQuery.infinite', variables];

usePlansQuery.fetcher = (client: GraphQLClient, variables?: PlansQueryVariables, headers?: RequestInit['headers']) =>
  fetcher<PlansQuery, PlansQueryVariables>(client, PlansQueryDocument, variables, headers);

export const PlanOfUserQueryDocument = `
    query planOfUserQuery {
  planOfUser {
    ...PlanOfAUserFragment
  }
}
    ${PlanOfAUserFragment}`;

export const usePlanOfUserQuery = <TData = PlanOfUserQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: PlanOfUserQueryVariables,
  options?: Omit<UseQueryOptions<PlanOfUserQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<PlanOfUserQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<PlanOfUserQuery, TError, TData>({
    queryKey: variables === undefined ? ['planOfUserQuery'] : ['planOfUserQuery', variables],
    queryFn: fetcher<PlanOfUserQuery, PlanOfUserQueryVariables>(client, PlanOfUserQueryDocument, variables, headers),
    ...options,
  });
};

usePlanOfUserQuery.getKey = (variables?: PlanOfUserQueryVariables) =>
  variables === undefined ? ['planOfUserQuery'] : ['planOfUserQuery', variables];

export const useInfinitePlanOfUserQuery = <TData = InfiniteData<PlanOfUserQuery>, TError = unknown>(
  client: GraphQLClient,
  variables: PlanOfUserQueryVariables,
  options: Omit<UseInfiniteQueryOptions<PlanOfUserQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<PlanOfUserQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<PlanOfUserQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['planOfUserQuery.infinite']
            : ['planOfUserQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<PlanOfUserQuery, PlanOfUserQueryVariables>(
            client,
            PlanOfUserQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfinitePlanOfUserQuery.getKey = (variables?: PlanOfUserQueryVariables) =>
  variables === undefined ? ['planOfUserQuery.infinite'] : ['planOfUserQuery.infinite', variables];

usePlanOfUserQuery.fetcher = (
  client: GraphQLClient,
  variables?: PlanOfUserQueryVariables,
  headers?: RequestInit['headers'],
) => fetcher<PlanOfUserQuery, PlanOfUserQueryVariables>(client, PlanOfUserQueryDocument, variables, headers);

export const InvoicesQueryDocument = `
    query invoicesQuery($limit: Int, $starting_after: String) {
  invoices(limit: $limit, starting_after: $starting_after) {
    id
    created
    hosted_invoice_url
    paid
    total
    status
  }
}
    `;

export const useInvoicesQuery = <TData = InvoicesQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: InvoicesQueryVariables,
  options?: Omit<UseQueryOptions<InvoicesQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<InvoicesQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<InvoicesQuery, TError, TData>({
    queryKey: variables === undefined ? ['invoicesQuery'] : ['invoicesQuery', variables],
    queryFn: fetcher<InvoicesQuery, InvoicesQueryVariables>(client, InvoicesQueryDocument, variables, headers),
    ...options,
  });
};

useInvoicesQuery.getKey = (variables?: InvoicesQueryVariables) =>
  variables === undefined ? ['invoicesQuery'] : ['invoicesQuery', variables];

export const useInfiniteInvoicesQuery = <TData = InfiniteData<InvoicesQuery>, TError = unknown>(
  client: GraphQLClient,
  variables: InvoicesQueryVariables,
  options: Omit<UseInfiniteQueryOptions<InvoicesQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<InvoicesQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<InvoicesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['invoicesQuery.infinite']
            : ['invoicesQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<InvoicesQuery, InvoicesQueryVariables>(
            client,
            InvoicesQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteInvoicesQuery.getKey = (variables?: InvoicesQueryVariables) =>
  variables === undefined ? ['invoicesQuery.infinite'] : ['invoicesQuery.infinite', variables];

useInvoicesQuery.fetcher = (
  client: GraphQLClient,
  variables?: InvoicesQueryVariables,
  headers?: RequestInit['headers'],
) => fetcher<InvoicesQuery, InvoicesQueryVariables>(client, InvoicesQueryDocument, variables, headers);

export const PreviewUpgradeInvoiceQueryDocument = `
    query previewUpgradeInvoiceQuery($plan_id: ID!, $quantity: Int, $proration_time: ProrationTimeEnum!) {
  previewUpgradeInvoice(
    plan_id: $plan_id
    quantity: $quantity
    proration_time: $proration_time
  ) {
    id
    billing_reason
    charge
    collection_method
    currency
    total
    subtotal
    subscription
    due_date
    default_payment_method
    period_end
    period_start
    statement_descriptor
    discount
    object
    amount_due
    created
    customer
    customer_address
    default_source
    default_tax_rates
    lines {
      object
      data {
        id
        subscription
        currency
        quantity
        amount
        object
        description
        proration
        period {
          start
          end
        }
        price {
          id
          unit_amount
          currency
          unit_amount_decimal
          tiers_mode
          transform_quantity
          type
        }
        tax_amounts {
          amount
          inclusive
          tax_rate
          taxability_reason
          taxable_amount
        }
      }
    }
  }
}
    `;

export const usePreviewUpgradeInvoiceQuery = <TData = PreviewUpgradeInvoiceQuery, TError = unknown>(
  client: GraphQLClient,
  variables: PreviewUpgradeInvoiceQueryVariables,
  options?: Omit<UseQueryOptions<PreviewUpgradeInvoiceQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<PreviewUpgradeInvoiceQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<PreviewUpgradeInvoiceQuery, TError, TData>({
    queryKey: ['previewUpgradeInvoiceQuery', variables],
    queryFn: fetcher<PreviewUpgradeInvoiceQuery, PreviewUpgradeInvoiceQueryVariables>(
      client,
      PreviewUpgradeInvoiceQueryDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

usePreviewUpgradeInvoiceQuery.getKey = (variables: PreviewUpgradeInvoiceQueryVariables) => [
  'previewUpgradeInvoiceQuery',
  variables,
];

export const useInfinitePreviewUpgradeInvoiceQuery = <
  TData = InfiniteData<PreviewUpgradeInvoiceQuery>,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: PreviewUpgradeInvoiceQueryVariables,
  options: Omit<UseInfiniteQueryOptions<PreviewUpgradeInvoiceQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<PreviewUpgradeInvoiceQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<PreviewUpgradeInvoiceQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['previewUpgradeInvoiceQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<PreviewUpgradeInvoiceQuery, PreviewUpgradeInvoiceQueryVariables>(
            client,
            PreviewUpgradeInvoiceQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfinitePreviewUpgradeInvoiceQuery.getKey = (variables: PreviewUpgradeInvoiceQueryVariables) => [
  'previewUpgradeInvoiceQuery.infinite',
  variables,
];

usePreviewUpgradeInvoiceQuery.fetcher = (
  client: GraphQLClient,
  variables: PreviewUpgradeInvoiceQueryVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<PreviewUpgradeInvoiceQuery, PreviewUpgradeInvoiceQueryVariables>(
    client,
    PreviewUpgradeInvoiceQueryDocument,
    variables,
    headers,
  );

export const UpcomingInvoiceQueryDocument = `
    query upcomingInvoiceQuery {
  upcomingInvoice {
    id
    billing_reason
    lines {
      object
      data {
        id
        subscription
        currency
        quantity
        amount
        object
        description
        period {
          start
          end
        }
        proration
        price {
          id
          unit_amount
          currency
          unit_amount_decimal
          tiers_mode
          transform_quantity
          type
        }
        period {
          start
          end
        }
        proration
      }
    }
  }
}
    `;

export const useUpcomingInvoiceQuery = <TData = UpcomingInvoiceQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: UpcomingInvoiceQueryVariables,
  options?: Omit<UseQueryOptions<UpcomingInvoiceQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<UpcomingInvoiceQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<UpcomingInvoiceQuery, TError, TData>({
    queryKey: variables === undefined ? ['upcomingInvoiceQuery'] : ['upcomingInvoiceQuery', variables],
    queryFn: fetcher<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>(
      client,
      UpcomingInvoiceQueryDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useUpcomingInvoiceQuery.getKey = (variables?: UpcomingInvoiceQueryVariables) =>
  variables === undefined ? ['upcomingInvoiceQuery'] : ['upcomingInvoiceQuery', variables];

export const useInfiniteUpcomingInvoiceQuery = <TData = InfiniteData<UpcomingInvoiceQuery>, TError = unknown>(
  client: GraphQLClient,
  variables: UpcomingInvoiceQueryVariables,
  options: Omit<UseInfiniteQueryOptions<UpcomingInvoiceQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<UpcomingInvoiceQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<UpcomingInvoiceQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['upcomingInvoiceQuery.infinite']
            : ['upcomingInvoiceQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>(
            client,
            UpcomingInvoiceQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteUpcomingInvoiceQuery.getKey = (variables?: UpcomingInvoiceQueryVariables) =>
  variables === undefined ? ['upcomingInvoiceQuery.infinite'] : ['upcomingInvoiceQuery.infinite', variables];

useUpcomingInvoiceQuery.fetcher = (
  client: GraphQLClient,
  variables?: UpcomingInvoiceQueryVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>(
    client,
    UpcomingInvoiceQueryDocument,
    variables,
    headers,
  );

export const ScheduledUpdateQueryDocument = `
    query scheduledUpdateQuery {
  scheduledUpdate {
    id
    object
    application
    canceled_at
    completed_at
    created
    current_phase
    customer
    default_settings {
      application_fee_percent
      automatic_tax {
        enabled
        liability
      }
      billing_cycle_anchor
      billing_thresholds
      collection_method
      default_payment_method
      default_source
      description
      issuer {
        type
      }
      on_behalf_of
      transfer_data
    }
    end_behavior
    livemode
    metadata
    phases {
      add_invoice_items
      application_fee_percent
      billing_cycle_anchor
      billing_thresholds
      collection_method
      coupon
      currency
      default_payment_method
      default_tax_rates
      description
      end_date
      invoice_settings
      items {
        billing_thresholds
        metadata
        plan
        price
        quantity
        tax_rates
      }
      metadata
      on_behalf_of
      proration_behavior
      start_date
      transfer_data
      trial_end
    }
    released_at
    released_subscription
    renewal_interval
    status
    subscription
    test_clock
  }
}
    `;

export const useScheduledUpdateQuery = <TData = ScheduledUpdateQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: ScheduledUpdateQueryVariables,
  options?: Omit<UseQueryOptions<ScheduledUpdateQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ScheduledUpdateQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<ScheduledUpdateQuery, TError, TData>({
    queryKey: variables === undefined ? ['scheduledUpdateQuery'] : ['scheduledUpdateQuery', variables],
    queryFn: fetcher<ScheduledUpdateQuery, ScheduledUpdateQueryVariables>(
      client,
      ScheduledUpdateQueryDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useScheduledUpdateQuery.getKey = (variables?: ScheduledUpdateQueryVariables) =>
  variables === undefined ? ['scheduledUpdateQuery'] : ['scheduledUpdateQuery', variables];

export const useInfiniteScheduledUpdateQuery = <TData = InfiniteData<ScheduledUpdateQuery>, TError = unknown>(
  client: GraphQLClient,
  variables: ScheduledUpdateQueryVariables,
  options: Omit<UseInfiniteQueryOptions<ScheduledUpdateQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<ScheduledUpdateQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<ScheduledUpdateQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['scheduledUpdateQuery.infinite']
            : ['scheduledUpdateQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<ScheduledUpdateQuery, ScheduledUpdateQueryVariables>(
            client,
            ScheduledUpdateQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteScheduledUpdateQuery.getKey = (variables?: ScheduledUpdateQueryVariables) =>
  variables === undefined ? ['scheduledUpdateQuery.infinite'] : ['scheduledUpdateQuery.infinite', variables];

useScheduledUpdateQuery.fetcher = (
  client: GraphQLClient,
  variables?: ScheduledUpdateQueryVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<ScheduledUpdateQuery, ScheduledUpdateQueryVariables>(
    client,
    ScheduledUpdateQueryDocument,
    variables,
    headers,
  );

export const GetRelatedUsersBoatsDocument = `
    query getRelatedUsersBoats($id: ID!, $limit: Int) {
  relatedUsersBoats(id: $id, limit: $limit) {
    user {
      name
      surname
    }
    flag
    boat {
      id
      views_count
      favorites_count
      year_first
      model
      manufacturer_name
      slug
      is_favorited
    }
  }
}
    `;

export const useGetRelatedUsersBoats = <TData = GetRelatedUsersBoats, TError = unknown>(
  client: GraphQLClient,
  variables: GetRelatedUsersBoatsVariables,
  options?: Omit<UseQueryOptions<GetRelatedUsersBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetRelatedUsersBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetRelatedUsersBoats, TError, TData>({
    queryKey: ['getRelatedUsersBoats', variables],
    queryFn: fetcher<GetRelatedUsersBoats, GetRelatedUsersBoatsVariables>(
      client,
      GetRelatedUsersBoatsDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetRelatedUsersBoats.getKey = (variables: GetRelatedUsersBoatsVariables) => ['getRelatedUsersBoats', variables];

export const useInfiniteGetRelatedUsersBoats = <TData = InfiniteData<GetRelatedUsersBoats>, TError = unknown>(
  client: GraphQLClient,
  variables: GetRelatedUsersBoatsVariables,
  options: Omit<UseInfiniteQueryOptions<GetRelatedUsersBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetRelatedUsersBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetRelatedUsersBoats, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getRelatedUsersBoats.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetRelatedUsersBoats, GetRelatedUsersBoatsVariables>(
            client,
            GetRelatedUsersBoatsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetRelatedUsersBoats.getKey = (variables: GetRelatedUsersBoatsVariables) => [
  'getRelatedUsersBoats.infinite',
  variables,
];

useGetRelatedUsersBoats.fetcher = (
  client: GraphQLClient,
  variables: GetRelatedUsersBoatsVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetRelatedUsersBoats, GetRelatedUsersBoatsVariables>(
    client,
    GetRelatedUsersBoatsDocument,
    variables,
    headers,
  );

export const UserSettingsDocument = `
    query userSettings {
  settings {
    data {
      key
      value
      __typename
    }
  }
}
    `;

export const useUserSettings = <TData = UserSettings, TError = unknown>(
  client: GraphQLClient,
  variables?: UserSettingsVariables,
  options?: Omit<UseQueryOptions<UserSettings, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<UserSettings, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<UserSettings, TError, TData>({
    queryKey: variables === undefined ? ['userSettings'] : ['userSettings', variables],
    queryFn: fetcher<UserSettings, UserSettingsVariables>(client, UserSettingsDocument, variables, headers),
    ...options,
  });
};

useUserSettings.getKey = (variables?: UserSettingsVariables) =>
  variables === undefined ? ['userSettings'] : ['userSettings', variables];

export const useInfiniteUserSettings = <TData = InfiniteData<UserSettings>, TError = unknown>(
  client: GraphQLClient,
  variables: UserSettingsVariables,
  options: Omit<UseInfiniteQueryOptions<UserSettings, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<UserSettings, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<UserSettings, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['userSettings.infinite']
            : ['userSettings.infinite', variables],
        queryFn: (metaData) =>
          fetcher<UserSettings, UserSettingsVariables>(
            client,
            UserSettingsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteUserSettings.getKey = (variables?: UserSettingsVariables) =>
  variables === undefined ? ['userSettings.infinite'] : ['userSettings.infinite', variables];

useUserSettings.fetcher = (
  client: GraphQLClient,
  variables?: UserSettingsVariables,
  headers?: RequestInit['headers'],
) => fetcher<UserSettings, UserSettingsVariables>(client, UserSettingsDocument, variables, headers);

export const UserSubscriptionQueryDocument = `
    query userSubscriptionQuery {
  subscription {
    ...UserSubscriptionFragment
    subscription_schedule {
      ...SubscriptionScheduleFragment
    }
    plan {
      ...SubscriptionPlanFragment
    }
  }
}
    ${UserSubscriptionFragment}
${SubscriptionScheduleFragment}
${SubscriptionPlanFragment}`;

export const useUserSubscriptionQuery = <TData = UserSubscriptionQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: UserSubscriptionQueryVariables,
  options?: Omit<UseQueryOptions<UserSubscriptionQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<UserSubscriptionQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<UserSubscriptionQuery, TError, TData>({
    queryKey: variables === undefined ? ['userSubscriptionQuery'] : ['userSubscriptionQuery', variables],
    queryFn: fetcher<UserSubscriptionQuery, UserSubscriptionQueryVariables>(
      client,
      UserSubscriptionQueryDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useUserSubscriptionQuery.getKey = (variables?: UserSubscriptionQueryVariables) =>
  variables === undefined ? ['userSubscriptionQuery'] : ['userSubscriptionQuery', variables];

export const useInfiniteUserSubscriptionQuery = <TData = InfiniteData<UserSubscriptionQuery>, TError = unknown>(
  client: GraphQLClient,
  variables: UserSubscriptionQueryVariables,
  options: Omit<UseInfiniteQueryOptions<UserSubscriptionQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<UserSubscriptionQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<UserSubscriptionQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['userSubscriptionQuery.infinite']
            : ['userSubscriptionQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<UserSubscriptionQuery, UserSubscriptionQueryVariables>(
            client,
            UserSubscriptionQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteUserSubscriptionQuery.getKey = (variables?: UserSubscriptionQueryVariables) =>
  variables === undefined ? ['userSubscriptionQuery.infinite'] : ['userSubscriptionQuery.infinite', variables];

useUserSubscriptionQuery.fetcher = (
  client: GraphQLClient,
  variables?: UserSubscriptionQueryVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<UserSubscriptionQuery, UserSubscriptionQueryVariables>(
    client,
    UserSubscriptionQueryDocument,
    variables,
    headers,
  );

export const GetTasksDocument = `
    query getTasks($keyword: String, $page: Int, $first: Int, $orderBy: [OrderByClause], $boat_details_id: ID, $with_disabled: Boolean, $type: String, $due_date_range: [String]) {
  tasks(
    keyword: $keyword
    page: $page
    first: $first
    orderBy: $orderBy
    boat_details_id: $boat_details_id
    with_disabled: $with_disabled
    type: $type
    due_date_range: $due_date_range
  ) {
    data {
      boat_detail_id
      boat_detail {
        id
        name
        flag
      }
      user_id
      assignee_ids
      assignee {
        display_name
        email
        name
        surname
        id
        image {
          ...RequiredFileFields
        }
      }
      id
      name
      taxonomies {
        id
        name
      }
      category {
        id
        name
        type
      }
      category_id
      type
      status
      user {
        id
        name
        surname
        display_name
      }
      frequency
      is_recurring
      priority
      notes
      created_at
      due_date
      has_notification
      completed_at
      time_unit
      time_unit_type
      linked_expense_id
      expenses {
        id
        item_name
      }
      marked_as_maintenance
      usage_is_custom
      usage_time_unit_type
      usage_time_unit
      usage_recurrence_time_unit
      usage_recurrence_time_unit_type
      has_usage_reminder
      recurrence_type
      usage_recurrence
      threshold_recurrence_reminder
      costs {
        id
        amount
        currency_id
        currency {
          id
          name
          iso_code
        }
        vat_percentage
        vat_type
        type
        supplier
      }
      cost {
        id
        amount
        currency_id
        currency {
          id
          name
          iso_code
        }
        vat_percentage
        vat_type
        type
        supplier
      }
      files {
        ...FileCardGallery
      }
      can_delete
      can_update
      can_share
      alert {
        id
      }
    }
    paginatorInfo {
      firstItem
      currentPage
      count
      perPage
      total
      firstItem
      lastItem
    }
  }
}
    ${RequiredFileFields}
${FileCardGallery}`;

export const useGetTasks = <TData = GetTasks, TError = unknown>(
  client: GraphQLClient,
  variables?: GetTasksVariables,
  options?: Omit<UseQueryOptions<GetTasks, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetTasks, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetTasks, TError, TData>({
    queryKey: variables === undefined ? ['getTasks'] : ['getTasks', variables],
    queryFn: fetcher<GetTasks, GetTasksVariables>(client, GetTasksDocument, variables, headers),
    ...options,
  });
};

useGetTasks.getKey = (variables?: GetTasksVariables) =>
  variables === undefined ? ['getTasks'] : ['getTasks', variables];

export const useInfiniteGetTasks = <TData = InfiniteData<GetTasks>, TError = unknown>(
  client: GraphQLClient,
  variables: GetTasksVariables,
  options: Omit<UseInfiniteQueryOptions<GetTasks, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetTasks, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetTasks, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined) ? ['getTasks.infinite'] : ['getTasks.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetTasks, GetTasksVariables>(
            client,
            GetTasksDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetTasks.getKey = (variables?: GetTasksVariables) =>
  variables === undefined ? ['getTasks.infinite'] : ['getTasks.infinite', variables];

useGetTasks.fetcher = (client: GraphQLClient, variables?: GetTasksVariables, headers?: RequestInit['headers']) =>
  fetcher<GetTasks, GetTasksVariables>(client, GetTasksDocument, variables, headers);

export const GetTaskDocument = `
    query getTask($id: ID!) {
  task(id: $id) {
    boat_detail_id
    boat_detail {
      id
      name
      flag
    }
    user_id
    assignee_ids
    assignee {
      id
      display_name
      email
      name
      surname
      image {
        ...RequiredFileFields
      }
    }
    id
    name
    taxonomies {
      id
      name
    }
    category {
      id
      name
      type
    }
    category_id
    type
    status
    user {
      id
      name
      surname
      display_name
    }
    is_recurring
    frequency
    priority
    notes
    due_date
    has_notification
    completed_at
    time_unit
    time_unit_type
    linked_expense_id
    expenses {
      id
      item_name
    }
    marked_as_maintenance
    usage_is_custom
    usage_time_unit_type
    usage_time_unit
    usage_recurrence_time_unit
    usage_recurrence_time_unit_type
    has_usage_reminder
    recurrence_type
    usage_recurrence
    threshold_recurrence_reminder
    costs {
      id
      amount
      currency_id
      currency {
        id
        name
        iso_code
      }
      vat_percentage
      vat_type
      type
      supplier
    }
    cost {
      id
      amount
      currency_id
      currency {
        id
        name
        iso_code
      }
      vat_percentage
      vat_type
      type
      supplier
    }
    created_at
    files {
      ...RequiredFileFields
      created_at
    }
    can_delete
    can_update
    can_share
    alert {
      id
    }
  }
}
    ${RequiredFileFields}`;

export const useGetTask = <TData = GetTask, TError = unknown>(
  client: GraphQLClient,
  variables: GetTaskVariables,
  options?: Omit<UseQueryOptions<GetTask, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetTask, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetTask, TError, TData>({
    queryKey: ['getTask', variables],
    queryFn: fetcher<GetTask, GetTaskVariables>(client, GetTaskDocument, variables, headers),
    ...options,
  });
};

useGetTask.getKey = (variables: GetTaskVariables) => ['getTask', variables];

export const useInfiniteGetTask = <TData = InfiniteData<GetTask>, TError = unknown>(
  client: GraphQLClient,
  variables: GetTaskVariables,
  options: Omit<UseInfiniteQueryOptions<GetTask, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetTask, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetTask, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getTask.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetTask, GetTaskVariables>(
            client,
            GetTaskDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetTask.getKey = (variables: GetTaskVariables) => ['getTask.infinite', variables];

useGetTask.fetcher = (client: GraphQLClient, variables: GetTaskVariables, headers?: RequestInit['headers']) =>
  fetcher<GetTask, GetTaskVariables>(client, GetTaskDocument, variables, headers);

export const GetTimeZonesDocument = `
    query getTimeZones {
  timezones(first: 5000) {
    data {
      id
      name
    }
  }
}
    `;

export const useGetTimeZones = <TData = GetTimeZones, TError = unknown>(
  client: GraphQLClient,
  variables?: GetTimeZonesVariables,
  options?: Omit<UseQueryOptions<GetTimeZones, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetTimeZones, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetTimeZones, TError, TData>({
    queryKey: variables === undefined ? ['getTimeZones'] : ['getTimeZones', variables],
    queryFn: fetcher<GetTimeZones, GetTimeZonesVariables>(client, GetTimeZonesDocument, variables, headers),
    ...options,
  });
};

useGetTimeZones.getKey = (variables?: GetTimeZonesVariables) =>
  variables === undefined ? ['getTimeZones'] : ['getTimeZones', variables];

export const useInfiniteGetTimeZones = <TData = InfiniteData<GetTimeZones>, TError = unknown>(
  client: GraphQLClient,
  variables: GetTimeZonesVariables,
  options: Omit<UseInfiniteQueryOptions<GetTimeZones, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetTimeZones, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetTimeZones, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getTimeZones.infinite']
            : ['getTimeZones.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetTimeZones, GetTimeZonesVariables>(
            client,
            GetTimeZonesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetTimeZones.getKey = (variables?: GetTimeZonesVariables) =>
  variables === undefined ? ['getTimeZones.infinite'] : ['getTimeZones.infinite', variables];

useGetTimeZones.fetcher = (
  client: GraphQLClient,
  variables?: GetTimeZonesVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetTimeZones, GetTimeZonesVariables>(client, GetTimeZonesDocument, variables, headers);

export const GetTripsDocument = `
    query getTrips($page: Int, $firstItem: Int, $orderBy: [OrderByClause], $active: Boolean, $filter: Filter, $boat_details_id: ID, $with_disabled: Boolean) {
  trips(
    page: $page
    first: $firstItem
    orderBy: $orderBy
    active: $active
    filter: $filter
    boat_details_id: $boat_details_id
    with_disabled: $with_disabled
  ) {
    data {
      ...TripFields
    }
    paginatorInfo {
      firstItem
      lastItem
      count
      currentPage
      perPage
      total
      hasMorePages
    }
  }
}
    ${TripFields}`;

export const useGetTrips = <TData = GetTrips, TError = unknown>(
  client: GraphQLClient,
  variables?: GetTripsVariables,
  options?: Omit<UseQueryOptions<GetTrips, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetTrips, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetTrips, TError, TData>({
    queryKey: variables === undefined ? ['getTrips'] : ['getTrips', variables],
    queryFn: fetcher<GetTrips, GetTripsVariables>(client, GetTripsDocument, variables, headers),
    ...options,
  });
};

useGetTrips.getKey = (variables?: GetTripsVariables) =>
  variables === undefined ? ['getTrips'] : ['getTrips', variables];

export const useInfiniteGetTrips = <TData = InfiniteData<GetTrips>, TError = unknown>(
  client: GraphQLClient,
  variables: GetTripsVariables,
  options: Omit<UseInfiniteQueryOptions<GetTrips, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetTrips, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetTrips, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined) ? ['getTrips.infinite'] : ['getTrips.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetTrips, GetTripsVariables>(
            client,
            GetTripsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetTrips.getKey = (variables?: GetTripsVariables) =>
  variables === undefined ? ['getTrips.infinite'] : ['getTrips.infinite', variables];

useGetTrips.fetcher = (client: GraphQLClient, variables?: GetTripsVariables, headers?: RequestInit['headers']) =>
  fetcher<GetTrips, GetTripsVariables>(client, GetTripsDocument, variables, headers);

export const GetTotalTripLogsDocument = `
    query getTotalTripLogs($trip_id: ID!) {
  logsOfTrip(trip_id: $trip_id) {
    paginatorInfo {
      total
      count
    }
  }
}
    `;

export const useGetTotalTripLogs = <TData = GetTotalTripLogs, TError = unknown>(
  client: GraphQLClient,
  variables: GetTotalTripLogsVariables,
  options?: Omit<UseQueryOptions<GetTotalTripLogs, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetTotalTripLogs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetTotalTripLogs, TError, TData>({
    queryKey: ['getTotalTripLogs', variables],
    queryFn: fetcher<GetTotalTripLogs, GetTotalTripLogsVariables>(client, GetTotalTripLogsDocument, variables, headers),
    ...options,
  });
};

useGetTotalTripLogs.getKey = (variables: GetTotalTripLogsVariables) => ['getTotalTripLogs', variables];

export const useInfiniteGetTotalTripLogs = <TData = InfiniteData<GetTotalTripLogs>, TError = unknown>(
  client: GraphQLClient,
  variables: GetTotalTripLogsVariables,
  options: Omit<UseInfiniteQueryOptions<GetTotalTripLogs, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetTotalTripLogs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetTotalTripLogs, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getTotalTripLogs.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetTotalTripLogs, GetTotalTripLogsVariables>(
            client,
            GetTotalTripLogsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetTotalTripLogs.getKey = (variables: GetTotalTripLogsVariables) => ['getTotalTripLogs.infinite', variables];

useGetTotalTripLogs.fetcher = (
  client: GraphQLClient,
  variables: GetTotalTripLogsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetTotalTripLogs, GetTotalTripLogsVariables>(client, GetTotalTripLogsDocument, variables, headers);

export const GetTripDetailsDocument = `
    query getTripDetails($trip_id: ID!) {
  trip(id: $trip_id) {
    ...TripFields
  }
}
    ${TripFields}`;

export const useGetTripDetails = <TData = GetTripDetails, TError = unknown>(
  client: GraphQLClient,
  variables: GetTripDetailsVariables,
  options?: Omit<UseQueryOptions<GetTripDetails, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetTripDetails, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetTripDetails, TError, TData>({
    queryKey: ['getTripDetails', variables],
    queryFn: fetcher<GetTripDetails, GetTripDetailsVariables>(client, GetTripDetailsDocument, variables, headers),
    ...options,
  });
};

useGetTripDetails.getKey = (variables: GetTripDetailsVariables) => ['getTripDetails', variables];

export const useInfiniteGetTripDetails = <TData = InfiniteData<GetTripDetails>, TError = unknown>(
  client: GraphQLClient,
  variables: GetTripDetailsVariables,
  options: Omit<UseInfiniteQueryOptions<GetTripDetails, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetTripDetails, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetTripDetails, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getTripDetails.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetTripDetails, GetTripDetailsVariables>(
            client,
            GetTripDetailsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetTripDetails.getKey = (variables: GetTripDetailsVariables) => ['getTripDetails.infinite', variables];

useGetTripDetails.fetcher = (
  client: GraphQLClient,
  variables: GetTripDetailsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetTripDetails, GetTripDetailsVariables>(client, GetTripDetailsDocument, variables, headers);

export const GetUserDocument = `
    query getUser($id: ID!) {
  user(id: $id) {
    id
    name
    surname
    email
    display_name
  }
}
    `;

export const useGetUser = <TData = GetUser, TError = unknown>(
  client: GraphQLClient,
  variables: GetUserVariables,
  options?: Omit<UseQueryOptions<GetUser, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetUser, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetUser, TError, TData>({
    queryKey: ['getUser', variables],
    queryFn: fetcher<GetUser, GetUserVariables>(client, GetUserDocument, variables, headers),
    ...options,
  });
};

useGetUser.getKey = (variables: GetUserVariables) => ['getUser', variables];

export const useInfiniteGetUser = <TData = InfiniteData<GetUser>, TError = unknown>(
  client: GraphQLClient,
  variables: GetUserVariables,
  options: Omit<UseInfiniteQueryOptions<GetUser, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetUser, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetUser, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getUser.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetUser, GetUserVariables>(
            client,
            GetUserDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetUser.getKey = (variables: GetUserVariables) => ['getUser.infinite', variables];

useGetUser.fetcher = (client: GraphQLClient, variables: GetUserVariables, headers?: RequestInit['headers']) =>
  fetcher<GetUser, GetUserVariables>(client, GetUserDocument, variables, headers);

export const GetSearchedUsersDocument = `
    query getSearchedUsers($keyword: String!) {
  searchUsers(keyword: $keyword) {
    id
    email
    display_name
    name
    surname
    image {
      url
    }
  }
}
    `;

export const useGetSearchedUsers = <TData = GetSearchedUsers, TError = unknown>(
  client: GraphQLClient,
  variables: GetSearchedUsersVariables,
  options?: Omit<UseQueryOptions<GetSearchedUsers, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetSearchedUsers, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetSearchedUsers, TError, TData>({
    queryKey: ['getSearchedUsers', variables],
    queryFn: fetcher<GetSearchedUsers, GetSearchedUsersVariables>(client, GetSearchedUsersDocument, variables, headers),
    ...options,
  });
};

useGetSearchedUsers.getKey = (variables: GetSearchedUsersVariables) => ['getSearchedUsers', variables];

export const useInfiniteGetSearchedUsers = <TData = InfiniteData<GetSearchedUsers>, TError = unknown>(
  client: GraphQLClient,
  variables: GetSearchedUsersVariables,
  options: Omit<UseInfiniteQueryOptions<GetSearchedUsers, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetSearchedUsers, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetSearchedUsers, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getSearchedUsers.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetSearchedUsers, GetSearchedUsersVariables>(
            client,
            GetSearchedUsersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetSearchedUsers.getKey = (variables: GetSearchedUsersVariables) => ['getSearchedUsers.infinite', variables];

useGetSearchedUsers.fetcher = (
  client: GraphQLClient,
  variables: GetSearchedUsersVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetSearchedUsers, GetSearchedUsersVariables>(client, GetSearchedUsersDocument, variables, headers);

export const GetUserBoatsDocument = `
    query getUserBoats($page: Int, $first: Int, $query: String, $orderBy: [OrderByClause], $with_disabled: Boolean) {
  boatDetails(
    page: $page
    first: $first
    query: $query
    orderBy: $orderBy
    with_disabled: $with_disabled
  ) {
    data {
      id
      name
      can_share
      can_update
      can_delete
      description
      flag
      user_id
      location
      location_toponym
      strapi_ref_document_id
      subscription_id
      image {
        id
        url
        public_url
      }
      boat {
        image {
          id
          url
          public_url
        }
        model
        year_first
        manufacturer {
          name
        }
      }
      files {
        id
        name
        url
      }
      user {
        id
        name
        surname
        display_name
      }
      plan {
        id
        name
        status
        available
        gateway_id
        cost
        slug
      }
      created_at
    }
    paginatorInfo {
      currentPage
      count
      perPage
      total
      firstItem
      lastItem
    }
  }
}
    `;

export const useGetUserBoats = <TData = GetUserBoats, TError = unknown>(
  client: GraphQLClient,
  variables?: GetUserBoatsVariables,
  options?: Omit<UseQueryOptions<GetUserBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetUserBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetUserBoats, TError, TData>({
    queryKey: variables === undefined ? ['getUserBoats'] : ['getUserBoats', variables],
    queryFn: fetcher<GetUserBoats, GetUserBoatsVariables>(client, GetUserBoatsDocument, variables, headers),
    ...options,
  });
};

useGetUserBoats.getKey = (variables?: GetUserBoatsVariables) =>
  variables === undefined ? ['getUserBoats'] : ['getUserBoats', variables];

export const useInfiniteGetUserBoats = <TData = InfiniteData<GetUserBoats>, TError = unknown>(
  client: GraphQLClient,
  variables: GetUserBoatsVariables,
  options: Omit<UseInfiniteQueryOptions<GetUserBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetUserBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetUserBoats, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getUserBoats.infinite']
            : ['getUserBoats.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetUserBoats, GetUserBoatsVariables>(
            client,
            GetUserBoatsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetUserBoats.getKey = (variables?: GetUserBoatsVariables) =>
  variables === undefined ? ['getUserBoats.infinite'] : ['getUserBoats.infinite', variables];

useGetUserBoats.fetcher = (
  client: GraphQLClient,
  variables?: GetUserBoatsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetUserBoats, GetUserBoatsVariables>(client, GetUserBoatsDocument, variables, headers);

export const GetBoatsToAddLicenseDocument = `
    query getBoatsToAddLicense {
  boatDetails(with_disabled: true, with_shared: false) {
    data {
      id
      user_id
      name
      status
      flag
      plan {
        id
        name
        slug
        gateway_id
        cost
        available
        used
        status
      }
      subscription_id
    }
  }
}
    `;

export const useGetBoatsToAddLicense = <TData = GetBoatsToAddLicense, TError = unknown>(
  client: GraphQLClient,
  variables?: GetBoatsToAddLicenseVariables,
  options?: Omit<UseQueryOptions<GetBoatsToAddLicense, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetBoatsToAddLicense, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetBoatsToAddLicense, TError, TData>({
    queryKey: variables === undefined ? ['getBoatsToAddLicense'] : ['getBoatsToAddLicense', variables],
    queryFn: fetcher<GetBoatsToAddLicense, GetBoatsToAddLicenseVariables>(
      client,
      GetBoatsToAddLicenseDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetBoatsToAddLicense.getKey = (variables?: GetBoatsToAddLicenseVariables) =>
  variables === undefined ? ['getBoatsToAddLicense'] : ['getBoatsToAddLicense', variables];

export const useInfiniteGetBoatsToAddLicense = <TData = InfiniteData<GetBoatsToAddLicense>, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatsToAddLicenseVariables,
  options: Omit<UseInfiniteQueryOptions<GetBoatsToAddLicense, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetBoatsToAddLicense, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetBoatsToAddLicense, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getBoatsToAddLicense.infinite']
            : ['getBoatsToAddLicense.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetBoatsToAddLicense, GetBoatsToAddLicenseVariables>(
            client,
            GetBoatsToAddLicenseDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetBoatsToAddLicense.getKey = (variables?: GetBoatsToAddLicenseVariables) =>
  variables === undefined ? ['getBoatsToAddLicense.infinite'] : ['getBoatsToAddLicense.infinite', variables];

useGetBoatsToAddLicense.fetcher = (
  client: GraphQLClient,
  variables?: GetBoatsToAddLicenseVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetBoatsToAddLicense, GetBoatsToAddLicenseVariables>(
    client,
    GetBoatsToAddLicenseDocument,
    variables,
    headers,
  );

export const GetStatisticsDocument = `
    query getStatistics($boat_detail_id: ID) {
  overviewWidget(boat_detail_id: $boat_detail_id) {
    boat_count
    trip_count
    task_count
    inventory_count
    alert_count
    total_costs
    storage_used_percentage
    storage_used_in_mb
  }
}
    `;

export const useGetStatistics = <TData = GetStatistics, TError = unknown>(
  client: GraphQLClient,
  variables?: GetStatisticsVariables,
  options?: Omit<UseQueryOptions<GetStatistics, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetStatistics, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetStatistics, TError, TData>({
    queryKey: variables === undefined ? ['getStatistics'] : ['getStatistics', variables],
    queryFn: fetcher<GetStatistics, GetStatisticsVariables>(client, GetStatisticsDocument, variables, headers),
    ...options,
  });
};

useGetStatistics.getKey = (variables?: GetStatisticsVariables) =>
  variables === undefined ? ['getStatistics'] : ['getStatistics', variables];

export const useInfiniteGetStatistics = <TData = InfiniteData<GetStatistics>, TError = unknown>(
  client: GraphQLClient,
  variables: GetStatisticsVariables,
  options: Omit<UseInfiniteQueryOptions<GetStatistics, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetStatistics, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetStatistics, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getStatistics.infinite']
            : ['getStatistics.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetStatistics, GetStatisticsVariables>(
            client,
            GetStatisticsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetStatistics.getKey = (variables?: GetStatisticsVariables) =>
  variables === undefined ? ['getStatistics.infinite'] : ['getStatistics.infinite', variables];

useGetStatistics.fetcher = (
  client: GraphQLClient,
  variables?: GetStatisticsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetStatistics, GetStatisticsVariables>(client, GetStatisticsDocument, variables, headers);
